export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601Date: any;
  ISO8601DateTime: any;
  JSON: any;
};

export type Area = {
  __typename?: 'Area';
  code: Scalars['String'];
  coursesCount: Scalars['Int'];
  coursesProgress: Array<AreaProgress>;
  createdAt: Scalars['ISO8601DateTime'];
  hoursTotal: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<Area>;
  parentId?: Maybe<Scalars['ID']>;
  participantsCount: Scalars['Int'];
  subareas: Array<Area>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type AreaPage = {
  __typename?: 'AreaPage';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<Area>;
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
};

export type AreaProgress = {
  __typename?: 'AreaProgress';
  courseId: Scalars['ID'];
  finish: Scalars['Int'];
  inProgress: Scalars['Int'];
  pending: Scalars['Int'];
};

export type AreaRansack = {
  code_blank?: InputMaybe<Scalars['String']>;
  code_cont?: InputMaybe<Scalars['String']>;
  code_cont_all?: InputMaybe<Scalars['String']>;
  code_cont_any?: InputMaybe<Scalars['String']>;
  code_does_not_match?: InputMaybe<Scalars['String']>;
  code_does_not_match_all?: InputMaybe<Scalars['String']>;
  code_does_not_match_any?: InputMaybe<Scalars['String']>;
  code_end?: InputMaybe<Scalars['String']>;
  code_end_all?: InputMaybe<Scalars['String']>;
  code_end_any?: InputMaybe<Scalars['String']>;
  code_eq?: InputMaybe<Scalars['String']>;
  code_eq_all?: InputMaybe<Scalars['String']>;
  code_eq_any?: InputMaybe<Scalars['String']>;
  code_false?: InputMaybe<Scalars['String']>;
  code_gt?: InputMaybe<Scalars['String']>;
  code_gt_all?: InputMaybe<Scalars['String']>;
  code_gt_any?: InputMaybe<Scalars['String']>;
  code_gteq?: InputMaybe<Scalars['String']>;
  code_gteq_all?: InputMaybe<Scalars['String']>;
  code_gteq_any?: InputMaybe<Scalars['String']>;
  code_i_cont?: InputMaybe<Scalars['String']>;
  code_i_cont_all?: InputMaybe<Scalars['String']>;
  code_i_cont_any?: InputMaybe<Scalars['String']>;
  code_in?: InputMaybe<Array<Scalars['String']>>;
  code_in_all?: InputMaybe<Array<Scalars['String']>>;
  code_in_any?: InputMaybe<Array<Scalars['String']>>;
  code_lt?: InputMaybe<Scalars['String']>;
  code_lt_all?: InputMaybe<Scalars['String']>;
  code_lt_any?: InputMaybe<Scalars['String']>;
  code_lteq?: InputMaybe<Scalars['String']>;
  code_lteq_all?: InputMaybe<Scalars['String']>;
  code_lteq_any?: InputMaybe<Scalars['String']>;
  code_matches?: InputMaybe<Scalars['String']>;
  code_matches_all?: InputMaybe<Scalars['String']>;
  code_matches_any?: InputMaybe<Scalars['String']>;
  code_not_cont?: InputMaybe<Scalars['String']>;
  code_not_cont_all?: InputMaybe<Scalars['String']>;
  code_not_cont_any?: InputMaybe<Scalars['String']>;
  code_not_end?: InputMaybe<Scalars['String']>;
  code_not_end_all?: InputMaybe<Scalars['String']>;
  code_not_end_any?: InputMaybe<Scalars['String']>;
  code_not_eq?: InputMaybe<Scalars['String']>;
  code_not_eq_all?: InputMaybe<Scalars['String']>;
  code_not_eq_any?: InputMaybe<Scalars['String']>;
  code_not_false?: InputMaybe<Scalars['String']>;
  code_not_i_cont?: InputMaybe<Scalars['String']>;
  code_not_i_cont_all?: InputMaybe<Scalars['String']>;
  code_not_i_cont_any?: InputMaybe<Scalars['String']>;
  code_not_in?: InputMaybe<Array<Scalars['String']>>;
  code_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  code_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  code_not_null?: InputMaybe<Scalars['String']>;
  code_not_start?: InputMaybe<Scalars['String']>;
  code_not_start_all?: InputMaybe<Scalars['String']>;
  code_not_start_any?: InputMaybe<Scalars['String']>;
  code_not_true?: InputMaybe<Scalars['String']>;
  code_null?: InputMaybe<Scalars['String']>;
  code_present?: InputMaybe<Scalars['String']>;
  code_start?: InputMaybe<Scalars['String']>;
  code_start_all?: InputMaybe<Scalars['String']>;
  code_start_any?: InputMaybe<Scalars['String']>;
  code_true?: InputMaybe<Scalars['String']>;
  created_at_blank?: InputMaybe<Scalars['String']>;
  created_at_cont?: InputMaybe<Scalars['String']>;
  created_at_cont_all?: InputMaybe<Scalars['String']>;
  created_at_cont_any?: InputMaybe<Scalars['String']>;
  created_at_does_not_match?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  created_at_end?: InputMaybe<Scalars['String']>;
  created_at_end_all?: InputMaybe<Scalars['String']>;
  created_at_end_any?: InputMaybe<Scalars['String']>;
  created_at_eq?: InputMaybe<Scalars['String']>;
  created_at_eq_all?: InputMaybe<Scalars['String']>;
  created_at_eq_any?: InputMaybe<Scalars['String']>;
  created_at_false?: InputMaybe<Scalars['String']>;
  created_at_gt?: InputMaybe<Scalars['String']>;
  created_at_gt_all?: InputMaybe<Scalars['String']>;
  created_at_gt_any?: InputMaybe<Scalars['String']>;
  created_at_gteq?: InputMaybe<Scalars['String']>;
  created_at_gteq_all?: InputMaybe<Scalars['String']>;
  created_at_gteq_any?: InputMaybe<Scalars['String']>;
  created_at_i_cont?: InputMaybe<Scalars['String']>;
  created_at_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_in?: InputMaybe<Scalars['String']>;
  created_at_in_all?: InputMaybe<Scalars['String']>;
  created_at_in_any?: InputMaybe<Scalars['String']>;
  created_at_lt?: InputMaybe<Scalars['String']>;
  created_at_lt_all?: InputMaybe<Scalars['String']>;
  created_at_lt_any?: InputMaybe<Scalars['String']>;
  created_at_lteq?: InputMaybe<Scalars['String']>;
  created_at_lteq_all?: InputMaybe<Scalars['String']>;
  created_at_lteq_any?: InputMaybe<Scalars['String']>;
  created_at_matches?: InputMaybe<Scalars['String']>;
  created_at_matches_all?: InputMaybe<Scalars['String']>;
  created_at_matches_any?: InputMaybe<Scalars['String']>;
  created_at_not_cont?: InputMaybe<Scalars['String']>;
  created_at_not_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_end?: InputMaybe<Scalars['String']>;
  created_at_not_end_all?: InputMaybe<Scalars['String']>;
  created_at_not_end_any?: InputMaybe<Scalars['String']>;
  created_at_not_eq?: InputMaybe<Scalars['String']>;
  created_at_not_eq_all?: InputMaybe<Scalars['String']>;
  created_at_not_eq_any?: InputMaybe<Scalars['String']>;
  created_at_not_false?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_in?: InputMaybe<Scalars['String']>;
  created_at_not_in_all?: InputMaybe<Scalars['String']>;
  created_at_not_in_any?: InputMaybe<Scalars['String']>;
  created_at_not_null?: InputMaybe<Scalars['String']>;
  created_at_not_start?: InputMaybe<Scalars['String']>;
  created_at_not_start_all?: InputMaybe<Scalars['String']>;
  created_at_not_start_any?: InputMaybe<Scalars['String']>;
  created_at_not_true?: InputMaybe<Scalars['String']>;
  created_at_null?: InputMaybe<Scalars['String']>;
  created_at_present?: InputMaybe<Scalars['String']>;
  created_at_start?: InputMaybe<Scalars['String']>;
  created_at_start_all?: InputMaybe<Scalars['String']>;
  created_at_start_any?: InputMaybe<Scalars['String']>;
  created_at_true?: InputMaybe<Scalars['String']>;
  description_blank?: InputMaybe<Scalars['String']>;
  description_cont?: InputMaybe<Scalars['String']>;
  description_cont_all?: InputMaybe<Scalars['String']>;
  description_cont_any?: InputMaybe<Scalars['String']>;
  description_does_not_match?: InputMaybe<Scalars['String']>;
  description_does_not_match_all?: InputMaybe<Scalars['String']>;
  description_does_not_match_any?: InputMaybe<Scalars['String']>;
  description_end?: InputMaybe<Scalars['String']>;
  description_end_all?: InputMaybe<Scalars['String']>;
  description_end_any?: InputMaybe<Scalars['String']>;
  description_eq?: InputMaybe<Scalars['String']>;
  description_eq_all?: InputMaybe<Scalars['String']>;
  description_eq_any?: InputMaybe<Scalars['String']>;
  description_false?: InputMaybe<Scalars['String']>;
  description_gt?: InputMaybe<Scalars['String']>;
  description_gt_all?: InputMaybe<Scalars['String']>;
  description_gt_any?: InputMaybe<Scalars['String']>;
  description_gteq?: InputMaybe<Scalars['String']>;
  description_gteq_all?: InputMaybe<Scalars['String']>;
  description_gteq_any?: InputMaybe<Scalars['String']>;
  description_i_cont?: InputMaybe<Scalars['String']>;
  description_i_cont_all?: InputMaybe<Scalars['String']>;
  description_i_cont_any?: InputMaybe<Scalars['String']>;
  description_in?: InputMaybe<Array<Scalars['String']>>;
  description_in_all?: InputMaybe<Array<Scalars['String']>>;
  description_in_any?: InputMaybe<Array<Scalars['String']>>;
  description_lt?: InputMaybe<Scalars['String']>;
  description_lt_all?: InputMaybe<Scalars['String']>;
  description_lt_any?: InputMaybe<Scalars['String']>;
  description_lteq?: InputMaybe<Scalars['String']>;
  description_lteq_all?: InputMaybe<Scalars['String']>;
  description_lteq_any?: InputMaybe<Scalars['String']>;
  description_matches?: InputMaybe<Scalars['String']>;
  description_matches_all?: InputMaybe<Scalars['String']>;
  description_matches_any?: InputMaybe<Scalars['String']>;
  description_not_cont?: InputMaybe<Scalars['String']>;
  description_not_cont_all?: InputMaybe<Scalars['String']>;
  description_not_cont_any?: InputMaybe<Scalars['String']>;
  description_not_end?: InputMaybe<Scalars['String']>;
  description_not_end_all?: InputMaybe<Scalars['String']>;
  description_not_end_any?: InputMaybe<Scalars['String']>;
  description_not_eq?: InputMaybe<Scalars['String']>;
  description_not_eq_all?: InputMaybe<Scalars['String']>;
  description_not_eq_any?: InputMaybe<Scalars['String']>;
  description_not_false?: InputMaybe<Scalars['String']>;
  description_not_i_cont?: InputMaybe<Scalars['String']>;
  description_not_i_cont_all?: InputMaybe<Scalars['String']>;
  description_not_i_cont_any?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<Scalars['String']>>;
  description_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  description_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  description_not_null?: InputMaybe<Scalars['String']>;
  description_not_start?: InputMaybe<Scalars['String']>;
  description_not_start_all?: InputMaybe<Scalars['String']>;
  description_not_start_any?: InputMaybe<Scalars['String']>;
  description_not_true?: InputMaybe<Scalars['String']>;
  description_null?: InputMaybe<Scalars['String']>;
  description_present?: InputMaybe<Scalars['String']>;
  description_start?: InputMaybe<Scalars['String']>;
  description_start_all?: InputMaybe<Scalars['String']>;
  description_start_any?: InputMaybe<Scalars['String']>;
  description_true?: InputMaybe<Scalars['String']>;
  g?: InputMaybe<Array<Scalars['JSON']>>;
  id_blank?: InputMaybe<Scalars['Int']>;
  id_cont?: InputMaybe<Scalars['Int']>;
  id_cont_all?: InputMaybe<Scalars['Int']>;
  id_cont_any?: InputMaybe<Scalars['Int']>;
  id_does_not_match?: InputMaybe<Scalars['Int']>;
  id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  id_end?: InputMaybe<Scalars['Int']>;
  id_end_all?: InputMaybe<Scalars['Int']>;
  id_end_any?: InputMaybe<Scalars['Int']>;
  id_eq?: InputMaybe<Scalars['Int']>;
  id_eq_all?: InputMaybe<Scalars['Int']>;
  id_eq_any?: InputMaybe<Scalars['Int']>;
  id_false?: InputMaybe<Scalars['Int']>;
  id_gt?: InputMaybe<Scalars['Int']>;
  id_gt_all?: InputMaybe<Scalars['Int']>;
  id_gt_any?: InputMaybe<Scalars['Int']>;
  id_gteq?: InputMaybe<Scalars['Int']>;
  id_gteq_all?: InputMaybe<Scalars['Int']>;
  id_gteq_any?: InputMaybe<Scalars['Int']>;
  id_i_cont?: InputMaybe<Scalars['Int']>;
  id_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_in?: InputMaybe<Array<Scalars['Int']>>;
  id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_lt?: InputMaybe<Scalars['Int']>;
  id_lt_all?: InputMaybe<Scalars['Int']>;
  id_lt_any?: InputMaybe<Scalars['Int']>;
  id_lteq?: InputMaybe<Scalars['Int']>;
  id_lteq_all?: InputMaybe<Scalars['Int']>;
  id_lteq_any?: InputMaybe<Scalars['Int']>;
  id_matches?: InputMaybe<Scalars['Int']>;
  id_matches_all?: InputMaybe<Scalars['Int']>;
  id_matches_any?: InputMaybe<Scalars['Int']>;
  id_not_cont?: InputMaybe<Scalars['Int']>;
  id_not_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_end?: InputMaybe<Scalars['Int']>;
  id_not_end_all?: InputMaybe<Scalars['Int']>;
  id_not_end_any?: InputMaybe<Scalars['Int']>;
  id_not_eq?: InputMaybe<Scalars['Int']>;
  id_not_eq_all?: InputMaybe<Scalars['Int']>;
  id_not_eq_any?: InputMaybe<Scalars['Int']>;
  id_not_false?: InputMaybe<Scalars['Int']>;
  id_not_i_cont?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_not_null?: InputMaybe<Scalars['Int']>;
  id_not_start?: InputMaybe<Scalars['Int']>;
  id_not_start_all?: InputMaybe<Scalars['Int']>;
  id_not_start_any?: InputMaybe<Scalars['Int']>;
  id_not_true?: InputMaybe<Scalars['Int']>;
  id_null?: InputMaybe<Scalars['Int']>;
  id_present?: InputMaybe<Scalars['Int']>;
  id_start?: InputMaybe<Scalars['Int']>;
  id_start_all?: InputMaybe<Scalars['Int']>;
  id_start_any?: InputMaybe<Scalars['Int']>;
  id_true?: InputMaybe<Scalars['Int']>;
  name_blank?: InputMaybe<Scalars['String']>;
  name_cont?: InputMaybe<Scalars['String']>;
  name_cont_all?: InputMaybe<Scalars['String']>;
  name_cont_any?: InputMaybe<Scalars['String']>;
  name_does_not_match?: InputMaybe<Scalars['String']>;
  name_does_not_match_all?: InputMaybe<Scalars['String']>;
  name_does_not_match_any?: InputMaybe<Scalars['String']>;
  name_end?: InputMaybe<Scalars['String']>;
  name_end_all?: InputMaybe<Scalars['String']>;
  name_end_any?: InputMaybe<Scalars['String']>;
  name_eq?: InputMaybe<Scalars['String']>;
  name_eq_all?: InputMaybe<Scalars['String']>;
  name_eq_any?: InputMaybe<Scalars['String']>;
  name_false?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gt_all?: InputMaybe<Scalars['String']>;
  name_gt_any?: InputMaybe<Scalars['String']>;
  name_gteq?: InputMaybe<Scalars['String']>;
  name_gteq_all?: InputMaybe<Scalars['String']>;
  name_gteq_any?: InputMaybe<Scalars['String']>;
  name_i_cont?: InputMaybe<Scalars['String']>;
  name_i_cont_all?: InputMaybe<Scalars['String']>;
  name_i_cont_any?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lt_all?: InputMaybe<Scalars['String']>;
  name_lt_any?: InputMaybe<Scalars['String']>;
  name_lteq?: InputMaybe<Scalars['String']>;
  name_lteq_all?: InputMaybe<Scalars['String']>;
  name_lteq_any?: InputMaybe<Scalars['String']>;
  name_matches?: InputMaybe<Scalars['String']>;
  name_matches_all?: InputMaybe<Scalars['String']>;
  name_matches_any?: InputMaybe<Scalars['String']>;
  name_not_cont?: InputMaybe<Scalars['String']>;
  name_not_cont_all?: InputMaybe<Scalars['String']>;
  name_not_cont_any?: InputMaybe<Scalars['String']>;
  name_not_end?: InputMaybe<Scalars['String']>;
  name_not_end_all?: InputMaybe<Scalars['String']>;
  name_not_end_any?: InputMaybe<Scalars['String']>;
  name_not_eq?: InputMaybe<Scalars['String']>;
  name_not_eq_all?: InputMaybe<Scalars['String']>;
  name_not_eq_any?: InputMaybe<Scalars['String']>;
  name_not_false?: InputMaybe<Scalars['String']>;
  name_not_i_cont?: InputMaybe<Scalars['String']>;
  name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_not_null?: InputMaybe<Scalars['String']>;
  name_not_start?: InputMaybe<Scalars['String']>;
  name_not_start_all?: InputMaybe<Scalars['String']>;
  name_not_start_any?: InputMaybe<Scalars['String']>;
  name_not_true?: InputMaybe<Scalars['String']>;
  name_null?: InputMaybe<Scalars['String']>;
  name_or_code_cont?: InputMaybe<Scalars['String']>;
  name_present?: InputMaybe<Scalars['String']>;
  name_start?: InputMaybe<Scalars['String']>;
  name_start_all?: InputMaybe<Scalars['String']>;
  name_start_any?: InputMaybe<Scalars['String']>;
  name_true?: InputMaybe<Scalars['String']>;
  parent_id_blank?: InputMaybe<Scalars['Int']>;
  parent_id_cont?: InputMaybe<Scalars['Int']>;
  parent_id_cont_all?: InputMaybe<Scalars['Int']>;
  parent_id_cont_any?: InputMaybe<Scalars['Int']>;
  parent_id_does_not_match?: InputMaybe<Scalars['Int']>;
  parent_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  parent_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  parent_id_end?: InputMaybe<Scalars['Int']>;
  parent_id_end_all?: InputMaybe<Scalars['Int']>;
  parent_id_end_any?: InputMaybe<Scalars['Int']>;
  parent_id_eq?: InputMaybe<Scalars['Int']>;
  parent_id_eq_all?: InputMaybe<Scalars['Int']>;
  parent_id_eq_any?: InputMaybe<Scalars['Int']>;
  parent_id_false?: InputMaybe<Scalars['Int']>;
  parent_id_gt?: InputMaybe<Scalars['Int']>;
  parent_id_gt_all?: InputMaybe<Scalars['Int']>;
  parent_id_gt_any?: InputMaybe<Scalars['Int']>;
  parent_id_gteq?: InputMaybe<Scalars['Int']>;
  parent_id_gteq_all?: InputMaybe<Scalars['Int']>;
  parent_id_gteq_any?: InputMaybe<Scalars['Int']>;
  parent_id_i_cont?: InputMaybe<Scalars['Int']>;
  parent_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  parent_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  parent_id_in?: InputMaybe<Array<Scalars['Int']>>;
  parent_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  parent_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  parent_id_lt?: InputMaybe<Scalars['Int']>;
  parent_id_lt_all?: InputMaybe<Scalars['Int']>;
  parent_id_lt_any?: InputMaybe<Scalars['Int']>;
  parent_id_lteq?: InputMaybe<Scalars['Int']>;
  parent_id_lteq_all?: InputMaybe<Scalars['Int']>;
  parent_id_lteq_any?: InputMaybe<Scalars['Int']>;
  parent_id_matches?: InputMaybe<Scalars['Int']>;
  parent_id_matches_all?: InputMaybe<Scalars['Int']>;
  parent_id_matches_any?: InputMaybe<Scalars['Int']>;
  parent_id_not_cont?: InputMaybe<Scalars['Int']>;
  parent_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  parent_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  parent_id_not_end?: InputMaybe<Scalars['Int']>;
  parent_id_not_end_all?: InputMaybe<Scalars['Int']>;
  parent_id_not_end_any?: InputMaybe<Scalars['Int']>;
  parent_id_not_eq?: InputMaybe<Scalars['Int']>;
  parent_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  parent_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  parent_id_not_false?: InputMaybe<Scalars['Int']>;
  parent_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  parent_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  parent_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  parent_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  parent_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  parent_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  parent_id_not_null?: InputMaybe<Scalars['Int']>;
  parent_id_not_start?: InputMaybe<Scalars['Int']>;
  parent_id_not_start_all?: InputMaybe<Scalars['Int']>;
  parent_id_not_start_any?: InputMaybe<Scalars['Int']>;
  parent_id_not_true?: InputMaybe<Scalars['Int']>;
  parent_id_null?: InputMaybe<Scalars['Int']>;
  parent_id_present?: InputMaybe<Scalars['Int']>;
  parent_id_start?: InputMaybe<Scalars['Int']>;
  parent_id_start_all?: InputMaybe<Scalars['Int']>;
  parent_id_start_any?: InputMaybe<Scalars['Int']>;
  parent_id_true?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<Scalars['String']>>;
  token_blank?: InputMaybe<Scalars['String']>;
  token_cont?: InputMaybe<Scalars['String']>;
  token_cont_all?: InputMaybe<Scalars['String']>;
  token_cont_any?: InputMaybe<Scalars['String']>;
  token_does_not_match?: InputMaybe<Scalars['String']>;
  token_does_not_match_all?: InputMaybe<Scalars['String']>;
  token_does_not_match_any?: InputMaybe<Scalars['String']>;
  token_end?: InputMaybe<Scalars['String']>;
  token_end_all?: InputMaybe<Scalars['String']>;
  token_end_any?: InputMaybe<Scalars['String']>;
  token_eq?: InputMaybe<Scalars['String']>;
  token_eq_all?: InputMaybe<Scalars['String']>;
  token_eq_any?: InputMaybe<Scalars['String']>;
  token_false?: InputMaybe<Scalars['String']>;
  token_gt?: InputMaybe<Scalars['String']>;
  token_gt_all?: InputMaybe<Scalars['String']>;
  token_gt_any?: InputMaybe<Scalars['String']>;
  token_gteq?: InputMaybe<Scalars['String']>;
  token_gteq_all?: InputMaybe<Scalars['String']>;
  token_gteq_any?: InputMaybe<Scalars['String']>;
  token_i_cont?: InputMaybe<Scalars['String']>;
  token_i_cont_all?: InputMaybe<Scalars['String']>;
  token_i_cont_any?: InputMaybe<Scalars['String']>;
  token_in?: InputMaybe<Array<Scalars['String']>>;
  token_in_all?: InputMaybe<Array<Scalars['String']>>;
  token_in_any?: InputMaybe<Array<Scalars['String']>>;
  token_lt?: InputMaybe<Scalars['String']>;
  token_lt_all?: InputMaybe<Scalars['String']>;
  token_lt_any?: InputMaybe<Scalars['String']>;
  token_lteq?: InputMaybe<Scalars['String']>;
  token_lteq_all?: InputMaybe<Scalars['String']>;
  token_lteq_any?: InputMaybe<Scalars['String']>;
  token_matches?: InputMaybe<Scalars['String']>;
  token_matches_all?: InputMaybe<Scalars['String']>;
  token_matches_any?: InputMaybe<Scalars['String']>;
  token_not_cont?: InputMaybe<Scalars['String']>;
  token_not_cont_all?: InputMaybe<Scalars['String']>;
  token_not_cont_any?: InputMaybe<Scalars['String']>;
  token_not_end?: InputMaybe<Scalars['String']>;
  token_not_end_all?: InputMaybe<Scalars['String']>;
  token_not_end_any?: InputMaybe<Scalars['String']>;
  token_not_eq?: InputMaybe<Scalars['String']>;
  token_not_eq_all?: InputMaybe<Scalars['String']>;
  token_not_eq_any?: InputMaybe<Scalars['String']>;
  token_not_false?: InputMaybe<Scalars['String']>;
  token_not_i_cont?: InputMaybe<Scalars['String']>;
  token_not_i_cont_all?: InputMaybe<Scalars['String']>;
  token_not_i_cont_any?: InputMaybe<Scalars['String']>;
  token_not_in?: InputMaybe<Array<Scalars['String']>>;
  token_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  token_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  token_not_null?: InputMaybe<Scalars['String']>;
  token_not_start?: InputMaybe<Scalars['String']>;
  token_not_start_all?: InputMaybe<Scalars['String']>;
  token_not_start_any?: InputMaybe<Scalars['String']>;
  token_not_true?: InputMaybe<Scalars['String']>;
  token_null?: InputMaybe<Scalars['String']>;
  token_present?: InputMaybe<Scalars['String']>;
  token_start?: InputMaybe<Scalars['String']>;
  token_start_all?: InputMaybe<Scalars['String']>;
  token_start_any?: InputMaybe<Scalars['String']>;
  token_true?: InputMaybe<Scalars['String']>;
};

export type BlockEvaluation = {
  __typename?: 'BlockEvaluation';
  approvalPoints?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  maxRetries?: Maybe<Scalars['Int']>;
  randomQuestions?: Maybe<Scalars['Boolean']>;
  showResults?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Course = {
  __typename?: 'Course';
  bannerData?: Maybe<Scalars['JSON']>;
  canGenerateCertificate?: Maybe<Scalars['Boolean']>;
  capacity?: Maybe<Scalars['Int']>;
  certificatesCount: Scalars['Int'];
  courseType?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  directChiefApproval?: Maybe<Scalars['Boolean']>;
  evaluations?: Maybe<Array<BlockEvaluation>>;
  evaluationsCount: Scalars['Int'];
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  integrationCourse?: Maybe<IntegrationCourse>;
  integrationCourseId?: Maybe<Scalars['ID']>;
  integrationCourseLink?: Maybe<Scalars['String']>;
  lessonsCount: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  onDuplicated?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  participantsCount: Scalars['Int'];
  progress?: Maybe<CourseProgress>;
  progressEvaluations?: Maybe<CourseProgressEvaluation>;
  sendEmail?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['Int']>;
  synchronousCourse?: Maybe<SynchronousCourse>;
  synchronousCourseEvaluationsCount: Scalars['Int'];
  thumbnailData?: Maybe<Scalars['JSON']>;
  untilDate?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type CourseParticipantsCountArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  ransack?: InputMaybe<CourseParticipantRansack>;
};


export type CourseProgressArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  ransack?: InputMaybe<CourseParticipantRansack>;
};


export type CourseProgressEvaluationsArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  ransack?: InputMaybe<CourseParticipantRansack>;
};

export type CoursePage = {
  __typename?: 'CoursePage';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<Course>;
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
};

export type CourseParticipantRansack = {
  advance_eq?: InputMaybe<Scalars['Int']>;
  advance_in?: InputMaybe<Array<Scalars['Int']>>;
  advance_not_eq?: InputMaybe<Scalars['Int']>;
  course_id_eq?: InputMaybe<Scalars['Int']>;
  course_id_in?: InputMaybe<Array<Scalars['Int']>>;
  course_id_not_eq?: InputMaybe<Scalars['Int']>;
  enrol_id_eq?: InputMaybe<Scalars['Int']>;
  enrol_id_in?: InputMaybe<Array<Scalars['Int']>>;
  enrol_id_not_eq?: InputMaybe<Scalars['Int']>;
  g?: InputMaybe<Array<Scalars['JSON']>>;
  lms_profile_id_eq?: InputMaybe<Scalars['Int']>;
  lms_profile_id_in?: InputMaybe<Array<Scalars['Int']>>;
  lms_profile_id_not_eq?: InputMaybe<Scalars['Int']>;
  mandatory_eq?: InputMaybe<Scalars['Boolean']>;
  mandatory_in?: InputMaybe<Array<Scalars['Boolean']>>;
  mandatory_not_eq?: InputMaybe<Scalars['Boolean']>;
  user_active_eq?: InputMaybe<Scalars['Boolean']>;
  user_active_in?: InputMaybe<Array<Scalars['Boolean']>>;
  user_active_not_eq?: InputMaybe<Scalars['Boolean']>;
  user_id_eq?: InputMaybe<Scalars['Int']>;
  user_id_in?: InputMaybe<Array<Scalars['Int']>>;
  user_id_not_eq?: InputMaybe<Scalars['Int']>;
  user_lms_active_eq?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_in?: InputMaybe<Array<Scalars['Boolean']>>;
  user_lms_active_not_eq?: InputMaybe<Scalars['Boolean']>;
};

export type CourseProgress = {
  __typename?: 'CourseProgress';
  finish: Scalars['Int'];
  inProgress: Scalars['Int'];
  pending: Scalars['Int'];
};

export type CourseProgressEvaluation = {
  __typename?: 'CourseProgressEvaluation';
  approved: Scalars['Int'];
  reproved: Scalars['Int'];
  total: Scalars['Int'];
};

export type CourseRansack = {
  advance_finish_blank?: InputMaybe<Scalars['String']>;
  advance_finish_cont?: InputMaybe<Scalars['String']>;
  advance_finish_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_blank?: InputMaybe<Scalars['String']>;
  advance_finish_count_cont?: InputMaybe<Scalars['String']>;
  advance_finish_count_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_does_not_match?: InputMaybe<Scalars['String']>;
  advance_finish_count_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_end?: InputMaybe<Scalars['String']>;
  advance_finish_count_end_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_end_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_eq?: InputMaybe<Scalars['String']>;
  advance_finish_count_eq_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_eq_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_false?: InputMaybe<Scalars['String']>;
  advance_finish_count_gt?: InputMaybe<Scalars['String']>;
  advance_finish_count_gt_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_gt_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_gteq?: InputMaybe<Scalars['String']>;
  advance_finish_count_gteq_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_gteq_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_i_cont?: InputMaybe<Scalars['String']>;
  advance_finish_count_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_in?: InputMaybe<Scalars['String']>;
  advance_finish_count_in_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_in_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_lt?: InputMaybe<Scalars['String']>;
  advance_finish_count_lt_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_lt_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_lteq?: InputMaybe<Scalars['String']>;
  advance_finish_count_lteq_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_lteq_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_matches?: InputMaybe<Scalars['String']>;
  advance_finish_count_matches_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_matches_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_cont?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_end?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_end_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_end_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_eq?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_false?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_in?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_in_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_in_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_null?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_start?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_start_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_start_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_not_true?: InputMaybe<Scalars['String']>;
  advance_finish_count_null?: InputMaybe<Scalars['String']>;
  advance_finish_count_present?: InputMaybe<Scalars['String']>;
  advance_finish_count_start?: InputMaybe<Scalars['String']>;
  advance_finish_count_start_all?: InputMaybe<Scalars['String']>;
  advance_finish_count_start_any?: InputMaybe<Scalars['String']>;
  advance_finish_count_true?: InputMaybe<Scalars['String']>;
  advance_finish_does_not_match?: InputMaybe<Scalars['String']>;
  advance_finish_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_finish_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_finish_end?: InputMaybe<Scalars['String']>;
  advance_finish_end_all?: InputMaybe<Scalars['String']>;
  advance_finish_end_any?: InputMaybe<Scalars['String']>;
  advance_finish_eq?: InputMaybe<Scalars['String']>;
  advance_finish_eq_all?: InputMaybe<Scalars['String']>;
  advance_finish_eq_any?: InputMaybe<Scalars['String']>;
  advance_finish_false?: InputMaybe<Scalars['String']>;
  advance_finish_gt?: InputMaybe<Scalars['String']>;
  advance_finish_gt_all?: InputMaybe<Scalars['String']>;
  advance_finish_gt_any?: InputMaybe<Scalars['String']>;
  advance_finish_gteq?: InputMaybe<Scalars['String']>;
  advance_finish_gteq_all?: InputMaybe<Scalars['String']>;
  advance_finish_gteq_any?: InputMaybe<Scalars['String']>;
  advance_finish_i_cont?: InputMaybe<Scalars['String']>;
  advance_finish_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_in?: InputMaybe<Scalars['String']>;
  advance_finish_in_all?: InputMaybe<Scalars['String']>;
  advance_finish_in_any?: InputMaybe<Scalars['String']>;
  advance_finish_lt?: InputMaybe<Scalars['String']>;
  advance_finish_lt_all?: InputMaybe<Scalars['String']>;
  advance_finish_lt_any?: InputMaybe<Scalars['String']>;
  advance_finish_lteq?: InputMaybe<Scalars['String']>;
  advance_finish_lteq_all?: InputMaybe<Scalars['String']>;
  advance_finish_lteq_any?: InputMaybe<Scalars['String']>;
  advance_finish_matches?: InputMaybe<Scalars['String']>;
  advance_finish_matches_all?: InputMaybe<Scalars['String']>;
  advance_finish_matches_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_cont?: InputMaybe<Scalars['String']>;
  advance_finish_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_end?: InputMaybe<Scalars['String']>;
  advance_finish_not_end_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_end_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_eq?: InputMaybe<Scalars['String']>;
  advance_finish_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_false?: InputMaybe<Scalars['String']>;
  advance_finish_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_finish_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_in?: InputMaybe<Scalars['String']>;
  advance_finish_not_in_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_in_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_null?: InputMaybe<Scalars['String']>;
  advance_finish_not_start?: InputMaybe<Scalars['String']>;
  advance_finish_not_start_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_start_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_true?: InputMaybe<Scalars['String']>;
  advance_finish_null?: InputMaybe<Scalars['String']>;
  advance_finish_present?: InputMaybe<Scalars['String']>;
  advance_finish_start?: InputMaybe<Scalars['String']>;
  advance_finish_start_all?: InputMaybe<Scalars['String']>;
  advance_finish_start_any?: InputMaybe<Scalars['String']>;
  advance_finish_true?: InputMaybe<Scalars['String']>;
  advance_in_progress_blank?: InputMaybe<Scalars['String']>;
  advance_in_progress_cont?: InputMaybe<Scalars['String']>;
  advance_in_progress_cont_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_cont_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_blank?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_cont?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_cont_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_cont_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_does_not_match?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_end?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_end_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_end_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_eq?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_eq_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_eq_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_false?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_gt?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_gt_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_gt_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_gteq?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_gteq_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_gteq_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_i_cont?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_in?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_in_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_in_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_lt?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_lt_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_lt_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_lteq?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_lteq_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_lteq_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_matches?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_matches_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_matches_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_cont?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_end?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_end_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_end_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_eq?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_false?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_in?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_in_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_in_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_null?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_start?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_start_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_start_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_not_true?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_null?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_present?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_start?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_start_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_start_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_count_true?: InputMaybe<Scalars['String']>;
  advance_in_progress_does_not_match?: InputMaybe<Scalars['String']>;
  advance_in_progress_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_end?: InputMaybe<Scalars['String']>;
  advance_in_progress_end_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_end_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_eq?: InputMaybe<Scalars['String']>;
  advance_in_progress_eq_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_eq_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_false?: InputMaybe<Scalars['String']>;
  advance_in_progress_gt?: InputMaybe<Scalars['String']>;
  advance_in_progress_gt_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_gt_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_gteq?: InputMaybe<Scalars['String']>;
  advance_in_progress_gteq_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_gteq_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_i_cont?: InputMaybe<Scalars['String']>;
  advance_in_progress_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_in?: InputMaybe<Scalars['String']>;
  advance_in_progress_in_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_in_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_lt?: InputMaybe<Scalars['String']>;
  advance_in_progress_lt_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_lt_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_lteq?: InputMaybe<Scalars['String']>;
  advance_in_progress_lteq_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_lteq_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_matches?: InputMaybe<Scalars['String']>;
  advance_in_progress_matches_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_matches_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_cont?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_end?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_end_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_end_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_eq?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_false?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_in?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_in_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_in_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_null?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_start?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_start_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_start_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_not_true?: InputMaybe<Scalars['String']>;
  advance_in_progress_null?: InputMaybe<Scalars['String']>;
  advance_in_progress_present?: InputMaybe<Scalars['String']>;
  advance_in_progress_start?: InputMaybe<Scalars['String']>;
  advance_in_progress_start_all?: InputMaybe<Scalars['String']>;
  advance_in_progress_start_any?: InputMaybe<Scalars['String']>;
  advance_in_progress_true?: InputMaybe<Scalars['String']>;
  advance_pending_blank?: InputMaybe<Scalars['String']>;
  advance_pending_cont?: InputMaybe<Scalars['String']>;
  advance_pending_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_blank?: InputMaybe<Scalars['String']>;
  advance_pending_count_cont?: InputMaybe<Scalars['String']>;
  advance_pending_count_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_does_not_match?: InputMaybe<Scalars['String']>;
  advance_pending_count_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_end?: InputMaybe<Scalars['String']>;
  advance_pending_count_end_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_end_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_eq?: InputMaybe<Scalars['String']>;
  advance_pending_count_eq_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_eq_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_false?: InputMaybe<Scalars['String']>;
  advance_pending_count_gt?: InputMaybe<Scalars['String']>;
  advance_pending_count_gt_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_gt_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_gteq?: InputMaybe<Scalars['String']>;
  advance_pending_count_gteq_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_gteq_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_i_cont?: InputMaybe<Scalars['String']>;
  advance_pending_count_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_in?: InputMaybe<Scalars['String']>;
  advance_pending_count_in_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_in_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_lt?: InputMaybe<Scalars['String']>;
  advance_pending_count_lt_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_lt_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_lteq?: InputMaybe<Scalars['String']>;
  advance_pending_count_lteq_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_lteq_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_matches?: InputMaybe<Scalars['String']>;
  advance_pending_count_matches_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_matches_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_cont?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_end?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_end_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_end_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_eq?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_false?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_in?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_in_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_in_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_null?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_start?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_start_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_start_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_not_true?: InputMaybe<Scalars['String']>;
  advance_pending_count_null?: InputMaybe<Scalars['String']>;
  advance_pending_count_present?: InputMaybe<Scalars['String']>;
  advance_pending_count_start?: InputMaybe<Scalars['String']>;
  advance_pending_count_start_all?: InputMaybe<Scalars['String']>;
  advance_pending_count_start_any?: InputMaybe<Scalars['String']>;
  advance_pending_count_true?: InputMaybe<Scalars['String']>;
  advance_pending_does_not_match?: InputMaybe<Scalars['String']>;
  advance_pending_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_pending_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_pending_end?: InputMaybe<Scalars['String']>;
  advance_pending_end_all?: InputMaybe<Scalars['String']>;
  advance_pending_end_any?: InputMaybe<Scalars['String']>;
  advance_pending_eq?: InputMaybe<Scalars['String']>;
  advance_pending_eq_all?: InputMaybe<Scalars['String']>;
  advance_pending_eq_any?: InputMaybe<Scalars['String']>;
  advance_pending_false?: InputMaybe<Scalars['String']>;
  advance_pending_gt?: InputMaybe<Scalars['String']>;
  advance_pending_gt_all?: InputMaybe<Scalars['String']>;
  advance_pending_gt_any?: InputMaybe<Scalars['String']>;
  advance_pending_gteq?: InputMaybe<Scalars['String']>;
  advance_pending_gteq_all?: InputMaybe<Scalars['String']>;
  advance_pending_gteq_any?: InputMaybe<Scalars['String']>;
  advance_pending_i_cont?: InputMaybe<Scalars['String']>;
  advance_pending_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_in?: InputMaybe<Scalars['String']>;
  advance_pending_in_all?: InputMaybe<Scalars['String']>;
  advance_pending_in_any?: InputMaybe<Scalars['String']>;
  advance_pending_lt?: InputMaybe<Scalars['String']>;
  advance_pending_lt_all?: InputMaybe<Scalars['String']>;
  advance_pending_lt_any?: InputMaybe<Scalars['String']>;
  advance_pending_lteq?: InputMaybe<Scalars['String']>;
  advance_pending_lteq_all?: InputMaybe<Scalars['String']>;
  advance_pending_lteq_any?: InputMaybe<Scalars['String']>;
  advance_pending_matches?: InputMaybe<Scalars['String']>;
  advance_pending_matches_all?: InputMaybe<Scalars['String']>;
  advance_pending_matches_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_cont?: InputMaybe<Scalars['String']>;
  advance_pending_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_end?: InputMaybe<Scalars['String']>;
  advance_pending_not_end_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_end_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_eq?: InputMaybe<Scalars['String']>;
  advance_pending_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_false?: InputMaybe<Scalars['String']>;
  advance_pending_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_pending_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_in?: InputMaybe<Scalars['String']>;
  advance_pending_not_in_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_in_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_null?: InputMaybe<Scalars['String']>;
  advance_pending_not_start?: InputMaybe<Scalars['String']>;
  advance_pending_not_start_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_start_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_true?: InputMaybe<Scalars['String']>;
  advance_pending_null?: InputMaybe<Scalars['String']>;
  advance_pending_present?: InputMaybe<Scalars['String']>;
  advance_pending_start?: InputMaybe<Scalars['String']>;
  advance_pending_start_all?: InputMaybe<Scalars['String']>;
  advance_pending_start_any?: InputMaybe<Scalars['String']>;
  advance_pending_true?: InputMaybe<Scalars['String']>;
  banner_data_blank?: InputMaybe<Scalars['String']>;
  banner_data_cont?: InputMaybe<Scalars['String']>;
  banner_data_cont_all?: InputMaybe<Scalars['String']>;
  banner_data_cont_any?: InputMaybe<Scalars['String']>;
  banner_data_does_not_match?: InputMaybe<Scalars['String']>;
  banner_data_does_not_match_all?: InputMaybe<Scalars['String']>;
  banner_data_does_not_match_any?: InputMaybe<Scalars['String']>;
  banner_data_end?: InputMaybe<Scalars['String']>;
  banner_data_end_all?: InputMaybe<Scalars['String']>;
  banner_data_end_any?: InputMaybe<Scalars['String']>;
  banner_data_eq?: InputMaybe<Scalars['String']>;
  banner_data_eq_all?: InputMaybe<Scalars['String']>;
  banner_data_eq_any?: InputMaybe<Scalars['String']>;
  banner_data_false?: InputMaybe<Scalars['String']>;
  banner_data_gt?: InputMaybe<Scalars['String']>;
  banner_data_gt_all?: InputMaybe<Scalars['String']>;
  banner_data_gt_any?: InputMaybe<Scalars['String']>;
  banner_data_gteq?: InputMaybe<Scalars['String']>;
  banner_data_gteq_all?: InputMaybe<Scalars['String']>;
  banner_data_gteq_any?: InputMaybe<Scalars['String']>;
  banner_data_i_cont?: InputMaybe<Scalars['String']>;
  banner_data_i_cont_all?: InputMaybe<Scalars['String']>;
  banner_data_i_cont_any?: InputMaybe<Scalars['String']>;
  banner_data_in?: InputMaybe<Scalars['String']>;
  banner_data_in_all?: InputMaybe<Scalars['String']>;
  banner_data_in_any?: InputMaybe<Scalars['String']>;
  banner_data_lt?: InputMaybe<Scalars['String']>;
  banner_data_lt_all?: InputMaybe<Scalars['String']>;
  banner_data_lt_any?: InputMaybe<Scalars['String']>;
  banner_data_lteq?: InputMaybe<Scalars['String']>;
  banner_data_lteq_all?: InputMaybe<Scalars['String']>;
  banner_data_lteq_any?: InputMaybe<Scalars['String']>;
  banner_data_matches?: InputMaybe<Scalars['String']>;
  banner_data_matches_all?: InputMaybe<Scalars['String']>;
  banner_data_matches_any?: InputMaybe<Scalars['String']>;
  banner_data_not_cont?: InputMaybe<Scalars['String']>;
  banner_data_not_cont_all?: InputMaybe<Scalars['String']>;
  banner_data_not_cont_any?: InputMaybe<Scalars['String']>;
  banner_data_not_end?: InputMaybe<Scalars['String']>;
  banner_data_not_end_all?: InputMaybe<Scalars['String']>;
  banner_data_not_end_any?: InputMaybe<Scalars['String']>;
  banner_data_not_eq?: InputMaybe<Scalars['String']>;
  banner_data_not_eq_all?: InputMaybe<Scalars['String']>;
  banner_data_not_eq_any?: InputMaybe<Scalars['String']>;
  banner_data_not_false?: InputMaybe<Scalars['String']>;
  banner_data_not_i_cont?: InputMaybe<Scalars['String']>;
  banner_data_not_i_cont_all?: InputMaybe<Scalars['String']>;
  banner_data_not_i_cont_any?: InputMaybe<Scalars['String']>;
  banner_data_not_in?: InputMaybe<Scalars['String']>;
  banner_data_not_in_all?: InputMaybe<Scalars['String']>;
  banner_data_not_in_any?: InputMaybe<Scalars['String']>;
  banner_data_not_null?: InputMaybe<Scalars['String']>;
  banner_data_not_start?: InputMaybe<Scalars['String']>;
  banner_data_not_start_all?: InputMaybe<Scalars['String']>;
  banner_data_not_start_any?: InputMaybe<Scalars['String']>;
  banner_data_not_true?: InputMaybe<Scalars['String']>;
  banner_data_null?: InputMaybe<Scalars['String']>;
  banner_data_present?: InputMaybe<Scalars['String']>;
  banner_data_start?: InputMaybe<Scalars['String']>;
  banner_data_start_all?: InputMaybe<Scalars['String']>;
  banner_data_start_any?: InputMaybe<Scalars['String']>;
  banner_data_true?: InputMaybe<Scalars['String']>;
  can_generate_certificate_blank?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_cont?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_does_not_match?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_end?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_end_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_end_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_eq?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_eq_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_eq_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_false?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gt?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gt_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gt_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gteq?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gteq_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gteq_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_i_cont?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_in?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_lt?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lt_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lt_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lteq?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lteq_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lteq_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_matches?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_matches_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_matches_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_cont?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_end?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_end_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_end_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_eq?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_false?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_not_null?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_start?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_start_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_start_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_true?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_null?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_present?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_start?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_start_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_start_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_true?: InputMaybe<Scalars['Boolean']>;
  can_restart_blank?: InputMaybe<Scalars['Boolean']>;
  can_restart_cont?: InputMaybe<Scalars['Boolean']>;
  can_restart_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_does_not_match?: InputMaybe<Scalars['Boolean']>;
  can_restart_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_end?: InputMaybe<Scalars['Boolean']>;
  can_restart_end_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_end_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_eq?: InputMaybe<Scalars['Boolean']>;
  can_restart_eq_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_eq_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_false?: InputMaybe<Scalars['Boolean']>;
  can_restart_gt?: InputMaybe<Scalars['Boolean']>;
  can_restart_gt_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_gt_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_gteq?: InputMaybe<Scalars['Boolean']>;
  can_restart_gteq_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_gteq_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_i_cont?: InputMaybe<Scalars['Boolean']>;
  can_restart_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_in?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_lt?: InputMaybe<Scalars['Boolean']>;
  can_restart_lt_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_lt_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_lteq?: InputMaybe<Scalars['Boolean']>;
  can_restart_lteq_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_lteq_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_matches?: InputMaybe<Scalars['Boolean']>;
  can_restart_matches_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_matches_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_cont?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_end?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_end_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_end_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_eq?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_false?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_not_null?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_start?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_start_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_start_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_true?: InputMaybe<Scalars['Boolean']>;
  can_restart_null?: InputMaybe<Scalars['Boolean']>;
  can_restart_present?: InputMaybe<Scalars['Boolean']>;
  can_restart_start?: InputMaybe<Scalars['Boolean']>;
  can_restart_start_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_start_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_true?: InputMaybe<Scalars['Boolean']>;
  capacity_blank?: InputMaybe<Scalars['Int']>;
  capacity_cont?: InputMaybe<Scalars['Int']>;
  capacity_cont_all?: InputMaybe<Scalars['Int']>;
  capacity_cont_any?: InputMaybe<Scalars['Int']>;
  capacity_does_not_match?: InputMaybe<Scalars['Int']>;
  capacity_does_not_match_all?: InputMaybe<Scalars['Int']>;
  capacity_does_not_match_any?: InputMaybe<Scalars['Int']>;
  capacity_end?: InputMaybe<Scalars['Int']>;
  capacity_end_all?: InputMaybe<Scalars['Int']>;
  capacity_end_any?: InputMaybe<Scalars['Int']>;
  capacity_eq?: InputMaybe<Scalars['Int']>;
  capacity_eq_all?: InputMaybe<Scalars['Int']>;
  capacity_eq_any?: InputMaybe<Scalars['Int']>;
  capacity_false?: InputMaybe<Scalars['Int']>;
  capacity_gt?: InputMaybe<Scalars['Int']>;
  capacity_gt_all?: InputMaybe<Scalars['Int']>;
  capacity_gt_any?: InputMaybe<Scalars['Int']>;
  capacity_gteq?: InputMaybe<Scalars['Int']>;
  capacity_gteq_all?: InputMaybe<Scalars['Int']>;
  capacity_gteq_any?: InputMaybe<Scalars['Int']>;
  capacity_i_cont?: InputMaybe<Scalars['Int']>;
  capacity_i_cont_all?: InputMaybe<Scalars['Int']>;
  capacity_i_cont_any?: InputMaybe<Scalars['Int']>;
  capacity_in?: InputMaybe<Array<Scalars['Int']>>;
  capacity_in_all?: InputMaybe<Array<Scalars['Int']>>;
  capacity_in_any?: InputMaybe<Array<Scalars['Int']>>;
  capacity_lt?: InputMaybe<Scalars['Int']>;
  capacity_lt_all?: InputMaybe<Scalars['Int']>;
  capacity_lt_any?: InputMaybe<Scalars['Int']>;
  capacity_lteq?: InputMaybe<Scalars['Int']>;
  capacity_lteq_all?: InputMaybe<Scalars['Int']>;
  capacity_lteq_any?: InputMaybe<Scalars['Int']>;
  capacity_matches?: InputMaybe<Scalars['Int']>;
  capacity_matches_all?: InputMaybe<Scalars['Int']>;
  capacity_matches_any?: InputMaybe<Scalars['Int']>;
  capacity_not_cont?: InputMaybe<Scalars['Int']>;
  capacity_not_cont_all?: InputMaybe<Scalars['Int']>;
  capacity_not_cont_any?: InputMaybe<Scalars['Int']>;
  capacity_not_end?: InputMaybe<Scalars['Int']>;
  capacity_not_end_all?: InputMaybe<Scalars['Int']>;
  capacity_not_end_any?: InputMaybe<Scalars['Int']>;
  capacity_not_eq?: InputMaybe<Scalars['Int']>;
  capacity_not_eq_all?: InputMaybe<Scalars['Int']>;
  capacity_not_eq_any?: InputMaybe<Scalars['Int']>;
  capacity_not_false?: InputMaybe<Scalars['Int']>;
  capacity_not_i_cont?: InputMaybe<Scalars['Int']>;
  capacity_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  capacity_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  capacity_not_in?: InputMaybe<Array<Scalars['Int']>>;
  capacity_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  capacity_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  capacity_not_null?: InputMaybe<Scalars['Int']>;
  capacity_not_start?: InputMaybe<Scalars['Int']>;
  capacity_not_start_all?: InputMaybe<Scalars['Int']>;
  capacity_not_start_any?: InputMaybe<Scalars['Int']>;
  capacity_not_true?: InputMaybe<Scalars['Int']>;
  capacity_null?: InputMaybe<Scalars['Int']>;
  capacity_present?: InputMaybe<Scalars['Int']>;
  capacity_start?: InputMaybe<Scalars['Int']>;
  capacity_start_all?: InputMaybe<Scalars['Int']>;
  capacity_start_any?: InputMaybe<Scalars['Int']>;
  capacity_true?: InputMaybe<Scalars['Int']>;
  course_type_blank?: InputMaybe<Scalars['Int']>;
  course_type_cont?: InputMaybe<Scalars['Int']>;
  course_type_cont_all?: InputMaybe<Scalars['Int']>;
  course_type_cont_any?: InputMaybe<Scalars['Int']>;
  course_type_does_not_match?: InputMaybe<Scalars['Int']>;
  course_type_does_not_match_all?: InputMaybe<Scalars['Int']>;
  course_type_does_not_match_any?: InputMaybe<Scalars['Int']>;
  course_type_end?: InputMaybe<Scalars['Int']>;
  course_type_end_all?: InputMaybe<Scalars['Int']>;
  course_type_end_any?: InputMaybe<Scalars['Int']>;
  course_type_eq?: InputMaybe<Scalars['Int']>;
  course_type_eq_all?: InputMaybe<Scalars['Int']>;
  course_type_eq_any?: InputMaybe<Scalars['Int']>;
  course_type_false?: InputMaybe<Scalars['Int']>;
  course_type_gt?: InputMaybe<Scalars['Int']>;
  course_type_gt_all?: InputMaybe<Scalars['Int']>;
  course_type_gt_any?: InputMaybe<Scalars['Int']>;
  course_type_gteq?: InputMaybe<Scalars['Int']>;
  course_type_gteq_all?: InputMaybe<Scalars['Int']>;
  course_type_gteq_any?: InputMaybe<Scalars['Int']>;
  course_type_i_cont?: InputMaybe<Scalars['Int']>;
  course_type_i_cont_all?: InputMaybe<Scalars['Int']>;
  course_type_i_cont_any?: InputMaybe<Scalars['Int']>;
  course_type_in?: InputMaybe<Array<Scalars['Int']>>;
  course_type_in_all?: InputMaybe<Array<Scalars['Int']>>;
  course_type_in_any?: InputMaybe<Array<Scalars['Int']>>;
  course_type_lt?: InputMaybe<Scalars['Int']>;
  course_type_lt_all?: InputMaybe<Scalars['Int']>;
  course_type_lt_any?: InputMaybe<Scalars['Int']>;
  course_type_lteq?: InputMaybe<Scalars['Int']>;
  course_type_lteq_all?: InputMaybe<Scalars['Int']>;
  course_type_lteq_any?: InputMaybe<Scalars['Int']>;
  course_type_matches?: InputMaybe<Scalars['Int']>;
  course_type_matches_all?: InputMaybe<Scalars['Int']>;
  course_type_matches_any?: InputMaybe<Scalars['Int']>;
  course_type_not_cont?: InputMaybe<Scalars['Int']>;
  course_type_not_cont_all?: InputMaybe<Scalars['Int']>;
  course_type_not_cont_any?: InputMaybe<Scalars['Int']>;
  course_type_not_end?: InputMaybe<Scalars['Int']>;
  course_type_not_end_all?: InputMaybe<Scalars['Int']>;
  course_type_not_end_any?: InputMaybe<Scalars['Int']>;
  course_type_not_eq?: InputMaybe<Scalars['Int']>;
  course_type_not_eq_all?: InputMaybe<Scalars['Int']>;
  course_type_not_eq_any?: InputMaybe<Scalars['Int']>;
  course_type_not_false?: InputMaybe<Scalars['Int']>;
  course_type_not_i_cont?: InputMaybe<Scalars['Int']>;
  course_type_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  course_type_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  course_type_not_in?: InputMaybe<Array<Scalars['Int']>>;
  course_type_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  course_type_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  course_type_not_null?: InputMaybe<Scalars['Int']>;
  course_type_not_start?: InputMaybe<Scalars['Int']>;
  course_type_not_start_all?: InputMaybe<Scalars['Int']>;
  course_type_not_start_any?: InputMaybe<Scalars['Int']>;
  course_type_not_true?: InputMaybe<Scalars['Int']>;
  course_type_null?: InputMaybe<Scalars['Int']>;
  course_type_present?: InputMaybe<Scalars['Int']>;
  course_type_start?: InputMaybe<Scalars['Int']>;
  course_type_start_all?: InputMaybe<Scalars['Int']>;
  course_type_start_any?: InputMaybe<Scalars['Int']>;
  course_type_true?: InputMaybe<Scalars['Int']>;
  created_at_blank?: InputMaybe<Scalars['String']>;
  created_at_cont?: InputMaybe<Scalars['String']>;
  created_at_cont_all?: InputMaybe<Scalars['String']>;
  created_at_cont_any?: InputMaybe<Scalars['String']>;
  created_at_does_not_match?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  created_at_end?: InputMaybe<Scalars['String']>;
  created_at_end_all?: InputMaybe<Scalars['String']>;
  created_at_end_any?: InputMaybe<Scalars['String']>;
  created_at_eq?: InputMaybe<Scalars['String']>;
  created_at_eq_all?: InputMaybe<Scalars['String']>;
  created_at_eq_any?: InputMaybe<Scalars['String']>;
  created_at_false?: InputMaybe<Scalars['String']>;
  created_at_formatted_blank?: InputMaybe<Scalars['String']>;
  created_at_formatted_cont?: InputMaybe<Scalars['String']>;
  created_at_formatted_cont_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_cont_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_does_not_match?: InputMaybe<Scalars['String']>;
  created_at_formatted_does_not_match_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_does_not_match_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_end?: InputMaybe<Scalars['String']>;
  created_at_formatted_end_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_end_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_eq?: InputMaybe<Scalars['String']>;
  created_at_formatted_eq_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_eq_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_false?: InputMaybe<Scalars['String']>;
  created_at_formatted_gt?: InputMaybe<Scalars['String']>;
  created_at_formatted_gt_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_gt_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_gteq?: InputMaybe<Scalars['String']>;
  created_at_formatted_gteq_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_gteq_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_i_cont?: InputMaybe<Scalars['String']>;
  created_at_formatted_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_in?: InputMaybe<Scalars['String']>;
  created_at_formatted_in_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_in_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_lt?: InputMaybe<Scalars['String']>;
  created_at_formatted_lt_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_lt_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_lteq?: InputMaybe<Scalars['String']>;
  created_at_formatted_lteq_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_lteq_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_matches?: InputMaybe<Scalars['String']>;
  created_at_formatted_matches_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_matches_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_cont?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_cont_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_cont_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_end?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_end_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_end_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_eq?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_eq_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_eq_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_false?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_i_cont?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_in?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_in_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_in_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_null?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_start?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_start_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_start_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_not_true?: InputMaybe<Scalars['String']>;
  created_at_formatted_null?: InputMaybe<Scalars['String']>;
  created_at_formatted_present?: InputMaybe<Scalars['String']>;
  created_at_formatted_start?: InputMaybe<Scalars['String']>;
  created_at_formatted_start_all?: InputMaybe<Scalars['String']>;
  created_at_formatted_start_any?: InputMaybe<Scalars['String']>;
  created_at_formatted_true?: InputMaybe<Scalars['String']>;
  created_at_gt?: InputMaybe<Scalars['String']>;
  created_at_gt_all?: InputMaybe<Scalars['String']>;
  created_at_gt_any?: InputMaybe<Scalars['String']>;
  created_at_gteq?: InputMaybe<Scalars['String']>;
  created_at_gteq_all?: InputMaybe<Scalars['String']>;
  created_at_gteq_any?: InputMaybe<Scalars['String']>;
  created_at_i_cont?: InputMaybe<Scalars['String']>;
  created_at_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_in?: InputMaybe<Scalars['String']>;
  created_at_in_all?: InputMaybe<Scalars['String']>;
  created_at_in_any?: InputMaybe<Scalars['String']>;
  created_at_lt?: InputMaybe<Scalars['String']>;
  created_at_lt_all?: InputMaybe<Scalars['String']>;
  created_at_lt_any?: InputMaybe<Scalars['String']>;
  created_at_lteq?: InputMaybe<Scalars['String']>;
  created_at_lteq_all?: InputMaybe<Scalars['String']>;
  created_at_lteq_any?: InputMaybe<Scalars['String']>;
  created_at_matches?: InputMaybe<Scalars['String']>;
  created_at_matches_all?: InputMaybe<Scalars['String']>;
  created_at_matches_any?: InputMaybe<Scalars['String']>;
  created_at_not_cont?: InputMaybe<Scalars['String']>;
  created_at_not_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_end?: InputMaybe<Scalars['String']>;
  created_at_not_end_all?: InputMaybe<Scalars['String']>;
  created_at_not_end_any?: InputMaybe<Scalars['String']>;
  created_at_not_eq?: InputMaybe<Scalars['String']>;
  created_at_not_eq_all?: InputMaybe<Scalars['String']>;
  created_at_not_eq_any?: InputMaybe<Scalars['String']>;
  created_at_not_false?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_in?: InputMaybe<Scalars['String']>;
  created_at_not_in_all?: InputMaybe<Scalars['String']>;
  created_at_not_in_any?: InputMaybe<Scalars['String']>;
  created_at_not_null?: InputMaybe<Scalars['String']>;
  created_at_not_start?: InputMaybe<Scalars['String']>;
  created_at_not_start_all?: InputMaybe<Scalars['String']>;
  created_at_not_start_any?: InputMaybe<Scalars['String']>;
  created_at_not_true?: InputMaybe<Scalars['String']>;
  created_at_null?: InputMaybe<Scalars['String']>;
  created_at_present?: InputMaybe<Scalars['String']>;
  created_at_start?: InputMaybe<Scalars['String']>;
  created_at_start_all?: InputMaybe<Scalars['String']>;
  created_at_start_any?: InputMaybe<Scalars['String']>;
  created_at_true?: InputMaybe<Scalars['String']>;
  deleted_at_blank?: InputMaybe<Scalars['String']>;
  deleted_at_cont?: InputMaybe<Scalars['String']>;
  deleted_at_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  deleted_at_end?: InputMaybe<Scalars['String']>;
  deleted_at_end_all?: InputMaybe<Scalars['String']>;
  deleted_at_end_any?: InputMaybe<Scalars['String']>;
  deleted_at_eq?: InputMaybe<Scalars['String']>;
  deleted_at_eq_all?: InputMaybe<Scalars['String']>;
  deleted_at_eq_any?: InputMaybe<Scalars['String']>;
  deleted_at_false?: InputMaybe<Scalars['String']>;
  deleted_at_gt?: InputMaybe<Scalars['String']>;
  deleted_at_gt_all?: InputMaybe<Scalars['String']>;
  deleted_at_gt_any?: InputMaybe<Scalars['String']>;
  deleted_at_gteq?: InputMaybe<Scalars['String']>;
  deleted_at_gteq_all?: InputMaybe<Scalars['String']>;
  deleted_at_gteq_any?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_in?: InputMaybe<Scalars['String']>;
  deleted_at_in_all?: InputMaybe<Scalars['String']>;
  deleted_at_in_any?: InputMaybe<Scalars['String']>;
  deleted_at_lt?: InputMaybe<Scalars['String']>;
  deleted_at_lt_all?: InputMaybe<Scalars['String']>;
  deleted_at_lt_any?: InputMaybe<Scalars['String']>;
  deleted_at_lteq?: InputMaybe<Scalars['String']>;
  deleted_at_lteq_all?: InputMaybe<Scalars['String']>;
  deleted_at_lteq_any?: InputMaybe<Scalars['String']>;
  deleted_at_matches?: InputMaybe<Scalars['String']>;
  deleted_at_matches_all?: InputMaybe<Scalars['String']>;
  deleted_at_matches_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_end?: InputMaybe<Scalars['String']>;
  deleted_at_not_end_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_end_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_false?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_in?: InputMaybe<Scalars['String']>;
  deleted_at_not_in_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_in_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_null?: InputMaybe<Scalars['String']>;
  deleted_at_not_start?: InputMaybe<Scalars['String']>;
  deleted_at_not_start_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_start_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_true?: InputMaybe<Scalars['String']>;
  deleted_at_null?: InputMaybe<Scalars['String']>;
  deleted_at_present?: InputMaybe<Scalars['String']>;
  deleted_at_start?: InputMaybe<Scalars['String']>;
  deleted_at_start_all?: InputMaybe<Scalars['String']>;
  deleted_at_start_any?: InputMaybe<Scalars['String']>;
  deleted_at_true?: InputMaybe<Scalars['String']>;
  description_blank?: InputMaybe<Scalars['String']>;
  description_cont?: InputMaybe<Scalars['String']>;
  description_cont_all?: InputMaybe<Scalars['String']>;
  description_cont_any?: InputMaybe<Scalars['String']>;
  description_does_not_match?: InputMaybe<Scalars['String']>;
  description_does_not_match_all?: InputMaybe<Scalars['String']>;
  description_does_not_match_any?: InputMaybe<Scalars['String']>;
  description_end?: InputMaybe<Scalars['String']>;
  description_end_all?: InputMaybe<Scalars['String']>;
  description_end_any?: InputMaybe<Scalars['String']>;
  description_eq?: InputMaybe<Scalars['String']>;
  description_eq_all?: InputMaybe<Scalars['String']>;
  description_eq_any?: InputMaybe<Scalars['String']>;
  description_false?: InputMaybe<Scalars['String']>;
  description_gt?: InputMaybe<Scalars['String']>;
  description_gt_all?: InputMaybe<Scalars['String']>;
  description_gt_any?: InputMaybe<Scalars['String']>;
  description_gteq?: InputMaybe<Scalars['String']>;
  description_gteq_all?: InputMaybe<Scalars['String']>;
  description_gteq_any?: InputMaybe<Scalars['String']>;
  description_i_cont?: InputMaybe<Scalars['String']>;
  description_i_cont_all?: InputMaybe<Scalars['String']>;
  description_i_cont_any?: InputMaybe<Scalars['String']>;
  description_in?: InputMaybe<Scalars['String']>;
  description_in_all?: InputMaybe<Scalars['String']>;
  description_in_any?: InputMaybe<Scalars['String']>;
  description_lt?: InputMaybe<Scalars['String']>;
  description_lt_all?: InputMaybe<Scalars['String']>;
  description_lt_any?: InputMaybe<Scalars['String']>;
  description_lteq?: InputMaybe<Scalars['String']>;
  description_lteq_all?: InputMaybe<Scalars['String']>;
  description_lteq_any?: InputMaybe<Scalars['String']>;
  description_matches?: InputMaybe<Scalars['String']>;
  description_matches_all?: InputMaybe<Scalars['String']>;
  description_matches_any?: InputMaybe<Scalars['String']>;
  description_not_cont?: InputMaybe<Scalars['String']>;
  description_not_cont_all?: InputMaybe<Scalars['String']>;
  description_not_cont_any?: InputMaybe<Scalars['String']>;
  description_not_end?: InputMaybe<Scalars['String']>;
  description_not_end_all?: InputMaybe<Scalars['String']>;
  description_not_end_any?: InputMaybe<Scalars['String']>;
  description_not_eq?: InputMaybe<Scalars['String']>;
  description_not_eq_all?: InputMaybe<Scalars['String']>;
  description_not_eq_any?: InputMaybe<Scalars['String']>;
  description_not_false?: InputMaybe<Scalars['String']>;
  description_not_i_cont?: InputMaybe<Scalars['String']>;
  description_not_i_cont_all?: InputMaybe<Scalars['String']>;
  description_not_i_cont_any?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Scalars['String']>;
  description_not_in_all?: InputMaybe<Scalars['String']>;
  description_not_in_any?: InputMaybe<Scalars['String']>;
  description_not_null?: InputMaybe<Scalars['String']>;
  description_not_start?: InputMaybe<Scalars['String']>;
  description_not_start_all?: InputMaybe<Scalars['String']>;
  description_not_start_any?: InputMaybe<Scalars['String']>;
  description_not_true?: InputMaybe<Scalars['String']>;
  description_null?: InputMaybe<Scalars['String']>;
  description_present?: InputMaybe<Scalars['String']>;
  description_start?: InputMaybe<Scalars['String']>;
  description_start_all?: InputMaybe<Scalars['String']>;
  description_start_any?: InputMaybe<Scalars['String']>;
  description_true?: InputMaybe<Scalars['String']>;
  direct_chief_approval_blank?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_cont?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_cont_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_cont_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_does_not_match?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_end?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_end_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_end_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_eq?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_eq_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_eq_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_false?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gt?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gt_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gt_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gteq?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gteq_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gteq_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_i_cont?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_in?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_lt?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lt_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lt_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lteq?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lteq_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lteq_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_matches?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_matches_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_matches_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_cont?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_end?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_end_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_end_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_eq?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_false?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_not_null?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_start?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_start_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_start_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_true?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_null?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_present?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_start?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_start_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_start_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_true?: InputMaybe<Scalars['Boolean']>;
  g?: InputMaybe<Array<Scalars['JSON']>>;
  hours_blank?: InputMaybe<Scalars['Float']>;
  hours_cont?: InputMaybe<Scalars['Float']>;
  hours_cont_all?: InputMaybe<Scalars['Float']>;
  hours_cont_any?: InputMaybe<Scalars['Float']>;
  hours_does_not_match?: InputMaybe<Scalars['Float']>;
  hours_does_not_match_all?: InputMaybe<Scalars['Float']>;
  hours_does_not_match_any?: InputMaybe<Scalars['Float']>;
  hours_end?: InputMaybe<Scalars['Float']>;
  hours_end_all?: InputMaybe<Scalars['Float']>;
  hours_end_any?: InputMaybe<Scalars['Float']>;
  hours_eq?: InputMaybe<Scalars['Float']>;
  hours_eq_all?: InputMaybe<Scalars['Float']>;
  hours_eq_any?: InputMaybe<Scalars['Float']>;
  hours_false?: InputMaybe<Scalars['Float']>;
  hours_gt?: InputMaybe<Scalars['Float']>;
  hours_gt_all?: InputMaybe<Scalars['Float']>;
  hours_gt_any?: InputMaybe<Scalars['Float']>;
  hours_gteq?: InputMaybe<Scalars['Float']>;
  hours_gteq_all?: InputMaybe<Scalars['Float']>;
  hours_gteq_any?: InputMaybe<Scalars['Float']>;
  hours_i_cont?: InputMaybe<Scalars['Float']>;
  hours_i_cont_all?: InputMaybe<Scalars['Float']>;
  hours_i_cont_any?: InputMaybe<Scalars['Float']>;
  hours_in?: InputMaybe<Array<Scalars['Float']>>;
  hours_in_all?: InputMaybe<Array<Scalars['Float']>>;
  hours_in_any?: InputMaybe<Array<Scalars['Float']>>;
  hours_lt?: InputMaybe<Scalars['Float']>;
  hours_lt_all?: InputMaybe<Scalars['Float']>;
  hours_lt_any?: InputMaybe<Scalars['Float']>;
  hours_lteq?: InputMaybe<Scalars['Float']>;
  hours_lteq_all?: InputMaybe<Scalars['Float']>;
  hours_lteq_any?: InputMaybe<Scalars['Float']>;
  hours_matches?: InputMaybe<Scalars['Float']>;
  hours_matches_all?: InputMaybe<Scalars['Float']>;
  hours_matches_any?: InputMaybe<Scalars['Float']>;
  hours_not_cont?: InputMaybe<Scalars['Float']>;
  hours_not_cont_all?: InputMaybe<Scalars['Float']>;
  hours_not_cont_any?: InputMaybe<Scalars['Float']>;
  hours_not_end?: InputMaybe<Scalars['Float']>;
  hours_not_end_all?: InputMaybe<Scalars['Float']>;
  hours_not_end_any?: InputMaybe<Scalars['Float']>;
  hours_not_eq?: InputMaybe<Scalars['Float']>;
  hours_not_eq_all?: InputMaybe<Scalars['Float']>;
  hours_not_eq_any?: InputMaybe<Scalars['Float']>;
  hours_not_false?: InputMaybe<Scalars['Float']>;
  hours_not_i_cont?: InputMaybe<Scalars['Float']>;
  hours_not_i_cont_all?: InputMaybe<Scalars['Float']>;
  hours_not_i_cont_any?: InputMaybe<Scalars['Float']>;
  hours_not_in?: InputMaybe<Array<Scalars['Float']>>;
  hours_not_in_all?: InputMaybe<Array<Scalars['Float']>>;
  hours_not_in_any?: InputMaybe<Array<Scalars['Float']>>;
  hours_not_null?: InputMaybe<Scalars['Float']>;
  hours_not_start?: InputMaybe<Scalars['Float']>;
  hours_not_start_all?: InputMaybe<Scalars['Float']>;
  hours_not_start_any?: InputMaybe<Scalars['Float']>;
  hours_not_true?: InputMaybe<Scalars['Float']>;
  hours_null?: InputMaybe<Scalars['Float']>;
  hours_present?: InputMaybe<Scalars['Float']>;
  hours_start?: InputMaybe<Scalars['Float']>;
  hours_start_all?: InputMaybe<Scalars['Float']>;
  hours_start_any?: InputMaybe<Scalars['Float']>;
  hours_true?: InputMaybe<Scalars['Float']>;
  id_blank?: InputMaybe<Scalars['Int']>;
  id_cont?: InputMaybe<Scalars['Int']>;
  id_cont_all?: InputMaybe<Scalars['Int']>;
  id_cont_any?: InputMaybe<Scalars['Int']>;
  id_does_not_match?: InputMaybe<Scalars['Int']>;
  id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  id_end?: InputMaybe<Scalars['Int']>;
  id_end_all?: InputMaybe<Scalars['Int']>;
  id_end_any?: InputMaybe<Scalars['Int']>;
  id_eq?: InputMaybe<Scalars['Int']>;
  id_eq_all?: InputMaybe<Scalars['Int']>;
  id_eq_any?: InputMaybe<Scalars['Int']>;
  id_false?: InputMaybe<Scalars['Int']>;
  id_gt?: InputMaybe<Scalars['Int']>;
  id_gt_all?: InputMaybe<Scalars['Int']>;
  id_gt_any?: InputMaybe<Scalars['Int']>;
  id_gteq?: InputMaybe<Scalars['Int']>;
  id_gteq_all?: InputMaybe<Scalars['Int']>;
  id_gteq_any?: InputMaybe<Scalars['Int']>;
  id_i_cont?: InputMaybe<Scalars['Int']>;
  id_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_in?: InputMaybe<Array<Scalars['Int']>>;
  id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_lt?: InputMaybe<Scalars['Int']>;
  id_lt_all?: InputMaybe<Scalars['Int']>;
  id_lt_any?: InputMaybe<Scalars['Int']>;
  id_lteq?: InputMaybe<Scalars['Int']>;
  id_lteq_all?: InputMaybe<Scalars['Int']>;
  id_lteq_any?: InputMaybe<Scalars['Int']>;
  id_matches?: InputMaybe<Scalars['Int']>;
  id_matches_all?: InputMaybe<Scalars['Int']>;
  id_matches_any?: InputMaybe<Scalars['Int']>;
  id_not_cont?: InputMaybe<Scalars['Int']>;
  id_not_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_end?: InputMaybe<Scalars['Int']>;
  id_not_end_all?: InputMaybe<Scalars['Int']>;
  id_not_end_any?: InputMaybe<Scalars['Int']>;
  id_not_eq?: InputMaybe<Scalars['Int']>;
  id_not_eq_all?: InputMaybe<Scalars['Int']>;
  id_not_eq_any?: InputMaybe<Scalars['Int']>;
  id_not_false?: InputMaybe<Scalars['Int']>;
  id_not_i_cont?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_not_null?: InputMaybe<Scalars['Int']>;
  id_not_start?: InputMaybe<Scalars['Int']>;
  id_not_start_all?: InputMaybe<Scalars['Int']>;
  id_not_start_any?: InputMaybe<Scalars['Int']>;
  id_not_true?: InputMaybe<Scalars['Int']>;
  id_null?: InputMaybe<Scalars['Int']>;
  id_present?: InputMaybe<Scalars['Int']>;
  id_start?: InputMaybe<Scalars['Int']>;
  id_start_all?: InputMaybe<Scalars['Int']>;
  id_start_any?: InputMaybe<Scalars['Int']>;
  id_true?: InputMaybe<Scalars['Int']>;
  integration_course_id_blank?: InputMaybe<Scalars['Int']>;
  integration_course_id_cont?: InputMaybe<Scalars['Int']>;
  integration_course_id_cont_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_cont_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_does_not_match?: InputMaybe<Scalars['Int']>;
  integration_course_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_end?: InputMaybe<Scalars['Int']>;
  integration_course_id_end_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_end_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_eq?: InputMaybe<Scalars['Int']>;
  integration_course_id_eq_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_eq_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_false?: InputMaybe<Scalars['Int']>;
  integration_course_id_gt?: InputMaybe<Scalars['Int']>;
  integration_course_id_gt_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_gt_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_gteq?: InputMaybe<Scalars['Int']>;
  integration_course_id_gteq_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_gteq_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_i_cont?: InputMaybe<Scalars['Int']>;
  integration_course_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_in?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_lt?: InputMaybe<Scalars['Int']>;
  integration_course_id_lt_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_lt_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_lteq?: InputMaybe<Scalars['Int']>;
  integration_course_id_lteq_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_lteq_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_matches?: InputMaybe<Scalars['Int']>;
  integration_course_id_matches_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_matches_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_cont?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_end?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_end_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_end_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_eq?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_false?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_not_null?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_start?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_start_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_start_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_true?: InputMaybe<Scalars['Int']>;
  integration_course_id_null?: InputMaybe<Scalars['Int']>;
  integration_course_id_present?: InputMaybe<Scalars['Int']>;
  integration_course_id_start?: InputMaybe<Scalars['Int']>;
  integration_course_id_start_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_start_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_true?: InputMaybe<Scalars['Int']>;
  integration_course_link_blank?: InputMaybe<Scalars['String']>;
  integration_course_link_cont?: InputMaybe<Scalars['String']>;
  integration_course_link_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_link_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_link_does_not_match?: InputMaybe<Scalars['String']>;
  integration_course_link_does_not_match_all?: InputMaybe<Scalars['String']>;
  integration_course_link_does_not_match_any?: InputMaybe<Scalars['String']>;
  integration_course_link_end?: InputMaybe<Scalars['String']>;
  integration_course_link_end_all?: InputMaybe<Scalars['String']>;
  integration_course_link_end_any?: InputMaybe<Scalars['String']>;
  integration_course_link_eq?: InputMaybe<Scalars['String']>;
  integration_course_link_eq_all?: InputMaybe<Scalars['String']>;
  integration_course_link_eq_any?: InputMaybe<Scalars['String']>;
  integration_course_link_false?: InputMaybe<Scalars['String']>;
  integration_course_link_gt?: InputMaybe<Scalars['String']>;
  integration_course_link_gt_all?: InputMaybe<Scalars['String']>;
  integration_course_link_gt_any?: InputMaybe<Scalars['String']>;
  integration_course_link_gteq?: InputMaybe<Scalars['String']>;
  integration_course_link_gteq_all?: InputMaybe<Scalars['String']>;
  integration_course_link_gteq_any?: InputMaybe<Scalars['String']>;
  integration_course_link_i_cont?: InputMaybe<Scalars['String']>;
  integration_course_link_i_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_link_i_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_link_in?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_in_all?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_in_any?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_lt?: InputMaybe<Scalars['String']>;
  integration_course_link_lt_all?: InputMaybe<Scalars['String']>;
  integration_course_link_lt_any?: InputMaybe<Scalars['String']>;
  integration_course_link_lteq?: InputMaybe<Scalars['String']>;
  integration_course_link_lteq_all?: InputMaybe<Scalars['String']>;
  integration_course_link_lteq_any?: InputMaybe<Scalars['String']>;
  integration_course_link_matches?: InputMaybe<Scalars['String']>;
  integration_course_link_matches_all?: InputMaybe<Scalars['String']>;
  integration_course_link_matches_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_cont?: InputMaybe<Scalars['String']>;
  integration_course_link_not_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_end?: InputMaybe<Scalars['String']>;
  integration_course_link_not_end_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_end_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_eq?: InputMaybe<Scalars['String']>;
  integration_course_link_not_eq_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_eq_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_false?: InputMaybe<Scalars['String']>;
  integration_course_link_not_i_cont?: InputMaybe<Scalars['String']>;
  integration_course_link_not_i_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_i_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_in?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_not_null?: InputMaybe<Scalars['String']>;
  integration_course_link_not_start?: InputMaybe<Scalars['String']>;
  integration_course_link_not_start_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_start_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_true?: InputMaybe<Scalars['String']>;
  integration_course_link_null?: InputMaybe<Scalars['String']>;
  integration_course_link_present?: InputMaybe<Scalars['String']>;
  integration_course_link_start?: InputMaybe<Scalars['String']>;
  integration_course_link_start_all?: InputMaybe<Scalars['String']>;
  integration_course_link_start_any?: InputMaybe<Scalars['String']>;
  integration_course_link_true?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_blank?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_cont?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_does_not_match?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_does_not_match_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_does_not_match_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_end?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_end_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_end_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_eq?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_eq_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_eq_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_false?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_gt?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_gt_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_gt_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_gteq?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_gteq_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_gteq_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_i_cont?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_i_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_i_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_in?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_in_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_in_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_lt?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_lt_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_lt_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_lteq?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_lteq_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_lteq_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_matches?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_matches_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_matches_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_cont?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_end?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_end_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_end_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_eq?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_eq_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_eq_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_false?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_i_cont?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_i_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_i_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_in?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_in_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_in_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_null?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_start?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_start_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_start_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_not_true?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_null?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_present?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_start?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_start_all?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_start_any?: InputMaybe<Scalars['String']>;
  integration_course_provider_filter_true?: InputMaybe<Scalars['String']>;
  name_blank?: InputMaybe<Scalars['String']>;
  name_cont?: InputMaybe<Scalars['String']>;
  name_cont_all?: InputMaybe<Scalars['String']>;
  name_cont_any?: InputMaybe<Scalars['String']>;
  name_does_not_match?: InputMaybe<Scalars['String']>;
  name_does_not_match_all?: InputMaybe<Scalars['String']>;
  name_does_not_match_any?: InputMaybe<Scalars['String']>;
  name_end?: InputMaybe<Scalars['String']>;
  name_end_all?: InputMaybe<Scalars['String']>;
  name_end_any?: InputMaybe<Scalars['String']>;
  name_eq?: InputMaybe<Scalars['String']>;
  name_eq_all?: InputMaybe<Scalars['String']>;
  name_eq_any?: InputMaybe<Scalars['String']>;
  name_false?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gt_all?: InputMaybe<Scalars['String']>;
  name_gt_any?: InputMaybe<Scalars['String']>;
  name_gteq?: InputMaybe<Scalars['String']>;
  name_gteq_all?: InputMaybe<Scalars['String']>;
  name_gteq_any?: InputMaybe<Scalars['String']>;
  name_i_cont?: InputMaybe<Scalars['String']>;
  name_i_cont_all?: InputMaybe<Scalars['String']>;
  name_i_cont_any?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lt_all?: InputMaybe<Scalars['String']>;
  name_lt_any?: InputMaybe<Scalars['String']>;
  name_lteq?: InputMaybe<Scalars['String']>;
  name_lteq_all?: InputMaybe<Scalars['String']>;
  name_lteq_any?: InputMaybe<Scalars['String']>;
  name_matches?: InputMaybe<Scalars['String']>;
  name_matches_all?: InputMaybe<Scalars['String']>;
  name_matches_any?: InputMaybe<Scalars['String']>;
  name_not_cont?: InputMaybe<Scalars['String']>;
  name_not_cont_all?: InputMaybe<Scalars['String']>;
  name_not_cont_any?: InputMaybe<Scalars['String']>;
  name_not_end?: InputMaybe<Scalars['String']>;
  name_not_end_all?: InputMaybe<Scalars['String']>;
  name_not_end_any?: InputMaybe<Scalars['String']>;
  name_not_eq?: InputMaybe<Scalars['String']>;
  name_not_eq_all?: InputMaybe<Scalars['String']>;
  name_not_eq_any?: InputMaybe<Scalars['String']>;
  name_not_false?: InputMaybe<Scalars['String']>;
  name_not_i_cont?: InputMaybe<Scalars['String']>;
  name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_not_null?: InputMaybe<Scalars['String']>;
  name_not_start?: InputMaybe<Scalars['String']>;
  name_not_start_all?: InputMaybe<Scalars['String']>;
  name_not_start_any?: InputMaybe<Scalars['String']>;
  name_not_true?: InputMaybe<Scalars['String']>;
  name_null?: InputMaybe<Scalars['String']>;
  name_or_code_cont?: InputMaybe<Scalars['String']>;
  name_present?: InputMaybe<Scalars['String']>;
  name_start?: InputMaybe<Scalars['String']>;
  name_start_all?: InputMaybe<Scalars['String']>;
  name_start_any?: InputMaybe<Scalars['String']>;
  name_true?: InputMaybe<Scalars['String']>;
  on_duplicated_blank?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_cont?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_cont_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_cont_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_does_not_match?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_end?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_end_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_end_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_eq?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_eq_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_eq_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_false?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gt?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gt_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gt_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gteq?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gteq_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gteq_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_i_cont?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_in?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_lt?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lt_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lt_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lteq?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lteq_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lteq_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_matches?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_matches_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_matches_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_cont?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_end?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_end_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_end_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_eq?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_false?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_not_null?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_start?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_start_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_start_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_true?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_null?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_present?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_start?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_start_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_start_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_true?: InputMaybe<Scalars['Boolean']>;
  order_blank?: InputMaybe<Scalars['Int']>;
  order_cont?: InputMaybe<Scalars['Int']>;
  order_cont_all?: InputMaybe<Scalars['Int']>;
  order_cont_any?: InputMaybe<Scalars['Int']>;
  order_does_not_match?: InputMaybe<Scalars['Int']>;
  order_does_not_match_all?: InputMaybe<Scalars['Int']>;
  order_does_not_match_any?: InputMaybe<Scalars['Int']>;
  order_end?: InputMaybe<Scalars['Int']>;
  order_end_all?: InputMaybe<Scalars['Int']>;
  order_end_any?: InputMaybe<Scalars['Int']>;
  order_eq?: InputMaybe<Scalars['Int']>;
  order_eq_all?: InputMaybe<Scalars['Int']>;
  order_eq_any?: InputMaybe<Scalars['Int']>;
  order_false?: InputMaybe<Scalars['Int']>;
  order_gt?: InputMaybe<Scalars['Int']>;
  order_gt_all?: InputMaybe<Scalars['Int']>;
  order_gt_any?: InputMaybe<Scalars['Int']>;
  order_gteq?: InputMaybe<Scalars['Int']>;
  order_gteq_all?: InputMaybe<Scalars['Int']>;
  order_gteq_any?: InputMaybe<Scalars['Int']>;
  order_i_cont?: InputMaybe<Scalars['Int']>;
  order_i_cont_all?: InputMaybe<Scalars['Int']>;
  order_i_cont_any?: InputMaybe<Scalars['Int']>;
  order_in?: InputMaybe<Array<Scalars['Int']>>;
  order_in_all?: InputMaybe<Array<Scalars['Int']>>;
  order_in_any?: InputMaybe<Array<Scalars['Int']>>;
  order_lt?: InputMaybe<Scalars['Int']>;
  order_lt_all?: InputMaybe<Scalars['Int']>;
  order_lt_any?: InputMaybe<Scalars['Int']>;
  order_lteq?: InputMaybe<Scalars['Int']>;
  order_lteq_all?: InputMaybe<Scalars['Int']>;
  order_lteq_any?: InputMaybe<Scalars['Int']>;
  order_matches?: InputMaybe<Scalars['Int']>;
  order_matches_all?: InputMaybe<Scalars['Int']>;
  order_matches_any?: InputMaybe<Scalars['Int']>;
  order_not_cont?: InputMaybe<Scalars['Int']>;
  order_not_cont_all?: InputMaybe<Scalars['Int']>;
  order_not_cont_any?: InputMaybe<Scalars['Int']>;
  order_not_end?: InputMaybe<Scalars['Int']>;
  order_not_end_all?: InputMaybe<Scalars['Int']>;
  order_not_end_any?: InputMaybe<Scalars['Int']>;
  order_not_eq?: InputMaybe<Scalars['Int']>;
  order_not_eq_all?: InputMaybe<Scalars['Int']>;
  order_not_eq_any?: InputMaybe<Scalars['Int']>;
  order_not_false?: InputMaybe<Scalars['Int']>;
  order_not_i_cont?: InputMaybe<Scalars['Int']>;
  order_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  order_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']>>;
  order_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  order_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  order_not_null?: InputMaybe<Scalars['Int']>;
  order_not_start?: InputMaybe<Scalars['Int']>;
  order_not_start_all?: InputMaybe<Scalars['Int']>;
  order_not_start_any?: InputMaybe<Scalars['Int']>;
  order_not_true?: InputMaybe<Scalars['Int']>;
  order_null?: InputMaybe<Scalars['Int']>;
  order_present?: InputMaybe<Scalars['Int']>;
  order_start?: InputMaybe<Scalars['Int']>;
  order_start_all?: InputMaybe<Scalars['Int']>;
  order_start_any?: InputMaybe<Scalars['Int']>;
  order_true?: InputMaybe<Scalars['Int']>;
  published_at_blank?: InputMaybe<Scalars['String']>;
  published_at_cont?: InputMaybe<Scalars['String']>;
  published_at_cont_all?: InputMaybe<Scalars['String']>;
  published_at_cont_any?: InputMaybe<Scalars['String']>;
  published_at_does_not_match?: InputMaybe<Scalars['String']>;
  published_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  published_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  published_at_end?: InputMaybe<Scalars['String']>;
  published_at_end_all?: InputMaybe<Scalars['String']>;
  published_at_end_any?: InputMaybe<Scalars['String']>;
  published_at_eq?: InputMaybe<Scalars['String']>;
  published_at_eq_all?: InputMaybe<Scalars['String']>;
  published_at_eq_any?: InputMaybe<Scalars['String']>;
  published_at_false?: InputMaybe<Scalars['String']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_gt_all?: InputMaybe<Scalars['String']>;
  published_at_gt_any?: InputMaybe<Scalars['String']>;
  published_at_gteq?: InputMaybe<Scalars['String']>;
  published_at_gteq_all?: InputMaybe<Scalars['String']>;
  published_at_gteq_any?: InputMaybe<Scalars['String']>;
  published_at_i_cont?: InputMaybe<Scalars['String']>;
  published_at_i_cont_all?: InputMaybe<Scalars['String']>;
  published_at_i_cont_any?: InputMaybe<Scalars['String']>;
  published_at_in?: InputMaybe<Scalars['String']>;
  published_at_in_all?: InputMaybe<Scalars['String']>;
  published_at_in_any?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  published_at_lt_all?: InputMaybe<Scalars['String']>;
  published_at_lt_any?: InputMaybe<Scalars['String']>;
  published_at_lteq?: InputMaybe<Scalars['String']>;
  published_at_lteq_all?: InputMaybe<Scalars['String']>;
  published_at_lteq_any?: InputMaybe<Scalars['String']>;
  published_at_matches?: InputMaybe<Scalars['String']>;
  published_at_matches_all?: InputMaybe<Scalars['String']>;
  published_at_matches_any?: InputMaybe<Scalars['String']>;
  published_at_not_cont?: InputMaybe<Scalars['String']>;
  published_at_not_cont_all?: InputMaybe<Scalars['String']>;
  published_at_not_cont_any?: InputMaybe<Scalars['String']>;
  published_at_not_end?: InputMaybe<Scalars['String']>;
  published_at_not_end_all?: InputMaybe<Scalars['String']>;
  published_at_not_end_any?: InputMaybe<Scalars['String']>;
  published_at_not_eq?: InputMaybe<Scalars['String']>;
  published_at_not_eq_all?: InputMaybe<Scalars['String']>;
  published_at_not_eq_any?: InputMaybe<Scalars['String']>;
  published_at_not_false?: InputMaybe<Scalars['String']>;
  published_at_not_i_cont?: InputMaybe<Scalars['String']>;
  published_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  published_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  published_at_not_in?: InputMaybe<Scalars['String']>;
  published_at_not_in_all?: InputMaybe<Scalars['String']>;
  published_at_not_in_any?: InputMaybe<Scalars['String']>;
  published_at_not_null?: InputMaybe<Scalars['String']>;
  published_at_not_start?: InputMaybe<Scalars['String']>;
  published_at_not_start_all?: InputMaybe<Scalars['String']>;
  published_at_not_start_any?: InputMaybe<Scalars['String']>;
  published_at_not_true?: InputMaybe<Scalars['String']>;
  published_at_null?: InputMaybe<Scalars['String']>;
  published_at_present?: InputMaybe<Scalars['String']>;
  published_at_start?: InputMaybe<Scalars['String']>;
  published_at_start_all?: InputMaybe<Scalars['String']>;
  published_at_start_any?: InputMaybe<Scalars['String']>;
  published_at_true?: InputMaybe<Scalars['String']>;
  search_name_blank?: InputMaybe<Scalars['String']>;
  search_name_cont?: InputMaybe<Scalars['String']>;
  search_name_cont_all?: InputMaybe<Scalars['String']>;
  search_name_cont_any?: InputMaybe<Scalars['String']>;
  search_name_does_not_match?: InputMaybe<Scalars['String']>;
  search_name_does_not_match_all?: InputMaybe<Scalars['String']>;
  search_name_does_not_match_any?: InputMaybe<Scalars['String']>;
  search_name_end?: InputMaybe<Scalars['String']>;
  search_name_end_all?: InputMaybe<Scalars['String']>;
  search_name_end_any?: InputMaybe<Scalars['String']>;
  search_name_eq?: InputMaybe<Scalars['String']>;
  search_name_eq_all?: InputMaybe<Scalars['String']>;
  search_name_eq_any?: InputMaybe<Scalars['String']>;
  search_name_false?: InputMaybe<Scalars['String']>;
  search_name_gt?: InputMaybe<Scalars['String']>;
  search_name_gt_all?: InputMaybe<Scalars['String']>;
  search_name_gt_any?: InputMaybe<Scalars['String']>;
  search_name_gteq?: InputMaybe<Scalars['String']>;
  search_name_gteq_all?: InputMaybe<Scalars['String']>;
  search_name_gteq_any?: InputMaybe<Scalars['String']>;
  search_name_i_cont?: InputMaybe<Scalars['String']>;
  search_name_i_cont_all?: InputMaybe<Scalars['String']>;
  search_name_i_cont_any?: InputMaybe<Scalars['String']>;
  search_name_in?: InputMaybe<Scalars['String']>;
  search_name_in_all?: InputMaybe<Scalars['String']>;
  search_name_in_any?: InputMaybe<Scalars['String']>;
  search_name_lt?: InputMaybe<Scalars['String']>;
  search_name_lt_all?: InputMaybe<Scalars['String']>;
  search_name_lt_any?: InputMaybe<Scalars['String']>;
  search_name_lteq?: InputMaybe<Scalars['String']>;
  search_name_lteq_all?: InputMaybe<Scalars['String']>;
  search_name_lteq_any?: InputMaybe<Scalars['String']>;
  search_name_matches?: InputMaybe<Scalars['String']>;
  search_name_matches_all?: InputMaybe<Scalars['String']>;
  search_name_matches_any?: InputMaybe<Scalars['String']>;
  search_name_not_cont?: InputMaybe<Scalars['String']>;
  search_name_not_cont_all?: InputMaybe<Scalars['String']>;
  search_name_not_cont_any?: InputMaybe<Scalars['String']>;
  search_name_not_end?: InputMaybe<Scalars['String']>;
  search_name_not_end_all?: InputMaybe<Scalars['String']>;
  search_name_not_end_any?: InputMaybe<Scalars['String']>;
  search_name_not_eq?: InputMaybe<Scalars['String']>;
  search_name_not_eq_all?: InputMaybe<Scalars['String']>;
  search_name_not_eq_any?: InputMaybe<Scalars['String']>;
  search_name_not_false?: InputMaybe<Scalars['String']>;
  search_name_not_i_cont?: InputMaybe<Scalars['String']>;
  search_name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  search_name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  search_name_not_in?: InputMaybe<Scalars['String']>;
  search_name_not_in_all?: InputMaybe<Scalars['String']>;
  search_name_not_in_any?: InputMaybe<Scalars['String']>;
  search_name_not_null?: InputMaybe<Scalars['String']>;
  search_name_not_start?: InputMaybe<Scalars['String']>;
  search_name_not_start_all?: InputMaybe<Scalars['String']>;
  search_name_not_start_any?: InputMaybe<Scalars['String']>;
  search_name_not_true?: InputMaybe<Scalars['String']>;
  search_name_null?: InputMaybe<Scalars['String']>;
  search_name_present?: InputMaybe<Scalars['String']>;
  search_name_start?: InputMaybe<Scalars['String']>;
  search_name_start_all?: InputMaybe<Scalars['String']>;
  search_name_start_any?: InputMaybe<Scalars['String']>;
  search_name_true?: InputMaybe<Scalars['String']>;
  send_email_blank?: InputMaybe<Scalars['Boolean']>;
  send_email_cont?: InputMaybe<Scalars['Boolean']>;
  send_email_cont_all?: InputMaybe<Scalars['Boolean']>;
  send_email_cont_any?: InputMaybe<Scalars['Boolean']>;
  send_email_does_not_match?: InputMaybe<Scalars['Boolean']>;
  send_email_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  send_email_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  send_email_end?: InputMaybe<Scalars['Boolean']>;
  send_email_end_all?: InputMaybe<Scalars['Boolean']>;
  send_email_end_any?: InputMaybe<Scalars['Boolean']>;
  send_email_eq?: InputMaybe<Scalars['Boolean']>;
  send_email_eq_all?: InputMaybe<Scalars['Boolean']>;
  send_email_eq_any?: InputMaybe<Scalars['Boolean']>;
  send_email_false?: InputMaybe<Scalars['Boolean']>;
  send_email_gt?: InputMaybe<Scalars['Boolean']>;
  send_email_gt_all?: InputMaybe<Scalars['Boolean']>;
  send_email_gt_any?: InputMaybe<Scalars['Boolean']>;
  send_email_gteq?: InputMaybe<Scalars['Boolean']>;
  send_email_gteq_all?: InputMaybe<Scalars['Boolean']>;
  send_email_gteq_any?: InputMaybe<Scalars['Boolean']>;
  send_email_i_cont?: InputMaybe<Scalars['Boolean']>;
  send_email_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  send_email_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  send_email_in?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_lt?: InputMaybe<Scalars['Boolean']>;
  send_email_lt_all?: InputMaybe<Scalars['Boolean']>;
  send_email_lt_any?: InputMaybe<Scalars['Boolean']>;
  send_email_lteq?: InputMaybe<Scalars['Boolean']>;
  send_email_lteq_all?: InputMaybe<Scalars['Boolean']>;
  send_email_lteq_any?: InputMaybe<Scalars['Boolean']>;
  send_email_matches?: InputMaybe<Scalars['Boolean']>;
  send_email_matches_all?: InputMaybe<Scalars['Boolean']>;
  send_email_matches_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_cont?: InputMaybe<Scalars['Boolean']>;
  send_email_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_end?: InputMaybe<Scalars['Boolean']>;
  send_email_not_end_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_end_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_eq?: InputMaybe<Scalars['Boolean']>;
  send_email_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_false?: InputMaybe<Scalars['Boolean']>;
  send_email_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  send_email_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_not_null?: InputMaybe<Scalars['Boolean']>;
  send_email_not_start?: InputMaybe<Scalars['Boolean']>;
  send_email_not_start_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_start_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_true?: InputMaybe<Scalars['Boolean']>;
  send_email_null?: InputMaybe<Scalars['Boolean']>;
  send_email_present?: InputMaybe<Scalars['Boolean']>;
  send_email_start?: InputMaybe<Scalars['Boolean']>;
  send_email_start_all?: InputMaybe<Scalars['Boolean']>;
  send_email_start_any?: InputMaybe<Scalars['Boolean']>;
  send_email_true?: InputMaybe<Scalars['Boolean']>;
  sorts?: InputMaybe<Array<Scalars['String']>>;
  start_date_blank?: InputMaybe<Scalars['String']>;
  start_date_cont?: InputMaybe<Scalars['String']>;
  start_date_cont_all?: InputMaybe<Scalars['String']>;
  start_date_cont_any?: InputMaybe<Scalars['String']>;
  start_date_does_not_match?: InputMaybe<Scalars['String']>;
  start_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  start_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  start_date_end?: InputMaybe<Scalars['String']>;
  start_date_end_all?: InputMaybe<Scalars['String']>;
  start_date_end_any?: InputMaybe<Scalars['String']>;
  start_date_eq?: InputMaybe<Scalars['String']>;
  start_date_eq_all?: InputMaybe<Scalars['String']>;
  start_date_eq_any?: InputMaybe<Scalars['String']>;
  start_date_false?: InputMaybe<Scalars['String']>;
  start_date_gt?: InputMaybe<Scalars['String']>;
  start_date_gt_all?: InputMaybe<Scalars['String']>;
  start_date_gt_any?: InputMaybe<Scalars['String']>;
  start_date_gteq?: InputMaybe<Scalars['String']>;
  start_date_gteq_all?: InputMaybe<Scalars['String']>;
  start_date_gteq_any?: InputMaybe<Scalars['String']>;
  start_date_i_cont?: InputMaybe<Scalars['String']>;
  start_date_i_cont_all?: InputMaybe<Scalars['String']>;
  start_date_i_cont_any?: InputMaybe<Scalars['String']>;
  start_date_in?: InputMaybe<Scalars['String']>;
  start_date_in_all?: InputMaybe<Scalars['String']>;
  start_date_in_any?: InputMaybe<Scalars['String']>;
  start_date_lt?: InputMaybe<Scalars['String']>;
  start_date_lt_all?: InputMaybe<Scalars['String']>;
  start_date_lt_any?: InputMaybe<Scalars['String']>;
  start_date_lteq?: InputMaybe<Scalars['String']>;
  start_date_lteq_all?: InputMaybe<Scalars['String']>;
  start_date_lteq_any?: InputMaybe<Scalars['String']>;
  start_date_matches?: InputMaybe<Scalars['String']>;
  start_date_matches_all?: InputMaybe<Scalars['String']>;
  start_date_matches_any?: InputMaybe<Scalars['String']>;
  start_date_not_cont?: InputMaybe<Scalars['String']>;
  start_date_not_cont_all?: InputMaybe<Scalars['String']>;
  start_date_not_cont_any?: InputMaybe<Scalars['String']>;
  start_date_not_end?: InputMaybe<Scalars['String']>;
  start_date_not_end_all?: InputMaybe<Scalars['String']>;
  start_date_not_end_any?: InputMaybe<Scalars['String']>;
  start_date_not_eq?: InputMaybe<Scalars['String']>;
  start_date_not_eq_all?: InputMaybe<Scalars['String']>;
  start_date_not_eq_any?: InputMaybe<Scalars['String']>;
  start_date_not_false?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  start_date_not_in?: InputMaybe<Scalars['String']>;
  start_date_not_in_all?: InputMaybe<Scalars['String']>;
  start_date_not_in_any?: InputMaybe<Scalars['String']>;
  start_date_not_null?: InputMaybe<Scalars['String']>;
  start_date_not_start?: InputMaybe<Scalars['String']>;
  start_date_not_start_all?: InputMaybe<Scalars['String']>;
  start_date_not_start_any?: InputMaybe<Scalars['String']>;
  start_date_not_true?: InputMaybe<Scalars['String']>;
  start_date_null?: InputMaybe<Scalars['String']>;
  start_date_present?: InputMaybe<Scalars['String']>;
  start_date_start?: InputMaybe<Scalars['String']>;
  start_date_start_all?: InputMaybe<Scalars['String']>;
  start_date_start_any?: InputMaybe<Scalars['String']>;
  start_date_true?: InputMaybe<Scalars['String']>;
  state_blank?: InputMaybe<Scalars['Int']>;
  state_cont?: InputMaybe<Scalars['Int']>;
  state_cont_all?: InputMaybe<Scalars['Int']>;
  state_cont_any?: InputMaybe<Scalars['Int']>;
  state_does_not_match?: InputMaybe<Scalars['Int']>;
  state_does_not_match_all?: InputMaybe<Scalars['Int']>;
  state_does_not_match_any?: InputMaybe<Scalars['Int']>;
  state_end?: InputMaybe<Scalars['Int']>;
  state_end_all?: InputMaybe<Scalars['Int']>;
  state_end_any?: InputMaybe<Scalars['Int']>;
  state_eq?: InputMaybe<Scalars['Int']>;
  state_eq_all?: InputMaybe<Scalars['Int']>;
  state_eq_any?: InputMaybe<Scalars['Int']>;
  state_false?: InputMaybe<Scalars['Int']>;
  state_gt?: InputMaybe<Scalars['Int']>;
  state_gt_all?: InputMaybe<Scalars['Int']>;
  state_gt_any?: InputMaybe<Scalars['Int']>;
  state_gteq?: InputMaybe<Scalars['Int']>;
  state_gteq_all?: InputMaybe<Scalars['Int']>;
  state_gteq_any?: InputMaybe<Scalars['Int']>;
  state_i_cont?: InputMaybe<Scalars['Int']>;
  state_i_cont_all?: InputMaybe<Scalars['Int']>;
  state_i_cont_any?: InputMaybe<Scalars['Int']>;
  state_in?: InputMaybe<Array<Scalars['Int']>>;
  state_in_all?: InputMaybe<Array<Scalars['Int']>>;
  state_in_any?: InputMaybe<Array<Scalars['Int']>>;
  state_lt?: InputMaybe<Scalars['Int']>;
  state_lt_all?: InputMaybe<Scalars['Int']>;
  state_lt_any?: InputMaybe<Scalars['Int']>;
  state_lteq?: InputMaybe<Scalars['Int']>;
  state_lteq_all?: InputMaybe<Scalars['Int']>;
  state_lteq_any?: InputMaybe<Scalars['Int']>;
  state_matches?: InputMaybe<Scalars['Int']>;
  state_matches_all?: InputMaybe<Scalars['Int']>;
  state_matches_any?: InputMaybe<Scalars['Int']>;
  state_not_cont?: InputMaybe<Scalars['Int']>;
  state_not_cont_all?: InputMaybe<Scalars['Int']>;
  state_not_cont_any?: InputMaybe<Scalars['Int']>;
  state_not_end?: InputMaybe<Scalars['Int']>;
  state_not_end_all?: InputMaybe<Scalars['Int']>;
  state_not_end_any?: InputMaybe<Scalars['Int']>;
  state_not_eq?: InputMaybe<Scalars['Int']>;
  state_not_eq_all?: InputMaybe<Scalars['Int']>;
  state_not_eq_any?: InputMaybe<Scalars['Int']>;
  state_not_false?: InputMaybe<Scalars['Int']>;
  state_not_i_cont?: InputMaybe<Scalars['Int']>;
  state_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  state_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  state_not_in?: InputMaybe<Array<Scalars['Int']>>;
  state_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  state_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  state_not_null?: InputMaybe<Scalars['Int']>;
  state_not_start?: InputMaybe<Scalars['Int']>;
  state_not_start_all?: InputMaybe<Scalars['Int']>;
  state_not_start_any?: InputMaybe<Scalars['Int']>;
  state_not_true?: InputMaybe<Scalars['Int']>;
  state_null?: InputMaybe<Scalars['Int']>;
  state_present?: InputMaybe<Scalars['Int']>;
  state_start?: InputMaybe<Scalars['Int']>;
  state_start_all?: InputMaybe<Scalars['Int']>;
  state_start_any?: InputMaybe<Scalars['Int']>;
  state_true?: InputMaybe<Scalars['Int']>;
  synchronous_blank?: InputMaybe<Scalars['String']>;
  synchronous_cont?: InputMaybe<Scalars['String']>;
  synchronous_cont_all?: InputMaybe<Scalars['String']>;
  synchronous_cont_any?: InputMaybe<Scalars['String']>;
  synchronous_does_not_match?: InputMaybe<Scalars['String']>;
  synchronous_does_not_match_all?: InputMaybe<Scalars['String']>;
  synchronous_does_not_match_any?: InputMaybe<Scalars['String']>;
  synchronous_end?: InputMaybe<Scalars['String']>;
  synchronous_end_all?: InputMaybe<Scalars['String']>;
  synchronous_end_any?: InputMaybe<Scalars['String']>;
  synchronous_eq?: InputMaybe<Scalars['String']>;
  synchronous_eq_all?: InputMaybe<Scalars['String']>;
  synchronous_eq_any?: InputMaybe<Scalars['String']>;
  synchronous_false?: InputMaybe<Scalars['String']>;
  synchronous_gt?: InputMaybe<Scalars['String']>;
  synchronous_gt_all?: InputMaybe<Scalars['String']>;
  synchronous_gt_any?: InputMaybe<Scalars['String']>;
  synchronous_gteq?: InputMaybe<Scalars['String']>;
  synchronous_gteq_all?: InputMaybe<Scalars['String']>;
  synchronous_gteq_any?: InputMaybe<Scalars['String']>;
  synchronous_i_cont?: InputMaybe<Scalars['String']>;
  synchronous_i_cont_all?: InputMaybe<Scalars['String']>;
  synchronous_i_cont_any?: InputMaybe<Scalars['String']>;
  synchronous_in?: InputMaybe<Scalars['String']>;
  synchronous_in_all?: InputMaybe<Scalars['String']>;
  synchronous_in_any?: InputMaybe<Scalars['String']>;
  synchronous_lt?: InputMaybe<Scalars['String']>;
  synchronous_lt_all?: InputMaybe<Scalars['String']>;
  synchronous_lt_any?: InputMaybe<Scalars['String']>;
  synchronous_lteq?: InputMaybe<Scalars['String']>;
  synchronous_lteq_all?: InputMaybe<Scalars['String']>;
  synchronous_lteq_any?: InputMaybe<Scalars['String']>;
  synchronous_matches?: InputMaybe<Scalars['String']>;
  synchronous_matches_all?: InputMaybe<Scalars['String']>;
  synchronous_matches_any?: InputMaybe<Scalars['String']>;
  synchronous_not_cont?: InputMaybe<Scalars['String']>;
  synchronous_not_cont_all?: InputMaybe<Scalars['String']>;
  synchronous_not_cont_any?: InputMaybe<Scalars['String']>;
  synchronous_not_end?: InputMaybe<Scalars['String']>;
  synchronous_not_end_all?: InputMaybe<Scalars['String']>;
  synchronous_not_end_any?: InputMaybe<Scalars['String']>;
  synchronous_not_eq?: InputMaybe<Scalars['String']>;
  synchronous_not_eq_all?: InputMaybe<Scalars['String']>;
  synchronous_not_eq_any?: InputMaybe<Scalars['String']>;
  synchronous_not_false?: InputMaybe<Scalars['String']>;
  synchronous_not_i_cont?: InputMaybe<Scalars['String']>;
  synchronous_not_i_cont_all?: InputMaybe<Scalars['String']>;
  synchronous_not_i_cont_any?: InputMaybe<Scalars['String']>;
  synchronous_not_in?: InputMaybe<Scalars['String']>;
  synchronous_not_in_all?: InputMaybe<Scalars['String']>;
  synchronous_not_in_any?: InputMaybe<Scalars['String']>;
  synchronous_not_null?: InputMaybe<Scalars['String']>;
  synchronous_not_start?: InputMaybe<Scalars['String']>;
  synchronous_not_start_all?: InputMaybe<Scalars['String']>;
  synchronous_not_start_any?: InputMaybe<Scalars['String']>;
  synchronous_not_true?: InputMaybe<Scalars['String']>;
  synchronous_null?: InputMaybe<Scalars['String']>;
  synchronous_present?: InputMaybe<Scalars['String']>;
  synchronous_start?: InputMaybe<Scalars['String']>;
  synchronous_start_all?: InputMaybe<Scalars['String']>;
  synchronous_start_any?: InputMaybe<Scalars['String']>;
  synchronous_true?: InputMaybe<Scalars['String']>;
  thumbnail_data_blank?: InputMaybe<Scalars['String']>;
  thumbnail_data_cont?: InputMaybe<Scalars['String']>;
  thumbnail_data_cont_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_cont_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_does_not_match?: InputMaybe<Scalars['String']>;
  thumbnail_data_does_not_match_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_does_not_match_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_end?: InputMaybe<Scalars['String']>;
  thumbnail_data_end_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_end_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_eq?: InputMaybe<Scalars['String']>;
  thumbnail_data_eq_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_eq_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_false?: InputMaybe<Scalars['String']>;
  thumbnail_data_gt?: InputMaybe<Scalars['String']>;
  thumbnail_data_gt_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_gt_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_gteq?: InputMaybe<Scalars['String']>;
  thumbnail_data_gteq_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_gteq_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_i_cont?: InputMaybe<Scalars['String']>;
  thumbnail_data_i_cont_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_i_cont_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_in?: InputMaybe<Scalars['String']>;
  thumbnail_data_in_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_in_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_lt?: InputMaybe<Scalars['String']>;
  thumbnail_data_lt_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_lt_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_lteq?: InputMaybe<Scalars['String']>;
  thumbnail_data_lteq_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_lteq_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_matches?: InputMaybe<Scalars['String']>;
  thumbnail_data_matches_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_matches_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_cont?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_cont_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_cont_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_end?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_end_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_end_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_eq?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_eq_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_eq_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_false?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_i_cont?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_i_cont_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_i_cont_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_in?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_in_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_in_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_null?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_start?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_start_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_start_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_true?: InputMaybe<Scalars['String']>;
  thumbnail_data_null?: InputMaybe<Scalars['String']>;
  thumbnail_data_present?: InputMaybe<Scalars['String']>;
  thumbnail_data_start?: InputMaybe<Scalars['String']>;
  thumbnail_data_start_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_start_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_true?: InputMaybe<Scalars['String']>;
  trim_name_blank?: InputMaybe<Scalars['String']>;
  trim_name_cont?: InputMaybe<Scalars['String']>;
  trim_name_cont_all?: InputMaybe<Scalars['String']>;
  trim_name_cont_any?: InputMaybe<Scalars['String']>;
  trim_name_does_not_match?: InputMaybe<Scalars['String']>;
  trim_name_does_not_match_all?: InputMaybe<Scalars['String']>;
  trim_name_does_not_match_any?: InputMaybe<Scalars['String']>;
  trim_name_end?: InputMaybe<Scalars['String']>;
  trim_name_end_all?: InputMaybe<Scalars['String']>;
  trim_name_end_any?: InputMaybe<Scalars['String']>;
  trim_name_eq?: InputMaybe<Scalars['String']>;
  trim_name_eq_all?: InputMaybe<Scalars['String']>;
  trim_name_eq_any?: InputMaybe<Scalars['String']>;
  trim_name_false?: InputMaybe<Scalars['String']>;
  trim_name_gt?: InputMaybe<Scalars['String']>;
  trim_name_gt_all?: InputMaybe<Scalars['String']>;
  trim_name_gt_any?: InputMaybe<Scalars['String']>;
  trim_name_gteq?: InputMaybe<Scalars['String']>;
  trim_name_gteq_all?: InputMaybe<Scalars['String']>;
  trim_name_gteq_any?: InputMaybe<Scalars['String']>;
  trim_name_i_cont?: InputMaybe<Scalars['String']>;
  trim_name_i_cont_all?: InputMaybe<Scalars['String']>;
  trim_name_i_cont_any?: InputMaybe<Scalars['String']>;
  trim_name_in?: InputMaybe<Scalars['String']>;
  trim_name_in_all?: InputMaybe<Scalars['String']>;
  trim_name_in_any?: InputMaybe<Scalars['String']>;
  trim_name_lt?: InputMaybe<Scalars['String']>;
  trim_name_lt_all?: InputMaybe<Scalars['String']>;
  trim_name_lt_any?: InputMaybe<Scalars['String']>;
  trim_name_lteq?: InputMaybe<Scalars['String']>;
  trim_name_lteq_all?: InputMaybe<Scalars['String']>;
  trim_name_lteq_any?: InputMaybe<Scalars['String']>;
  trim_name_matches?: InputMaybe<Scalars['String']>;
  trim_name_matches_all?: InputMaybe<Scalars['String']>;
  trim_name_matches_any?: InputMaybe<Scalars['String']>;
  trim_name_not_cont?: InputMaybe<Scalars['String']>;
  trim_name_not_cont_all?: InputMaybe<Scalars['String']>;
  trim_name_not_cont_any?: InputMaybe<Scalars['String']>;
  trim_name_not_end?: InputMaybe<Scalars['String']>;
  trim_name_not_end_all?: InputMaybe<Scalars['String']>;
  trim_name_not_end_any?: InputMaybe<Scalars['String']>;
  trim_name_not_eq?: InputMaybe<Scalars['String']>;
  trim_name_not_eq_all?: InputMaybe<Scalars['String']>;
  trim_name_not_eq_any?: InputMaybe<Scalars['String']>;
  trim_name_not_false?: InputMaybe<Scalars['String']>;
  trim_name_not_i_cont?: InputMaybe<Scalars['String']>;
  trim_name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  trim_name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  trim_name_not_in?: InputMaybe<Scalars['String']>;
  trim_name_not_in_all?: InputMaybe<Scalars['String']>;
  trim_name_not_in_any?: InputMaybe<Scalars['String']>;
  trim_name_not_null?: InputMaybe<Scalars['String']>;
  trim_name_not_start?: InputMaybe<Scalars['String']>;
  trim_name_not_start_all?: InputMaybe<Scalars['String']>;
  trim_name_not_start_any?: InputMaybe<Scalars['String']>;
  trim_name_not_true?: InputMaybe<Scalars['String']>;
  trim_name_null?: InputMaybe<Scalars['String']>;
  trim_name_present?: InputMaybe<Scalars['String']>;
  trim_name_start?: InputMaybe<Scalars['String']>;
  trim_name_start_all?: InputMaybe<Scalars['String']>;
  trim_name_start_any?: InputMaybe<Scalars['String']>;
  trim_name_true?: InputMaybe<Scalars['String']>;
  until_date_blank?: InputMaybe<Scalars['String']>;
  until_date_cont?: InputMaybe<Scalars['String']>;
  until_date_cont_all?: InputMaybe<Scalars['String']>;
  until_date_cont_any?: InputMaybe<Scalars['String']>;
  until_date_does_not_match?: InputMaybe<Scalars['String']>;
  until_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  until_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  until_date_end?: InputMaybe<Scalars['String']>;
  until_date_end_all?: InputMaybe<Scalars['String']>;
  until_date_end_any?: InputMaybe<Scalars['String']>;
  until_date_eq?: InputMaybe<Scalars['String']>;
  until_date_eq_all?: InputMaybe<Scalars['String']>;
  until_date_eq_any?: InputMaybe<Scalars['String']>;
  until_date_false?: InputMaybe<Scalars['String']>;
  until_date_gt?: InputMaybe<Scalars['String']>;
  until_date_gt_all?: InputMaybe<Scalars['String']>;
  until_date_gt_any?: InputMaybe<Scalars['String']>;
  until_date_gteq?: InputMaybe<Scalars['String']>;
  until_date_gteq_all?: InputMaybe<Scalars['String']>;
  until_date_gteq_any?: InputMaybe<Scalars['String']>;
  until_date_i_cont?: InputMaybe<Scalars['String']>;
  until_date_i_cont_all?: InputMaybe<Scalars['String']>;
  until_date_i_cont_any?: InputMaybe<Scalars['String']>;
  until_date_in?: InputMaybe<Scalars['String']>;
  until_date_in_all?: InputMaybe<Scalars['String']>;
  until_date_in_any?: InputMaybe<Scalars['String']>;
  until_date_lt?: InputMaybe<Scalars['String']>;
  until_date_lt_all?: InputMaybe<Scalars['String']>;
  until_date_lt_any?: InputMaybe<Scalars['String']>;
  until_date_lteq?: InputMaybe<Scalars['String']>;
  until_date_lteq_all?: InputMaybe<Scalars['String']>;
  until_date_lteq_any?: InputMaybe<Scalars['String']>;
  until_date_matches?: InputMaybe<Scalars['String']>;
  until_date_matches_all?: InputMaybe<Scalars['String']>;
  until_date_matches_any?: InputMaybe<Scalars['String']>;
  until_date_not_cont?: InputMaybe<Scalars['String']>;
  until_date_not_cont_all?: InputMaybe<Scalars['String']>;
  until_date_not_cont_any?: InputMaybe<Scalars['String']>;
  until_date_not_end?: InputMaybe<Scalars['String']>;
  until_date_not_end_all?: InputMaybe<Scalars['String']>;
  until_date_not_end_any?: InputMaybe<Scalars['String']>;
  until_date_not_eq?: InputMaybe<Scalars['String']>;
  until_date_not_eq_all?: InputMaybe<Scalars['String']>;
  until_date_not_eq_any?: InputMaybe<Scalars['String']>;
  until_date_not_false?: InputMaybe<Scalars['String']>;
  until_date_not_i_cont?: InputMaybe<Scalars['String']>;
  until_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  until_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  until_date_not_in?: InputMaybe<Scalars['String']>;
  until_date_not_in_all?: InputMaybe<Scalars['String']>;
  until_date_not_in_any?: InputMaybe<Scalars['String']>;
  until_date_not_null?: InputMaybe<Scalars['String']>;
  until_date_not_start?: InputMaybe<Scalars['String']>;
  until_date_not_start_all?: InputMaybe<Scalars['String']>;
  until_date_not_start_any?: InputMaybe<Scalars['String']>;
  until_date_not_true?: InputMaybe<Scalars['String']>;
  until_date_null?: InputMaybe<Scalars['String']>;
  until_date_present?: InputMaybe<Scalars['String']>;
  until_date_start?: InputMaybe<Scalars['String']>;
  until_date_start_all?: InputMaybe<Scalars['String']>;
  until_date_start_any?: InputMaybe<Scalars['String']>;
  until_date_true?: InputMaybe<Scalars['String']>;
};

export type CourseUser = {
  __typename?: 'CourseUser';
  /** Sin comenzar = 0 | En progreso = 1 | Finalizado = 2 */
  advance?: Maybe<Scalars['Int']>;
  area?: Maybe<Area>;
  assignedLessons?: Maybe<Scalars['Int']>;
  certificatesCount?: Maybe<Scalars['Int']>;
  course: Course;
  courseId: Scalars['ID'];
  enrol?: Maybe<Enrol>;
  enrolId?: Maybe<Scalars['ID']>;
  evaluations?: Maybe<Array<EvaluationsResult>>;
  evaluationsDone?: Maybe<Scalars['Int']>;
  evaluationsState?: Maybe<Scalars['Int']>;
  /** Optional = 0 | Required = 1 */
  mandatory?: Maybe<Scalars['Boolean']>;
  overallProgress?: Maybe<Scalars['Float']>;
  stateEvaluations?: Maybe<Scalars['Int']>;
  synchronousCourseEnrol?: Maybe<SynchronousCourseEnrol>;
  synchronousCourseEvaluations?: Maybe<Array<SynchronousCourseEnrolAssessment>>;
  user: User;
  userId: Scalars['ID'];
};

export type CourseUserPage = {
  __typename?: 'CourseUserPage';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<CourseUser>;
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
};

/** Autogenerated input type of DownloadAllCoursesMonitoring */
export type DownloadAllCoursesMonitoringInput = {
  areaId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  idOrParentId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  perPage?: InputMaybe<Scalars['Int']>;
  qCourses?: InputMaybe<CourseRansack>;
  qExternalCourses?: InputMaybe<ExternalCourseRansack>;
};

/** Autogenerated return type of DownloadAllCoursesMonitoring */
export type DownloadAllCoursesMonitoringPayload = {
  __typename?: 'DownloadAllCoursesMonitoringPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  url: Scalars['String'];
};

/** Autogenerated input type of DownloadCourseUsersMonitoring */
export type DownloadCourseUsersMonitoringInput = {
  areaId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  courseId: Scalars['ID'];
  q?: InputMaybe<UserCourseRansack>;
};

/** Autogenerated return type of DownloadCourseUsersMonitoring */
export type DownloadCourseUsersMonitoringPayload = {
  __typename?: 'DownloadCourseUsersMonitoringPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  url: Scalars['String'];
};

/** Autogenerated input type of DownloadExternalCourseUsersMonitoring */
export type DownloadExternalCourseUsersMonitoringInput = {
  areaId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalCourseId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<ExternalCourseUserRansack>;
};

/** Autogenerated return type of DownloadExternalCourseUsersMonitoring */
export type DownloadExternalCourseUsersMonitoringPayload = {
  __typename?: 'DownloadExternalCourseUsersMonitoringPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  url: Scalars['String'];
};

/** Autogenerated input type of DownloadLearningPathsMonitoring */
export type DownloadLearningPathsMonitoringInput = {
  areaId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  q?: InputMaybe<LearningPathRansack>;
};

/** Autogenerated return type of DownloadLearningPathsMonitoring */
export type DownloadLearningPathsMonitoringPayload = {
  __typename?: 'DownloadLearningPathsMonitoringPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  generating: Scalars['Boolean'];
};

/** Autogenerated input type of DownloadUsers */
export type DownloadUsersInput = {
  areaId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  q?: InputMaybe<UserRansack>;
};

/** Autogenerated return type of DownloadUsers */
export type DownloadUsersPayload = {
  __typename?: 'DownloadUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  generating: Scalars['Boolean'];
};

export type Enrol = {
  __typename?: 'Enrol';
  active?: Maybe<Scalars['Boolean']>;
  answer?: Maybe<Scalars['String']>;
  answerAdmin?: Maybe<Scalars['String']>;
  course: Course;
  courseId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  finishDate?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  integrationStatus?: Maybe<IntegrationStatus>;
  note?: Maybe<Scalars['String']>;
  overallProgress?: Maybe<Scalars['Float']>;
  reboots?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['Int']>;
  stateAdmin?: Maybe<Scalars['Int']>;
  synchronousCourseEnrol?: Maybe<SynchronousCourseEnrol>;
  synchronousCourseEnrolId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  userId: Scalars['ID'];
};

export type EnrolExternalCourse = {
  __typename?: 'EnrolExternalCourse';
  attendance?: Maybe<Scalars['Float']>;
  compromise?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  endDate?: Maybe<Scalars['ISO8601Date']>;
  evaluations: Array<EvaluationsEnrolledExternalCourse>;
  externalCourse: ExternalCourse;
  finalScore?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  startDate?: Maybe<Scalars['ISO8601Date']>;
  state?: Maybe<Scalars['Int']>;
  totalHours?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
};

export type EnrolExternalCoursePage = {
  __typename?: 'EnrolExternalCoursePage';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<EnrolExternalCourse>;
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
};

export type EvaluationsEnrolledExternalCourse = {
  __typename?: 'EvaluationsEnrolledExternalCourse';
  createdAt: Scalars['ISO8601DateTime'];
  enrollExternalCourseId?: Maybe<Scalars['Int']>;
  externalCourseEvaluationId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  points: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type EvaluationsResult = {
  __typename?: 'EvaluationsResult';
  approved?: Maybe<Scalars['Boolean']>;
  attemps?: Maybe<Scalars['Int']>;
  blockEvaluationId?: Maybe<Scalars['Int']>;
  correct?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  enrolId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  points?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ExternalCourse = {
  __typename?: 'ExternalCourse';
  additionalCode?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  endDate?: Maybe<Scalars['ISO8601Date']>;
  evaluationsCount: Scalars['Int'];
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  institution?: Maybe<Scalars['String']>;
  modality?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  participants?: Maybe<Array<User>>;
  participantsCount: Scalars['Int'];
  progress?: Maybe<CourseProgress>;
  progressEvaluations?: Maybe<CourseProgressEvaluation>;
  startDate?: Maybe<Scalars['ISO8601Date']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ExternalCoursePage = {
  __typename?: 'ExternalCoursePage';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<ExternalCourse>;
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
};

export type ExternalCourseRansack = {
  additional_code_blank?: InputMaybe<Scalars['String']>;
  additional_code_cont?: InputMaybe<Scalars['String']>;
  additional_code_cont_all?: InputMaybe<Scalars['String']>;
  additional_code_cont_any?: InputMaybe<Scalars['String']>;
  additional_code_does_not_match?: InputMaybe<Scalars['String']>;
  additional_code_does_not_match_all?: InputMaybe<Scalars['String']>;
  additional_code_does_not_match_any?: InputMaybe<Scalars['String']>;
  additional_code_end?: InputMaybe<Scalars['String']>;
  additional_code_end_all?: InputMaybe<Scalars['String']>;
  additional_code_end_any?: InputMaybe<Scalars['String']>;
  additional_code_eq?: InputMaybe<Scalars['String']>;
  additional_code_eq_all?: InputMaybe<Scalars['String']>;
  additional_code_eq_any?: InputMaybe<Scalars['String']>;
  additional_code_false?: InputMaybe<Scalars['String']>;
  additional_code_gt?: InputMaybe<Scalars['String']>;
  additional_code_gt_all?: InputMaybe<Scalars['String']>;
  additional_code_gt_any?: InputMaybe<Scalars['String']>;
  additional_code_gteq?: InputMaybe<Scalars['String']>;
  additional_code_gteq_all?: InputMaybe<Scalars['String']>;
  additional_code_gteq_any?: InputMaybe<Scalars['String']>;
  additional_code_i_cont?: InputMaybe<Scalars['String']>;
  additional_code_i_cont_all?: InputMaybe<Scalars['String']>;
  additional_code_i_cont_any?: InputMaybe<Scalars['String']>;
  additional_code_in?: InputMaybe<Array<Scalars['String']>>;
  additional_code_in_all?: InputMaybe<Array<Scalars['String']>>;
  additional_code_in_any?: InputMaybe<Array<Scalars['String']>>;
  additional_code_lt?: InputMaybe<Scalars['String']>;
  additional_code_lt_all?: InputMaybe<Scalars['String']>;
  additional_code_lt_any?: InputMaybe<Scalars['String']>;
  additional_code_lteq?: InputMaybe<Scalars['String']>;
  additional_code_lteq_all?: InputMaybe<Scalars['String']>;
  additional_code_lteq_any?: InputMaybe<Scalars['String']>;
  additional_code_matches?: InputMaybe<Scalars['String']>;
  additional_code_matches_all?: InputMaybe<Scalars['String']>;
  additional_code_matches_any?: InputMaybe<Scalars['String']>;
  additional_code_not_cont?: InputMaybe<Scalars['String']>;
  additional_code_not_cont_all?: InputMaybe<Scalars['String']>;
  additional_code_not_cont_any?: InputMaybe<Scalars['String']>;
  additional_code_not_end?: InputMaybe<Scalars['String']>;
  additional_code_not_end_all?: InputMaybe<Scalars['String']>;
  additional_code_not_end_any?: InputMaybe<Scalars['String']>;
  additional_code_not_eq?: InputMaybe<Scalars['String']>;
  additional_code_not_eq_all?: InputMaybe<Scalars['String']>;
  additional_code_not_eq_any?: InputMaybe<Scalars['String']>;
  additional_code_not_false?: InputMaybe<Scalars['String']>;
  additional_code_not_i_cont?: InputMaybe<Scalars['String']>;
  additional_code_not_i_cont_all?: InputMaybe<Scalars['String']>;
  additional_code_not_i_cont_any?: InputMaybe<Scalars['String']>;
  additional_code_not_in?: InputMaybe<Array<Scalars['String']>>;
  additional_code_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  additional_code_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  additional_code_not_null?: InputMaybe<Scalars['String']>;
  additional_code_not_start?: InputMaybe<Scalars['String']>;
  additional_code_not_start_all?: InputMaybe<Scalars['String']>;
  additional_code_not_start_any?: InputMaybe<Scalars['String']>;
  additional_code_not_true?: InputMaybe<Scalars['String']>;
  additional_code_null?: InputMaybe<Scalars['String']>;
  additional_code_present?: InputMaybe<Scalars['String']>;
  additional_code_start?: InputMaybe<Scalars['String']>;
  additional_code_start_all?: InputMaybe<Scalars['String']>;
  additional_code_start_any?: InputMaybe<Scalars['String']>;
  additional_code_true?: InputMaybe<Scalars['String']>;
  advance_finish_blank?: InputMaybe<Scalars['String']>;
  advance_finish_cont?: InputMaybe<Scalars['String']>;
  advance_finish_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_does_not_match?: InputMaybe<Scalars['String']>;
  advance_finish_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_finish_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_finish_end?: InputMaybe<Scalars['String']>;
  advance_finish_end_all?: InputMaybe<Scalars['String']>;
  advance_finish_end_any?: InputMaybe<Scalars['String']>;
  advance_finish_eq?: InputMaybe<Scalars['String']>;
  advance_finish_eq_all?: InputMaybe<Scalars['String']>;
  advance_finish_eq_any?: InputMaybe<Scalars['String']>;
  advance_finish_false?: InputMaybe<Scalars['String']>;
  advance_finish_gt?: InputMaybe<Scalars['String']>;
  advance_finish_gt_all?: InputMaybe<Scalars['String']>;
  advance_finish_gt_any?: InputMaybe<Scalars['String']>;
  advance_finish_gteq?: InputMaybe<Scalars['String']>;
  advance_finish_gteq_all?: InputMaybe<Scalars['String']>;
  advance_finish_gteq_any?: InputMaybe<Scalars['String']>;
  advance_finish_i_cont?: InputMaybe<Scalars['String']>;
  advance_finish_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_in?: InputMaybe<Scalars['String']>;
  advance_finish_in_all?: InputMaybe<Scalars['String']>;
  advance_finish_in_any?: InputMaybe<Scalars['String']>;
  advance_finish_lt?: InputMaybe<Scalars['String']>;
  advance_finish_lt_all?: InputMaybe<Scalars['String']>;
  advance_finish_lt_any?: InputMaybe<Scalars['String']>;
  advance_finish_lteq?: InputMaybe<Scalars['String']>;
  advance_finish_lteq_all?: InputMaybe<Scalars['String']>;
  advance_finish_lteq_any?: InputMaybe<Scalars['String']>;
  advance_finish_matches?: InputMaybe<Scalars['String']>;
  advance_finish_matches_all?: InputMaybe<Scalars['String']>;
  advance_finish_matches_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_cont?: InputMaybe<Scalars['String']>;
  advance_finish_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_end?: InputMaybe<Scalars['String']>;
  advance_finish_not_end_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_end_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_eq?: InputMaybe<Scalars['String']>;
  advance_finish_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_false?: InputMaybe<Scalars['String']>;
  advance_finish_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_finish_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_in?: InputMaybe<Scalars['String']>;
  advance_finish_not_in_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_in_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_null?: InputMaybe<Scalars['String']>;
  advance_finish_not_start?: InputMaybe<Scalars['String']>;
  advance_finish_not_start_all?: InputMaybe<Scalars['String']>;
  advance_finish_not_start_any?: InputMaybe<Scalars['String']>;
  advance_finish_not_true?: InputMaybe<Scalars['String']>;
  advance_finish_null?: InputMaybe<Scalars['String']>;
  advance_finish_present?: InputMaybe<Scalars['String']>;
  advance_finish_start?: InputMaybe<Scalars['String']>;
  advance_finish_start_all?: InputMaybe<Scalars['String']>;
  advance_finish_start_any?: InputMaybe<Scalars['String']>;
  advance_finish_true?: InputMaybe<Scalars['String']>;
  advance_pending_blank?: InputMaybe<Scalars['String']>;
  advance_pending_cont?: InputMaybe<Scalars['String']>;
  advance_pending_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_does_not_match?: InputMaybe<Scalars['String']>;
  advance_pending_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_pending_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_pending_end?: InputMaybe<Scalars['String']>;
  advance_pending_end_all?: InputMaybe<Scalars['String']>;
  advance_pending_end_any?: InputMaybe<Scalars['String']>;
  advance_pending_eq?: InputMaybe<Scalars['String']>;
  advance_pending_eq_all?: InputMaybe<Scalars['String']>;
  advance_pending_eq_any?: InputMaybe<Scalars['String']>;
  advance_pending_false?: InputMaybe<Scalars['String']>;
  advance_pending_gt?: InputMaybe<Scalars['String']>;
  advance_pending_gt_all?: InputMaybe<Scalars['String']>;
  advance_pending_gt_any?: InputMaybe<Scalars['String']>;
  advance_pending_gteq?: InputMaybe<Scalars['String']>;
  advance_pending_gteq_all?: InputMaybe<Scalars['String']>;
  advance_pending_gteq_any?: InputMaybe<Scalars['String']>;
  advance_pending_i_cont?: InputMaybe<Scalars['String']>;
  advance_pending_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_in?: InputMaybe<Scalars['String']>;
  advance_pending_in_all?: InputMaybe<Scalars['String']>;
  advance_pending_in_any?: InputMaybe<Scalars['String']>;
  advance_pending_lt?: InputMaybe<Scalars['String']>;
  advance_pending_lt_all?: InputMaybe<Scalars['String']>;
  advance_pending_lt_any?: InputMaybe<Scalars['String']>;
  advance_pending_lteq?: InputMaybe<Scalars['String']>;
  advance_pending_lteq_all?: InputMaybe<Scalars['String']>;
  advance_pending_lteq_any?: InputMaybe<Scalars['String']>;
  advance_pending_matches?: InputMaybe<Scalars['String']>;
  advance_pending_matches_all?: InputMaybe<Scalars['String']>;
  advance_pending_matches_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_cont?: InputMaybe<Scalars['String']>;
  advance_pending_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_end?: InputMaybe<Scalars['String']>;
  advance_pending_not_end_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_end_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_eq?: InputMaybe<Scalars['String']>;
  advance_pending_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_false?: InputMaybe<Scalars['String']>;
  advance_pending_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_pending_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_in?: InputMaybe<Scalars['String']>;
  advance_pending_not_in_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_in_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_null?: InputMaybe<Scalars['String']>;
  advance_pending_not_start?: InputMaybe<Scalars['String']>;
  advance_pending_not_start_all?: InputMaybe<Scalars['String']>;
  advance_pending_not_start_any?: InputMaybe<Scalars['String']>;
  advance_pending_not_true?: InputMaybe<Scalars['String']>;
  advance_pending_null?: InputMaybe<Scalars['String']>;
  advance_pending_present?: InputMaybe<Scalars['String']>;
  advance_pending_start?: InputMaybe<Scalars['String']>;
  advance_pending_start_all?: InputMaybe<Scalars['String']>;
  advance_pending_start_any?: InputMaybe<Scalars['String']>;
  advance_pending_true?: InputMaybe<Scalars['String']>;
  code_blank?: InputMaybe<Scalars['String']>;
  code_cont?: InputMaybe<Scalars['String']>;
  code_cont_all?: InputMaybe<Scalars['String']>;
  code_cont_any?: InputMaybe<Scalars['String']>;
  code_does_not_match?: InputMaybe<Scalars['String']>;
  code_does_not_match_all?: InputMaybe<Scalars['String']>;
  code_does_not_match_any?: InputMaybe<Scalars['String']>;
  code_end?: InputMaybe<Scalars['String']>;
  code_end_all?: InputMaybe<Scalars['String']>;
  code_end_any?: InputMaybe<Scalars['String']>;
  code_eq?: InputMaybe<Scalars['String']>;
  code_eq_all?: InputMaybe<Scalars['String']>;
  code_eq_any?: InputMaybe<Scalars['String']>;
  code_false?: InputMaybe<Scalars['String']>;
  code_gt?: InputMaybe<Scalars['String']>;
  code_gt_all?: InputMaybe<Scalars['String']>;
  code_gt_any?: InputMaybe<Scalars['String']>;
  code_gteq?: InputMaybe<Scalars['String']>;
  code_gteq_all?: InputMaybe<Scalars['String']>;
  code_gteq_any?: InputMaybe<Scalars['String']>;
  code_i_cont?: InputMaybe<Scalars['String']>;
  code_i_cont_all?: InputMaybe<Scalars['String']>;
  code_i_cont_any?: InputMaybe<Scalars['String']>;
  code_in?: InputMaybe<Array<Scalars['String']>>;
  code_in_all?: InputMaybe<Array<Scalars['String']>>;
  code_in_any?: InputMaybe<Array<Scalars['String']>>;
  code_lt?: InputMaybe<Scalars['String']>;
  code_lt_all?: InputMaybe<Scalars['String']>;
  code_lt_any?: InputMaybe<Scalars['String']>;
  code_lteq?: InputMaybe<Scalars['String']>;
  code_lteq_all?: InputMaybe<Scalars['String']>;
  code_lteq_any?: InputMaybe<Scalars['String']>;
  code_matches?: InputMaybe<Scalars['String']>;
  code_matches_all?: InputMaybe<Scalars['String']>;
  code_matches_any?: InputMaybe<Scalars['String']>;
  code_not_cont?: InputMaybe<Scalars['String']>;
  code_not_cont_all?: InputMaybe<Scalars['String']>;
  code_not_cont_any?: InputMaybe<Scalars['String']>;
  code_not_end?: InputMaybe<Scalars['String']>;
  code_not_end_all?: InputMaybe<Scalars['String']>;
  code_not_end_any?: InputMaybe<Scalars['String']>;
  code_not_eq?: InputMaybe<Scalars['String']>;
  code_not_eq_all?: InputMaybe<Scalars['String']>;
  code_not_eq_any?: InputMaybe<Scalars['String']>;
  code_not_false?: InputMaybe<Scalars['String']>;
  code_not_i_cont?: InputMaybe<Scalars['String']>;
  code_not_i_cont_all?: InputMaybe<Scalars['String']>;
  code_not_i_cont_any?: InputMaybe<Scalars['String']>;
  code_not_in?: InputMaybe<Array<Scalars['String']>>;
  code_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  code_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  code_not_null?: InputMaybe<Scalars['String']>;
  code_not_start?: InputMaybe<Scalars['String']>;
  code_not_start_all?: InputMaybe<Scalars['String']>;
  code_not_start_any?: InputMaybe<Scalars['String']>;
  code_not_true?: InputMaybe<Scalars['String']>;
  code_null?: InputMaybe<Scalars['String']>;
  code_present?: InputMaybe<Scalars['String']>;
  code_start?: InputMaybe<Scalars['String']>;
  code_start_all?: InputMaybe<Scalars['String']>;
  code_start_any?: InputMaybe<Scalars['String']>;
  code_true?: InputMaybe<Scalars['String']>;
  created_at_blank?: InputMaybe<Scalars['String']>;
  created_at_cont?: InputMaybe<Scalars['String']>;
  created_at_cont_all?: InputMaybe<Scalars['String']>;
  created_at_cont_any?: InputMaybe<Scalars['String']>;
  created_at_does_not_match?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  created_at_end?: InputMaybe<Scalars['String']>;
  created_at_end_all?: InputMaybe<Scalars['String']>;
  created_at_end_any?: InputMaybe<Scalars['String']>;
  created_at_eq?: InputMaybe<Scalars['String']>;
  created_at_eq_all?: InputMaybe<Scalars['String']>;
  created_at_eq_any?: InputMaybe<Scalars['String']>;
  created_at_false?: InputMaybe<Scalars['String']>;
  created_at_gt?: InputMaybe<Scalars['String']>;
  created_at_gt_all?: InputMaybe<Scalars['String']>;
  created_at_gt_any?: InputMaybe<Scalars['String']>;
  created_at_gteq?: InputMaybe<Scalars['String']>;
  created_at_gteq_all?: InputMaybe<Scalars['String']>;
  created_at_gteq_any?: InputMaybe<Scalars['String']>;
  created_at_i_cont?: InputMaybe<Scalars['String']>;
  created_at_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_in?: InputMaybe<Scalars['String']>;
  created_at_in_all?: InputMaybe<Scalars['String']>;
  created_at_in_any?: InputMaybe<Scalars['String']>;
  created_at_lt?: InputMaybe<Scalars['String']>;
  created_at_lt_all?: InputMaybe<Scalars['String']>;
  created_at_lt_any?: InputMaybe<Scalars['String']>;
  created_at_lteq?: InputMaybe<Scalars['String']>;
  created_at_lteq_all?: InputMaybe<Scalars['String']>;
  created_at_lteq_any?: InputMaybe<Scalars['String']>;
  created_at_matches?: InputMaybe<Scalars['String']>;
  created_at_matches_all?: InputMaybe<Scalars['String']>;
  created_at_matches_any?: InputMaybe<Scalars['String']>;
  created_at_not_cont?: InputMaybe<Scalars['String']>;
  created_at_not_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_end?: InputMaybe<Scalars['String']>;
  created_at_not_end_all?: InputMaybe<Scalars['String']>;
  created_at_not_end_any?: InputMaybe<Scalars['String']>;
  created_at_not_eq?: InputMaybe<Scalars['String']>;
  created_at_not_eq_all?: InputMaybe<Scalars['String']>;
  created_at_not_eq_any?: InputMaybe<Scalars['String']>;
  created_at_not_false?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_in?: InputMaybe<Scalars['String']>;
  created_at_not_in_all?: InputMaybe<Scalars['String']>;
  created_at_not_in_any?: InputMaybe<Scalars['String']>;
  created_at_not_null?: InputMaybe<Scalars['String']>;
  created_at_not_start?: InputMaybe<Scalars['String']>;
  created_at_not_start_all?: InputMaybe<Scalars['String']>;
  created_at_not_start_any?: InputMaybe<Scalars['String']>;
  created_at_not_true?: InputMaybe<Scalars['String']>;
  created_at_null?: InputMaybe<Scalars['String']>;
  created_at_present?: InputMaybe<Scalars['String']>;
  created_at_start?: InputMaybe<Scalars['String']>;
  created_at_start_all?: InputMaybe<Scalars['String']>;
  created_at_start_any?: InputMaybe<Scalars['String']>;
  created_at_true?: InputMaybe<Scalars['String']>;
  end_date_blank?: InputMaybe<Scalars['String']>;
  end_date_cont?: InputMaybe<Scalars['String']>;
  end_date_cont_all?: InputMaybe<Scalars['String']>;
  end_date_cont_any?: InputMaybe<Scalars['String']>;
  end_date_does_not_match?: InputMaybe<Scalars['String']>;
  end_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  end_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  end_date_end?: InputMaybe<Scalars['String']>;
  end_date_end_all?: InputMaybe<Scalars['String']>;
  end_date_end_any?: InputMaybe<Scalars['String']>;
  end_date_eq?: InputMaybe<Scalars['String']>;
  end_date_eq_all?: InputMaybe<Scalars['String']>;
  end_date_eq_any?: InputMaybe<Scalars['String']>;
  end_date_false?: InputMaybe<Scalars['String']>;
  end_date_gt?: InputMaybe<Scalars['String']>;
  end_date_gt_all?: InputMaybe<Scalars['String']>;
  end_date_gt_any?: InputMaybe<Scalars['String']>;
  end_date_gteq?: InputMaybe<Scalars['String']>;
  end_date_gteq_all?: InputMaybe<Scalars['String']>;
  end_date_gteq_any?: InputMaybe<Scalars['String']>;
  end_date_i_cont?: InputMaybe<Scalars['String']>;
  end_date_i_cont_all?: InputMaybe<Scalars['String']>;
  end_date_i_cont_any?: InputMaybe<Scalars['String']>;
  end_date_in?: InputMaybe<Scalars['String']>;
  end_date_in_all?: InputMaybe<Scalars['String']>;
  end_date_in_any?: InputMaybe<Scalars['String']>;
  end_date_lt?: InputMaybe<Scalars['String']>;
  end_date_lt_all?: InputMaybe<Scalars['String']>;
  end_date_lt_any?: InputMaybe<Scalars['String']>;
  end_date_lteq?: InputMaybe<Scalars['String']>;
  end_date_lteq_all?: InputMaybe<Scalars['String']>;
  end_date_lteq_any?: InputMaybe<Scalars['String']>;
  end_date_matches?: InputMaybe<Scalars['String']>;
  end_date_matches_all?: InputMaybe<Scalars['String']>;
  end_date_matches_any?: InputMaybe<Scalars['String']>;
  end_date_not_cont?: InputMaybe<Scalars['String']>;
  end_date_not_cont_all?: InputMaybe<Scalars['String']>;
  end_date_not_cont_any?: InputMaybe<Scalars['String']>;
  end_date_not_end?: InputMaybe<Scalars['String']>;
  end_date_not_end_all?: InputMaybe<Scalars['String']>;
  end_date_not_end_any?: InputMaybe<Scalars['String']>;
  end_date_not_eq?: InputMaybe<Scalars['String']>;
  end_date_not_eq_all?: InputMaybe<Scalars['String']>;
  end_date_not_eq_any?: InputMaybe<Scalars['String']>;
  end_date_not_false?: InputMaybe<Scalars['String']>;
  end_date_not_i_cont?: InputMaybe<Scalars['String']>;
  end_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  end_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  end_date_not_in?: InputMaybe<Scalars['String']>;
  end_date_not_in_all?: InputMaybe<Scalars['String']>;
  end_date_not_in_any?: InputMaybe<Scalars['String']>;
  end_date_not_null?: InputMaybe<Scalars['String']>;
  end_date_not_start?: InputMaybe<Scalars['String']>;
  end_date_not_start_all?: InputMaybe<Scalars['String']>;
  end_date_not_start_any?: InputMaybe<Scalars['String']>;
  end_date_not_true?: InputMaybe<Scalars['String']>;
  end_date_null?: InputMaybe<Scalars['String']>;
  end_date_present?: InputMaybe<Scalars['String']>;
  end_date_start?: InputMaybe<Scalars['String']>;
  end_date_start_all?: InputMaybe<Scalars['String']>;
  end_date_start_any?: InputMaybe<Scalars['String']>;
  end_date_true?: InputMaybe<Scalars['String']>;
  evaluations_blank?: InputMaybe<Scalars['String']>;
  evaluations_cont?: InputMaybe<Scalars['String']>;
  evaluations_cont_all?: InputMaybe<Scalars['String']>;
  evaluations_cont_any?: InputMaybe<Scalars['String']>;
  evaluations_does_not_match?: InputMaybe<Scalars['String']>;
  evaluations_does_not_match_all?: InputMaybe<Scalars['String']>;
  evaluations_does_not_match_any?: InputMaybe<Scalars['String']>;
  evaluations_end?: InputMaybe<Scalars['String']>;
  evaluations_end_all?: InputMaybe<Scalars['String']>;
  evaluations_end_any?: InputMaybe<Scalars['String']>;
  evaluations_eq?: InputMaybe<Scalars['String']>;
  evaluations_eq_all?: InputMaybe<Scalars['String']>;
  evaluations_eq_any?: InputMaybe<Scalars['String']>;
  evaluations_false?: InputMaybe<Scalars['String']>;
  evaluations_gt?: InputMaybe<Scalars['String']>;
  evaluations_gt_all?: InputMaybe<Scalars['String']>;
  evaluations_gt_any?: InputMaybe<Scalars['String']>;
  evaluations_gteq?: InputMaybe<Scalars['String']>;
  evaluations_gteq_all?: InputMaybe<Scalars['String']>;
  evaluations_gteq_any?: InputMaybe<Scalars['String']>;
  evaluations_i_cont?: InputMaybe<Scalars['String']>;
  evaluations_i_cont_all?: InputMaybe<Scalars['String']>;
  evaluations_i_cont_any?: InputMaybe<Scalars['String']>;
  evaluations_in?: InputMaybe<Scalars['String']>;
  evaluations_in_all?: InputMaybe<Scalars['String']>;
  evaluations_in_any?: InputMaybe<Scalars['String']>;
  evaluations_lt?: InputMaybe<Scalars['String']>;
  evaluations_lt_all?: InputMaybe<Scalars['String']>;
  evaluations_lt_any?: InputMaybe<Scalars['String']>;
  evaluations_lteq?: InputMaybe<Scalars['String']>;
  evaluations_lteq_all?: InputMaybe<Scalars['String']>;
  evaluations_lteq_any?: InputMaybe<Scalars['String']>;
  evaluations_matches?: InputMaybe<Scalars['String']>;
  evaluations_matches_all?: InputMaybe<Scalars['String']>;
  evaluations_matches_any?: InputMaybe<Scalars['String']>;
  evaluations_not_cont?: InputMaybe<Scalars['String']>;
  evaluations_not_cont_all?: InputMaybe<Scalars['String']>;
  evaluations_not_cont_any?: InputMaybe<Scalars['String']>;
  evaluations_not_end?: InputMaybe<Scalars['String']>;
  evaluations_not_end_all?: InputMaybe<Scalars['String']>;
  evaluations_not_end_any?: InputMaybe<Scalars['String']>;
  evaluations_not_eq?: InputMaybe<Scalars['String']>;
  evaluations_not_eq_all?: InputMaybe<Scalars['String']>;
  evaluations_not_eq_any?: InputMaybe<Scalars['String']>;
  evaluations_not_false?: InputMaybe<Scalars['String']>;
  evaluations_not_i_cont?: InputMaybe<Scalars['String']>;
  evaluations_not_i_cont_all?: InputMaybe<Scalars['String']>;
  evaluations_not_i_cont_any?: InputMaybe<Scalars['String']>;
  evaluations_not_in?: InputMaybe<Scalars['String']>;
  evaluations_not_in_all?: InputMaybe<Scalars['String']>;
  evaluations_not_in_any?: InputMaybe<Scalars['String']>;
  evaluations_not_null?: InputMaybe<Scalars['String']>;
  evaluations_not_start?: InputMaybe<Scalars['String']>;
  evaluations_not_start_all?: InputMaybe<Scalars['String']>;
  evaluations_not_start_any?: InputMaybe<Scalars['String']>;
  evaluations_not_true?: InputMaybe<Scalars['String']>;
  evaluations_null?: InputMaybe<Scalars['String']>;
  evaluations_present?: InputMaybe<Scalars['String']>;
  evaluations_start?: InputMaybe<Scalars['String']>;
  evaluations_start_all?: InputMaybe<Scalars['String']>;
  evaluations_start_any?: InputMaybe<Scalars['String']>;
  evaluations_true?: InputMaybe<Scalars['String']>;
  g?: InputMaybe<Array<Scalars['JSON']>>;
  id_blank?: InputMaybe<Scalars['Int']>;
  id_cont?: InputMaybe<Scalars['Int']>;
  id_cont_all?: InputMaybe<Scalars['Int']>;
  id_cont_any?: InputMaybe<Scalars['Int']>;
  id_does_not_match?: InputMaybe<Scalars['Int']>;
  id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  id_end?: InputMaybe<Scalars['Int']>;
  id_end_all?: InputMaybe<Scalars['Int']>;
  id_end_any?: InputMaybe<Scalars['Int']>;
  id_eq?: InputMaybe<Scalars['Int']>;
  id_eq_all?: InputMaybe<Scalars['Int']>;
  id_eq_any?: InputMaybe<Scalars['Int']>;
  id_false?: InputMaybe<Scalars['Int']>;
  id_gt?: InputMaybe<Scalars['Int']>;
  id_gt_all?: InputMaybe<Scalars['Int']>;
  id_gt_any?: InputMaybe<Scalars['Int']>;
  id_gteq?: InputMaybe<Scalars['Int']>;
  id_gteq_all?: InputMaybe<Scalars['Int']>;
  id_gteq_any?: InputMaybe<Scalars['Int']>;
  id_i_cont?: InputMaybe<Scalars['Int']>;
  id_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_in?: InputMaybe<Array<Scalars['Int']>>;
  id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_lt?: InputMaybe<Scalars['Int']>;
  id_lt_all?: InputMaybe<Scalars['Int']>;
  id_lt_any?: InputMaybe<Scalars['Int']>;
  id_lteq?: InputMaybe<Scalars['Int']>;
  id_lteq_all?: InputMaybe<Scalars['Int']>;
  id_lteq_any?: InputMaybe<Scalars['Int']>;
  id_matches?: InputMaybe<Scalars['Int']>;
  id_matches_all?: InputMaybe<Scalars['Int']>;
  id_matches_any?: InputMaybe<Scalars['Int']>;
  id_not_cont?: InputMaybe<Scalars['Int']>;
  id_not_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_end?: InputMaybe<Scalars['Int']>;
  id_not_end_all?: InputMaybe<Scalars['Int']>;
  id_not_end_any?: InputMaybe<Scalars['Int']>;
  id_not_eq?: InputMaybe<Scalars['Int']>;
  id_not_eq_all?: InputMaybe<Scalars['Int']>;
  id_not_eq_any?: InputMaybe<Scalars['Int']>;
  id_not_false?: InputMaybe<Scalars['Int']>;
  id_not_i_cont?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_not_null?: InputMaybe<Scalars['Int']>;
  id_not_start?: InputMaybe<Scalars['Int']>;
  id_not_start_all?: InputMaybe<Scalars['Int']>;
  id_not_start_any?: InputMaybe<Scalars['Int']>;
  id_not_true?: InputMaybe<Scalars['Int']>;
  id_null?: InputMaybe<Scalars['Int']>;
  id_present?: InputMaybe<Scalars['Int']>;
  id_start?: InputMaybe<Scalars['Int']>;
  id_start_all?: InputMaybe<Scalars['Int']>;
  id_start_any?: InputMaybe<Scalars['Int']>;
  id_true?: InputMaybe<Scalars['Int']>;
  institution_blank?: InputMaybe<Scalars['String']>;
  institution_cont?: InputMaybe<Scalars['String']>;
  institution_cont_all?: InputMaybe<Scalars['String']>;
  institution_cont_any?: InputMaybe<Scalars['String']>;
  institution_does_not_match?: InputMaybe<Scalars['String']>;
  institution_does_not_match_all?: InputMaybe<Scalars['String']>;
  institution_does_not_match_any?: InputMaybe<Scalars['String']>;
  institution_end?: InputMaybe<Scalars['String']>;
  institution_end_all?: InputMaybe<Scalars['String']>;
  institution_end_any?: InputMaybe<Scalars['String']>;
  institution_eq?: InputMaybe<Scalars['String']>;
  institution_eq_all?: InputMaybe<Scalars['String']>;
  institution_eq_any?: InputMaybe<Scalars['String']>;
  institution_false?: InputMaybe<Scalars['String']>;
  institution_gt?: InputMaybe<Scalars['String']>;
  institution_gt_all?: InputMaybe<Scalars['String']>;
  institution_gt_any?: InputMaybe<Scalars['String']>;
  institution_gteq?: InputMaybe<Scalars['String']>;
  institution_gteq_all?: InputMaybe<Scalars['String']>;
  institution_gteq_any?: InputMaybe<Scalars['String']>;
  institution_i_cont?: InputMaybe<Scalars['String']>;
  institution_i_cont_all?: InputMaybe<Scalars['String']>;
  institution_i_cont_any?: InputMaybe<Scalars['String']>;
  institution_in?: InputMaybe<Array<Scalars['String']>>;
  institution_in_all?: InputMaybe<Array<Scalars['String']>>;
  institution_in_any?: InputMaybe<Array<Scalars['String']>>;
  institution_lt?: InputMaybe<Scalars['String']>;
  institution_lt_all?: InputMaybe<Scalars['String']>;
  institution_lt_any?: InputMaybe<Scalars['String']>;
  institution_lteq?: InputMaybe<Scalars['String']>;
  institution_lteq_all?: InputMaybe<Scalars['String']>;
  institution_lteq_any?: InputMaybe<Scalars['String']>;
  institution_matches?: InputMaybe<Scalars['String']>;
  institution_matches_all?: InputMaybe<Scalars['String']>;
  institution_matches_any?: InputMaybe<Scalars['String']>;
  institution_not_cont?: InputMaybe<Scalars['String']>;
  institution_not_cont_all?: InputMaybe<Scalars['String']>;
  institution_not_cont_any?: InputMaybe<Scalars['String']>;
  institution_not_end?: InputMaybe<Scalars['String']>;
  institution_not_end_all?: InputMaybe<Scalars['String']>;
  institution_not_end_any?: InputMaybe<Scalars['String']>;
  institution_not_eq?: InputMaybe<Scalars['String']>;
  institution_not_eq_all?: InputMaybe<Scalars['String']>;
  institution_not_eq_any?: InputMaybe<Scalars['String']>;
  institution_not_false?: InputMaybe<Scalars['String']>;
  institution_not_i_cont?: InputMaybe<Scalars['String']>;
  institution_not_i_cont_all?: InputMaybe<Scalars['String']>;
  institution_not_i_cont_any?: InputMaybe<Scalars['String']>;
  institution_not_in?: InputMaybe<Array<Scalars['String']>>;
  institution_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  institution_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  institution_not_null?: InputMaybe<Scalars['String']>;
  institution_not_start?: InputMaybe<Scalars['String']>;
  institution_not_start_all?: InputMaybe<Scalars['String']>;
  institution_not_start_any?: InputMaybe<Scalars['String']>;
  institution_not_true?: InputMaybe<Scalars['String']>;
  institution_null?: InputMaybe<Scalars['String']>;
  institution_present?: InputMaybe<Scalars['String']>;
  institution_start?: InputMaybe<Scalars['String']>;
  institution_start_all?: InputMaybe<Scalars['String']>;
  institution_start_any?: InputMaybe<Scalars['String']>;
  institution_true?: InputMaybe<Scalars['String']>;
  modality_blank?: InputMaybe<Scalars['Int']>;
  modality_cont?: InputMaybe<Scalars['Int']>;
  modality_cont_all?: InputMaybe<Scalars['Int']>;
  modality_cont_any?: InputMaybe<Scalars['Int']>;
  modality_does_not_match?: InputMaybe<Scalars['Int']>;
  modality_does_not_match_all?: InputMaybe<Scalars['Int']>;
  modality_does_not_match_any?: InputMaybe<Scalars['Int']>;
  modality_end?: InputMaybe<Scalars['Int']>;
  modality_end_all?: InputMaybe<Scalars['Int']>;
  modality_end_any?: InputMaybe<Scalars['Int']>;
  modality_eq?: InputMaybe<Scalars['Int']>;
  modality_eq_all?: InputMaybe<Scalars['Int']>;
  modality_eq_any?: InputMaybe<Scalars['Int']>;
  modality_false?: InputMaybe<Scalars['Int']>;
  modality_gt?: InputMaybe<Scalars['Int']>;
  modality_gt_all?: InputMaybe<Scalars['Int']>;
  modality_gt_any?: InputMaybe<Scalars['Int']>;
  modality_gteq?: InputMaybe<Scalars['Int']>;
  modality_gteq_all?: InputMaybe<Scalars['Int']>;
  modality_gteq_any?: InputMaybe<Scalars['Int']>;
  modality_i_cont?: InputMaybe<Scalars['Int']>;
  modality_i_cont_all?: InputMaybe<Scalars['Int']>;
  modality_i_cont_any?: InputMaybe<Scalars['Int']>;
  modality_in?: InputMaybe<Array<Scalars['Int']>>;
  modality_in_all?: InputMaybe<Array<Scalars['Int']>>;
  modality_in_any?: InputMaybe<Array<Scalars['Int']>>;
  modality_lt?: InputMaybe<Scalars['Int']>;
  modality_lt_all?: InputMaybe<Scalars['Int']>;
  modality_lt_any?: InputMaybe<Scalars['Int']>;
  modality_lteq?: InputMaybe<Scalars['Int']>;
  modality_lteq_all?: InputMaybe<Scalars['Int']>;
  modality_lteq_any?: InputMaybe<Scalars['Int']>;
  modality_matches?: InputMaybe<Scalars['Int']>;
  modality_matches_all?: InputMaybe<Scalars['Int']>;
  modality_matches_any?: InputMaybe<Scalars['Int']>;
  modality_not_cont?: InputMaybe<Scalars['Int']>;
  modality_not_cont_all?: InputMaybe<Scalars['Int']>;
  modality_not_cont_any?: InputMaybe<Scalars['Int']>;
  modality_not_end?: InputMaybe<Scalars['Int']>;
  modality_not_end_all?: InputMaybe<Scalars['Int']>;
  modality_not_end_any?: InputMaybe<Scalars['Int']>;
  modality_not_eq?: InputMaybe<Scalars['Int']>;
  modality_not_eq_all?: InputMaybe<Scalars['Int']>;
  modality_not_eq_any?: InputMaybe<Scalars['Int']>;
  modality_not_false?: InputMaybe<Scalars['Int']>;
  modality_not_i_cont?: InputMaybe<Scalars['Int']>;
  modality_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  modality_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  modality_not_in?: InputMaybe<Array<Scalars['Int']>>;
  modality_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  modality_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  modality_not_null?: InputMaybe<Scalars['Int']>;
  modality_not_start?: InputMaybe<Scalars['Int']>;
  modality_not_start_all?: InputMaybe<Scalars['Int']>;
  modality_not_start_any?: InputMaybe<Scalars['Int']>;
  modality_not_true?: InputMaybe<Scalars['Int']>;
  modality_null?: InputMaybe<Scalars['Int']>;
  modality_present?: InputMaybe<Scalars['Int']>;
  modality_start?: InputMaybe<Scalars['Int']>;
  modality_start_all?: InputMaybe<Scalars['Int']>;
  modality_start_any?: InputMaybe<Scalars['Int']>;
  modality_true?: InputMaybe<Scalars['Int']>;
  name_blank?: InputMaybe<Scalars['String']>;
  name_cont?: InputMaybe<Scalars['String']>;
  name_cont_all?: InputMaybe<Scalars['String']>;
  name_cont_any?: InputMaybe<Scalars['String']>;
  name_does_not_match?: InputMaybe<Scalars['String']>;
  name_does_not_match_all?: InputMaybe<Scalars['String']>;
  name_does_not_match_any?: InputMaybe<Scalars['String']>;
  name_end?: InputMaybe<Scalars['String']>;
  name_end_all?: InputMaybe<Scalars['String']>;
  name_end_any?: InputMaybe<Scalars['String']>;
  name_eq?: InputMaybe<Scalars['String']>;
  name_eq_all?: InputMaybe<Scalars['String']>;
  name_eq_any?: InputMaybe<Scalars['String']>;
  name_false?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gt_all?: InputMaybe<Scalars['String']>;
  name_gt_any?: InputMaybe<Scalars['String']>;
  name_gteq?: InputMaybe<Scalars['String']>;
  name_gteq_all?: InputMaybe<Scalars['String']>;
  name_gteq_any?: InputMaybe<Scalars['String']>;
  name_i_cont?: InputMaybe<Scalars['String']>;
  name_i_cont_all?: InputMaybe<Scalars['String']>;
  name_i_cont_any?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lt_all?: InputMaybe<Scalars['String']>;
  name_lt_any?: InputMaybe<Scalars['String']>;
  name_lteq?: InputMaybe<Scalars['String']>;
  name_lteq_all?: InputMaybe<Scalars['String']>;
  name_lteq_any?: InputMaybe<Scalars['String']>;
  name_matches?: InputMaybe<Scalars['String']>;
  name_matches_all?: InputMaybe<Scalars['String']>;
  name_matches_any?: InputMaybe<Scalars['String']>;
  name_not_cont?: InputMaybe<Scalars['String']>;
  name_not_cont_all?: InputMaybe<Scalars['String']>;
  name_not_cont_any?: InputMaybe<Scalars['String']>;
  name_not_end?: InputMaybe<Scalars['String']>;
  name_not_end_all?: InputMaybe<Scalars['String']>;
  name_not_end_any?: InputMaybe<Scalars['String']>;
  name_not_eq?: InputMaybe<Scalars['String']>;
  name_not_eq_all?: InputMaybe<Scalars['String']>;
  name_not_eq_any?: InputMaybe<Scalars['String']>;
  name_not_false?: InputMaybe<Scalars['String']>;
  name_not_i_cont?: InputMaybe<Scalars['String']>;
  name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_not_null?: InputMaybe<Scalars['String']>;
  name_not_start?: InputMaybe<Scalars['String']>;
  name_not_start_all?: InputMaybe<Scalars['String']>;
  name_not_start_any?: InputMaybe<Scalars['String']>;
  name_not_true?: InputMaybe<Scalars['String']>;
  name_null?: InputMaybe<Scalars['String']>;
  name_or_code_cont?: InputMaybe<Scalars['String']>;
  name_present?: InputMaybe<Scalars['String']>;
  name_start?: InputMaybe<Scalars['String']>;
  name_start_all?: InputMaybe<Scalars['String']>;
  name_start_any?: InputMaybe<Scalars['String']>;
  name_true?: InputMaybe<Scalars['String']>;
  search_name_blank?: InputMaybe<Scalars['String']>;
  search_name_cont?: InputMaybe<Scalars['String']>;
  search_name_cont_all?: InputMaybe<Scalars['String']>;
  search_name_cont_any?: InputMaybe<Scalars['String']>;
  search_name_does_not_match?: InputMaybe<Scalars['String']>;
  search_name_does_not_match_all?: InputMaybe<Scalars['String']>;
  search_name_does_not_match_any?: InputMaybe<Scalars['String']>;
  search_name_end?: InputMaybe<Scalars['String']>;
  search_name_end_all?: InputMaybe<Scalars['String']>;
  search_name_end_any?: InputMaybe<Scalars['String']>;
  search_name_eq?: InputMaybe<Scalars['String']>;
  search_name_eq_all?: InputMaybe<Scalars['String']>;
  search_name_eq_any?: InputMaybe<Scalars['String']>;
  search_name_false?: InputMaybe<Scalars['String']>;
  search_name_gt?: InputMaybe<Scalars['String']>;
  search_name_gt_all?: InputMaybe<Scalars['String']>;
  search_name_gt_any?: InputMaybe<Scalars['String']>;
  search_name_gteq?: InputMaybe<Scalars['String']>;
  search_name_gteq_all?: InputMaybe<Scalars['String']>;
  search_name_gteq_any?: InputMaybe<Scalars['String']>;
  search_name_i_cont?: InputMaybe<Scalars['String']>;
  search_name_i_cont_all?: InputMaybe<Scalars['String']>;
  search_name_i_cont_any?: InputMaybe<Scalars['String']>;
  search_name_in?: InputMaybe<Scalars['String']>;
  search_name_in_all?: InputMaybe<Scalars['String']>;
  search_name_in_any?: InputMaybe<Scalars['String']>;
  search_name_lt?: InputMaybe<Scalars['String']>;
  search_name_lt_all?: InputMaybe<Scalars['String']>;
  search_name_lt_any?: InputMaybe<Scalars['String']>;
  search_name_lteq?: InputMaybe<Scalars['String']>;
  search_name_lteq_all?: InputMaybe<Scalars['String']>;
  search_name_lteq_any?: InputMaybe<Scalars['String']>;
  search_name_matches?: InputMaybe<Scalars['String']>;
  search_name_matches_all?: InputMaybe<Scalars['String']>;
  search_name_matches_any?: InputMaybe<Scalars['String']>;
  search_name_not_cont?: InputMaybe<Scalars['String']>;
  search_name_not_cont_all?: InputMaybe<Scalars['String']>;
  search_name_not_cont_any?: InputMaybe<Scalars['String']>;
  search_name_not_end?: InputMaybe<Scalars['String']>;
  search_name_not_end_all?: InputMaybe<Scalars['String']>;
  search_name_not_end_any?: InputMaybe<Scalars['String']>;
  search_name_not_eq?: InputMaybe<Scalars['String']>;
  search_name_not_eq_all?: InputMaybe<Scalars['String']>;
  search_name_not_eq_any?: InputMaybe<Scalars['String']>;
  search_name_not_false?: InputMaybe<Scalars['String']>;
  search_name_not_i_cont?: InputMaybe<Scalars['String']>;
  search_name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  search_name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  search_name_not_in?: InputMaybe<Scalars['String']>;
  search_name_not_in_all?: InputMaybe<Scalars['String']>;
  search_name_not_in_any?: InputMaybe<Scalars['String']>;
  search_name_not_null?: InputMaybe<Scalars['String']>;
  search_name_not_start?: InputMaybe<Scalars['String']>;
  search_name_not_start_all?: InputMaybe<Scalars['String']>;
  search_name_not_start_any?: InputMaybe<Scalars['String']>;
  search_name_not_true?: InputMaybe<Scalars['String']>;
  search_name_null?: InputMaybe<Scalars['String']>;
  search_name_present?: InputMaybe<Scalars['String']>;
  search_name_start?: InputMaybe<Scalars['String']>;
  search_name_start_all?: InputMaybe<Scalars['String']>;
  search_name_start_any?: InputMaybe<Scalars['String']>;
  search_name_true?: InputMaybe<Scalars['String']>;
  sorts?: InputMaybe<Array<Scalars['String']>>;
  start_date_blank?: InputMaybe<Scalars['String']>;
  start_date_cont?: InputMaybe<Scalars['String']>;
  start_date_cont_all?: InputMaybe<Scalars['String']>;
  start_date_cont_any?: InputMaybe<Scalars['String']>;
  start_date_does_not_match?: InputMaybe<Scalars['String']>;
  start_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  start_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  start_date_end?: InputMaybe<Scalars['String']>;
  start_date_end_all?: InputMaybe<Scalars['String']>;
  start_date_end_any?: InputMaybe<Scalars['String']>;
  start_date_eq?: InputMaybe<Scalars['String']>;
  start_date_eq_all?: InputMaybe<Scalars['String']>;
  start_date_eq_any?: InputMaybe<Scalars['String']>;
  start_date_false?: InputMaybe<Scalars['String']>;
  start_date_gt?: InputMaybe<Scalars['String']>;
  start_date_gt_all?: InputMaybe<Scalars['String']>;
  start_date_gt_any?: InputMaybe<Scalars['String']>;
  start_date_gteq?: InputMaybe<Scalars['String']>;
  start_date_gteq_all?: InputMaybe<Scalars['String']>;
  start_date_gteq_any?: InputMaybe<Scalars['String']>;
  start_date_i_cont?: InputMaybe<Scalars['String']>;
  start_date_i_cont_all?: InputMaybe<Scalars['String']>;
  start_date_i_cont_any?: InputMaybe<Scalars['String']>;
  start_date_in?: InputMaybe<Scalars['String']>;
  start_date_in_all?: InputMaybe<Scalars['String']>;
  start_date_in_any?: InputMaybe<Scalars['String']>;
  start_date_lt?: InputMaybe<Scalars['String']>;
  start_date_lt_all?: InputMaybe<Scalars['String']>;
  start_date_lt_any?: InputMaybe<Scalars['String']>;
  start_date_lteq?: InputMaybe<Scalars['String']>;
  start_date_lteq_all?: InputMaybe<Scalars['String']>;
  start_date_lteq_any?: InputMaybe<Scalars['String']>;
  start_date_matches?: InputMaybe<Scalars['String']>;
  start_date_matches_all?: InputMaybe<Scalars['String']>;
  start_date_matches_any?: InputMaybe<Scalars['String']>;
  start_date_not_cont?: InputMaybe<Scalars['String']>;
  start_date_not_cont_all?: InputMaybe<Scalars['String']>;
  start_date_not_cont_any?: InputMaybe<Scalars['String']>;
  start_date_not_end?: InputMaybe<Scalars['String']>;
  start_date_not_end_all?: InputMaybe<Scalars['String']>;
  start_date_not_end_any?: InputMaybe<Scalars['String']>;
  start_date_not_eq?: InputMaybe<Scalars['String']>;
  start_date_not_eq_all?: InputMaybe<Scalars['String']>;
  start_date_not_eq_any?: InputMaybe<Scalars['String']>;
  start_date_not_false?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  start_date_not_in?: InputMaybe<Scalars['String']>;
  start_date_not_in_all?: InputMaybe<Scalars['String']>;
  start_date_not_in_any?: InputMaybe<Scalars['String']>;
  start_date_not_null?: InputMaybe<Scalars['String']>;
  start_date_not_start?: InputMaybe<Scalars['String']>;
  start_date_not_start_all?: InputMaybe<Scalars['String']>;
  start_date_not_start_any?: InputMaybe<Scalars['String']>;
  start_date_not_true?: InputMaybe<Scalars['String']>;
  start_date_null?: InputMaybe<Scalars['String']>;
  start_date_present?: InputMaybe<Scalars['String']>;
  start_date_start?: InputMaybe<Scalars['String']>;
  start_date_start_all?: InputMaybe<Scalars['String']>;
  start_date_start_any?: InputMaybe<Scalars['String']>;
  start_date_true?: InputMaybe<Scalars['String']>;
  trim_name_blank?: InputMaybe<Scalars['String']>;
  trim_name_cont?: InputMaybe<Scalars['String']>;
  trim_name_cont_all?: InputMaybe<Scalars['String']>;
  trim_name_cont_any?: InputMaybe<Scalars['String']>;
  trim_name_does_not_match?: InputMaybe<Scalars['String']>;
  trim_name_does_not_match_all?: InputMaybe<Scalars['String']>;
  trim_name_does_not_match_any?: InputMaybe<Scalars['String']>;
  trim_name_end?: InputMaybe<Scalars['String']>;
  trim_name_end_all?: InputMaybe<Scalars['String']>;
  trim_name_end_any?: InputMaybe<Scalars['String']>;
  trim_name_eq?: InputMaybe<Scalars['String']>;
  trim_name_eq_all?: InputMaybe<Scalars['String']>;
  trim_name_eq_any?: InputMaybe<Scalars['String']>;
  trim_name_false?: InputMaybe<Scalars['String']>;
  trim_name_gt?: InputMaybe<Scalars['String']>;
  trim_name_gt_all?: InputMaybe<Scalars['String']>;
  trim_name_gt_any?: InputMaybe<Scalars['String']>;
  trim_name_gteq?: InputMaybe<Scalars['String']>;
  trim_name_gteq_all?: InputMaybe<Scalars['String']>;
  trim_name_gteq_any?: InputMaybe<Scalars['String']>;
  trim_name_i_cont?: InputMaybe<Scalars['String']>;
  trim_name_i_cont_all?: InputMaybe<Scalars['String']>;
  trim_name_i_cont_any?: InputMaybe<Scalars['String']>;
  trim_name_in?: InputMaybe<Scalars['String']>;
  trim_name_in_all?: InputMaybe<Scalars['String']>;
  trim_name_in_any?: InputMaybe<Scalars['String']>;
  trim_name_lt?: InputMaybe<Scalars['String']>;
  trim_name_lt_all?: InputMaybe<Scalars['String']>;
  trim_name_lt_any?: InputMaybe<Scalars['String']>;
  trim_name_lteq?: InputMaybe<Scalars['String']>;
  trim_name_lteq_all?: InputMaybe<Scalars['String']>;
  trim_name_lteq_any?: InputMaybe<Scalars['String']>;
  trim_name_matches?: InputMaybe<Scalars['String']>;
  trim_name_matches_all?: InputMaybe<Scalars['String']>;
  trim_name_matches_any?: InputMaybe<Scalars['String']>;
  trim_name_not_cont?: InputMaybe<Scalars['String']>;
  trim_name_not_cont_all?: InputMaybe<Scalars['String']>;
  trim_name_not_cont_any?: InputMaybe<Scalars['String']>;
  trim_name_not_end?: InputMaybe<Scalars['String']>;
  trim_name_not_end_all?: InputMaybe<Scalars['String']>;
  trim_name_not_end_any?: InputMaybe<Scalars['String']>;
  trim_name_not_eq?: InputMaybe<Scalars['String']>;
  trim_name_not_eq_all?: InputMaybe<Scalars['String']>;
  trim_name_not_eq_any?: InputMaybe<Scalars['String']>;
  trim_name_not_false?: InputMaybe<Scalars['String']>;
  trim_name_not_i_cont?: InputMaybe<Scalars['String']>;
  trim_name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  trim_name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  trim_name_not_in?: InputMaybe<Scalars['String']>;
  trim_name_not_in_all?: InputMaybe<Scalars['String']>;
  trim_name_not_in_any?: InputMaybe<Scalars['String']>;
  trim_name_not_null?: InputMaybe<Scalars['String']>;
  trim_name_not_start?: InputMaybe<Scalars['String']>;
  trim_name_not_start_all?: InputMaybe<Scalars['String']>;
  trim_name_not_start_any?: InputMaybe<Scalars['String']>;
  trim_name_not_true?: InputMaybe<Scalars['String']>;
  trim_name_null?: InputMaybe<Scalars['String']>;
  trim_name_present?: InputMaybe<Scalars['String']>;
  trim_name_start?: InputMaybe<Scalars['String']>;
  trim_name_start_all?: InputMaybe<Scalars['String']>;
  trim_name_start_any?: InputMaybe<Scalars['String']>;
  trim_name_true?: InputMaybe<Scalars['String']>;
};

export type ExternalCourseUserRansack = {
  advance_blank?: InputMaybe<Scalars['String']>;
  advance_cont?: InputMaybe<Scalars['String']>;
  advance_cont_all?: InputMaybe<Scalars['String']>;
  advance_cont_any?: InputMaybe<Scalars['String']>;
  advance_does_not_match?: InputMaybe<Scalars['String']>;
  advance_does_not_match_all?: InputMaybe<Scalars['String']>;
  advance_does_not_match_any?: InputMaybe<Scalars['String']>;
  advance_end?: InputMaybe<Scalars['String']>;
  advance_end_all?: InputMaybe<Scalars['String']>;
  advance_end_any?: InputMaybe<Scalars['String']>;
  advance_eq?: InputMaybe<Scalars['String']>;
  advance_eq_all?: InputMaybe<Scalars['String']>;
  advance_eq_any?: InputMaybe<Scalars['String']>;
  advance_false?: InputMaybe<Scalars['String']>;
  advance_gt?: InputMaybe<Scalars['String']>;
  advance_gt_all?: InputMaybe<Scalars['String']>;
  advance_gt_any?: InputMaybe<Scalars['String']>;
  advance_gteq?: InputMaybe<Scalars['String']>;
  advance_gteq_all?: InputMaybe<Scalars['String']>;
  advance_gteq_any?: InputMaybe<Scalars['String']>;
  advance_i_cont?: InputMaybe<Scalars['String']>;
  advance_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_in?: InputMaybe<Scalars['String']>;
  advance_in_all?: InputMaybe<Scalars['String']>;
  advance_in_any?: InputMaybe<Scalars['String']>;
  advance_lt?: InputMaybe<Scalars['String']>;
  advance_lt_all?: InputMaybe<Scalars['String']>;
  advance_lt_any?: InputMaybe<Scalars['String']>;
  advance_lteq?: InputMaybe<Scalars['String']>;
  advance_lteq_all?: InputMaybe<Scalars['String']>;
  advance_lteq_any?: InputMaybe<Scalars['String']>;
  advance_matches?: InputMaybe<Scalars['String']>;
  advance_matches_all?: InputMaybe<Scalars['String']>;
  advance_matches_any?: InputMaybe<Scalars['String']>;
  advance_not_cont?: InputMaybe<Scalars['String']>;
  advance_not_cont_all?: InputMaybe<Scalars['String']>;
  advance_not_cont_any?: InputMaybe<Scalars['String']>;
  advance_not_end?: InputMaybe<Scalars['String']>;
  advance_not_end_all?: InputMaybe<Scalars['String']>;
  advance_not_end_any?: InputMaybe<Scalars['String']>;
  advance_not_eq?: InputMaybe<Scalars['String']>;
  advance_not_eq_all?: InputMaybe<Scalars['String']>;
  advance_not_eq_any?: InputMaybe<Scalars['String']>;
  advance_not_false?: InputMaybe<Scalars['String']>;
  advance_not_i_cont?: InputMaybe<Scalars['String']>;
  advance_not_i_cont_all?: InputMaybe<Scalars['String']>;
  advance_not_i_cont_any?: InputMaybe<Scalars['String']>;
  advance_not_in?: InputMaybe<Scalars['String']>;
  advance_not_in_all?: InputMaybe<Scalars['String']>;
  advance_not_in_any?: InputMaybe<Scalars['String']>;
  advance_not_null?: InputMaybe<Scalars['String']>;
  advance_not_start?: InputMaybe<Scalars['String']>;
  advance_not_start_all?: InputMaybe<Scalars['String']>;
  advance_not_start_any?: InputMaybe<Scalars['String']>;
  advance_not_true?: InputMaybe<Scalars['String']>;
  advance_null?: InputMaybe<Scalars['String']>;
  advance_present?: InputMaybe<Scalars['String']>;
  advance_start?: InputMaybe<Scalars['String']>;
  advance_start_all?: InputMaybe<Scalars['String']>;
  advance_start_any?: InputMaybe<Scalars['String']>;
  advance_true?: InputMaybe<Scalars['String']>;
  attendance_blank?: InputMaybe<Scalars['String']>;
  attendance_cont?: InputMaybe<Scalars['String']>;
  attendance_cont_all?: InputMaybe<Scalars['String']>;
  attendance_cont_any?: InputMaybe<Scalars['String']>;
  attendance_does_not_match?: InputMaybe<Scalars['String']>;
  attendance_does_not_match_all?: InputMaybe<Scalars['String']>;
  attendance_does_not_match_any?: InputMaybe<Scalars['String']>;
  attendance_end?: InputMaybe<Scalars['String']>;
  attendance_end_all?: InputMaybe<Scalars['String']>;
  attendance_end_any?: InputMaybe<Scalars['String']>;
  attendance_eq?: InputMaybe<Scalars['String']>;
  attendance_eq_all?: InputMaybe<Scalars['String']>;
  attendance_eq_any?: InputMaybe<Scalars['String']>;
  attendance_false?: InputMaybe<Scalars['String']>;
  attendance_gt?: InputMaybe<Scalars['String']>;
  attendance_gt_all?: InputMaybe<Scalars['String']>;
  attendance_gt_any?: InputMaybe<Scalars['String']>;
  attendance_gteq?: InputMaybe<Scalars['String']>;
  attendance_gteq_all?: InputMaybe<Scalars['String']>;
  attendance_gteq_any?: InputMaybe<Scalars['String']>;
  attendance_i_cont?: InputMaybe<Scalars['String']>;
  attendance_i_cont_all?: InputMaybe<Scalars['String']>;
  attendance_i_cont_any?: InputMaybe<Scalars['String']>;
  attendance_in?: InputMaybe<Scalars['String']>;
  attendance_in_all?: InputMaybe<Scalars['String']>;
  attendance_in_any?: InputMaybe<Scalars['String']>;
  attendance_lt?: InputMaybe<Scalars['String']>;
  attendance_lt_all?: InputMaybe<Scalars['String']>;
  attendance_lt_any?: InputMaybe<Scalars['String']>;
  attendance_lteq?: InputMaybe<Scalars['String']>;
  attendance_lteq_all?: InputMaybe<Scalars['String']>;
  attendance_lteq_any?: InputMaybe<Scalars['String']>;
  attendance_matches?: InputMaybe<Scalars['String']>;
  attendance_matches_all?: InputMaybe<Scalars['String']>;
  attendance_matches_any?: InputMaybe<Scalars['String']>;
  attendance_not_cont?: InputMaybe<Scalars['String']>;
  attendance_not_cont_all?: InputMaybe<Scalars['String']>;
  attendance_not_cont_any?: InputMaybe<Scalars['String']>;
  attendance_not_end?: InputMaybe<Scalars['String']>;
  attendance_not_end_all?: InputMaybe<Scalars['String']>;
  attendance_not_end_any?: InputMaybe<Scalars['String']>;
  attendance_not_eq?: InputMaybe<Scalars['String']>;
  attendance_not_eq_all?: InputMaybe<Scalars['String']>;
  attendance_not_eq_any?: InputMaybe<Scalars['String']>;
  attendance_not_false?: InputMaybe<Scalars['String']>;
  attendance_not_i_cont?: InputMaybe<Scalars['String']>;
  attendance_not_i_cont_all?: InputMaybe<Scalars['String']>;
  attendance_not_i_cont_any?: InputMaybe<Scalars['String']>;
  attendance_not_in?: InputMaybe<Scalars['String']>;
  attendance_not_in_all?: InputMaybe<Scalars['String']>;
  attendance_not_in_any?: InputMaybe<Scalars['String']>;
  attendance_not_null?: InputMaybe<Scalars['String']>;
  attendance_not_start?: InputMaybe<Scalars['String']>;
  attendance_not_start_all?: InputMaybe<Scalars['String']>;
  attendance_not_start_any?: InputMaybe<Scalars['String']>;
  attendance_not_true?: InputMaybe<Scalars['String']>;
  attendance_null?: InputMaybe<Scalars['String']>;
  attendance_present?: InputMaybe<Scalars['String']>;
  attendance_start?: InputMaybe<Scalars['String']>;
  attendance_start_all?: InputMaybe<Scalars['String']>;
  attendance_start_any?: InputMaybe<Scalars['String']>;
  attendance_true?: InputMaybe<Scalars['String']>;
  compromise_blank?: InputMaybe<Scalars['String']>;
  compromise_cont?: InputMaybe<Scalars['String']>;
  compromise_cont_all?: InputMaybe<Scalars['String']>;
  compromise_cont_any?: InputMaybe<Scalars['String']>;
  compromise_does_not_match?: InputMaybe<Scalars['String']>;
  compromise_does_not_match_all?: InputMaybe<Scalars['String']>;
  compromise_does_not_match_any?: InputMaybe<Scalars['String']>;
  compromise_end?: InputMaybe<Scalars['String']>;
  compromise_end_all?: InputMaybe<Scalars['String']>;
  compromise_end_any?: InputMaybe<Scalars['String']>;
  compromise_eq?: InputMaybe<Scalars['String']>;
  compromise_eq_all?: InputMaybe<Scalars['String']>;
  compromise_eq_any?: InputMaybe<Scalars['String']>;
  compromise_false?: InputMaybe<Scalars['String']>;
  compromise_gt?: InputMaybe<Scalars['String']>;
  compromise_gt_all?: InputMaybe<Scalars['String']>;
  compromise_gt_any?: InputMaybe<Scalars['String']>;
  compromise_gteq?: InputMaybe<Scalars['String']>;
  compromise_gteq_all?: InputMaybe<Scalars['String']>;
  compromise_gteq_any?: InputMaybe<Scalars['String']>;
  compromise_i_cont?: InputMaybe<Scalars['String']>;
  compromise_i_cont_all?: InputMaybe<Scalars['String']>;
  compromise_i_cont_any?: InputMaybe<Scalars['String']>;
  compromise_in?: InputMaybe<Scalars['String']>;
  compromise_in_all?: InputMaybe<Scalars['String']>;
  compromise_in_any?: InputMaybe<Scalars['String']>;
  compromise_lt?: InputMaybe<Scalars['String']>;
  compromise_lt_all?: InputMaybe<Scalars['String']>;
  compromise_lt_any?: InputMaybe<Scalars['String']>;
  compromise_lteq?: InputMaybe<Scalars['String']>;
  compromise_lteq_all?: InputMaybe<Scalars['String']>;
  compromise_lteq_any?: InputMaybe<Scalars['String']>;
  compromise_matches?: InputMaybe<Scalars['String']>;
  compromise_matches_all?: InputMaybe<Scalars['String']>;
  compromise_matches_any?: InputMaybe<Scalars['String']>;
  compromise_not_cont?: InputMaybe<Scalars['String']>;
  compromise_not_cont_all?: InputMaybe<Scalars['String']>;
  compromise_not_cont_any?: InputMaybe<Scalars['String']>;
  compromise_not_end?: InputMaybe<Scalars['String']>;
  compromise_not_end_all?: InputMaybe<Scalars['String']>;
  compromise_not_end_any?: InputMaybe<Scalars['String']>;
  compromise_not_eq?: InputMaybe<Scalars['String']>;
  compromise_not_eq_all?: InputMaybe<Scalars['String']>;
  compromise_not_eq_any?: InputMaybe<Scalars['String']>;
  compromise_not_false?: InputMaybe<Scalars['String']>;
  compromise_not_i_cont?: InputMaybe<Scalars['String']>;
  compromise_not_i_cont_all?: InputMaybe<Scalars['String']>;
  compromise_not_i_cont_any?: InputMaybe<Scalars['String']>;
  compromise_not_in?: InputMaybe<Scalars['String']>;
  compromise_not_in_all?: InputMaybe<Scalars['String']>;
  compromise_not_in_any?: InputMaybe<Scalars['String']>;
  compromise_not_null?: InputMaybe<Scalars['String']>;
  compromise_not_start?: InputMaybe<Scalars['String']>;
  compromise_not_start_all?: InputMaybe<Scalars['String']>;
  compromise_not_start_any?: InputMaybe<Scalars['String']>;
  compromise_not_true?: InputMaybe<Scalars['String']>;
  compromise_null?: InputMaybe<Scalars['String']>;
  compromise_present?: InputMaybe<Scalars['String']>;
  compromise_start?: InputMaybe<Scalars['String']>;
  compromise_start_all?: InputMaybe<Scalars['String']>;
  compromise_start_any?: InputMaybe<Scalars['String']>;
  compromise_true?: InputMaybe<Scalars['String']>;
  created_at_blank?: InputMaybe<Scalars['String']>;
  created_at_cont?: InputMaybe<Scalars['String']>;
  created_at_cont_all?: InputMaybe<Scalars['String']>;
  created_at_cont_any?: InputMaybe<Scalars['String']>;
  created_at_does_not_match?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  created_at_end?: InputMaybe<Scalars['String']>;
  created_at_end_all?: InputMaybe<Scalars['String']>;
  created_at_end_any?: InputMaybe<Scalars['String']>;
  created_at_eq?: InputMaybe<Scalars['String']>;
  created_at_eq_all?: InputMaybe<Scalars['String']>;
  created_at_eq_any?: InputMaybe<Scalars['String']>;
  created_at_false?: InputMaybe<Scalars['String']>;
  created_at_gt?: InputMaybe<Scalars['String']>;
  created_at_gt_all?: InputMaybe<Scalars['String']>;
  created_at_gt_any?: InputMaybe<Scalars['String']>;
  created_at_gteq?: InputMaybe<Scalars['String']>;
  created_at_gteq_all?: InputMaybe<Scalars['String']>;
  created_at_gteq_any?: InputMaybe<Scalars['String']>;
  created_at_i_cont?: InputMaybe<Scalars['String']>;
  created_at_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_in?: InputMaybe<Scalars['String']>;
  created_at_in_all?: InputMaybe<Scalars['String']>;
  created_at_in_any?: InputMaybe<Scalars['String']>;
  created_at_lt?: InputMaybe<Scalars['String']>;
  created_at_lt_all?: InputMaybe<Scalars['String']>;
  created_at_lt_any?: InputMaybe<Scalars['String']>;
  created_at_lteq?: InputMaybe<Scalars['String']>;
  created_at_lteq_all?: InputMaybe<Scalars['String']>;
  created_at_lteq_any?: InputMaybe<Scalars['String']>;
  created_at_matches?: InputMaybe<Scalars['String']>;
  created_at_matches_all?: InputMaybe<Scalars['String']>;
  created_at_matches_any?: InputMaybe<Scalars['String']>;
  created_at_not_cont?: InputMaybe<Scalars['String']>;
  created_at_not_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_end?: InputMaybe<Scalars['String']>;
  created_at_not_end_all?: InputMaybe<Scalars['String']>;
  created_at_not_end_any?: InputMaybe<Scalars['String']>;
  created_at_not_eq?: InputMaybe<Scalars['String']>;
  created_at_not_eq_all?: InputMaybe<Scalars['String']>;
  created_at_not_eq_any?: InputMaybe<Scalars['String']>;
  created_at_not_false?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_in?: InputMaybe<Scalars['String']>;
  created_at_not_in_all?: InputMaybe<Scalars['String']>;
  created_at_not_in_any?: InputMaybe<Scalars['String']>;
  created_at_not_null?: InputMaybe<Scalars['String']>;
  created_at_not_start?: InputMaybe<Scalars['String']>;
  created_at_not_start_all?: InputMaybe<Scalars['String']>;
  created_at_not_start_any?: InputMaybe<Scalars['String']>;
  created_at_not_true?: InputMaybe<Scalars['String']>;
  created_at_null?: InputMaybe<Scalars['String']>;
  created_at_present?: InputMaybe<Scalars['String']>;
  created_at_start?: InputMaybe<Scalars['String']>;
  created_at_start_all?: InputMaybe<Scalars['String']>;
  created_at_start_any?: InputMaybe<Scalars['String']>;
  created_at_true?: InputMaybe<Scalars['String']>;
  end_date_blank?: InputMaybe<Scalars['String']>;
  end_date_cont?: InputMaybe<Scalars['String']>;
  end_date_cont_all?: InputMaybe<Scalars['String']>;
  end_date_cont_any?: InputMaybe<Scalars['String']>;
  end_date_does_not_match?: InputMaybe<Scalars['String']>;
  end_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  end_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  end_date_end?: InputMaybe<Scalars['String']>;
  end_date_end_all?: InputMaybe<Scalars['String']>;
  end_date_end_any?: InputMaybe<Scalars['String']>;
  end_date_eq?: InputMaybe<Scalars['String']>;
  end_date_eq_all?: InputMaybe<Scalars['String']>;
  end_date_eq_any?: InputMaybe<Scalars['String']>;
  end_date_false?: InputMaybe<Scalars['String']>;
  end_date_gt?: InputMaybe<Scalars['String']>;
  end_date_gt_all?: InputMaybe<Scalars['String']>;
  end_date_gt_any?: InputMaybe<Scalars['String']>;
  end_date_gteq?: InputMaybe<Scalars['String']>;
  end_date_gteq_all?: InputMaybe<Scalars['String']>;
  end_date_gteq_any?: InputMaybe<Scalars['String']>;
  end_date_i_cont?: InputMaybe<Scalars['String']>;
  end_date_i_cont_all?: InputMaybe<Scalars['String']>;
  end_date_i_cont_any?: InputMaybe<Scalars['String']>;
  end_date_in?: InputMaybe<Scalars['String']>;
  end_date_in_all?: InputMaybe<Scalars['String']>;
  end_date_in_any?: InputMaybe<Scalars['String']>;
  end_date_lt?: InputMaybe<Scalars['String']>;
  end_date_lt_all?: InputMaybe<Scalars['String']>;
  end_date_lt_any?: InputMaybe<Scalars['String']>;
  end_date_lteq?: InputMaybe<Scalars['String']>;
  end_date_lteq_all?: InputMaybe<Scalars['String']>;
  end_date_lteq_any?: InputMaybe<Scalars['String']>;
  end_date_matches?: InputMaybe<Scalars['String']>;
  end_date_matches_all?: InputMaybe<Scalars['String']>;
  end_date_matches_any?: InputMaybe<Scalars['String']>;
  end_date_not_cont?: InputMaybe<Scalars['String']>;
  end_date_not_cont_all?: InputMaybe<Scalars['String']>;
  end_date_not_cont_any?: InputMaybe<Scalars['String']>;
  end_date_not_end?: InputMaybe<Scalars['String']>;
  end_date_not_end_all?: InputMaybe<Scalars['String']>;
  end_date_not_end_any?: InputMaybe<Scalars['String']>;
  end_date_not_eq?: InputMaybe<Scalars['String']>;
  end_date_not_eq_all?: InputMaybe<Scalars['String']>;
  end_date_not_eq_any?: InputMaybe<Scalars['String']>;
  end_date_not_false?: InputMaybe<Scalars['String']>;
  end_date_not_i_cont?: InputMaybe<Scalars['String']>;
  end_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  end_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  end_date_not_in?: InputMaybe<Scalars['String']>;
  end_date_not_in_all?: InputMaybe<Scalars['String']>;
  end_date_not_in_any?: InputMaybe<Scalars['String']>;
  end_date_not_null?: InputMaybe<Scalars['String']>;
  end_date_not_start?: InputMaybe<Scalars['String']>;
  end_date_not_start_all?: InputMaybe<Scalars['String']>;
  end_date_not_start_any?: InputMaybe<Scalars['String']>;
  end_date_not_true?: InputMaybe<Scalars['String']>;
  end_date_null?: InputMaybe<Scalars['String']>;
  end_date_present?: InputMaybe<Scalars['String']>;
  end_date_start?: InputMaybe<Scalars['String']>;
  end_date_start_all?: InputMaybe<Scalars['String']>;
  end_date_start_any?: InputMaybe<Scalars['String']>;
  end_date_true?: InputMaybe<Scalars['String']>;
  external_course_id_blank?: InputMaybe<Scalars['String']>;
  external_course_id_cont?: InputMaybe<Scalars['String']>;
  external_course_id_cont_all?: InputMaybe<Scalars['String']>;
  external_course_id_cont_any?: InputMaybe<Scalars['String']>;
  external_course_id_does_not_match?: InputMaybe<Scalars['String']>;
  external_course_id_does_not_match_all?: InputMaybe<Scalars['String']>;
  external_course_id_does_not_match_any?: InputMaybe<Scalars['String']>;
  external_course_id_end?: InputMaybe<Scalars['String']>;
  external_course_id_end_all?: InputMaybe<Scalars['String']>;
  external_course_id_end_any?: InputMaybe<Scalars['String']>;
  external_course_id_eq?: InputMaybe<Scalars['String']>;
  external_course_id_eq_all?: InputMaybe<Scalars['String']>;
  external_course_id_eq_any?: InputMaybe<Scalars['String']>;
  external_course_id_false?: InputMaybe<Scalars['String']>;
  external_course_id_gt?: InputMaybe<Scalars['String']>;
  external_course_id_gt_all?: InputMaybe<Scalars['String']>;
  external_course_id_gt_any?: InputMaybe<Scalars['String']>;
  external_course_id_gteq?: InputMaybe<Scalars['String']>;
  external_course_id_gteq_all?: InputMaybe<Scalars['String']>;
  external_course_id_gteq_any?: InputMaybe<Scalars['String']>;
  external_course_id_i_cont?: InputMaybe<Scalars['String']>;
  external_course_id_i_cont_all?: InputMaybe<Scalars['String']>;
  external_course_id_i_cont_any?: InputMaybe<Scalars['String']>;
  external_course_id_in?: InputMaybe<Scalars['String']>;
  external_course_id_in_all?: InputMaybe<Scalars['String']>;
  external_course_id_in_any?: InputMaybe<Scalars['String']>;
  external_course_id_lt?: InputMaybe<Scalars['String']>;
  external_course_id_lt_all?: InputMaybe<Scalars['String']>;
  external_course_id_lt_any?: InputMaybe<Scalars['String']>;
  external_course_id_lteq?: InputMaybe<Scalars['String']>;
  external_course_id_lteq_all?: InputMaybe<Scalars['String']>;
  external_course_id_lteq_any?: InputMaybe<Scalars['String']>;
  external_course_id_matches?: InputMaybe<Scalars['String']>;
  external_course_id_matches_all?: InputMaybe<Scalars['String']>;
  external_course_id_matches_any?: InputMaybe<Scalars['String']>;
  external_course_id_not_cont?: InputMaybe<Scalars['String']>;
  external_course_id_not_cont_all?: InputMaybe<Scalars['String']>;
  external_course_id_not_cont_any?: InputMaybe<Scalars['String']>;
  external_course_id_not_end?: InputMaybe<Scalars['String']>;
  external_course_id_not_end_all?: InputMaybe<Scalars['String']>;
  external_course_id_not_end_any?: InputMaybe<Scalars['String']>;
  external_course_id_not_eq?: InputMaybe<Scalars['String']>;
  external_course_id_not_eq_all?: InputMaybe<Scalars['String']>;
  external_course_id_not_eq_any?: InputMaybe<Scalars['String']>;
  external_course_id_not_false?: InputMaybe<Scalars['String']>;
  external_course_id_not_i_cont?: InputMaybe<Scalars['String']>;
  external_course_id_not_i_cont_all?: InputMaybe<Scalars['String']>;
  external_course_id_not_i_cont_any?: InputMaybe<Scalars['String']>;
  external_course_id_not_in?: InputMaybe<Scalars['String']>;
  external_course_id_not_in_all?: InputMaybe<Scalars['String']>;
  external_course_id_not_in_any?: InputMaybe<Scalars['String']>;
  external_course_id_not_null?: InputMaybe<Scalars['String']>;
  external_course_id_not_start?: InputMaybe<Scalars['String']>;
  external_course_id_not_start_all?: InputMaybe<Scalars['String']>;
  external_course_id_not_start_any?: InputMaybe<Scalars['String']>;
  external_course_id_not_true?: InputMaybe<Scalars['String']>;
  external_course_id_null?: InputMaybe<Scalars['String']>;
  external_course_id_present?: InputMaybe<Scalars['String']>;
  external_course_id_start?: InputMaybe<Scalars['String']>;
  external_course_id_start_all?: InputMaybe<Scalars['String']>;
  external_course_id_start_any?: InputMaybe<Scalars['String']>;
  external_course_id_true?: InputMaybe<Scalars['String']>;
  final_score_blank?: InputMaybe<Scalars['String']>;
  final_score_cont?: InputMaybe<Scalars['String']>;
  final_score_cont_all?: InputMaybe<Scalars['String']>;
  final_score_cont_any?: InputMaybe<Scalars['String']>;
  final_score_does_not_match?: InputMaybe<Scalars['String']>;
  final_score_does_not_match_all?: InputMaybe<Scalars['String']>;
  final_score_does_not_match_any?: InputMaybe<Scalars['String']>;
  final_score_end?: InputMaybe<Scalars['String']>;
  final_score_end_all?: InputMaybe<Scalars['String']>;
  final_score_end_any?: InputMaybe<Scalars['String']>;
  final_score_eq?: InputMaybe<Scalars['String']>;
  final_score_eq_all?: InputMaybe<Scalars['String']>;
  final_score_eq_any?: InputMaybe<Scalars['String']>;
  final_score_false?: InputMaybe<Scalars['String']>;
  final_score_gt?: InputMaybe<Scalars['String']>;
  final_score_gt_all?: InputMaybe<Scalars['String']>;
  final_score_gt_any?: InputMaybe<Scalars['String']>;
  final_score_gteq?: InputMaybe<Scalars['String']>;
  final_score_gteq_all?: InputMaybe<Scalars['String']>;
  final_score_gteq_any?: InputMaybe<Scalars['String']>;
  final_score_i_cont?: InputMaybe<Scalars['String']>;
  final_score_i_cont_all?: InputMaybe<Scalars['String']>;
  final_score_i_cont_any?: InputMaybe<Scalars['String']>;
  final_score_in?: InputMaybe<Scalars['String']>;
  final_score_in_all?: InputMaybe<Scalars['String']>;
  final_score_in_any?: InputMaybe<Scalars['String']>;
  final_score_lt?: InputMaybe<Scalars['String']>;
  final_score_lt_all?: InputMaybe<Scalars['String']>;
  final_score_lt_any?: InputMaybe<Scalars['String']>;
  final_score_lteq?: InputMaybe<Scalars['String']>;
  final_score_lteq_all?: InputMaybe<Scalars['String']>;
  final_score_lteq_any?: InputMaybe<Scalars['String']>;
  final_score_matches?: InputMaybe<Scalars['String']>;
  final_score_matches_all?: InputMaybe<Scalars['String']>;
  final_score_matches_any?: InputMaybe<Scalars['String']>;
  final_score_not_cont?: InputMaybe<Scalars['String']>;
  final_score_not_cont_all?: InputMaybe<Scalars['String']>;
  final_score_not_cont_any?: InputMaybe<Scalars['String']>;
  final_score_not_end?: InputMaybe<Scalars['String']>;
  final_score_not_end_all?: InputMaybe<Scalars['String']>;
  final_score_not_end_any?: InputMaybe<Scalars['String']>;
  final_score_not_eq?: InputMaybe<Scalars['String']>;
  final_score_not_eq_all?: InputMaybe<Scalars['String']>;
  final_score_not_eq_any?: InputMaybe<Scalars['String']>;
  final_score_not_false?: InputMaybe<Scalars['String']>;
  final_score_not_i_cont?: InputMaybe<Scalars['String']>;
  final_score_not_i_cont_all?: InputMaybe<Scalars['String']>;
  final_score_not_i_cont_any?: InputMaybe<Scalars['String']>;
  final_score_not_in?: InputMaybe<Scalars['String']>;
  final_score_not_in_all?: InputMaybe<Scalars['String']>;
  final_score_not_in_any?: InputMaybe<Scalars['String']>;
  final_score_not_null?: InputMaybe<Scalars['String']>;
  final_score_not_start?: InputMaybe<Scalars['String']>;
  final_score_not_start_all?: InputMaybe<Scalars['String']>;
  final_score_not_start_any?: InputMaybe<Scalars['String']>;
  final_score_not_true?: InputMaybe<Scalars['String']>;
  final_score_null?: InputMaybe<Scalars['String']>;
  final_score_present?: InputMaybe<Scalars['String']>;
  final_score_start?: InputMaybe<Scalars['String']>;
  final_score_start_all?: InputMaybe<Scalars['String']>;
  final_score_start_any?: InputMaybe<Scalars['String']>;
  final_score_true?: InputMaybe<Scalars['String']>;
  g?: InputMaybe<Array<Scalars['JSON']>>;
  has_certificate_blank?: InputMaybe<Scalars['String']>;
  has_certificate_cont?: InputMaybe<Scalars['String']>;
  has_certificate_cont_all?: InputMaybe<Scalars['String']>;
  has_certificate_cont_any?: InputMaybe<Scalars['String']>;
  has_certificate_does_not_match?: InputMaybe<Scalars['String']>;
  has_certificate_does_not_match_all?: InputMaybe<Scalars['String']>;
  has_certificate_does_not_match_any?: InputMaybe<Scalars['String']>;
  has_certificate_end?: InputMaybe<Scalars['String']>;
  has_certificate_end_all?: InputMaybe<Scalars['String']>;
  has_certificate_end_any?: InputMaybe<Scalars['String']>;
  has_certificate_eq?: InputMaybe<Scalars['String']>;
  has_certificate_eq_all?: InputMaybe<Scalars['String']>;
  has_certificate_eq_any?: InputMaybe<Scalars['String']>;
  has_certificate_false?: InputMaybe<Scalars['String']>;
  has_certificate_gt?: InputMaybe<Scalars['String']>;
  has_certificate_gt_all?: InputMaybe<Scalars['String']>;
  has_certificate_gt_any?: InputMaybe<Scalars['String']>;
  has_certificate_gteq?: InputMaybe<Scalars['String']>;
  has_certificate_gteq_all?: InputMaybe<Scalars['String']>;
  has_certificate_gteq_any?: InputMaybe<Scalars['String']>;
  has_certificate_i_cont?: InputMaybe<Scalars['String']>;
  has_certificate_i_cont_all?: InputMaybe<Scalars['String']>;
  has_certificate_i_cont_any?: InputMaybe<Scalars['String']>;
  has_certificate_in?: InputMaybe<Scalars['String']>;
  has_certificate_in_all?: InputMaybe<Scalars['String']>;
  has_certificate_in_any?: InputMaybe<Scalars['String']>;
  has_certificate_lt?: InputMaybe<Scalars['String']>;
  has_certificate_lt_all?: InputMaybe<Scalars['String']>;
  has_certificate_lt_any?: InputMaybe<Scalars['String']>;
  has_certificate_lteq?: InputMaybe<Scalars['String']>;
  has_certificate_lteq_all?: InputMaybe<Scalars['String']>;
  has_certificate_lteq_any?: InputMaybe<Scalars['String']>;
  has_certificate_matches?: InputMaybe<Scalars['String']>;
  has_certificate_matches_all?: InputMaybe<Scalars['String']>;
  has_certificate_matches_any?: InputMaybe<Scalars['String']>;
  has_certificate_not_cont?: InputMaybe<Scalars['String']>;
  has_certificate_not_cont_all?: InputMaybe<Scalars['String']>;
  has_certificate_not_cont_any?: InputMaybe<Scalars['String']>;
  has_certificate_not_end?: InputMaybe<Scalars['String']>;
  has_certificate_not_end_all?: InputMaybe<Scalars['String']>;
  has_certificate_not_end_any?: InputMaybe<Scalars['String']>;
  has_certificate_not_eq?: InputMaybe<Scalars['String']>;
  has_certificate_not_eq_all?: InputMaybe<Scalars['String']>;
  has_certificate_not_eq_any?: InputMaybe<Scalars['String']>;
  has_certificate_not_false?: InputMaybe<Scalars['String']>;
  has_certificate_not_i_cont?: InputMaybe<Scalars['String']>;
  has_certificate_not_i_cont_all?: InputMaybe<Scalars['String']>;
  has_certificate_not_i_cont_any?: InputMaybe<Scalars['String']>;
  has_certificate_not_in?: InputMaybe<Scalars['String']>;
  has_certificate_not_in_all?: InputMaybe<Scalars['String']>;
  has_certificate_not_in_any?: InputMaybe<Scalars['String']>;
  has_certificate_not_null?: InputMaybe<Scalars['String']>;
  has_certificate_not_start?: InputMaybe<Scalars['String']>;
  has_certificate_not_start_all?: InputMaybe<Scalars['String']>;
  has_certificate_not_start_any?: InputMaybe<Scalars['String']>;
  has_certificate_not_true?: InputMaybe<Scalars['String']>;
  has_certificate_null?: InputMaybe<Scalars['String']>;
  has_certificate_present?: InputMaybe<Scalars['String']>;
  has_certificate_start?: InputMaybe<Scalars['String']>;
  has_certificate_start_all?: InputMaybe<Scalars['String']>;
  has_certificate_start_any?: InputMaybe<Scalars['String']>;
  has_certificate_true?: InputMaybe<Scalars['String']>;
  id_blank?: InputMaybe<Scalars['Int']>;
  id_cont?: InputMaybe<Scalars['Int']>;
  id_cont_all?: InputMaybe<Scalars['Int']>;
  id_cont_any?: InputMaybe<Scalars['Int']>;
  id_does_not_match?: InputMaybe<Scalars['Int']>;
  id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  id_end?: InputMaybe<Scalars['Int']>;
  id_end_all?: InputMaybe<Scalars['Int']>;
  id_end_any?: InputMaybe<Scalars['Int']>;
  id_eq?: InputMaybe<Scalars['Int']>;
  id_eq_all?: InputMaybe<Scalars['Int']>;
  id_eq_any?: InputMaybe<Scalars['Int']>;
  id_false?: InputMaybe<Scalars['Int']>;
  id_gt?: InputMaybe<Scalars['Int']>;
  id_gt_all?: InputMaybe<Scalars['Int']>;
  id_gt_any?: InputMaybe<Scalars['Int']>;
  id_gteq?: InputMaybe<Scalars['Int']>;
  id_gteq_all?: InputMaybe<Scalars['Int']>;
  id_gteq_any?: InputMaybe<Scalars['Int']>;
  id_i_cont?: InputMaybe<Scalars['Int']>;
  id_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_in?: InputMaybe<Array<Scalars['Int']>>;
  id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_lt?: InputMaybe<Scalars['Int']>;
  id_lt_all?: InputMaybe<Scalars['Int']>;
  id_lt_any?: InputMaybe<Scalars['Int']>;
  id_lteq?: InputMaybe<Scalars['Int']>;
  id_lteq_all?: InputMaybe<Scalars['Int']>;
  id_lteq_any?: InputMaybe<Scalars['Int']>;
  id_matches?: InputMaybe<Scalars['Int']>;
  id_matches_all?: InputMaybe<Scalars['Int']>;
  id_matches_any?: InputMaybe<Scalars['Int']>;
  id_not_cont?: InputMaybe<Scalars['Int']>;
  id_not_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_end?: InputMaybe<Scalars['Int']>;
  id_not_end_all?: InputMaybe<Scalars['Int']>;
  id_not_end_any?: InputMaybe<Scalars['Int']>;
  id_not_eq?: InputMaybe<Scalars['Int']>;
  id_not_eq_all?: InputMaybe<Scalars['Int']>;
  id_not_eq_any?: InputMaybe<Scalars['Int']>;
  id_not_false?: InputMaybe<Scalars['Int']>;
  id_not_i_cont?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_not_null?: InputMaybe<Scalars['Int']>;
  id_not_start?: InputMaybe<Scalars['Int']>;
  id_not_start_all?: InputMaybe<Scalars['Int']>;
  id_not_start_any?: InputMaybe<Scalars['Int']>;
  id_not_true?: InputMaybe<Scalars['Int']>;
  id_null?: InputMaybe<Scalars['Int']>;
  id_present?: InputMaybe<Scalars['Int']>;
  id_start?: InputMaybe<Scalars['Int']>;
  id_start_all?: InputMaybe<Scalars['Int']>;
  id_start_any?: InputMaybe<Scalars['Int']>;
  id_true?: InputMaybe<Scalars['Int']>;
  sorts?: InputMaybe<Array<Scalars['String']>>;
  start_date_blank?: InputMaybe<Scalars['String']>;
  start_date_cont?: InputMaybe<Scalars['String']>;
  start_date_cont_all?: InputMaybe<Scalars['String']>;
  start_date_cont_any?: InputMaybe<Scalars['String']>;
  start_date_does_not_match?: InputMaybe<Scalars['String']>;
  start_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  start_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  start_date_end?: InputMaybe<Scalars['String']>;
  start_date_end_all?: InputMaybe<Scalars['String']>;
  start_date_end_any?: InputMaybe<Scalars['String']>;
  start_date_eq?: InputMaybe<Scalars['String']>;
  start_date_eq_all?: InputMaybe<Scalars['String']>;
  start_date_eq_any?: InputMaybe<Scalars['String']>;
  start_date_false?: InputMaybe<Scalars['String']>;
  start_date_gt?: InputMaybe<Scalars['String']>;
  start_date_gt_all?: InputMaybe<Scalars['String']>;
  start_date_gt_any?: InputMaybe<Scalars['String']>;
  start_date_gteq?: InputMaybe<Scalars['String']>;
  start_date_gteq_all?: InputMaybe<Scalars['String']>;
  start_date_gteq_any?: InputMaybe<Scalars['String']>;
  start_date_i_cont?: InputMaybe<Scalars['String']>;
  start_date_i_cont_all?: InputMaybe<Scalars['String']>;
  start_date_i_cont_any?: InputMaybe<Scalars['String']>;
  start_date_in?: InputMaybe<Scalars['String']>;
  start_date_in_all?: InputMaybe<Scalars['String']>;
  start_date_in_any?: InputMaybe<Scalars['String']>;
  start_date_lt?: InputMaybe<Scalars['String']>;
  start_date_lt_all?: InputMaybe<Scalars['String']>;
  start_date_lt_any?: InputMaybe<Scalars['String']>;
  start_date_lteq?: InputMaybe<Scalars['String']>;
  start_date_lteq_all?: InputMaybe<Scalars['String']>;
  start_date_lteq_any?: InputMaybe<Scalars['String']>;
  start_date_matches?: InputMaybe<Scalars['String']>;
  start_date_matches_all?: InputMaybe<Scalars['String']>;
  start_date_matches_any?: InputMaybe<Scalars['String']>;
  start_date_not_cont?: InputMaybe<Scalars['String']>;
  start_date_not_cont_all?: InputMaybe<Scalars['String']>;
  start_date_not_cont_any?: InputMaybe<Scalars['String']>;
  start_date_not_end?: InputMaybe<Scalars['String']>;
  start_date_not_end_all?: InputMaybe<Scalars['String']>;
  start_date_not_end_any?: InputMaybe<Scalars['String']>;
  start_date_not_eq?: InputMaybe<Scalars['String']>;
  start_date_not_eq_all?: InputMaybe<Scalars['String']>;
  start_date_not_eq_any?: InputMaybe<Scalars['String']>;
  start_date_not_false?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  start_date_not_in?: InputMaybe<Scalars['String']>;
  start_date_not_in_all?: InputMaybe<Scalars['String']>;
  start_date_not_in_any?: InputMaybe<Scalars['String']>;
  start_date_not_null?: InputMaybe<Scalars['String']>;
  start_date_not_start?: InputMaybe<Scalars['String']>;
  start_date_not_start_all?: InputMaybe<Scalars['String']>;
  start_date_not_start_any?: InputMaybe<Scalars['String']>;
  start_date_not_true?: InputMaybe<Scalars['String']>;
  start_date_null?: InputMaybe<Scalars['String']>;
  start_date_present?: InputMaybe<Scalars['String']>;
  start_date_start?: InputMaybe<Scalars['String']>;
  start_date_start_all?: InputMaybe<Scalars['String']>;
  start_date_start_any?: InputMaybe<Scalars['String']>;
  start_date_true?: InputMaybe<Scalars['String']>;
  state_blank?: InputMaybe<Scalars['String']>;
  state_cont?: InputMaybe<Scalars['String']>;
  state_cont_all?: InputMaybe<Scalars['String']>;
  state_cont_any?: InputMaybe<Scalars['String']>;
  state_does_not_match?: InputMaybe<Scalars['String']>;
  state_does_not_match_all?: InputMaybe<Scalars['String']>;
  state_does_not_match_any?: InputMaybe<Scalars['String']>;
  state_end?: InputMaybe<Scalars['String']>;
  state_end_all?: InputMaybe<Scalars['String']>;
  state_end_any?: InputMaybe<Scalars['String']>;
  state_eq?: InputMaybe<Scalars['String']>;
  state_eq_all?: InputMaybe<Scalars['String']>;
  state_eq_any?: InputMaybe<Scalars['String']>;
  state_false?: InputMaybe<Scalars['String']>;
  state_gt?: InputMaybe<Scalars['String']>;
  state_gt_all?: InputMaybe<Scalars['String']>;
  state_gt_any?: InputMaybe<Scalars['String']>;
  state_gteq?: InputMaybe<Scalars['String']>;
  state_gteq_all?: InputMaybe<Scalars['String']>;
  state_gteq_any?: InputMaybe<Scalars['String']>;
  state_i_cont?: InputMaybe<Scalars['String']>;
  state_i_cont_all?: InputMaybe<Scalars['String']>;
  state_i_cont_any?: InputMaybe<Scalars['String']>;
  state_in?: InputMaybe<Scalars['String']>;
  state_in_all?: InputMaybe<Scalars['String']>;
  state_in_any?: InputMaybe<Scalars['String']>;
  state_lt?: InputMaybe<Scalars['String']>;
  state_lt_all?: InputMaybe<Scalars['String']>;
  state_lt_any?: InputMaybe<Scalars['String']>;
  state_lteq?: InputMaybe<Scalars['String']>;
  state_lteq_all?: InputMaybe<Scalars['String']>;
  state_lteq_any?: InputMaybe<Scalars['String']>;
  state_matches?: InputMaybe<Scalars['String']>;
  state_matches_all?: InputMaybe<Scalars['String']>;
  state_matches_any?: InputMaybe<Scalars['String']>;
  state_not_cont?: InputMaybe<Scalars['String']>;
  state_not_cont_all?: InputMaybe<Scalars['String']>;
  state_not_cont_any?: InputMaybe<Scalars['String']>;
  state_not_end?: InputMaybe<Scalars['String']>;
  state_not_end_all?: InputMaybe<Scalars['String']>;
  state_not_end_any?: InputMaybe<Scalars['String']>;
  state_not_eq?: InputMaybe<Scalars['String']>;
  state_not_eq_all?: InputMaybe<Scalars['String']>;
  state_not_eq_any?: InputMaybe<Scalars['String']>;
  state_not_false?: InputMaybe<Scalars['String']>;
  state_not_i_cont?: InputMaybe<Scalars['String']>;
  state_not_i_cont_all?: InputMaybe<Scalars['String']>;
  state_not_i_cont_any?: InputMaybe<Scalars['String']>;
  state_not_in?: InputMaybe<Scalars['String']>;
  state_not_in_all?: InputMaybe<Scalars['String']>;
  state_not_in_any?: InputMaybe<Scalars['String']>;
  state_not_null?: InputMaybe<Scalars['String']>;
  state_not_start?: InputMaybe<Scalars['String']>;
  state_not_start_all?: InputMaybe<Scalars['String']>;
  state_not_start_any?: InputMaybe<Scalars['String']>;
  state_not_true?: InputMaybe<Scalars['String']>;
  state_null?: InputMaybe<Scalars['String']>;
  state_present?: InputMaybe<Scalars['String']>;
  state_start?: InputMaybe<Scalars['String']>;
  state_start_all?: InputMaybe<Scalars['String']>;
  state_start_any?: InputMaybe<Scalars['String']>;
  state_true?: InputMaybe<Scalars['String']>;
  total_hours_blank?: InputMaybe<Scalars['String']>;
  total_hours_cont?: InputMaybe<Scalars['String']>;
  total_hours_cont_all?: InputMaybe<Scalars['String']>;
  total_hours_cont_any?: InputMaybe<Scalars['String']>;
  total_hours_does_not_match?: InputMaybe<Scalars['String']>;
  total_hours_does_not_match_all?: InputMaybe<Scalars['String']>;
  total_hours_does_not_match_any?: InputMaybe<Scalars['String']>;
  total_hours_end?: InputMaybe<Scalars['String']>;
  total_hours_end_all?: InputMaybe<Scalars['String']>;
  total_hours_end_any?: InputMaybe<Scalars['String']>;
  total_hours_eq?: InputMaybe<Scalars['String']>;
  total_hours_eq_all?: InputMaybe<Scalars['String']>;
  total_hours_eq_any?: InputMaybe<Scalars['String']>;
  total_hours_false?: InputMaybe<Scalars['String']>;
  total_hours_gt?: InputMaybe<Scalars['String']>;
  total_hours_gt_all?: InputMaybe<Scalars['String']>;
  total_hours_gt_any?: InputMaybe<Scalars['String']>;
  total_hours_gteq?: InputMaybe<Scalars['String']>;
  total_hours_gteq_all?: InputMaybe<Scalars['String']>;
  total_hours_gteq_any?: InputMaybe<Scalars['String']>;
  total_hours_i_cont?: InputMaybe<Scalars['String']>;
  total_hours_i_cont_all?: InputMaybe<Scalars['String']>;
  total_hours_i_cont_any?: InputMaybe<Scalars['String']>;
  total_hours_in?: InputMaybe<Scalars['String']>;
  total_hours_in_all?: InputMaybe<Scalars['String']>;
  total_hours_in_any?: InputMaybe<Scalars['String']>;
  total_hours_lt?: InputMaybe<Scalars['String']>;
  total_hours_lt_all?: InputMaybe<Scalars['String']>;
  total_hours_lt_any?: InputMaybe<Scalars['String']>;
  total_hours_lteq?: InputMaybe<Scalars['String']>;
  total_hours_lteq_all?: InputMaybe<Scalars['String']>;
  total_hours_lteq_any?: InputMaybe<Scalars['String']>;
  total_hours_matches?: InputMaybe<Scalars['String']>;
  total_hours_matches_all?: InputMaybe<Scalars['String']>;
  total_hours_matches_any?: InputMaybe<Scalars['String']>;
  total_hours_not_cont?: InputMaybe<Scalars['String']>;
  total_hours_not_cont_all?: InputMaybe<Scalars['String']>;
  total_hours_not_cont_any?: InputMaybe<Scalars['String']>;
  total_hours_not_end?: InputMaybe<Scalars['String']>;
  total_hours_not_end_all?: InputMaybe<Scalars['String']>;
  total_hours_not_end_any?: InputMaybe<Scalars['String']>;
  total_hours_not_eq?: InputMaybe<Scalars['String']>;
  total_hours_not_eq_all?: InputMaybe<Scalars['String']>;
  total_hours_not_eq_any?: InputMaybe<Scalars['String']>;
  total_hours_not_false?: InputMaybe<Scalars['String']>;
  total_hours_not_i_cont?: InputMaybe<Scalars['String']>;
  total_hours_not_i_cont_all?: InputMaybe<Scalars['String']>;
  total_hours_not_i_cont_any?: InputMaybe<Scalars['String']>;
  total_hours_not_in?: InputMaybe<Scalars['String']>;
  total_hours_not_in_all?: InputMaybe<Scalars['String']>;
  total_hours_not_in_any?: InputMaybe<Scalars['String']>;
  total_hours_not_null?: InputMaybe<Scalars['String']>;
  total_hours_not_start?: InputMaybe<Scalars['String']>;
  total_hours_not_start_all?: InputMaybe<Scalars['String']>;
  total_hours_not_start_any?: InputMaybe<Scalars['String']>;
  total_hours_not_true?: InputMaybe<Scalars['String']>;
  total_hours_null?: InputMaybe<Scalars['String']>;
  total_hours_present?: InputMaybe<Scalars['String']>;
  total_hours_start?: InputMaybe<Scalars['String']>;
  total_hours_start_all?: InputMaybe<Scalars['String']>;
  total_hours_start_any?: InputMaybe<Scalars['String']>;
  total_hours_true?: InputMaybe<Scalars['String']>;
  user_full_name_or_user_identifier_or_user_position_cont?: InputMaybe<Scalars['String']>;
  user_id_blank?: InputMaybe<Scalars['String']>;
  user_id_cont?: InputMaybe<Scalars['String']>;
  user_id_cont_all?: InputMaybe<Scalars['String']>;
  user_id_cont_any?: InputMaybe<Scalars['String']>;
  user_id_does_not_match?: InputMaybe<Scalars['String']>;
  user_id_does_not_match_all?: InputMaybe<Scalars['String']>;
  user_id_does_not_match_any?: InputMaybe<Scalars['String']>;
  user_id_end?: InputMaybe<Scalars['String']>;
  user_id_end_all?: InputMaybe<Scalars['String']>;
  user_id_end_any?: InputMaybe<Scalars['String']>;
  user_id_eq?: InputMaybe<Scalars['String']>;
  user_id_eq_all?: InputMaybe<Scalars['String']>;
  user_id_eq_any?: InputMaybe<Scalars['String']>;
  user_id_false?: InputMaybe<Scalars['String']>;
  user_id_gt?: InputMaybe<Scalars['String']>;
  user_id_gt_all?: InputMaybe<Scalars['String']>;
  user_id_gt_any?: InputMaybe<Scalars['String']>;
  user_id_gteq?: InputMaybe<Scalars['String']>;
  user_id_gteq_all?: InputMaybe<Scalars['String']>;
  user_id_gteq_any?: InputMaybe<Scalars['String']>;
  user_id_i_cont?: InputMaybe<Scalars['String']>;
  user_id_i_cont_all?: InputMaybe<Scalars['String']>;
  user_id_i_cont_any?: InputMaybe<Scalars['String']>;
  user_id_in?: InputMaybe<Scalars['String']>;
  user_id_in_all?: InputMaybe<Scalars['String']>;
  user_id_in_any?: InputMaybe<Scalars['String']>;
  user_id_lt?: InputMaybe<Scalars['String']>;
  user_id_lt_all?: InputMaybe<Scalars['String']>;
  user_id_lt_any?: InputMaybe<Scalars['String']>;
  user_id_lteq?: InputMaybe<Scalars['String']>;
  user_id_lteq_all?: InputMaybe<Scalars['String']>;
  user_id_lteq_any?: InputMaybe<Scalars['String']>;
  user_id_matches?: InputMaybe<Scalars['String']>;
  user_id_matches_all?: InputMaybe<Scalars['String']>;
  user_id_matches_any?: InputMaybe<Scalars['String']>;
  user_id_not_cont?: InputMaybe<Scalars['String']>;
  user_id_not_cont_all?: InputMaybe<Scalars['String']>;
  user_id_not_cont_any?: InputMaybe<Scalars['String']>;
  user_id_not_end?: InputMaybe<Scalars['String']>;
  user_id_not_end_all?: InputMaybe<Scalars['String']>;
  user_id_not_end_any?: InputMaybe<Scalars['String']>;
  user_id_not_eq?: InputMaybe<Scalars['String']>;
  user_id_not_eq_all?: InputMaybe<Scalars['String']>;
  user_id_not_eq_any?: InputMaybe<Scalars['String']>;
  user_id_not_false?: InputMaybe<Scalars['String']>;
  user_id_not_i_cont?: InputMaybe<Scalars['String']>;
  user_id_not_i_cont_all?: InputMaybe<Scalars['String']>;
  user_id_not_i_cont_any?: InputMaybe<Scalars['String']>;
  user_id_not_in?: InputMaybe<Scalars['String']>;
  user_id_not_in_all?: InputMaybe<Scalars['String']>;
  user_id_not_in_any?: InputMaybe<Scalars['String']>;
  user_id_not_null?: InputMaybe<Scalars['String']>;
  user_id_not_start?: InputMaybe<Scalars['String']>;
  user_id_not_start_all?: InputMaybe<Scalars['String']>;
  user_id_not_start_any?: InputMaybe<Scalars['String']>;
  user_id_not_true?: InputMaybe<Scalars['String']>;
  user_id_null?: InputMaybe<Scalars['String']>;
  user_id_present?: InputMaybe<Scalars['String']>;
  user_id_start?: InputMaybe<Scalars['String']>;
  user_id_start_all?: InputMaybe<Scalars['String']>;
  user_id_start_any?: InputMaybe<Scalars['String']>;
  user_id_true?: InputMaybe<Scalars['String']>;
};

export type GlobalAdvancement = {
  __typename?: 'GlobalAdvancement';
  coursesCount: Scalars['Int'];
  coursesProgress: Array<AreaProgress>;
  hoursTotal: Scalars['Int'];
  participantsCount: Scalars['Int'];
};


export type GlobalAdvancementCoursesProgressArgs = {
  ransack?: InputMaybe<Scalars['JSON']>;
};


export type GlobalAdvancementParticipantsCountArgs = {
  ransack?: InputMaybe<Scalars['JSON']>;
};

export type IntegrationCourse = {
  __typename?: 'IntegrationCourse';
  createdAt: Scalars['ISO8601DateTime'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSON']>;
  photo?: Maybe<Scalars['String']>;
  provider?: Maybe<Provider>;
  slug?: Maybe<Scalars['String']>;
  syncDate?: Maybe<Scalars['ISO8601DateTime']>;
  synchronized?: Maybe<Scalars['Boolean']>;
  syncing?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum IntegrationStatus {
  EnrolledInCourse = 'enrolled_in_course',
  EnrolledInProgram = 'enrolled_in_program',
  InvitedToCourse = 'invited_to_course',
  InvitedToProgram = 'invited_to_program',
  NoAccount = 'no_account',
  Pending = 'pending',
  UncontrolledError = 'uncontrolled_error'
}

export type LearningPath = {
  __typename?: 'LearningPath';
  code: Scalars['String'];
  coursesCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  learningPathType?: Maybe<Scalars['Int']>;
  monitoring?: Maybe<LearningPathMonitoring>;
  name?: Maybe<Scalars['String']>;
  pictureData?: Maybe<Scalars['JSON']>;
  profiles?: Maybe<Array<LmsProfile>>;
  state?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  usersCount?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

export type LearningPathMonitoring = {
  __typename?: 'LearningPathMonitoring';
  learningPathId: Scalars['ID'];
  usersFinish: Scalars['Int'];
  usersInProgress: Scalars['Int'];
  usersPending: Scalars['Int'];
};

export type LearningPathPage = {
  __typename?: 'LearningPathPage';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<LearningPath>;
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
};

export type LearningPathRansack = {
  code_blank?: InputMaybe<Scalars['String']>;
  code_cont?: InputMaybe<Scalars['String']>;
  code_cont_all?: InputMaybe<Scalars['String']>;
  code_cont_any?: InputMaybe<Scalars['String']>;
  code_does_not_match?: InputMaybe<Scalars['String']>;
  code_does_not_match_all?: InputMaybe<Scalars['String']>;
  code_does_not_match_any?: InputMaybe<Scalars['String']>;
  code_end?: InputMaybe<Scalars['String']>;
  code_end_all?: InputMaybe<Scalars['String']>;
  code_end_any?: InputMaybe<Scalars['String']>;
  code_eq?: InputMaybe<Scalars['String']>;
  code_eq_all?: InputMaybe<Scalars['String']>;
  code_eq_any?: InputMaybe<Scalars['String']>;
  code_false?: InputMaybe<Scalars['String']>;
  code_gt?: InputMaybe<Scalars['String']>;
  code_gt_all?: InputMaybe<Scalars['String']>;
  code_gt_any?: InputMaybe<Scalars['String']>;
  code_gteq?: InputMaybe<Scalars['String']>;
  code_gteq_all?: InputMaybe<Scalars['String']>;
  code_gteq_any?: InputMaybe<Scalars['String']>;
  code_i_cont?: InputMaybe<Scalars['String']>;
  code_i_cont_all?: InputMaybe<Scalars['String']>;
  code_i_cont_any?: InputMaybe<Scalars['String']>;
  code_in?: InputMaybe<Array<Scalars['String']>>;
  code_in_all?: InputMaybe<Array<Scalars['String']>>;
  code_in_any?: InputMaybe<Array<Scalars['String']>>;
  code_lt?: InputMaybe<Scalars['String']>;
  code_lt_all?: InputMaybe<Scalars['String']>;
  code_lt_any?: InputMaybe<Scalars['String']>;
  code_lteq?: InputMaybe<Scalars['String']>;
  code_lteq_all?: InputMaybe<Scalars['String']>;
  code_lteq_any?: InputMaybe<Scalars['String']>;
  code_matches?: InputMaybe<Scalars['String']>;
  code_matches_all?: InputMaybe<Scalars['String']>;
  code_matches_any?: InputMaybe<Scalars['String']>;
  code_not_cont?: InputMaybe<Scalars['String']>;
  code_not_cont_all?: InputMaybe<Scalars['String']>;
  code_not_cont_any?: InputMaybe<Scalars['String']>;
  code_not_end?: InputMaybe<Scalars['String']>;
  code_not_end_all?: InputMaybe<Scalars['String']>;
  code_not_end_any?: InputMaybe<Scalars['String']>;
  code_not_eq?: InputMaybe<Scalars['String']>;
  code_not_eq_all?: InputMaybe<Scalars['String']>;
  code_not_eq_any?: InputMaybe<Scalars['String']>;
  code_not_false?: InputMaybe<Scalars['String']>;
  code_not_i_cont?: InputMaybe<Scalars['String']>;
  code_not_i_cont_all?: InputMaybe<Scalars['String']>;
  code_not_i_cont_any?: InputMaybe<Scalars['String']>;
  code_not_in?: InputMaybe<Array<Scalars['String']>>;
  code_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  code_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  code_not_null?: InputMaybe<Scalars['String']>;
  code_not_start?: InputMaybe<Scalars['String']>;
  code_not_start_all?: InputMaybe<Scalars['String']>;
  code_not_start_any?: InputMaybe<Scalars['String']>;
  code_not_true?: InputMaybe<Scalars['String']>;
  code_null?: InputMaybe<Scalars['String']>;
  code_present?: InputMaybe<Scalars['String']>;
  code_start?: InputMaybe<Scalars['String']>;
  code_start_all?: InputMaybe<Scalars['String']>;
  code_start_any?: InputMaybe<Scalars['String']>;
  code_true?: InputMaybe<Scalars['String']>;
  courses_count_blank?: InputMaybe<Scalars['String']>;
  courses_count_cont?: InputMaybe<Scalars['String']>;
  courses_count_cont_all?: InputMaybe<Scalars['String']>;
  courses_count_cont_any?: InputMaybe<Scalars['String']>;
  courses_count_does_not_match?: InputMaybe<Scalars['String']>;
  courses_count_does_not_match_all?: InputMaybe<Scalars['String']>;
  courses_count_does_not_match_any?: InputMaybe<Scalars['String']>;
  courses_count_end?: InputMaybe<Scalars['String']>;
  courses_count_end_all?: InputMaybe<Scalars['String']>;
  courses_count_end_any?: InputMaybe<Scalars['String']>;
  courses_count_eq?: InputMaybe<Scalars['String']>;
  courses_count_eq_all?: InputMaybe<Scalars['String']>;
  courses_count_eq_any?: InputMaybe<Scalars['String']>;
  courses_count_false?: InputMaybe<Scalars['String']>;
  courses_count_gt?: InputMaybe<Scalars['String']>;
  courses_count_gt_all?: InputMaybe<Scalars['String']>;
  courses_count_gt_any?: InputMaybe<Scalars['String']>;
  courses_count_gteq?: InputMaybe<Scalars['String']>;
  courses_count_gteq_all?: InputMaybe<Scalars['String']>;
  courses_count_gteq_any?: InputMaybe<Scalars['String']>;
  courses_count_i_cont?: InputMaybe<Scalars['String']>;
  courses_count_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_count_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_count_in?: InputMaybe<Scalars['String']>;
  courses_count_in_all?: InputMaybe<Scalars['String']>;
  courses_count_in_any?: InputMaybe<Scalars['String']>;
  courses_count_lt?: InputMaybe<Scalars['String']>;
  courses_count_lt_all?: InputMaybe<Scalars['String']>;
  courses_count_lt_any?: InputMaybe<Scalars['String']>;
  courses_count_lteq?: InputMaybe<Scalars['String']>;
  courses_count_lteq_all?: InputMaybe<Scalars['String']>;
  courses_count_lteq_any?: InputMaybe<Scalars['String']>;
  courses_count_matches?: InputMaybe<Scalars['String']>;
  courses_count_matches_all?: InputMaybe<Scalars['String']>;
  courses_count_matches_any?: InputMaybe<Scalars['String']>;
  courses_count_not_cont?: InputMaybe<Scalars['String']>;
  courses_count_not_cont_all?: InputMaybe<Scalars['String']>;
  courses_count_not_cont_any?: InputMaybe<Scalars['String']>;
  courses_count_not_end?: InputMaybe<Scalars['String']>;
  courses_count_not_end_all?: InputMaybe<Scalars['String']>;
  courses_count_not_end_any?: InputMaybe<Scalars['String']>;
  courses_count_not_eq?: InputMaybe<Scalars['String']>;
  courses_count_not_eq_all?: InputMaybe<Scalars['String']>;
  courses_count_not_eq_any?: InputMaybe<Scalars['String']>;
  courses_count_not_false?: InputMaybe<Scalars['String']>;
  courses_count_not_i_cont?: InputMaybe<Scalars['String']>;
  courses_count_not_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_count_not_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_count_not_in?: InputMaybe<Scalars['String']>;
  courses_count_not_in_all?: InputMaybe<Scalars['String']>;
  courses_count_not_in_any?: InputMaybe<Scalars['String']>;
  courses_count_not_null?: InputMaybe<Scalars['String']>;
  courses_count_not_start?: InputMaybe<Scalars['String']>;
  courses_count_not_start_all?: InputMaybe<Scalars['String']>;
  courses_count_not_start_any?: InputMaybe<Scalars['String']>;
  courses_count_not_true?: InputMaybe<Scalars['String']>;
  courses_count_null?: InputMaybe<Scalars['String']>;
  courses_count_present?: InputMaybe<Scalars['String']>;
  courses_count_start?: InputMaybe<Scalars['String']>;
  courses_count_start_all?: InputMaybe<Scalars['String']>;
  courses_count_start_any?: InputMaybe<Scalars['String']>;
  courses_count_true?: InputMaybe<Scalars['String']>;
  created_at_blank?: InputMaybe<Scalars['String']>;
  created_at_cont?: InputMaybe<Scalars['String']>;
  created_at_cont_all?: InputMaybe<Scalars['String']>;
  created_at_cont_any?: InputMaybe<Scalars['String']>;
  created_at_does_not_match?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  created_at_end?: InputMaybe<Scalars['String']>;
  created_at_end_all?: InputMaybe<Scalars['String']>;
  created_at_end_any?: InputMaybe<Scalars['String']>;
  created_at_eq?: InputMaybe<Scalars['String']>;
  created_at_eq_all?: InputMaybe<Scalars['String']>;
  created_at_eq_any?: InputMaybe<Scalars['String']>;
  created_at_false?: InputMaybe<Scalars['String']>;
  created_at_gt?: InputMaybe<Scalars['String']>;
  created_at_gt_all?: InputMaybe<Scalars['String']>;
  created_at_gt_any?: InputMaybe<Scalars['String']>;
  created_at_gteq?: InputMaybe<Scalars['String']>;
  created_at_gteq_all?: InputMaybe<Scalars['String']>;
  created_at_gteq_any?: InputMaybe<Scalars['String']>;
  created_at_i_cont?: InputMaybe<Scalars['String']>;
  created_at_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_in?: InputMaybe<Scalars['String']>;
  created_at_in_all?: InputMaybe<Scalars['String']>;
  created_at_in_any?: InputMaybe<Scalars['String']>;
  created_at_lt?: InputMaybe<Scalars['String']>;
  created_at_lt_all?: InputMaybe<Scalars['String']>;
  created_at_lt_any?: InputMaybe<Scalars['String']>;
  created_at_lteq?: InputMaybe<Scalars['String']>;
  created_at_lteq_all?: InputMaybe<Scalars['String']>;
  created_at_lteq_any?: InputMaybe<Scalars['String']>;
  created_at_matches?: InputMaybe<Scalars['String']>;
  created_at_matches_all?: InputMaybe<Scalars['String']>;
  created_at_matches_any?: InputMaybe<Scalars['String']>;
  created_at_not_cont?: InputMaybe<Scalars['String']>;
  created_at_not_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_end?: InputMaybe<Scalars['String']>;
  created_at_not_end_all?: InputMaybe<Scalars['String']>;
  created_at_not_end_any?: InputMaybe<Scalars['String']>;
  created_at_not_eq?: InputMaybe<Scalars['String']>;
  created_at_not_eq_all?: InputMaybe<Scalars['String']>;
  created_at_not_eq_any?: InputMaybe<Scalars['String']>;
  created_at_not_false?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_in?: InputMaybe<Scalars['String']>;
  created_at_not_in_all?: InputMaybe<Scalars['String']>;
  created_at_not_in_any?: InputMaybe<Scalars['String']>;
  created_at_not_null?: InputMaybe<Scalars['String']>;
  created_at_not_start?: InputMaybe<Scalars['String']>;
  created_at_not_start_all?: InputMaybe<Scalars['String']>;
  created_at_not_start_any?: InputMaybe<Scalars['String']>;
  created_at_not_true?: InputMaybe<Scalars['String']>;
  created_at_null?: InputMaybe<Scalars['String']>;
  created_at_present?: InputMaybe<Scalars['String']>;
  created_at_start?: InputMaybe<Scalars['String']>;
  created_at_start_all?: InputMaybe<Scalars['String']>;
  created_at_start_any?: InputMaybe<Scalars['String']>;
  created_at_true?: InputMaybe<Scalars['String']>;
  current_data_blank?: InputMaybe<Scalars['String']>;
  current_data_cont?: InputMaybe<Scalars['String']>;
  current_data_cont_all?: InputMaybe<Scalars['String']>;
  current_data_cont_any?: InputMaybe<Scalars['String']>;
  current_data_does_not_match?: InputMaybe<Scalars['String']>;
  current_data_does_not_match_all?: InputMaybe<Scalars['String']>;
  current_data_does_not_match_any?: InputMaybe<Scalars['String']>;
  current_data_end?: InputMaybe<Scalars['String']>;
  current_data_end_all?: InputMaybe<Scalars['String']>;
  current_data_end_any?: InputMaybe<Scalars['String']>;
  current_data_eq?: InputMaybe<Scalars['String']>;
  current_data_eq_all?: InputMaybe<Scalars['String']>;
  current_data_eq_any?: InputMaybe<Scalars['String']>;
  current_data_false?: InputMaybe<Scalars['String']>;
  current_data_gt?: InputMaybe<Scalars['String']>;
  current_data_gt_all?: InputMaybe<Scalars['String']>;
  current_data_gt_any?: InputMaybe<Scalars['String']>;
  current_data_gteq?: InputMaybe<Scalars['String']>;
  current_data_gteq_all?: InputMaybe<Scalars['String']>;
  current_data_gteq_any?: InputMaybe<Scalars['String']>;
  current_data_i_cont?: InputMaybe<Scalars['String']>;
  current_data_i_cont_all?: InputMaybe<Scalars['String']>;
  current_data_i_cont_any?: InputMaybe<Scalars['String']>;
  current_data_in?: InputMaybe<Scalars['String']>;
  current_data_in_all?: InputMaybe<Scalars['String']>;
  current_data_in_any?: InputMaybe<Scalars['String']>;
  current_data_lt?: InputMaybe<Scalars['String']>;
  current_data_lt_all?: InputMaybe<Scalars['String']>;
  current_data_lt_any?: InputMaybe<Scalars['String']>;
  current_data_lteq?: InputMaybe<Scalars['String']>;
  current_data_lteq_all?: InputMaybe<Scalars['String']>;
  current_data_lteq_any?: InputMaybe<Scalars['String']>;
  current_data_matches?: InputMaybe<Scalars['String']>;
  current_data_matches_all?: InputMaybe<Scalars['String']>;
  current_data_matches_any?: InputMaybe<Scalars['String']>;
  current_data_not_cont?: InputMaybe<Scalars['String']>;
  current_data_not_cont_all?: InputMaybe<Scalars['String']>;
  current_data_not_cont_any?: InputMaybe<Scalars['String']>;
  current_data_not_end?: InputMaybe<Scalars['String']>;
  current_data_not_end_all?: InputMaybe<Scalars['String']>;
  current_data_not_end_any?: InputMaybe<Scalars['String']>;
  current_data_not_eq?: InputMaybe<Scalars['String']>;
  current_data_not_eq_all?: InputMaybe<Scalars['String']>;
  current_data_not_eq_any?: InputMaybe<Scalars['String']>;
  current_data_not_false?: InputMaybe<Scalars['String']>;
  current_data_not_i_cont?: InputMaybe<Scalars['String']>;
  current_data_not_i_cont_all?: InputMaybe<Scalars['String']>;
  current_data_not_i_cont_any?: InputMaybe<Scalars['String']>;
  current_data_not_in?: InputMaybe<Scalars['String']>;
  current_data_not_in_all?: InputMaybe<Scalars['String']>;
  current_data_not_in_any?: InputMaybe<Scalars['String']>;
  current_data_not_null?: InputMaybe<Scalars['String']>;
  current_data_not_start?: InputMaybe<Scalars['String']>;
  current_data_not_start_all?: InputMaybe<Scalars['String']>;
  current_data_not_start_any?: InputMaybe<Scalars['String']>;
  current_data_not_true?: InputMaybe<Scalars['String']>;
  current_data_null?: InputMaybe<Scalars['String']>;
  current_data_present?: InputMaybe<Scalars['String']>;
  current_data_start?: InputMaybe<Scalars['String']>;
  current_data_start_all?: InputMaybe<Scalars['String']>;
  current_data_start_any?: InputMaybe<Scalars['String']>;
  current_data_true?: InputMaybe<Scalars['String']>;
  deleted_at_blank?: InputMaybe<Scalars['String']>;
  deleted_at_cont?: InputMaybe<Scalars['String']>;
  deleted_at_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  deleted_at_end?: InputMaybe<Scalars['String']>;
  deleted_at_end_all?: InputMaybe<Scalars['String']>;
  deleted_at_end_any?: InputMaybe<Scalars['String']>;
  deleted_at_eq?: InputMaybe<Scalars['String']>;
  deleted_at_eq_all?: InputMaybe<Scalars['String']>;
  deleted_at_eq_any?: InputMaybe<Scalars['String']>;
  deleted_at_false?: InputMaybe<Scalars['String']>;
  deleted_at_gt?: InputMaybe<Scalars['String']>;
  deleted_at_gt_all?: InputMaybe<Scalars['String']>;
  deleted_at_gt_any?: InputMaybe<Scalars['String']>;
  deleted_at_gteq?: InputMaybe<Scalars['String']>;
  deleted_at_gteq_all?: InputMaybe<Scalars['String']>;
  deleted_at_gteq_any?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_in?: InputMaybe<Scalars['String']>;
  deleted_at_in_all?: InputMaybe<Scalars['String']>;
  deleted_at_in_any?: InputMaybe<Scalars['String']>;
  deleted_at_lt?: InputMaybe<Scalars['String']>;
  deleted_at_lt_all?: InputMaybe<Scalars['String']>;
  deleted_at_lt_any?: InputMaybe<Scalars['String']>;
  deleted_at_lteq?: InputMaybe<Scalars['String']>;
  deleted_at_lteq_all?: InputMaybe<Scalars['String']>;
  deleted_at_lteq_any?: InputMaybe<Scalars['String']>;
  deleted_at_matches?: InputMaybe<Scalars['String']>;
  deleted_at_matches_all?: InputMaybe<Scalars['String']>;
  deleted_at_matches_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_end?: InputMaybe<Scalars['String']>;
  deleted_at_not_end_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_end_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_false?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_in?: InputMaybe<Scalars['String']>;
  deleted_at_not_in_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_in_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_null?: InputMaybe<Scalars['String']>;
  deleted_at_not_start?: InputMaybe<Scalars['String']>;
  deleted_at_not_start_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_start_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_true?: InputMaybe<Scalars['String']>;
  deleted_at_null?: InputMaybe<Scalars['String']>;
  deleted_at_present?: InputMaybe<Scalars['String']>;
  deleted_at_start?: InputMaybe<Scalars['String']>;
  deleted_at_start_all?: InputMaybe<Scalars['String']>;
  deleted_at_start_any?: InputMaybe<Scalars['String']>;
  deleted_at_true?: InputMaybe<Scalars['String']>;
  description_blank?: InputMaybe<Scalars['String']>;
  description_cont?: InputMaybe<Scalars['String']>;
  description_cont_all?: InputMaybe<Scalars['String']>;
  description_cont_any?: InputMaybe<Scalars['String']>;
  description_does_not_match?: InputMaybe<Scalars['String']>;
  description_does_not_match_all?: InputMaybe<Scalars['String']>;
  description_does_not_match_any?: InputMaybe<Scalars['String']>;
  description_end?: InputMaybe<Scalars['String']>;
  description_end_all?: InputMaybe<Scalars['String']>;
  description_end_any?: InputMaybe<Scalars['String']>;
  description_eq?: InputMaybe<Scalars['String']>;
  description_eq_all?: InputMaybe<Scalars['String']>;
  description_eq_any?: InputMaybe<Scalars['String']>;
  description_false?: InputMaybe<Scalars['String']>;
  description_gt?: InputMaybe<Scalars['String']>;
  description_gt_all?: InputMaybe<Scalars['String']>;
  description_gt_any?: InputMaybe<Scalars['String']>;
  description_gteq?: InputMaybe<Scalars['String']>;
  description_gteq_all?: InputMaybe<Scalars['String']>;
  description_gteq_any?: InputMaybe<Scalars['String']>;
  description_i_cont?: InputMaybe<Scalars['String']>;
  description_i_cont_all?: InputMaybe<Scalars['String']>;
  description_i_cont_any?: InputMaybe<Scalars['String']>;
  description_in?: InputMaybe<Array<Scalars['String']>>;
  description_in_all?: InputMaybe<Array<Scalars['String']>>;
  description_in_any?: InputMaybe<Array<Scalars['String']>>;
  description_lt?: InputMaybe<Scalars['String']>;
  description_lt_all?: InputMaybe<Scalars['String']>;
  description_lt_any?: InputMaybe<Scalars['String']>;
  description_lteq?: InputMaybe<Scalars['String']>;
  description_lteq_all?: InputMaybe<Scalars['String']>;
  description_lteq_any?: InputMaybe<Scalars['String']>;
  description_matches?: InputMaybe<Scalars['String']>;
  description_matches_all?: InputMaybe<Scalars['String']>;
  description_matches_any?: InputMaybe<Scalars['String']>;
  description_not_cont?: InputMaybe<Scalars['String']>;
  description_not_cont_all?: InputMaybe<Scalars['String']>;
  description_not_cont_any?: InputMaybe<Scalars['String']>;
  description_not_end?: InputMaybe<Scalars['String']>;
  description_not_end_all?: InputMaybe<Scalars['String']>;
  description_not_end_any?: InputMaybe<Scalars['String']>;
  description_not_eq?: InputMaybe<Scalars['String']>;
  description_not_eq_all?: InputMaybe<Scalars['String']>;
  description_not_eq_any?: InputMaybe<Scalars['String']>;
  description_not_false?: InputMaybe<Scalars['String']>;
  description_not_i_cont?: InputMaybe<Scalars['String']>;
  description_not_i_cont_all?: InputMaybe<Scalars['String']>;
  description_not_i_cont_any?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<Scalars['String']>>;
  description_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  description_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  description_not_null?: InputMaybe<Scalars['String']>;
  description_not_start?: InputMaybe<Scalars['String']>;
  description_not_start_all?: InputMaybe<Scalars['String']>;
  description_not_start_any?: InputMaybe<Scalars['String']>;
  description_not_true?: InputMaybe<Scalars['String']>;
  description_null?: InputMaybe<Scalars['String']>;
  description_present?: InputMaybe<Scalars['String']>;
  description_start?: InputMaybe<Scalars['String']>;
  description_start_all?: InputMaybe<Scalars['String']>;
  description_start_any?: InputMaybe<Scalars['String']>;
  description_true?: InputMaybe<Scalars['String']>;
  g?: InputMaybe<Array<Scalars['JSON']>>;
  id_blank?: InputMaybe<Scalars['Int']>;
  id_cont?: InputMaybe<Scalars['Int']>;
  id_cont_all?: InputMaybe<Scalars['Int']>;
  id_cont_any?: InputMaybe<Scalars['Int']>;
  id_does_not_match?: InputMaybe<Scalars['Int']>;
  id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  id_end?: InputMaybe<Scalars['Int']>;
  id_end_all?: InputMaybe<Scalars['Int']>;
  id_end_any?: InputMaybe<Scalars['Int']>;
  id_eq?: InputMaybe<Scalars['Int']>;
  id_eq_all?: InputMaybe<Scalars['Int']>;
  id_eq_any?: InputMaybe<Scalars['Int']>;
  id_false?: InputMaybe<Scalars['Int']>;
  id_gt?: InputMaybe<Scalars['Int']>;
  id_gt_all?: InputMaybe<Scalars['Int']>;
  id_gt_any?: InputMaybe<Scalars['Int']>;
  id_gteq?: InputMaybe<Scalars['Int']>;
  id_gteq_all?: InputMaybe<Scalars['Int']>;
  id_gteq_any?: InputMaybe<Scalars['Int']>;
  id_i_cont?: InputMaybe<Scalars['Int']>;
  id_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_in?: InputMaybe<Array<Scalars['Int']>>;
  id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_lt?: InputMaybe<Scalars['Int']>;
  id_lt_all?: InputMaybe<Scalars['Int']>;
  id_lt_any?: InputMaybe<Scalars['Int']>;
  id_lteq?: InputMaybe<Scalars['Int']>;
  id_lteq_all?: InputMaybe<Scalars['Int']>;
  id_lteq_any?: InputMaybe<Scalars['Int']>;
  id_matches?: InputMaybe<Scalars['Int']>;
  id_matches_all?: InputMaybe<Scalars['Int']>;
  id_matches_any?: InputMaybe<Scalars['Int']>;
  id_not_cont?: InputMaybe<Scalars['Int']>;
  id_not_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_end?: InputMaybe<Scalars['Int']>;
  id_not_end_all?: InputMaybe<Scalars['Int']>;
  id_not_end_any?: InputMaybe<Scalars['Int']>;
  id_not_eq?: InputMaybe<Scalars['Int']>;
  id_not_eq_all?: InputMaybe<Scalars['Int']>;
  id_not_eq_any?: InputMaybe<Scalars['Int']>;
  id_not_false?: InputMaybe<Scalars['Int']>;
  id_not_i_cont?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_not_null?: InputMaybe<Scalars['Int']>;
  id_not_start?: InputMaybe<Scalars['Int']>;
  id_not_start_all?: InputMaybe<Scalars['Int']>;
  id_not_start_any?: InputMaybe<Scalars['Int']>;
  id_not_true?: InputMaybe<Scalars['Int']>;
  id_null?: InputMaybe<Scalars['Int']>;
  id_present?: InputMaybe<Scalars['Int']>;
  id_start?: InputMaybe<Scalars['Int']>;
  id_start_all?: InputMaybe<Scalars['Int']>;
  id_start_any?: InputMaybe<Scalars['Int']>;
  id_true?: InputMaybe<Scalars['Int']>;
  learning_path_type_blank?: InputMaybe<Scalars['Int']>;
  learning_path_type_cont?: InputMaybe<Scalars['Int']>;
  learning_path_type_cont_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_cont_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_does_not_match?: InputMaybe<Scalars['Int']>;
  learning_path_type_does_not_match_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_does_not_match_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_end?: InputMaybe<Scalars['Int']>;
  learning_path_type_end_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_end_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_eq?: InputMaybe<Scalars['Int']>;
  learning_path_type_eq_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_eq_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_false?: InputMaybe<Scalars['Int']>;
  learning_path_type_gt?: InputMaybe<Scalars['Int']>;
  learning_path_type_gt_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_gt_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_gteq?: InputMaybe<Scalars['Int']>;
  learning_path_type_gteq_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_gteq_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_i_cont?: InputMaybe<Scalars['Int']>;
  learning_path_type_i_cont_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_i_cont_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_in?: InputMaybe<Array<Scalars['Int']>>;
  learning_path_type_in_all?: InputMaybe<Array<Scalars['Int']>>;
  learning_path_type_in_any?: InputMaybe<Array<Scalars['Int']>>;
  learning_path_type_lt?: InputMaybe<Scalars['Int']>;
  learning_path_type_lt_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_lt_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_lteq?: InputMaybe<Scalars['Int']>;
  learning_path_type_lteq_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_lteq_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_matches?: InputMaybe<Scalars['Int']>;
  learning_path_type_matches_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_matches_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_cont?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_cont_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_cont_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_end?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_end_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_end_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_eq?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_eq_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_eq_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_false?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_i_cont?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_in?: InputMaybe<Array<Scalars['Int']>>;
  learning_path_type_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  learning_path_type_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  learning_path_type_not_null?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_start?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_start_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_start_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_not_true?: InputMaybe<Scalars['Int']>;
  learning_path_type_null?: InputMaybe<Scalars['Int']>;
  learning_path_type_present?: InputMaybe<Scalars['Int']>;
  learning_path_type_start?: InputMaybe<Scalars['Int']>;
  learning_path_type_start_all?: InputMaybe<Scalars['Int']>;
  learning_path_type_start_any?: InputMaybe<Scalars['Int']>;
  learning_path_type_true?: InputMaybe<Scalars['Int']>;
  name_blank?: InputMaybe<Scalars['String']>;
  name_cont?: InputMaybe<Scalars['String']>;
  name_cont_all?: InputMaybe<Scalars['String']>;
  name_cont_any?: InputMaybe<Scalars['String']>;
  name_does_not_match?: InputMaybe<Scalars['String']>;
  name_does_not_match_all?: InputMaybe<Scalars['String']>;
  name_does_not_match_any?: InputMaybe<Scalars['String']>;
  name_end?: InputMaybe<Scalars['String']>;
  name_end_all?: InputMaybe<Scalars['String']>;
  name_end_any?: InputMaybe<Scalars['String']>;
  name_eq?: InputMaybe<Scalars['String']>;
  name_eq_all?: InputMaybe<Scalars['String']>;
  name_eq_any?: InputMaybe<Scalars['String']>;
  name_false?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gt_all?: InputMaybe<Scalars['String']>;
  name_gt_any?: InputMaybe<Scalars['String']>;
  name_gteq?: InputMaybe<Scalars['String']>;
  name_gteq_all?: InputMaybe<Scalars['String']>;
  name_gteq_any?: InputMaybe<Scalars['String']>;
  name_i_cont?: InputMaybe<Scalars['String']>;
  name_i_cont_all?: InputMaybe<Scalars['String']>;
  name_i_cont_any?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lt_all?: InputMaybe<Scalars['String']>;
  name_lt_any?: InputMaybe<Scalars['String']>;
  name_lteq?: InputMaybe<Scalars['String']>;
  name_lteq_all?: InputMaybe<Scalars['String']>;
  name_lteq_any?: InputMaybe<Scalars['String']>;
  name_matches?: InputMaybe<Scalars['String']>;
  name_matches_all?: InputMaybe<Scalars['String']>;
  name_matches_any?: InputMaybe<Scalars['String']>;
  name_not_cont?: InputMaybe<Scalars['String']>;
  name_not_cont_all?: InputMaybe<Scalars['String']>;
  name_not_cont_any?: InputMaybe<Scalars['String']>;
  name_not_end?: InputMaybe<Scalars['String']>;
  name_not_end_all?: InputMaybe<Scalars['String']>;
  name_not_end_any?: InputMaybe<Scalars['String']>;
  name_not_eq?: InputMaybe<Scalars['String']>;
  name_not_eq_all?: InputMaybe<Scalars['String']>;
  name_not_eq_any?: InputMaybe<Scalars['String']>;
  name_not_false?: InputMaybe<Scalars['String']>;
  name_not_i_cont?: InputMaybe<Scalars['String']>;
  name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_not_null?: InputMaybe<Scalars['String']>;
  name_not_start?: InputMaybe<Scalars['String']>;
  name_not_start_all?: InputMaybe<Scalars['String']>;
  name_not_start_any?: InputMaybe<Scalars['String']>;
  name_not_true?: InputMaybe<Scalars['String']>;
  name_null?: InputMaybe<Scalars['String']>;
  name_present?: InputMaybe<Scalars['String']>;
  name_start?: InputMaybe<Scalars['String']>;
  name_start_all?: InputMaybe<Scalars['String']>;
  name_start_any?: InputMaybe<Scalars['String']>;
  name_true?: InputMaybe<Scalars['String']>;
  picture_data_blank?: InputMaybe<Scalars['String']>;
  picture_data_cont?: InputMaybe<Scalars['String']>;
  picture_data_cont_all?: InputMaybe<Scalars['String']>;
  picture_data_cont_any?: InputMaybe<Scalars['String']>;
  picture_data_does_not_match?: InputMaybe<Scalars['String']>;
  picture_data_does_not_match_all?: InputMaybe<Scalars['String']>;
  picture_data_does_not_match_any?: InputMaybe<Scalars['String']>;
  picture_data_end?: InputMaybe<Scalars['String']>;
  picture_data_end_all?: InputMaybe<Scalars['String']>;
  picture_data_end_any?: InputMaybe<Scalars['String']>;
  picture_data_eq?: InputMaybe<Scalars['String']>;
  picture_data_eq_all?: InputMaybe<Scalars['String']>;
  picture_data_eq_any?: InputMaybe<Scalars['String']>;
  picture_data_false?: InputMaybe<Scalars['String']>;
  picture_data_gt?: InputMaybe<Scalars['String']>;
  picture_data_gt_all?: InputMaybe<Scalars['String']>;
  picture_data_gt_any?: InputMaybe<Scalars['String']>;
  picture_data_gteq?: InputMaybe<Scalars['String']>;
  picture_data_gteq_all?: InputMaybe<Scalars['String']>;
  picture_data_gteq_any?: InputMaybe<Scalars['String']>;
  picture_data_i_cont?: InputMaybe<Scalars['String']>;
  picture_data_i_cont_all?: InputMaybe<Scalars['String']>;
  picture_data_i_cont_any?: InputMaybe<Scalars['String']>;
  picture_data_in?: InputMaybe<Scalars['String']>;
  picture_data_in_all?: InputMaybe<Scalars['String']>;
  picture_data_in_any?: InputMaybe<Scalars['String']>;
  picture_data_lt?: InputMaybe<Scalars['String']>;
  picture_data_lt_all?: InputMaybe<Scalars['String']>;
  picture_data_lt_any?: InputMaybe<Scalars['String']>;
  picture_data_lteq?: InputMaybe<Scalars['String']>;
  picture_data_lteq_all?: InputMaybe<Scalars['String']>;
  picture_data_lteq_any?: InputMaybe<Scalars['String']>;
  picture_data_matches?: InputMaybe<Scalars['String']>;
  picture_data_matches_all?: InputMaybe<Scalars['String']>;
  picture_data_matches_any?: InputMaybe<Scalars['String']>;
  picture_data_not_cont?: InputMaybe<Scalars['String']>;
  picture_data_not_cont_all?: InputMaybe<Scalars['String']>;
  picture_data_not_cont_any?: InputMaybe<Scalars['String']>;
  picture_data_not_end?: InputMaybe<Scalars['String']>;
  picture_data_not_end_all?: InputMaybe<Scalars['String']>;
  picture_data_not_end_any?: InputMaybe<Scalars['String']>;
  picture_data_not_eq?: InputMaybe<Scalars['String']>;
  picture_data_not_eq_all?: InputMaybe<Scalars['String']>;
  picture_data_not_eq_any?: InputMaybe<Scalars['String']>;
  picture_data_not_false?: InputMaybe<Scalars['String']>;
  picture_data_not_i_cont?: InputMaybe<Scalars['String']>;
  picture_data_not_i_cont_all?: InputMaybe<Scalars['String']>;
  picture_data_not_i_cont_any?: InputMaybe<Scalars['String']>;
  picture_data_not_in?: InputMaybe<Scalars['String']>;
  picture_data_not_in_all?: InputMaybe<Scalars['String']>;
  picture_data_not_in_any?: InputMaybe<Scalars['String']>;
  picture_data_not_null?: InputMaybe<Scalars['String']>;
  picture_data_not_start?: InputMaybe<Scalars['String']>;
  picture_data_not_start_all?: InputMaybe<Scalars['String']>;
  picture_data_not_start_any?: InputMaybe<Scalars['String']>;
  picture_data_not_true?: InputMaybe<Scalars['String']>;
  picture_data_null?: InputMaybe<Scalars['String']>;
  picture_data_present?: InputMaybe<Scalars['String']>;
  picture_data_start?: InputMaybe<Scalars['String']>;
  picture_data_start_all?: InputMaybe<Scalars['String']>;
  picture_data_start_any?: InputMaybe<Scalars['String']>;
  picture_data_true?: InputMaybe<Scalars['String']>;
  sorts?: InputMaybe<Array<Scalars['String']>>;
  state_blank?: InputMaybe<Scalars['Int']>;
  state_cont?: InputMaybe<Scalars['Int']>;
  state_cont_all?: InputMaybe<Scalars['Int']>;
  state_cont_any?: InputMaybe<Scalars['Int']>;
  state_does_not_match?: InputMaybe<Scalars['Int']>;
  state_does_not_match_all?: InputMaybe<Scalars['Int']>;
  state_does_not_match_any?: InputMaybe<Scalars['Int']>;
  state_end?: InputMaybe<Scalars['Int']>;
  state_end_all?: InputMaybe<Scalars['Int']>;
  state_end_any?: InputMaybe<Scalars['Int']>;
  state_eq?: InputMaybe<Scalars['Int']>;
  state_eq_all?: InputMaybe<Scalars['Int']>;
  state_eq_any?: InputMaybe<Scalars['Int']>;
  state_false?: InputMaybe<Scalars['Int']>;
  state_gt?: InputMaybe<Scalars['Int']>;
  state_gt_all?: InputMaybe<Scalars['Int']>;
  state_gt_any?: InputMaybe<Scalars['Int']>;
  state_gteq?: InputMaybe<Scalars['Int']>;
  state_gteq_all?: InputMaybe<Scalars['Int']>;
  state_gteq_any?: InputMaybe<Scalars['Int']>;
  state_i_cont?: InputMaybe<Scalars['Int']>;
  state_i_cont_all?: InputMaybe<Scalars['Int']>;
  state_i_cont_any?: InputMaybe<Scalars['Int']>;
  state_in?: InputMaybe<Array<Scalars['Int']>>;
  state_in_all?: InputMaybe<Array<Scalars['Int']>>;
  state_in_any?: InputMaybe<Array<Scalars['Int']>>;
  state_lt?: InputMaybe<Scalars['Int']>;
  state_lt_all?: InputMaybe<Scalars['Int']>;
  state_lt_any?: InputMaybe<Scalars['Int']>;
  state_lteq?: InputMaybe<Scalars['Int']>;
  state_lteq_all?: InputMaybe<Scalars['Int']>;
  state_lteq_any?: InputMaybe<Scalars['Int']>;
  state_matches?: InputMaybe<Scalars['Int']>;
  state_matches_all?: InputMaybe<Scalars['Int']>;
  state_matches_any?: InputMaybe<Scalars['Int']>;
  state_not_cont?: InputMaybe<Scalars['Int']>;
  state_not_cont_all?: InputMaybe<Scalars['Int']>;
  state_not_cont_any?: InputMaybe<Scalars['Int']>;
  state_not_end?: InputMaybe<Scalars['Int']>;
  state_not_end_all?: InputMaybe<Scalars['Int']>;
  state_not_end_any?: InputMaybe<Scalars['Int']>;
  state_not_eq?: InputMaybe<Scalars['Int']>;
  state_not_eq_all?: InputMaybe<Scalars['Int']>;
  state_not_eq_any?: InputMaybe<Scalars['Int']>;
  state_not_false?: InputMaybe<Scalars['Int']>;
  state_not_i_cont?: InputMaybe<Scalars['Int']>;
  state_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  state_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  state_not_in?: InputMaybe<Array<Scalars['Int']>>;
  state_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  state_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  state_not_null?: InputMaybe<Scalars['Int']>;
  state_not_start?: InputMaybe<Scalars['Int']>;
  state_not_start_all?: InputMaybe<Scalars['Int']>;
  state_not_start_any?: InputMaybe<Scalars['Int']>;
  state_not_true?: InputMaybe<Scalars['Int']>;
  state_null?: InputMaybe<Scalars['Int']>;
  state_present?: InputMaybe<Scalars['Int']>;
  state_start?: InputMaybe<Scalars['Int']>;
  state_start_all?: InputMaybe<Scalars['Int']>;
  state_start_any?: InputMaybe<Scalars['Int']>;
  state_true?: InputMaybe<Scalars['Int']>;
  users_count_blank?: InputMaybe<Scalars['String']>;
  users_count_cont?: InputMaybe<Scalars['String']>;
  users_count_cont_all?: InputMaybe<Scalars['String']>;
  users_count_cont_any?: InputMaybe<Scalars['String']>;
  users_count_does_not_match?: InputMaybe<Scalars['String']>;
  users_count_does_not_match_all?: InputMaybe<Scalars['String']>;
  users_count_does_not_match_any?: InputMaybe<Scalars['String']>;
  users_count_end?: InputMaybe<Scalars['String']>;
  users_count_end_all?: InputMaybe<Scalars['String']>;
  users_count_end_any?: InputMaybe<Scalars['String']>;
  users_count_eq?: InputMaybe<Scalars['String']>;
  users_count_eq_all?: InputMaybe<Scalars['String']>;
  users_count_eq_any?: InputMaybe<Scalars['String']>;
  users_count_false?: InputMaybe<Scalars['String']>;
  users_count_gt?: InputMaybe<Scalars['String']>;
  users_count_gt_all?: InputMaybe<Scalars['String']>;
  users_count_gt_any?: InputMaybe<Scalars['String']>;
  users_count_gteq?: InputMaybe<Scalars['String']>;
  users_count_gteq_all?: InputMaybe<Scalars['String']>;
  users_count_gteq_any?: InputMaybe<Scalars['String']>;
  users_count_i_cont?: InputMaybe<Scalars['String']>;
  users_count_i_cont_all?: InputMaybe<Scalars['String']>;
  users_count_i_cont_any?: InputMaybe<Scalars['String']>;
  users_count_in?: InputMaybe<Scalars['String']>;
  users_count_in_all?: InputMaybe<Scalars['String']>;
  users_count_in_any?: InputMaybe<Scalars['String']>;
  users_count_lt?: InputMaybe<Scalars['String']>;
  users_count_lt_all?: InputMaybe<Scalars['String']>;
  users_count_lt_any?: InputMaybe<Scalars['String']>;
  users_count_lteq?: InputMaybe<Scalars['String']>;
  users_count_lteq_all?: InputMaybe<Scalars['String']>;
  users_count_lteq_any?: InputMaybe<Scalars['String']>;
  users_count_matches?: InputMaybe<Scalars['String']>;
  users_count_matches_all?: InputMaybe<Scalars['String']>;
  users_count_matches_any?: InputMaybe<Scalars['String']>;
  users_count_not_cont?: InputMaybe<Scalars['String']>;
  users_count_not_cont_all?: InputMaybe<Scalars['String']>;
  users_count_not_cont_any?: InputMaybe<Scalars['String']>;
  users_count_not_end?: InputMaybe<Scalars['String']>;
  users_count_not_end_all?: InputMaybe<Scalars['String']>;
  users_count_not_end_any?: InputMaybe<Scalars['String']>;
  users_count_not_eq?: InputMaybe<Scalars['String']>;
  users_count_not_eq_all?: InputMaybe<Scalars['String']>;
  users_count_not_eq_any?: InputMaybe<Scalars['String']>;
  users_count_not_false?: InputMaybe<Scalars['String']>;
  users_count_not_i_cont?: InputMaybe<Scalars['String']>;
  users_count_not_i_cont_all?: InputMaybe<Scalars['String']>;
  users_count_not_i_cont_any?: InputMaybe<Scalars['String']>;
  users_count_not_in?: InputMaybe<Scalars['String']>;
  users_count_not_in_all?: InputMaybe<Scalars['String']>;
  users_count_not_in_any?: InputMaybe<Scalars['String']>;
  users_count_not_null?: InputMaybe<Scalars['String']>;
  users_count_not_start?: InputMaybe<Scalars['String']>;
  users_count_not_start_all?: InputMaybe<Scalars['String']>;
  users_count_not_start_any?: InputMaybe<Scalars['String']>;
  users_count_not_true?: InputMaybe<Scalars['String']>;
  users_count_null?: InputMaybe<Scalars['String']>;
  users_count_present?: InputMaybe<Scalars['String']>;
  users_count_start?: InputMaybe<Scalars['String']>;
  users_count_start_all?: InputMaybe<Scalars['String']>;
  users_count_start_any?: InputMaybe<Scalars['String']>;
  users_count_true?: InputMaybe<Scalars['String']>;
  users_finished_percentage_blank?: InputMaybe<Scalars['String']>;
  users_finished_percentage_cont?: InputMaybe<Scalars['String']>;
  users_finished_percentage_cont_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_cont_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_does_not_match?: InputMaybe<Scalars['String']>;
  users_finished_percentage_does_not_match_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_does_not_match_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_end?: InputMaybe<Scalars['String']>;
  users_finished_percentage_end_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_end_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_eq?: InputMaybe<Scalars['String']>;
  users_finished_percentage_eq_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_eq_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_false?: InputMaybe<Scalars['String']>;
  users_finished_percentage_gt?: InputMaybe<Scalars['String']>;
  users_finished_percentage_gt_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_gt_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_gteq?: InputMaybe<Scalars['String']>;
  users_finished_percentage_gteq_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_gteq_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_i_cont?: InputMaybe<Scalars['String']>;
  users_finished_percentage_i_cont_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_i_cont_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_in?: InputMaybe<Scalars['String']>;
  users_finished_percentage_in_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_in_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_lt?: InputMaybe<Scalars['String']>;
  users_finished_percentage_lt_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_lt_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_lteq?: InputMaybe<Scalars['String']>;
  users_finished_percentage_lteq_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_lteq_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_matches?: InputMaybe<Scalars['String']>;
  users_finished_percentage_matches_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_matches_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_cont?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_cont_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_cont_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_end?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_end_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_end_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_eq?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_eq_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_eq_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_false?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_i_cont?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_i_cont_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_i_cont_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_in?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_in_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_in_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_null?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_start?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_start_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_start_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_not_true?: InputMaybe<Scalars['String']>;
  users_finished_percentage_null?: InputMaybe<Scalars['String']>;
  users_finished_percentage_present?: InputMaybe<Scalars['String']>;
  users_finished_percentage_start?: InputMaybe<Scalars['String']>;
  users_finished_percentage_start_all?: InputMaybe<Scalars['String']>;
  users_finished_percentage_start_any?: InputMaybe<Scalars['String']>;
  users_finished_percentage_true?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_blank?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_cont?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_cont_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_cont_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_does_not_match?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_does_not_match_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_does_not_match_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_end?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_end_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_end_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_eq?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_eq_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_eq_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_false?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_gt?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_gt_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_gt_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_gteq?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_gteq_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_gteq_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_i_cont?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_i_cont_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_i_cont_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_in?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_in_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_in_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_lt?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_lt_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_lt_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_lteq?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_lteq_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_lteq_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_matches?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_matches_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_matches_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_cont?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_cont_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_cont_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_end?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_end_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_end_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_eq?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_eq_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_eq_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_false?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_i_cont?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_i_cont_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_i_cont_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_in?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_in_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_in_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_null?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_start?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_start_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_start_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_not_true?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_null?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_present?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_start?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_start_all?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_start_any?: InputMaybe<Scalars['String']>;
  users_in_progress_percentage_true?: InputMaybe<Scalars['String']>;
  users_pending_percentage_blank?: InputMaybe<Scalars['String']>;
  users_pending_percentage_cont?: InputMaybe<Scalars['String']>;
  users_pending_percentage_cont_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_cont_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_does_not_match?: InputMaybe<Scalars['String']>;
  users_pending_percentage_does_not_match_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_does_not_match_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_end?: InputMaybe<Scalars['String']>;
  users_pending_percentage_end_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_end_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_eq?: InputMaybe<Scalars['String']>;
  users_pending_percentage_eq_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_eq_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_false?: InputMaybe<Scalars['String']>;
  users_pending_percentage_gt?: InputMaybe<Scalars['String']>;
  users_pending_percentage_gt_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_gt_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_gteq?: InputMaybe<Scalars['String']>;
  users_pending_percentage_gteq_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_gteq_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_i_cont?: InputMaybe<Scalars['String']>;
  users_pending_percentage_i_cont_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_i_cont_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_in?: InputMaybe<Scalars['String']>;
  users_pending_percentage_in_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_in_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_lt?: InputMaybe<Scalars['String']>;
  users_pending_percentage_lt_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_lt_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_lteq?: InputMaybe<Scalars['String']>;
  users_pending_percentage_lteq_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_lteq_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_matches?: InputMaybe<Scalars['String']>;
  users_pending_percentage_matches_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_matches_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_cont?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_cont_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_cont_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_end?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_end_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_end_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_eq?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_eq_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_eq_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_false?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_i_cont?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_i_cont_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_i_cont_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_in?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_in_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_in_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_null?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_start?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_start_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_start_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_not_true?: InputMaybe<Scalars['String']>;
  users_pending_percentage_null?: InputMaybe<Scalars['String']>;
  users_pending_percentage_present?: InputMaybe<Scalars['String']>;
  users_pending_percentage_start?: InputMaybe<Scalars['String']>;
  users_pending_percentage_start_all?: InputMaybe<Scalars['String']>;
  users_pending_percentage_start_any?: InputMaybe<Scalars['String']>;
  users_pending_percentage_true?: InputMaybe<Scalars['String']>;
  version_blank?: InputMaybe<Scalars['Int']>;
  version_cont?: InputMaybe<Scalars['Int']>;
  version_cont_all?: InputMaybe<Scalars['Int']>;
  version_cont_any?: InputMaybe<Scalars['Int']>;
  version_does_not_match?: InputMaybe<Scalars['Int']>;
  version_does_not_match_all?: InputMaybe<Scalars['Int']>;
  version_does_not_match_any?: InputMaybe<Scalars['Int']>;
  version_end?: InputMaybe<Scalars['Int']>;
  version_end_all?: InputMaybe<Scalars['Int']>;
  version_end_any?: InputMaybe<Scalars['Int']>;
  version_eq?: InputMaybe<Scalars['Int']>;
  version_eq_all?: InputMaybe<Scalars['Int']>;
  version_eq_any?: InputMaybe<Scalars['Int']>;
  version_false?: InputMaybe<Scalars['Int']>;
  version_gt?: InputMaybe<Scalars['Int']>;
  version_gt_all?: InputMaybe<Scalars['Int']>;
  version_gt_any?: InputMaybe<Scalars['Int']>;
  version_gteq?: InputMaybe<Scalars['Int']>;
  version_gteq_all?: InputMaybe<Scalars['Int']>;
  version_gteq_any?: InputMaybe<Scalars['Int']>;
  version_i_cont?: InputMaybe<Scalars['Int']>;
  version_i_cont_all?: InputMaybe<Scalars['Int']>;
  version_i_cont_any?: InputMaybe<Scalars['Int']>;
  version_in?: InputMaybe<Array<Scalars['Int']>>;
  version_in_all?: InputMaybe<Array<Scalars['Int']>>;
  version_in_any?: InputMaybe<Array<Scalars['Int']>>;
  version_lt?: InputMaybe<Scalars['Int']>;
  version_lt_all?: InputMaybe<Scalars['Int']>;
  version_lt_any?: InputMaybe<Scalars['Int']>;
  version_lteq?: InputMaybe<Scalars['Int']>;
  version_lteq_all?: InputMaybe<Scalars['Int']>;
  version_lteq_any?: InputMaybe<Scalars['Int']>;
  version_matches?: InputMaybe<Scalars['Int']>;
  version_matches_all?: InputMaybe<Scalars['Int']>;
  version_matches_any?: InputMaybe<Scalars['Int']>;
  version_not_cont?: InputMaybe<Scalars['Int']>;
  version_not_cont_all?: InputMaybe<Scalars['Int']>;
  version_not_cont_any?: InputMaybe<Scalars['Int']>;
  version_not_end?: InputMaybe<Scalars['Int']>;
  version_not_end_all?: InputMaybe<Scalars['Int']>;
  version_not_end_any?: InputMaybe<Scalars['Int']>;
  version_not_eq?: InputMaybe<Scalars['Int']>;
  version_not_eq_all?: InputMaybe<Scalars['Int']>;
  version_not_eq_any?: InputMaybe<Scalars['Int']>;
  version_not_false?: InputMaybe<Scalars['Int']>;
  version_not_i_cont?: InputMaybe<Scalars['Int']>;
  version_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  version_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  version_not_in?: InputMaybe<Array<Scalars['Int']>>;
  version_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  version_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  version_not_null?: InputMaybe<Scalars['Int']>;
  version_not_start?: InputMaybe<Scalars['Int']>;
  version_not_start_all?: InputMaybe<Scalars['Int']>;
  version_not_start_any?: InputMaybe<Scalars['Int']>;
  version_not_true?: InputMaybe<Scalars['Int']>;
  version_null?: InputMaybe<Scalars['Int']>;
  version_present?: InputMaybe<Scalars['Int']>;
  version_start?: InputMaybe<Scalars['Int']>;
  version_start_all?: InputMaybe<Scalars['Int']>;
  version_start_any?: InputMaybe<Scalars['Int']>;
  version_true?: InputMaybe<Scalars['Int']>;
};

export type LmsProfile = {
  __typename?: 'LmsProfile';
  code: Scalars['String'];
  color: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  downloadAllCoursesMonitoring: DownloadAllCoursesMonitoringPayload;
  downloadCourseUsersMonitoring?: Maybe<DownloadCourseUsersMonitoringPayload>;
  downloadExternalCourseUsersMonitoring?: Maybe<DownloadExternalCourseUsersMonitoringPayload>;
  downloadLearningPathsMonitoring?: Maybe<DownloadLearningPathsMonitoringPayload>;
  downloadUsers?: Maybe<DownloadUsersPayload>;
};


export type MutationDownloadAllCoursesMonitoringArgs = {
  input: DownloadAllCoursesMonitoringInput;
};


export type MutationDownloadCourseUsersMonitoringArgs = {
  input: DownloadCourseUsersMonitoringInput;
};


export type MutationDownloadExternalCourseUsersMonitoringArgs = {
  input: DownloadExternalCourseUsersMonitoringInput;
};


export type MutationDownloadLearningPathsMonitoringArgs = {
  input: DownloadLearningPathsMonitoringInput;
};


export type MutationDownloadUsersArgs = {
  input: DownloadUsersInput;
};

export type PopularCourse = {
  __typename?: 'PopularCourse';
  course?: Maybe<Course>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  participantsCount: Scalars['Int'];
  progress?: Maybe<CourseProgress>;
};


export type PopularCourseProgressArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
};

export type PopularCoursePage = {
  __typename?: 'PopularCoursePage';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<PopularCourse>;
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
};

export type PopularCourseRansack = {
  banner_data_blank?: InputMaybe<Scalars['String']>;
  banner_data_cont?: InputMaybe<Scalars['String']>;
  banner_data_cont_all?: InputMaybe<Scalars['String']>;
  banner_data_cont_any?: InputMaybe<Scalars['String']>;
  banner_data_does_not_match?: InputMaybe<Scalars['String']>;
  banner_data_does_not_match_all?: InputMaybe<Scalars['String']>;
  banner_data_does_not_match_any?: InputMaybe<Scalars['String']>;
  banner_data_end?: InputMaybe<Scalars['String']>;
  banner_data_end_all?: InputMaybe<Scalars['String']>;
  banner_data_end_any?: InputMaybe<Scalars['String']>;
  banner_data_eq?: InputMaybe<Scalars['String']>;
  banner_data_eq_all?: InputMaybe<Scalars['String']>;
  banner_data_eq_any?: InputMaybe<Scalars['String']>;
  banner_data_false?: InputMaybe<Scalars['String']>;
  banner_data_gt?: InputMaybe<Scalars['String']>;
  banner_data_gt_all?: InputMaybe<Scalars['String']>;
  banner_data_gt_any?: InputMaybe<Scalars['String']>;
  banner_data_gteq?: InputMaybe<Scalars['String']>;
  banner_data_gteq_all?: InputMaybe<Scalars['String']>;
  banner_data_gteq_any?: InputMaybe<Scalars['String']>;
  banner_data_i_cont?: InputMaybe<Scalars['String']>;
  banner_data_i_cont_all?: InputMaybe<Scalars['String']>;
  banner_data_i_cont_any?: InputMaybe<Scalars['String']>;
  banner_data_in?: InputMaybe<Scalars['String']>;
  banner_data_in_all?: InputMaybe<Scalars['String']>;
  banner_data_in_any?: InputMaybe<Scalars['String']>;
  banner_data_lt?: InputMaybe<Scalars['String']>;
  banner_data_lt_all?: InputMaybe<Scalars['String']>;
  banner_data_lt_any?: InputMaybe<Scalars['String']>;
  banner_data_lteq?: InputMaybe<Scalars['String']>;
  banner_data_lteq_all?: InputMaybe<Scalars['String']>;
  banner_data_lteq_any?: InputMaybe<Scalars['String']>;
  banner_data_matches?: InputMaybe<Scalars['String']>;
  banner_data_matches_all?: InputMaybe<Scalars['String']>;
  banner_data_matches_any?: InputMaybe<Scalars['String']>;
  banner_data_not_cont?: InputMaybe<Scalars['String']>;
  banner_data_not_cont_all?: InputMaybe<Scalars['String']>;
  banner_data_not_cont_any?: InputMaybe<Scalars['String']>;
  banner_data_not_end?: InputMaybe<Scalars['String']>;
  banner_data_not_end_all?: InputMaybe<Scalars['String']>;
  banner_data_not_end_any?: InputMaybe<Scalars['String']>;
  banner_data_not_eq?: InputMaybe<Scalars['String']>;
  banner_data_not_eq_all?: InputMaybe<Scalars['String']>;
  banner_data_not_eq_any?: InputMaybe<Scalars['String']>;
  banner_data_not_false?: InputMaybe<Scalars['String']>;
  banner_data_not_i_cont?: InputMaybe<Scalars['String']>;
  banner_data_not_i_cont_all?: InputMaybe<Scalars['String']>;
  banner_data_not_i_cont_any?: InputMaybe<Scalars['String']>;
  banner_data_not_in?: InputMaybe<Scalars['String']>;
  banner_data_not_in_all?: InputMaybe<Scalars['String']>;
  banner_data_not_in_any?: InputMaybe<Scalars['String']>;
  banner_data_not_null?: InputMaybe<Scalars['String']>;
  banner_data_not_start?: InputMaybe<Scalars['String']>;
  banner_data_not_start_all?: InputMaybe<Scalars['String']>;
  banner_data_not_start_any?: InputMaybe<Scalars['String']>;
  banner_data_not_true?: InputMaybe<Scalars['String']>;
  banner_data_null?: InputMaybe<Scalars['String']>;
  banner_data_present?: InputMaybe<Scalars['String']>;
  banner_data_start?: InputMaybe<Scalars['String']>;
  banner_data_start_all?: InputMaybe<Scalars['String']>;
  banner_data_start_any?: InputMaybe<Scalars['String']>;
  banner_data_true?: InputMaybe<Scalars['String']>;
  can_generate_certificate_blank?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_cont?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_does_not_match?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_end?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_end_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_end_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_eq?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_eq_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_eq_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_false?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gt?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gt_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gt_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gteq?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gteq_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_gteq_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_i_cont?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_in?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_lt?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lt_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lt_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lteq?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lteq_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_lteq_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_matches?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_matches_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_matches_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_cont?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_end?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_end_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_end_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_eq?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_false?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  can_generate_certificate_not_null?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_start?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_start_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_start_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_not_true?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_null?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_present?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_start?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_start_all?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_start_any?: InputMaybe<Scalars['Boolean']>;
  can_generate_certificate_true?: InputMaybe<Scalars['Boolean']>;
  can_restart_blank?: InputMaybe<Scalars['Boolean']>;
  can_restart_cont?: InputMaybe<Scalars['Boolean']>;
  can_restart_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_does_not_match?: InputMaybe<Scalars['Boolean']>;
  can_restart_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_end?: InputMaybe<Scalars['Boolean']>;
  can_restart_end_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_end_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_eq?: InputMaybe<Scalars['Boolean']>;
  can_restart_eq_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_eq_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_false?: InputMaybe<Scalars['Boolean']>;
  can_restart_gt?: InputMaybe<Scalars['Boolean']>;
  can_restart_gt_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_gt_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_gteq?: InputMaybe<Scalars['Boolean']>;
  can_restart_gteq_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_gteq_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_i_cont?: InputMaybe<Scalars['Boolean']>;
  can_restart_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_in?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_lt?: InputMaybe<Scalars['Boolean']>;
  can_restart_lt_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_lt_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_lteq?: InputMaybe<Scalars['Boolean']>;
  can_restart_lteq_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_lteq_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_matches?: InputMaybe<Scalars['Boolean']>;
  can_restart_matches_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_matches_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_cont?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_end?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_end_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_end_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_eq?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_false?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  can_restart_not_null?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_start?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_start_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_start_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_not_true?: InputMaybe<Scalars['Boolean']>;
  can_restart_null?: InputMaybe<Scalars['Boolean']>;
  can_restart_present?: InputMaybe<Scalars['Boolean']>;
  can_restart_start?: InputMaybe<Scalars['Boolean']>;
  can_restart_start_all?: InputMaybe<Scalars['Boolean']>;
  can_restart_start_any?: InputMaybe<Scalars['Boolean']>;
  can_restart_true?: InputMaybe<Scalars['Boolean']>;
  capacity_blank?: InputMaybe<Scalars['Int']>;
  capacity_cont?: InputMaybe<Scalars['Int']>;
  capacity_cont_all?: InputMaybe<Scalars['Int']>;
  capacity_cont_any?: InputMaybe<Scalars['Int']>;
  capacity_does_not_match?: InputMaybe<Scalars['Int']>;
  capacity_does_not_match_all?: InputMaybe<Scalars['Int']>;
  capacity_does_not_match_any?: InputMaybe<Scalars['Int']>;
  capacity_end?: InputMaybe<Scalars['Int']>;
  capacity_end_all?: InputMaybe<Scalars['Int']>;
  capacity_end_any?: InputMaybe<Scalars['Int']>;
  capacity_eq?: InputMaybe<Scalars['Int']>;
  capacity_eq_all?: InputMaybe<Scalars['Int']>;
  capacity_eq_any?: InputMaybe<Scalars['Int']>;
  capacity_false?: InputMaybe<Scalars['Int']>;
  capacity_gt?: InputMaybe<Scalars['Int']>;
  capacity_gt_all?: InputMaybe<Scalars['Int']>;
  capacity_gt_any?: InputMaybe<Scalars['Int']>;
  capacity_gteq?: InputMaybe<Scalars['Int']>;
  capacity_gteq_all?: InputMaybe<Scalars['Int']>;
  capacity_gteq_any?: InputMaybe<Scalars['Int']>;
  capacity_i_cont?: InputMaybe<Scalars['Int']>;
  capacity_i_cont_all?: InputMaybe<Scalars['Int']>;
  capacity_i_cont_any?: InputMaybe<Scalars['Int']>;
  capacity_in?: InputMaybe<Array<Scalars['Int']>>;
  capacity_in_all?: InputMaybe<Array<Scalars['Int']>>;
  capacity_in_any?: InputMaybe<Array<Scalars['Int']>>;
  capacity_lt?: InputMaybe<Scalars['Int']>;
  capacity_lt_all?: InputMaybe<Scalars['Int']>;
  capacity_lt_any?: InputMaybe<Scalars['Int']>;
  capacity_lteq?: InputMaybe<Scalars['Int']>;
  capacity_lteq_all?: InputMaybe<Scalars['Int']>;
  capacity_lteq_any?: InputMaybe<Scalars['Int']>;
  capacity_matches?: InputMaybe<Scalars['Int']>;
  capacity_matches_all?: InputMaybe<Scalars['Int']>;
  capacity_matches_any?: InputMaybe<Scalars['Int']>;
  capacity_not_cont?: InputMaybe<Scalars['Int']>;
  capacity_not_cont_all?: InputMaybe<Scalars['Int']>;
  capacity_not_cont_any?: InputMaybe<Scalars['Int']>;
  capacity_not_end?: InputMaybe<Scalars['Int']>;
  capacity_not_end_all?: InputMaybe<Scalars['Int']>;
  capacity_not_end_any?: InputMaybe<Scalars['Int']>;
  capacity_not_eq?: InputMaybe<Scalars['Int']>;
  capacity_not_eq_all?: InputMaybe<Scalars['Int']>;
  capacity_not_eq_any?: InputMaybe<Scalars['Int']>;
  capacity_not_false?: InputMaybe<Scalars['Int']>;
  capacity_not_i_cont?: InputMaybe<Scalars['Int']>;
  capacity_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  capacity_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  capacity_not_in?: InputMaybe<Array<Scalars['Int']>>;
  capacity_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  capacity_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  capacity_not_null?: InputMaybe<Scalars['Int']>;
  capacity_not_start?: InputMaybe<Scalars['Int']>;
  capacity_not_start_all?: InputMaybe<Scalars['Int']>;
  capacity_not_start_any?: InputMaybe<Scalars['Int']>;
  capacity_not_true?: InputMaybe<Scalars['Int']>;
  capacity_null?: InputMaybe<Scalars['Int']>;
  capacity_present?: InputMaybe<Scalars['Int']>;
  capacity_start?: InputMaybe<Scalars['Int']>;
  capacity_start_all?: InputMaybe<Scalars['Int']>;
  capacity_start_any?: InputMaybe<Scalars['Int']>;
  capacity_true?: InputMaybe<Scalars['Int']>;
  course_type_blank?: InputMaybe<Scalars['Int']>;
  course_type_cont?: InputMaybe<Scalars['Int']>;
  course_type_cont_all?: InputMaybe<Scalars['Int']>;
  course_type_cont_any?: InputMaybe<Scalars['Int']>;
  course_type_does_not_match?: InputMaybe<Scalars['Int']>;
  course_type_does_not_match_all?: InputMaybe<Scalars['Int']>;
  course_type_does_not_match_any?: InputMaybe<Scalars['Int']>;
  course_type_end?: InputMaybe<Scalars['Int']>;
  course_type_end_all?: InputMaybe<Scalars['Int']>;
  course_type_end_any?: InputMaybe<Scalars['Int']>;
  course_type_eq?: InputMaybe<Scalars['Int']>;
  course_type_eq_all?: InputMaybe<Scalars['Int']>;
  course_type_eq_any?: InputMaybe<Scalars['Int']>;
  course_type_false?: InputMaybe<Scalars['Int']>;
  course_type_gt?: InputMaybe<Scalars['Int']>;
  course_type_gt_all?: InputMaybe<Scalars['Int']>;
  course_type_gt_any?: InputMaybe<Scalars['Int']>;
  course_type_gteq?: InputMaybe<Scalars['Int']>;
  course_type_gteq_all?: InputMaybe<Scalars['Int']>;
  course_type_gteq_any?: InputMaybe<Scalars['Int']>;
  course_type_i_cont?: InputMaybe<Scalars['Int']>;
  course_type_i_cont_all?: InputMaybe<Scalars['Int']>;
  course_type_i_cont_any?: InputMaybe<Scalars['Int']>;
  course_type_in?: InputMaybe<Array<Scalars['Int']>>;
  course_type_in_all?: InputMaybe<Array<Scalars['Int']>>;
  course_type_in_any?: InputMaybe<Array<Scalars['Int']>>;
  course_type_lt?: InputMaybe<Scalars['Int']>;
  course_type_lt_all?: InputMaybe<Scalars['Int']>;
  course_type_lt_any?: InputMaybe<Scalars['Int']>;
  course_type_lteq?: InputMaybe<Scalars['Int']>;
  course_type_lteq_all?: InputMaybe<Scalars['Int']>;
  course_type_lteq_any?: InputMaybe<Scalars['Int']>;
  course_type_matches?: InputMaybe<Scalars['Int']>;
  course_type_matches_all?: InputMaybe<Scalars['Int']>;
  course_type_matches_any?: InputMaybe<Scalars['Int']>;
  course_type_not_cont?: InputMaybe<Scalars['Int']>;
  course_type_not_cont_all?: InputMaybe<Scalars['Int']>;
  course_type_not_cont_any?: InputMaybe<Scalars['Int']>;
  course_type_not_end?: InputMaybe<Scalars['Int']>;
  course_type_not_end_all?: InputMaybe<Scalars['Int']>;
  course_type_not_end_any?: InputMaybe<Scalars['Int']>;
  course_type_not_eq?: InputMaybe<Scalars['Int']>;
  course_type_not_eq_all?: InputMaybe<Scalars['Int']>;
  course_type_not_eq_any?: InputMaybe<Scalars['Int']>;
  course_type_not_false?: InputMaybe<Scalars['Int']>;
  course_type_not_i_cont?: InputMaybe<Scalars['Int']>;
  course_type_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  course_type_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  course_type_not_in?: InputMaybe<Array<Scalars['Int']>>;
  course_type_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  course_type_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  course_type_not_null?: InputMaybe<Scalars['Int']>;
  course_type_not_start?: InputMaybe<Scalars['Int']>;
  course_type_not_start_all?: InputMaybe<Scalars['Int']>;
  course_type_not_start_any?: InputMaybe<Scalars['Int']>;
  course_type_not_true?: InputMaybe<Scalars['Int']>;
  course_type_null?: InputMaybe<Scalars['Int']>;
  course_type_present?: InputMaybe<Scalars['Int']>;
  course_type_start?: InputMaybe<Scalars['Int']>;
  course_type_start_all?: InputMaybe<Scalars['Int']>;
  course_type_start_any?: InputMaybe<Scalars['Int']>;
  course_type_true?: InputMaybe<Scalars['Int']>;
  created_at_blank?: InputMaybe<Scalars['String']>;
  created_at_cont?: InputMaybe<Scalars['String']>;
  created_at_cont_all?: InputMaybe<Scalars['String']>;
  created_at_cont_any?: InputMaybe<Scalars['String']>;
  created_at_does_not_match?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  created_at_end?: InputMaybe<Scalars['String']>;
  created_at_end_all?: InputMaybe<Scalars['String']>;
  created_at_end_any?: InputMaybe<Scalars['String']>;
  created_at_eq?: InputMaybe<Scalars['String']>;
  created_at_eq_all?: InputMaybe<Scalars['String']>;
  created_at_eq_any?: InputMaybe<Scalars['String']>;
  created_at_false?: InputMaybe<Scalars['String']>;
  created_at_gt?: InputMaybe<Scalars['String']>;
  created_at_gt_all?: InputMaybe<Scalars['String']>;
  created_at_gt_any?: InputMaybe<Scalars['String']>;
  created_at_gteq?: InputMaybe<Scalars['String']>;
  created_at_gteq_all?: InputMaybe<Scalars['String']>;
  created_at_gteq_any?: InputMaybe<Scalars['String']>;
  created_at_i_cont?: InputMaybe<Scalars['String']>;
  created_at_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_in?: InputMaybe<Scalars['String']>;
  created_at_in_all?: InputMaybe<Scalars['String']>;
  created_at_in_any?: InputMaybe<Scalars['String']>;
  created_at_lt?: InputMaybe<Scalars['String']>;
  created_at_lt_all?: InputMaybe<Scalars['String']>;
  created_at_lt_any?: InputMaybe<Scalars['String']>;
  created_at_lteq?: InputMaybe<Scalars['String']>;
  created_at_lteq_all?: InputMaybe<Scalars['String']>;
  created_at_lteq_any?: InputMaybe<Scalars['String']>;
  created_at_matches?: InputMaybe<Scalars['String']>;
  created_at_matches_all?: InputMaybe<Scalars['String']>;
  created_at_matches_any?: InputMaybe<Scalars['String']>;
  created_at_not_cont?: InputMaybe<Scalars['String']>;
  created_at_not_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_end?: InputMaybe<Scalars['String']>;
  created_at_not_end_all?: InputMaybe<Scalars['String']>;
  created_at_not_end_any?: InputMaybe<Scalars['String']>;
  created_at_not_eq?: InputMaybe<Scalars['String']>;
  created_at_not_eq_all?: InputMaybe<Scalars['String']>;
  created_at_not_eq_any?: InputMaybe<Scalars['String']>;
  created_at_not_false?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_in?: InputMaybe<Scalars['String']>;
  created_at_not_in_all?: InputMaybe<Scalars['String']>;
  created_at_not_in_any?: InputMaybe<Scalars['String']>;
  created_at_not_null?: InputMaybe<Scalars['String']>;
  created_at_not_start?: InputMaybe<Scalars['String']>;
  created_at_not_start_all?: InputMaybe<Scalars['String']>;
  created_at_not_start_any?: InputMaybe<Scalars['String']>;
  created_at_not_true?: InputMaybe<Scalars['String']>;
  created_at_null?: InputMaybe<Scalars['String']>;
  created_at_present?: InputMaybe<Scalars['String']>;
  created_at_start?: InputMaybe<Scalars['String']>;
  created_at_start_all?: InputMaybe<Scalars['String']>;
  created_at_start_any?: InputMaybe<Scalars['String']>;
  created_at_true?: InputMaybe<Scalars['String']>;
  deleted_at_blank?: InputMaybe<Scalars['String']>;
  deleted_at_cont?: InputMaybe<Scalars['String']>;
  deleted_at_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  deleted_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  deleted_at_end?: InputMaybe<Scalars['String']>;
  deleted_at_end_all?: InputMaybe<Scalars['String']>;
  deleted_at_end_any?: InputMaybe<Scalars['String']>;
  deleted_at_eq?: InputMaybe<Scalars['String']>;
  deleted_at_eq_all?: InputMaybe<Scalars['String']>;
  deleted_at_eq_any?: InputMaybe<Scalars['String']>;
  deleted_at_false?: InputMaybe<Scalars['String']>;
  deleted_at_gt?: InputMaybe<Scalars['String']>;
  deleted_at_gt_all?: InputMaybe<Scalars['String']>;
  deleted_at_gt_any?: InputMaybe<Scalars['String']>;
  deleted_at_gteq?: InputMaybe<Scalars['String']>;
  deleted_at_gteq_all?: InputMaybe<Scalars['String']>;
  deleted_at_gteq_any?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_i_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_in?: InputMaybe<Scalars['String']>;
  deleted_at_in_all?: InputMaybe<Scalars['String']>;
  deleted_at_in_any?: InputMaybe<Scalars['String']>;
  deleted_at_lt?: InputMaybe<Scalars['String']>;
  deleted_at_lt_all?: InputMaybe<Scalars['String']>;
  deleted_at_lt_any?: InputMaybe<Scalars['String']>;
  deleted_at_lteq?: InputMaybe<Scalars['String']>;
  deleted_at_lteq_all?: InputMaybe<Scalars['String']>;
  deleted_at_lteq_any?: InputMaybe<Scalars['String']>;
  deleted_at_matches?: InputMaybe<Scalars['String']>;
  deleted_at_matches_all?: InputMaybe<Scalars['String']>;
  deleted_at_matches_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_end?: InputMaybe<Scalars['String']>;
  deleted_at_not_end_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_end_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_eq_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_false?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_in?: InputMaybe<Scalars['String']>;
  deleted_at_not_in_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_in_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_null?: InputMaybe<Scalars['String']>;
  deleted_at_not_start?: InputMaybe<Scalars['String']>;
  deleted_at_not_start_all?: InputMaybe<Scalars['String']>;
  deleted_at_not_start_any?: InputMaybe<Scalars['String']>;
  deleted_at_not_true?: InputMaybe<Scalars['String']>;
  deleted_at_null?: InputMaybe<Scalars['String']>;
  deleted_at_present?: InputMaybe<Scalars['String']>;
  deleted_at_start?: InputMaybe<Scalars['String']>;
  deleted_at_start_all?: InputMaybe<Scalars['String']>;
  deleted_at_start_any?: InputMaybe<Scalars['String']>;
  deleted_at_true?: InputMaybe<Scalars['String']>;
  description_blank?: InputMaybe<Scalars['String']>;
  description_cont?: InputMaybe<Scalars['String']>;
  description_cont_all?: InputMaybe<Scalars['String']>;
  description_cont_any?: InputMaybe<Scalars['String']>;
  description_does_not_match?: InputMaybe<Scalars['String']>;
  description_does_not_match_all?: InputMaybe<Scalars['String']>;
  description_does_not_match_any?: InputMaybe<Scalars['String']>;
  description_end?: InputMaybe<Scalars['String']>;
  description_end_all?: InputMaybe<Scalars['String']>;
  description_end_any?: InputMaybe<Scalars['String']>;
  description_eq?: InputMaybe<Scalars['String']>;
  description_eq_all?: InputMaybe<Scalars['String']>;
  description_eq_any?: InputMaybe<Scalars['String']>;
  description_false?: InputMaybe<Scalars['String']>;
  description_gt?: InputMaybe<Scalars['String']>;
  description_gt_all?: InputMaybe<Scalars['String']>;
  description_gt_any?: InputMaybe<Scalars['String']>;
  description_gteq?: InputMaybe<Scalars['String']>;
  description_gteq_all?: InputMaybe<Scalars['String']>;
  description_gteq_any?: InputMaybe<Scalars['String']>;
  description_i_cont?: InputMaybe<Scalars['String']>;
  description_i_cont_all?: InputMaybe<Scalars['String']>;
  description_i_cont_any?: InputMaybe<Scalars['String']>;
  description_in?: InputMaybe<Scalars['String']>;
  description_in_all?: InputMaybe<Scalars['String']>;
  description_in_any?: InputMaybe<Scalars['String']>;
  description_lt?: InputMaybe<Scalars['String']>;
  description_lt_all?: InputMaybe<Scalars['String']>;
  description_lt_any?: InputMaybe<Scalars['String']>;
  description_lteq?: InputMaybe<Scalars['String']>;
  description_lteq_all?: InputMaybe<Scalars['String']>;
  description_lteq_any?: InputMaybe<Scalars['String']>;
  description_matches?: InputMaybe<Scalars['String']>;
  description_matches_all?: InputMaybe<Scalars['String']>;
  description_matches_any?: InputMaybe<Scalars['String']>;
  description_not_cont?: InputMaybe<Scalars['String']>;
  description_not_cont_all?: InputMaybe<Scalars['String']>;
  description_not_cont_any?: InputMaybe<Scalars['String']>;
  description_not_end?: InputMaybe<Scalars['String']>;
  description_not_end_all?: InputMaybe<Scalars['String']>;
  description_not_end_any?: InputMaybe<Scalars['String']>;
  description_not_eq?: InputMaybe<Scalars['String']>;
  description_not_eq_all?: InputMaybe<Scalars['String']>;
  description_not_eq_any?: InputMaybe<Scalars['String']>;
  description_not_false?: InputMaybe<Scalars['String']>;
  description_not_i_cont?: InputMaybe<Scalars['String']>;
  description_not_i_cont_all?: InputMaybe<Scalars['String']>;
  description_not_i_cont_any?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Scalars['String']>;
  description_not_in_all?: InputMaybe<Scalars['String']>;
  description_not_in_any?: InputMaybe<Scalars['String']>;
  description_not_null?: InputMaybe<Scalars['String']>;
  description_not_start?: InputMaybe<Scalars['String']>;
  description_not_start_all?: InputMaybe<Scalars['String']>;
  description_not_start_any?: InputMaybe<Scalars['String']>;
  description_not_true?: InputMaybe<Scalars['String']>;
  description_null?: InputMaybe<Scalars['String']>;
  description_present?: InputMaybe<Scalars['String']>;
  description_start?: InputMaybe<Scalars['String']>;
  description_start_all?: InputMaybe<Scalars['String']>;
  description_start_any?: InputMaybe<Scalars['String']>;
  description_true?: InputMaybe<Scalars['String']>;
  direct_chief_approval_blank?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_cont?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_cont_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_cont_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_does_not_match?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_end?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_end_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_end_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_eq?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_eq_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_eq_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_false?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gt?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gt_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gt_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gteq?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gteq_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_gteq_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_i_cont?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_in?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_lt?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lt_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lt_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lteq?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lteq_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_lteq_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_matches?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_matches_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_matches_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_cont?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_end?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_end_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_end_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_eq?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_false?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  direct_chief_approval_not_null?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_start?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_start_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_start_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_not_true?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_null?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_present?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_start?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_start_all?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_start_any?: InputMaybe<Scalars['Boolean']>;
  direct_chief_approval_true?: InputMaybe<Scalars['Boolean']>;
  hours_blank?: InputMaybe<Scalars['Float']>;
  hours_cont?: InputMaybe<Scalars['Float']>;
  hours_cont_all?: InputMaybe<Scalars['Float']>;
  hours_cont_any?: InputMaybe<Scalars['Float']>;
  hours_does_not_match?: InputMaybe<Scalars['Float']>;
  hours_does_not_match_all?: InputMaybe<Scalars['Float']>;
  hours_does_not_match_any?: InputMaybe<Scalars['Float']>;
  hours_end?: InputMaybe<Scalars['Float']>;
  hours_end_all?: InputMaybe<Scalars['Float']>;
  hours_end_any?: InputMaybe<Scalars['Float']>;
  hours_eq?: InputMaybe<Scalars['Float']>;
  hours_eq_all?: InputMaybe<Scalars['Float']>;
  hours_eq_any?: InputMaybe<Scalars['Float']>;
  hours_false?: InputMaybe<Scalars['Float']>;
  hours_gt?: InputMaybe<Scalars['Float']>;
  hours_gt_all?: InputMaybe<Scalars['Float']>;
  hours_gt_any?: InputMaybe<Scalars['Float']>;
  hours_gteq?: InputMaybe<Scalars['Float']>;
  hours_gteq_all?: InputMaybe<Scalars['Float']>;
  hours_gteq_any?: InputMaybe<Scalars['Float']>;
  hours_i_cont?: InputMaybe<Scalars['Float']>;
  hours_i_cont_all?: InputMaybe<Scalars['Float']>;
  hours_i_cont_any?: InputMaybe<Scalars['Float']>;
  hours_in?: InputMaybe<Array<Scalars['Float']>>;
  hours_in_all?: InputMaybe<Array<Scalars['Float']>>;
  hours_in_any?: InputMaybe<Array<Scalars['Float']>>;
  hours_lt?: InputMaybe<Scalars['Float']>;
  hours_lt_all?: InputMaybe<Scalars['Float']>;
  hours_lt_any?: InputMaybe<Scalars['Float']>;
  hours_lteq?: InputMaybe<Scalars['Float']>;
  hours_lteq_all?: InputMaybe<Scalars['Float']>;
  hours_lteq_any?: InputMaybe<Scalars['Float']>;
  hours_matches?: InputMaybe<Scalars['Float']>;
  hours_matches_all?: InputMaybe<Scalars['Float']>;
  hours_matches_any?: InputMaybe<Scalars['Float']>;
  hours_not_cont?: InputMaybe<Scalars['Float']>;
  hours_not_cont_all?: InputMaybe<Scalars['Float']>;
  hours_not_cont_any?: InputMaybe<Scalars['Float']>;
  hours_not_end?: InputMaybe<Scalars['Float']>;
  hours_not_end_all?: InputMaybe<Scalars['Float']>;
  hours_not_end_any?: InputMaybe<Scalars['Float']>;
  hours_not_eq?: InputMaybe<Scalars['Float']>;
  hours_not_eq_all?: InputMaybe<Scalars['Float']>;
  hours_not_eq_any?: InputMaybe<Scalars['Float']>;
  hours_not_false?: InputMaybe<Scalars['Float']>;
  hours_not_i_cont?: InputMaybe<Scalars['Float']>;
  hours_not_i_cont_all?: InputMaybe<Scalars['Float']>;
  hours_not_i_cont_any?: InputMaybe<Scalars['Float']>;
  hours_not_in?: InputMaybe<Array<Scalars['Float']>>;
  hours_not_in_all?: InputMaybe<Array<Scalars['Float']>>;
  hours_not_in_any?: InputMaybe<Array<Scalars['Float']>>;
  hours_not_null?: InputMaybe<Scalars['Float']>;
  hours_not_start?: InputMaybe<Scalars['Float']>;
  hours_not_start_all?: InputMaybe<Scalars['Float']>;
  hours_not_start_any?: InputMaybe<Scalars['Float']>;
  hours_not_true?: InputMaybe<Scalars['Float']>;
  hours_null?: InputMaybe<Scalars['Float']>;
  hours_present?: InputMaybe<Scalars['Float']>;
  hours_start?: InputMaybe<Scalars['Float']>;
  hours_start_all?: InputMaybe<Scalars['Float']>;
  hours_start_any?: InputMaybe<Scalars['Float']>;
  hours_true?: InputMaybe<Scalars['Float']>;
  id_blank?: InputMaybe<Scalars['Int']>;
  id_cont?: InputMaybe<Scalars['Int']>;
  id_cont_all?: InputMaybe<Scalars['Int']>;
  id_cont_any?: InputMaybe<Scalars['Int']>;
  id_does_not_match?: InputMaybe<Scalars['Int']>;
  id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  id_end?: InputMaybe<Scalars['Int']>;
  id_end_all?: InputMaybe<Scalars['Int']>;
  id_end_any?: InputMaybe<Scalars['Int']>;
  id_eq?: InputMaybe<Scalars['Int']>;
  id_eq_all?: InputMaybe<Scalars['Int']>;
  id_eq_any?: InputMaybe<Scalars['Int']>;
  id_false?: InputMaybe<Scalars['Int']>;
  id_gt?: InputMaybe<Scalars['Int']>;
  id_gt_all?: InputMaybe<Scalars['Int']>;
  id_gt_any?: InputMaybe<Scalars['Int']>;
  id_gteq?: InputMaybe<Scalars['Int']>;
  id_gteq_all?: InputMaybe<Scalars['Int']>;
  id_gteq_any?: InputMaybe<Scalars['Int']>;
  id_i_cont?: InputMaybe<Scalars['Int']>;
  id_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_in?: InputMaybe<Array<Scalars['Int']>>;
  id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_lt?: InputMaybe<Scalars['Int']>;
  id_lt_all?: InputMaybe<Scalars['Int']>;
  id_lt_any?: InputMaybe<Scalars['Int']>;
  id_lteq?: InputMaybe<Scalars['Int']>;
  id_lteq_all?: InputMaybe<Scalars['Int']>;
  id_lteq_any?: InputMaybe<Scalars['Int']>;
  id_matches?: InputMaybe<Scalars['Int']>;
  id_matches_all?: InputMaybe<Scalars['Int']>;
  id_matches_any?: InputMaybe<Scalars['Int']>;
  id_not_cont?: InputMaybe<Scalars['Int']>;
  id_not_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_end?: InputMaybe<Scalars['Int']>;
  id_not_end_all?: InputMaybe<Scalars['Int']>;
  id_not_end_any?: InputMaybe<Scalars['Int']>;
  id_not_eq?: InputMaybe<Scalars['Int']>;
  id_not_eq_all?: InputMaybe<Scalars['Int']>;
  id_not_eq_any?: InputMaybe<Scalars['Int']>;
  id_not_false?: InputMaybe<Scalars['Int']>;
  id_not_i_cont?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_not_null?: InputMaybe<Scalars['Int']>;
  id_not_start?: InputMaybe<Scalars['Int']>;
  id_not_start_all?: InputMaybe<Scalars['Int']>;
  id_not_start_any?: InputMaybe<Scalars['Int']>;
  id_not_true?: InputMaybe<Scalars['Int']>;
  id_null?: InputMaybe<Scalars['Int']>;
  id_present?: InputMaybe<Scalars['Int']>;
  id_start?: InputMaybe<Scalars['Int']>;
  id_start_all?: InputMaybe<Scalars['Int']>;
  id_start_any?: InputMaybe<Scalars['Int']>;
  id_true?: InputMaybe<Scalars['Int']>;
  integration_course_id_blank?: InputMaybe<Scalars['Int']>;
  integration_course_id_cont?: InputMaybe<Scalars['Int']>;
  integration_course_id_cont_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_cont_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_does_not_match?: InputMaybe<Scalars['Int']>;
  integration_course_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_end?: InputMaybe<Scalars['Int']>;
  integration_course_id_end_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_end_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_eq?: InputMaybe<Scalars['Int']>;
  integration_course_id_eq_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_eq_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_false?: InputMaybe<Scalars['Int']>;
  integration_course_id_gt?: InputMaybe<Scalars['Int']>;
  integration_course_id_gt_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_gt_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_gteq?: InputMaybe<Scalars['Int']>;
  integration_course_id_gteq_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_gteq_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_i_cont?: InputMaybe<Scalars['Int']>;
  integration_course_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_in?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_lt?: InputMaybe<Scalars['Int']>;
  integration_course_id_lt_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_lt_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_lteq?: InputMaybe<Scalars['Int']>;
  integration_course_id_lteq_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_lteq_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_matches?: InputMaybe<Scalars['Int']>;
  integration_course_id_matches_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_matches_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_cont?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_end?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_end_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_end_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_eq?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_false?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  integration_course_id_not_null?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_start?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_start_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_start_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_not_true?: InputMaybe<Scalars['Int']>;
  integration_course_id_null?: InputMaybe<Scalars['Int']>;
  integration_course_id_present?: InputMaybe<Scalars['Int']>;
  integration_course_id_start?: InputMaybe<Scalars['Int']>;
  integration_course_id_start_all?: InputMaybe<Scalars['Int']>;
  integration_course_id_start_any?: InputMaybe<Scalars['Int']>;
  integration_course_id_true?: InputMaybe<Scalars['Int']>;
  integration_course_link_blank?: InputMaybe<Scalars['String']>;
  integration_course_link_cont?: InputMaybe<Scalars['String']>;
  integration_course_link_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_link_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_link_does_not_match?: InputMaybe<Scalars['String']>;
  integration_course_link_does_not_match_all?: InputMaybe<Scalars['String']>;
  integration_course_link_does_not_match_any?: InputMaybe<Scalars['String']>;
  integration_course_link_end?: InputMaybe<Scalars['String']>;
  integration_course_link_end_all?: InputMaybe<Scalars['String']>;
  integration_course_link_end_any?: InputMaybe<Scalars['String']>;
  integration_course_link_eq?: InputMaybe<Scalars['String']>;
  integration_course_link_eq_all?: InputMaybe<Scalars['String']>;
  integration_course_link_eq_any?: InputMaybe<Scalars['String']>;
  integration_course_link_false?: InputMaybe<Scalars['String']>;
  integration_course_link_gt?: InputMaybe<Scalars['String']>;
  integration_course_link_gt_all?: InputMaybe<Scalars['String']>;
  integration_course_link_gt_any?: InputMaybe<Scalars['String']>;
  integration_course_link_gteq?: InputMaybe<Scalars['String']>;
  integration_course_link_gteq_all?: InputMaybe<Scalars['String']>;
  integration_course_link_gteq_any?: InputMaybe<Scalars['String']>;
  integration_course_link_i_cont?: InputMaybe<Scalars['String']>;
  integration_course_link_i_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_link_i_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_link_in?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_in_all?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_in_any?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_lt?: InputMaybe<Scalars['String']>;
  integration_course_link_lt_all?: InputMaybe<Scalars['String']>;
  integration_course_link_lt_any?: InputMaybe<Scalars['String']>;
  integration_course_link_lteq?: InputMaybe<Scalars['String']>;
  integration_course_link_lteq_all?: InputMaybe<Scalars['String']>;
  integration_course_link_lteq_any?: InputMaybe<Scalars['String']>;
  integration_course_link_matches?: InputMaybe<Scalars['String']>;
  integration_course_link_matches_all?: InputMaybe<Scalars['String']>;
  integration_course_link_matches_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_cont?: InputMaybe<Scalars['String']>;
  integration_course_link_not_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_end?: InputMaybe<Scalars['String']>;
  integration_course_link_not_end_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_end_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_eq?: InputMaybe<Scalars['String']>;
  integration_course_link_not_eq_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_eq_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_false?: InputMaybe<Scalars['String']>;
  integration_course_link_not_i_cont?: InputMaybe<Scalars['String']>;
  integration_course_link_not_i_cont_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_i_cont_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_in?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  integration_course_link_not_null?: InputMaybe<Scalars['String']>;
  integration_course_link_not_start?: InputMaybe<Scalars['String']>;
  integration_course_link_not_start_all?: InputMaybe<Scalars['String']>;
  integration_course_link_not_start_any?: InputMaybe<Scalars['String']>;
  integration_course_link_not_true?: InputMaybe<Scalars['String']>;
  integration_course_link_null?: InputMaybe<Scalars['String']>;
  integration_course_link_present?: InputMaybe<Scalars['String']>;
  integration_course_link_start?: InputMaybe<Scalars['String']>;
  integration_course_link_start_all?: InputMaybe<Scalars['String']>;
  integration_course_link_start_any?: InputMaybe<Scalars['String']>;
  integration_course_link_true?: InputMaybe<Scalars['String']>;
  name_blank?: InputMaybe<Scalars['String']>;
  name_cont?: InputMaybe<Scalars['String']>;
  name_cont_all?: InputMaybe<Scalars['String']>;
  name_cont_any?: InputMaybe<Scalars['String']>;
  name_does_not_match?: InputMaybe<Scalars['String']>;
  name_does_not_match_all?: InputMaybe<Scalars['String']>;
  name_does_not_match_any?: InputMaybe<Scalars['String']>;
  name_end?: InputMaybe<Scalars['String']>;
  name_end_all?: InputMaybe<Scalars['String']>;
  name_end_any?: InputMaybe<Scalars['String']>;
  name_eq?: InputMaybe<Scalars['String']>;
  name_eq_all?: InputMaybe<Scalars['String']>;
  name_eq_any?: InputMaybe<Scalars['String']>;
  name_false?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gt_all?: InputMaybe<Scalars['String']>;
  name_gt_any?: InputMaybe<Scalars['String']>;
  name_gteq?: InputMaybe<Scalars['String']>;
  name_gteq_all?: InputMaybe<Scalars['String']>;
  name_gteq_any?: InputMaybe<Scalars['String']>;
  name_i_cont?: InputMaybe<Scalars['String']>;
  name_i_cont_all?: InputMaybe<Scalars['String']>;
  name_i_cont_any?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lt_all?: InputMaybe<Scalars['String']>;
  name_lt_any?: InputMaybe<Scalars['String']>;
  name_lteq?: InputMaybe<Scalars['String']>;
  name_lteq_all?: InputMaybe<Scalars['String']>;
  name_lteq_any?: InputMaybe<Scalars['String']>;
  name_matches?: InputMaybe<Scalars['String']>;
  name_matches_all?: InputMaybe<Scalars['String']>;
  name_matches_any?: InputMaybe<Scalars['String']>;
  name_not_cont?: InputMaybe<Scalars['String']>;
  name_not_cont_all?: InputMaybe<Scalars['String']>;
  name_not_cont_any?: InputMaybe<Scalars['String']>;
  name_not_end?: InputMaybe<Scalars['String']>;
  name_not_end_all?: InputMaybe<Scalars['String']>;
  name_not_end_any?: InputMaybe<Scalars['String']>;
  name_not_eq?: InputMaybe<Scalars['String']>;
  name_not_eq_all?: InputMaybe<Scalars['String']>;
  name_not_eq_any?: InputMaybe<Scalars['String']>;
  name_not_false?: InputMaybe<Scalars['String']>;
  name_not_i_cont?: InputMaybe<Scalars['String']>;
  name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_not_null?: InputMaybe<Scalars['String']>;
  name_not_start?: InputMaybe<Scalars['String']>;
  name_not_start_all?: InputMaybe<Scalars['String']>;
  name_not_start_any?: InputMaybe<Scalars['String']>;
  name_not_true?: InputMaybe<Scalars['String']>;
  name_null?: InputMaybe<Scalars['String']>;
  name_or_code_cont?: InputMaybe<Scalars['String']>;
  name_present?: InputMaybe<Scalars['String']>;
  name_start?: InputMaybe<Scalars['String']>;
  name_start_all?: InputMaybe<Scalars['String']>;
  name_start_any?: InputMaybe<Scalars['String']>;
  name_true?: InputMaybe<Scalars['String']>;
  on_duplicated_blank?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_cont?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_cont_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_cont_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_does_not_match?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_end?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_end_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_end_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_eq?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_eq_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_eq_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_false?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gt?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gt_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gt_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gteq?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gteq_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_gteq_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_i_cont?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_in?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_lt?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lt_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lt_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lteq?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lteq_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_lteq_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_matches?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_matches_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_matches_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_cont?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_end?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_end_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_end_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_eq?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_false?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  on_duplicated_not_null?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_start?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_start_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_start_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_not_true?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_null?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_present?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_start?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_start_all?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_start_any?: InputMaybe<Scalars['Boolean']>;
  on_duplicated_true?: InputMaybe<Scalars['Boolean']>;
  order_blank?: InputMaybe<Scalars['Int']>;
  order_cont?: InputMaybe<Scalars['Int']>;
  order_cont_all?: InputMaybe<Scalars['Int']>;
  order_cont_any?: InputMaybe<Scalars['Int']>;
  order_does_not_match?: InputMaybe<Scalars['Int']>;
  order_does_not_match_all?: InputMaybe<Scalars['Int']>;
  order_does_not_match_any?: InputMaybe<Scalars['Int']>;
  order_end?: InputMaybe<Scalars['Int']>;
  order_end_all?: InputMaybe<Scalars['Int']>;
  order_end_any?: InputMaybe<Scalars['Int']>;
  order_eq?: InputMaybe<Scalars['Int']>;
  order_eq_all?: InputMaybe<Scalars['Int']>;
  order_eq_any?: InputMaybe<Scalars['Int']>;
  order_false?: InputMaybe<Scalars['Int']>;
  order_gt?: InputMaybe<Scalars['Int']>;
  order_gt_all?: InputMaybe<Scalars['Int']>;
  order_gt_any?: InputMaybe<Scalars['Int']>;
  order_gteq?: InputMaybe<Scalars['Int']>;
  order_gteq_all?: InputMaybe<Scalars['Int']>;
  order_gteq_any?: InputMaybe<Scalars['Int']>;
  order_i_cont?: InputMaybe<Scalars['Int']>;
  order_i_cont_all?: InputMaybe<Scalars['Int']>;
  order_i_cont_any?: InputMaybe<Scalars['Int']>;
  order_in?: InputMaybe<Array<Scalars['Int']>>;
  order_in_all?: InputMaybe<Array<Scalars['Int']>>;
  order_in_any?: InputMaybe<Array<Scalars['Int']>>;
  order_lt?: InputMaybe<Scalars['Int']>;
  order_lt_all?: InputMaybe<Scalars['Int']>;
  order_lt_any?: InputMaybe<Scalars['Int']>;
  order_lteq?: InputMaybe<Scalars['Int']>;
  order_lteq_all?: InputMaybe<Scalars['Int']>;
  order_lteq_any?: InputMaybe<Scalars['Int']>;
  order_matches?: InputMaybe<Scalars['Int']>;
  order_matches_all?: InputMaybe<Scalars['Int']>;
  order_matches_any?: InputMaybe<Scalars['Int']>;
  order_not_cont?: InputMaybe<Scalars['Int']>;
  order_not_cont_all?: InputMaybe<Scalars['Int']>;
  order_not_cont_any?: InputMaybe<Scalars['Int']>;
  order_not_end?: InputMaybe<Scalars['Int']>;
  order_not_end_all?: InputMaybe<Scalars['Int']>;
  order_not_end_any?: InputMaybe<Scalars['Int']>;
  order_not_eq?: InputMaybe<Scalars['Int']>;
  order_not_eq_all?: InputMaybe<Scalars['Int']>;
  order_not_eq_any?: InputMaybe<Scalars['Int']>;
  order_not_false?: InputMaybe<Scalars['Int']>;
  order_not_i_cont?: InputMaybe<Scalars['Int']>;
  order_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  order_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']>>;
  order_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  order_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  order_not_null?: InputMaybe<Scalars['Int']>;
  order_not_start?: InputMaybe<Scalars['Int']>;
  order_not_start_all?: InputMaybe<Scalars['Int']>;
  order_not_start_any?: InputMaybe<Scalars['Int']>;
  order_not_true?: InputMaybe<Scalars['Int']>;
  order_null?: InputMaybe<Scalars['Int']>;
  order_present?: InputMaybe<Scalars['Int']>;
  order_start?: InputMaybe<Scalars['Int']>;
  order_start_all?: InputMaybe<Scalars['Int']>;
  order_start_any?: InputMaybe<Scalars['Int']>;
  order_true?: InputMaybe<Scalars['Int']>;
  published_at_blank?: InputMaybe<Scalars['String']>;
  published_at_cont?: InputMaybe<Scalars['String']>;
  published_at_cont_all?: InputMaybe<Scalars['String']>;
  published_at_cont_any?: InputMaybe<Scalars['String']>;
  published_at_does_not_match?: InputMaybe<Scalars['String']>;
  published_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  published_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  published_at_end?: InputMaybe<Scalars['String']>;
  published_at_end_all?: InputMaybe<Scalars['String']>;
  published_at_end_any?: InputMaybe<Scalars['String']>;
  published_at_eq?: InputMaybe<Scalars['String']>;
  published_at_eq_all?: InputMaybe<Scalars['String']>;
  published_at_eq_any?: InputMaybe<Scalars['String']>;
  published_at_false?: InputMaybe<Scalars['String']>;
  published_at_gt?: InputMaybe<Scalars['String']>;
  published_at_gt_all?: InputMaybe<Scalars['String']>;
  published_at_gt_any?: InputMaybe<Scalars['String']>;
  published_at_gteq?: InputMaybe<Scalars['String']>;
  published_at_gteq_all?: InputMaybe<Scalars['String']>;
  published_at_gteq_any?: InputMaybe<Scalars['String']>;
  published_at_i_cont?: InputMaybe<Scalars['String']>;
  published_at_i_cont_all?: InputMaybe<Scalars['String']>;
  published_at_i_cont_any?: InputMaybe<Scalars['String']>;
  published_at_in?: InputMaybe<Scalars['String']>;
  published_at_in_all?: InputMaybe<Scalars['String']>;
  published_at_in_any?: InputMaybe<Scalars['String']>;
  published_at_lt?: InputMaybe<Scalars['String']>;
  published_at_lt_all?: InputMaybe<Scalars['String']>;
  published_at_lt_any?: InputMaybe<Scalars['String']>;
  published_at_lteq?: InputMaybe<Scalars['String']>;
  published_at_lteq_all?: InputMaybe<Scalars['String']>;
  published_at_lteq_any?: InputMaybe<Scalars['String']>;
  published_at_matches?: InputMaybe<Scalars['String']>;
  published_at_matches_all?: InputMaybe<Scalars['String']>;
  published_at_matches_any?: InputMaybe<Scalars['String']>;
  published_at_not_cont?: InputMaybe<Scalars['String']>;
  published_at_not_cont_all?: InputMaybe<Scalars['String']>;
  published_at_not_cont_any?: InputMaybe<Scalars['String']>;
  published_at_not_end?: InputMaybe<Scalars['String']>;
  published_at_not_end_all?: InputMaybe<Scalars['String']>;
  published_at_not_end_any?: InputMaybe<Scalars['String']>;
  published_at_not_eq?: InputMaybe<Scalars['String']>;
  published_at_not_eq_all?: InputMaybe<Scalars['String']>;
  published_at_not_eq_any?: InputMaybe<Scalars['String']>;
  published_at_not_false?: InputMaybe<Scalars['String']>;
  published_at_not_i_cont?: InputMaybe<Scalars['String']>;
  published_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  published_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  published_at_not_in?: InputMaybe<Scalars['String']>;
  published_at_not_in_all?: InputMaybe<Scalars['String']>;
  published_at_not_in_any?: InputMaybe<Scalars['String']>;
  published_at_not_null?: InputMaybe<Scalars['String']>;
  published_at_not_start?: InputMaybe<Scalars['String']>;
  published_at_not_start_all?: InputMaybe<Scalars['String']>;
  published_at_not_start_any?: InputMaybe<Scalars['String']>;
  published_at_not_true?: InputMaybe<Scalars['String']>;
  published_at_null?: InputMaybe<Scalars['String']>;
  published_at_present?: InputMaybe<Scalars['String']>;
  published_at_start?: InputMaybe<Scalars['String']>;
  published_at_start_all?: InputMaybe<Scalars['String']>;
  published_at_start_any?: InputMaybe<Scalars['String']>;
  published_at_true?: InputMaybe<Scalars['String']>;
  send_email_blank?: InputMaybe<Scalars['Boolean']>;
  send_email_cont?: InputMaybe<Scalars['Boolean']>;
  send_email_cont_all?: InputMaybe<Scalars['Boolean']>;
  send_email_cont_any?: InputMaybe<Scalars['Boolean']>;
  send_email_does_not_match?: InputMaybe<Scalars['Boolean']>;
  send_email_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  send_email_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  send_email_end?: InputMaybe<Scalars['Boolean']>;
  send_email_end_all?: InputMaybe<Scalars['Boolean']>;
  send_email_end_any?: InputMaybe<Scalars['Boolean']>;
  send_email_eq?: InputMaybe<Scalars['Boolean']>;
  send_email_eq_all?: InputMaybe<Scalars['Boolean']>;
  send_email_eq_any?: InputMaybe<Scalars['Boolean']>;
  send_email_false?: InputMaybe<Scalars['Boolean']>;
  send_email_gt?: InputMaybe<Scalars['Boolean']>;
  send_email_gt_all?: InputMaybe<Scalars['Boolean']>;
  send_email_gt_any?: InputMaybe<Scalars['Boolean']>;
  send_email_gteq?: InputMaybe<Scalars['Boolean']>;
  send_email_gteq_all?: InputMaybe<Scalars['Boolean']>;
  send_email_gteq_any?: InputMaybe<Scalars['Boolean']>;
  send_email_i_cont?: InputMaybe<Scalars['Boolean']>;
  send_email_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  send_email_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  send_email_in?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_lt?: InputMaybe<Scalars['Boolean']>;
  send_email_lt_all?: InputMaybe<Scalars['Boolean']>;
  send_email_lt_any?: InputMaybe<Scalars['Boolean']>;
  send_email_lteq?: InputMaybe<Scalars['Boolean']>;
  send_email_lteq_all?: InputMaybe<Scalars['Boolean']>;
  send_email_lteq_any?: InputMaybe<Scalars['Boolean']>;
  send_email_matches?: InputMaybe<Scalars['Boolean']>;
  send_email_matches_all?: InputMaybe<Scalars['Boolean']>;
  send_email_matches_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_cont?: InputMaybe<Scalars['Boolean']>;
  send_email_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_end?: InputMaybe<Scalars['Boolean']>;
  send_email_not_end_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_end_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_eq?: InputMaybe<Scalars['Boolean']>;
  send_email_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_false?: InputMaybe<Scalars['Boolean']>;
  send_email_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  send_email_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  send_email_not_null?: InputMaybe<Scalars['Boolean']>;
  send_email_not_start?: InputMaybe<Scalars['Boolean']>;
  send_email_not_start_all?: InputMaybe<Scalars['Boolean']>;
  send_email_not_start_any?: InputMaybe<Scalars['Boolean']>;
  send_email_not_true?: InputMaybe<Scalars['Boolean']>;
  send_email_null?: InputMaybe<Scalars['Boolean']>;
  send_email_present?: InputMaybe<Scalars['Boolean']>;
  send_email_start?: InputMaybe<Scalars['Boolean']>;
  send_email_start_all?: InputMaybe<Scalars['Boolean']>;
  send_email_start_any?: InputMaybe<Scalars['Boolean']>;
  send_email_true?: InputMaybe<Scalars['Boolean']>;
  start_date_blank?: InputMaybe<Scalars['String']>;
  start_date_cont?: InputMaybe<Scalars['String']>;
  start_date_cont_all?: InputMaybe<Scalars['String']>;
  start_date_cont_any?: InputMaybe<Scalars['String']>;
  start_date_does_not_match?: InputMaybe<Scalars['String']>;
  start_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  start_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  start_date_end?: InputMaybe<Scalars['String']>;
  start_date_end_all?: InputMaybe<Scalars['String']>;
  start_date_end_any?: InputMaybe<Scalars['String']>;
  start_date_eq?: InputMaybe<Scalars['String']>;
  start_date_eq_all?: InputMaybe<Scalars['String']>;
  start_date_eq_any?: InputMaybe<Scalars['String']>;
  start_date_false?: InputMaybe<Scalars['String']>;
  start_date_gt?: InputMaybe<Scalars['String']>;
  start_date_gt_all?: InputMaybe<Scalars['String']>;
  start_date_gt_any?: InputMaybe<Scalars['String']>;
  start_date_gteq?: InputMaybe<Scalars['String']>;
  start_date_gteq_all?: InputMaybe<Scalars['String']>;
  start_date_gteq_any?: InputMaybe<Scalars['String']>;
  start_date_i_cont?: InputMaybe<Scalars['String']>;
  start_date_i_cont_all?: InputMaybe<Scalars['String']>;
  start_date_i_cont_any?: InputMaybe<Scalars['String']>;
  start_date_in?: InputMaybe<Scalars['String']>;
  start_date_in_all?: InputMaybe<Scalars['String']>;
  start_date_in_any?: InputMaybe<Scalars['String']>;
  start_date_lt?: InputMaybe<Scalars['String']>;
  start_date_lt_all?: InputMaybe<Scalars['String']>;
  start_date_lt_any?: InputMaybe<Scalars['String']>;
  start_date_lteq?: InputMaybe<Scalars['String']>;
  start_date_lteq_all?: InputMaybe<Scalars['String']>;
  start_date_lteq_any?: InputMaybe<Scalars['String']>;
  start_date_matches?: InputMaybe<Scalars['String']>;
  start_date_matches_all?: InputMaybe<Scalars['String']>;
  start_date_matches_any?: InputMaybe<Scalars['String']>;
  start_date_not_cont?: InputMaybe<Scalars['String']>;
  start_date_not_cont_all?: InputMaybe<Scalars['String']>;
  start_date_not_cont_any?: InputMaybe<Scalars['String']>;
  start_date_not_end?: InputMaybe<Scalars['String']>;
  start_date_not_end_all?: InputMaybe<Scalars['String']>;
  start_date_not_end_any?: InputMaybe<Scalars['String']>;
  start_date_not_eq?: InputMaybe<Scalars['String']>;
  start_date_not_eq_all?: InputMaybe<Scalars['String']>;
  start_date_not_eq_any?: InputMaybe<Scalars['String']>;
  start_date_not_false?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  start_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  start_date_not_in?: InputMaybe<Scalars['String']>;
  start_date_not_in_all?: InputMaybe<Scalars['String']>;
  start_date_not_in_any?: InputMaybe<Scalars['String']>;
  start_date_not_null?: InputMaybe<Scalars['String']>;
  start_date_not_start?: InputMaybe<Scalars['String']>;
  start_date_not_start_all?: InputMaybe<Scalars['String']>;
  start_date_not_start_any?: InputMaybe<Scalars['String']>;
  start_date_not_true?: InputMaybe<Scalars['String']>;
  start_date_null?: InputMaybe<Scalars['String']>;
  start_date_present?: InputMaybe<Scalars['String']>;
  start_date_start?: InputMaybe<Scalars['String']>;
  start_date_start_all?: InputMaybe<Scalars['String']>;
  start_date_start_any?: InputMaybe<Scalars['String']>;
  start_date_true?: InputMaybe<Scalars['String']>;
  state_blank?: InputMaybe<Scalars['Int']>;
  state_cont?: InputMaybe<Scalars['Int']>;
  state_cont_all?: InputMaybe<Scalars['Int']>;
  state_cont_any?: InputMaybe<Scalars['Int']>;
  state_does_not_match?: InputMaybe<Scalars['Int']>;
  state_does_not_match_all?: InputMaybe<Scalars['Int']>;
  state_does_not_match_any?: InputMaybe<Scalars['Int']>;
  state_end?: InputMaybe<Scalars['Int']>;
  state_end_all?: InputMaybe<Scalars['Int']>;
  state_end_any?: InputMaybe<Scalars['Int']>;
  state_eq?: InputMaybe<Scalars['Int']>;
  state_eq_all?: InputMaybe<Scalars['Int']>;
  state_eq_any?: InputMaybe<Scalars['Int']>;
  state_false?: InputMaybe<Scalars['Int']>;
  state_gt?: InputMaybe<Scalars['Int']>;
  state_gt_all?: InputMaybe<Scalars['Int']>;
  state_gt_any?: InputMaybe<Scalars['Int']>;
  state_gteq?: InputMaybe<Scalars['Int']>;
  state_gteq_all?: InputMaybe<Scalars['Int']>;
  state_gteq_any?: InputMaybe<Scalars['Int']>;
  state_i_cont?: InputMaybe<Scalars['Int']>;
  state_i_cont_all?: InputMaybe<Scalars['Int']>;
  state_i_cont_any?: InputMaybe<Scalars['Int']>;
  state_in?: InputMaybe<Array<Scalars['Int']>>;
  state_in_all?: InputMaybe<Array<Scalars['Int']>>;
  state_in_any?: InputMaybe<Array<Scalars['Int']>>;
  state_lt?: InputMaybe<Scalars['Int']>;
  state_lt_all?: InputMaybe<Scalars['Int']>;
  state_lt_any?: InputMaybe<Scalars['Int']>;
  state_lteq?: InputMaybe<Scalars['Int']>;
  state_lteq_all?: InputMaybe<Scalars['Int']>;
  state_lteq_any?: InputMaybe<Scalars['Int']>;
  state_matches?: InputMaybe<Scalars['Int']>;
  state_matches_all?: InputMaybe<Scalars['Int']>;
  state_matches_any?: InputMaybe<Scalars['Int']>;
  state_not_cont?: InputMaybe<Scalars['Int']>;
  state_not_cont_all?: InputMaybe<Scalars['Int']>;
  state_not_cont_any?: InputMaybe<Scalars['Int']>;
  state_not_end?: InputMaybe<Scalars['Int']>;
  state_not_end_all?: InputMaybe<Scalars['Int']>;
  state_not_end_any?: InputMaybe<Scalars['Int']>;
  state_not_eq?: InputMaybe<Scalars['Int']>;
  state_not_eq_all?: InputMaybe<Scalars['Int']>;
  state_not_eq_any?: InputMaybe<Scalars['Int']>;
  state_not_false?: InputMaybe<Scalars['Int']>;
  state_not_i_cont?: InputMaybe<Scalars['Int']>;
  state_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  state_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  state_not_in?: InputMaybe<Array<Scalars['Int']>>;
  state_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  state_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  state_not_null?: InputMaybe<Scalars['Int']>;
  state_not_start?: InputMaybe<Scalars['Int']>;
  state_not_start_all?: InputMaybe<Scalars['Int']>;
  state_not_start_any?: InputMaybe<Scalars['Int']>;
  state_not_true?: InputMaybe<Scalars['Int']>;
  state_null?: InputMaybe<Scalars['Int']>;
  state_present?: InputMaybe<Scalars['Int']>;
  state_start?: InputMaybe<Scalars['Int']>;
  state_start_all?: InputMaybe<Scalars['Int']>;
  state_start_any?: InputMaybe<Scalars['Int']>;
  state_true?: InputMaybe<Scalars['Int']>;
  thumbnail_data_blank?: InputMaybe<Scalars['String']>;
  thumbnail_data_cont?: InputMaybe<Scalars['String']>;
  thumbnail_data_cont_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_cont_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_does_not_match?: InputMaybe<Scalars['String']>;
  thumbnail_data_does_not_match_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_does_not_match_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_end?: InputMaybe<Scalars['String']>;
  thumbnail_data_end_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_end_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_eq?: InputMaybe<Scalars['String']>;
  thumbnail_data_eq_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_eq_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_false?: InputMaybe<Scalars['String']>;
  thumbnail_data_gt?: InputMaybe<Scalars['String']>;
  thumbnail_data_gt_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_gt_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_gteq?: InputMaybe<Scalars['String']>;
  thumbnail_data_gteq_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_gteq_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_i_cont?: InputMaybe<Scalars['String']>;
  thumbnail_data_i_cont_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_i_cont_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_in?: InputMaybe<Scalars['String']>;
  thumbnail_data_in_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_in_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_lt?: InputMaybe<Scalars['String']>;
  thumbnail_data_lt_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_lt_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_lteq?: InputMaybe<Scalars['String']>;
  thumbnail_data_lteq_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_lteq_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_matches?: InputMaybe<Scalars['String']>;
  thumbnail_data_matches_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_matches_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_cont?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_cont_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_cont_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_end?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_end_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_end_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_eq?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_eq_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_eq_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_false?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_i_cont?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_i_cont_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_i_cont_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_in?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_in_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_in_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_null?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_start?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_start_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_start_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_not_true?: InputMaybe<Scalars['String']>;
  thumbnail_data_null?: InputMaybe<Scalars['String']>;
  thumbnail_data_present?: InputMaybe<Scalars['String']>;
  thumbnail_data_start?: InputMaybe<Scalars['String']>;
  thumbnail_data_start_all?: InputMaybe<Scalars['String']>;
  thumbnail_data_start_any?: InputMaybe<Scalars['String']>;
  thumbnail_data_true?: InputMaybe<Scalars['String']>;
  until_date_blank?: InputMaybe<Scalars['String']>;
  until_date_cont?: InputMaybe<Scalars['String']>;
  until_date_cont_all?: InputMaybe<Scalars['String']>;
  until_date_cont_any?: InputMaybe<Scalars['String']>;
  until_date_does_not_match?: InputMaybe<Scalars['String']>;
  until_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  until_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  until_date_end?: InputMaybe<Scalars['String']>;
  until_date_end_all?: InputMaybe<Scalars['String']>;
  until_date_end_any?: InputMaybe<Scalars['String']>;
  until_date_eq?: InputMaybe<Scalars['String']>;
  until_date_eq_all?: InputMaybe<Scalars['String']>;
  until_date_eq_any?: InputMaybe<Scalars['String']>;
  until_date_false?: InputMaybe<Scalars['String']>;
  until_date_gt?: InputMaybe<Scalars['String']>;
  until_date_gt_all?: InputMaybe<Scalars['String']>;
  until_date_gt_any?: InputMaybe<Scalars['String']>;
  until_date_gteq?: InputMaybe<Scalars['String']>;
  until_date_gteq_all?: InputMaybe<Scalars['String']>;
  until_date_gteq_any?: InputMaybe<Scalars['String']>;
  until_date_i_cont?: InputMaybe<Scalars['String']>;
  until_date_i_cont_all?: InputMaybe<Scalars['String']>;
  until_date_i_cont_any?: InputMaybe<Scalars['String']>;
  until_date_in?: InputMaybe<Scalars['String']>;
  until_date_in_all?: InputMaybe<Scalars['String']>;
  until_date_in_any?: InputMaybe<Scalars['String']>;
  until_date_lt?: InputMaybe<Scalars['String']>;
  until_date_lt_all?: InputMaybe<Scalars['String']>;
  until_date_lt_any?: InputMaybe<Scalars['String']>;
  until_date_lteq?: InputMaybe<Scalars['String']>;
  until_date_lteq_all?: InputMaybe<Scalars['String']>;
  until_date_lteq_any?: InputMaybe<Scalars['String']>;
  until_date_matches?: InputMaybe<Scalars['String']>;
  until_date_matches_all?: InputMaybe<Scalars['String']>;
  until_date_matches_any?: InputMaybe<Scalars['String']>;
  until_date_not_cont?: InputMaybe<Scalars['String']>;
  until_date_not_cont_all?: InputMaybe<Scalars['String']>;
  until_date_not_cont_any?: InputMaybe<Scalars['String']>;
  until_date_not_end?: InputMaybe<Scalars['String']>;
  until_date_not_end_all?: InputMaybe<Scalars['String']>;
  until_date_not_end_any?: InputMaybe<Scalars['String']>;
  until_date_not_eq?: InputMaybe<Scalars['String']>;
  until_date_not_eq_all?: InputMaybe<Scalars['String']>;
  until_date_not_eq_any?: InputMaybe<Scalars['String']>;
  until_date_not_false?: InputMaybe<Scalars['String']>;
  until_date_not_i_cont?: InputMaybe<Scalars['String']>;
  until_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  until_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  until_date_not_in?: InputMaybe<Scalars['String']>;
  until_date_not_in_all?: InputMaybe<Scalars['String']>;
  until_date_not_in_any?: InputMaybe<Scalars['String']>;
  until_date_not_null?: InputMaybe<Scalars['String']>;
  until_date_not_start?: InputMaybe<Scalars['String']>;
  until_date_not_start_all?: InputMaybe<Scalars['String']>;
  until_date_not_start_any?: InputMaybe<Scalars['String']>;
  until_date_not_true?: InputMaybe<Scalars['String']>;
  until_date_null?: InputMaybe<Scalars['String']>;
  until_date_present?: InputMaybe<Scalars['String']>;
  until_date_start?: InputMaybe<Scalars['String']>;
  until_date_start_all?: InputMaybe<Scalars['String']>;
  until_date_start_any?: InputMaybe<Scalars['String']>;
  until_date_true?: InputMaybe<Scalars['String']>;
};

export enum Provider {
  Coursera = 'coursera',
  Internal = 'internal',
  Udemy = 'udemy'
}

export type Query = {
  __typename?: 'Query';
  area: Area;
  /** Lists areas */
  areas: AreaPage;
  course: Course;
  /** Lists courses users */
  courseUsers: CourseUserPage;
  /** Lists courses */
  courses: CoursePage;
  externalCourse: ExternalCourse;
  /** Lists external courses */
  externalCourseUsers: EnrolExternalCoursePage;
  /** Lists external courses */
  externalCourses: ExternalCoursePage;
  globalAdvancement?: Maybe<GlobalAdvancement>;
  /** Lists learning paths */
  learningPaths: LearningPathPage;
  /** User in session */
  me: User;
  /** Lists the courses of the user in session */
  myCourses: CourseUserPage;
  /** Popular lists courses */
  popularCourses: PopularCoursePage;
  /** Lists users */
  users: UserPage;
  /** Count users */
  usersCount: Scalars['Int'];
};


export type QueryAreaArgs = {
  id: Scalars['ID'];
  q?: InputMaybe<AreaRansack>;
};


export type QueryAreasArgs = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  idOrParentId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<AreaRansack>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
};


export type QueryCourseUsersArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  courseId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<UserCourseRansack>;
};


export type QueryCoursesArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  bannerData?: InputMaybe<Scalars['JSON']>;
  canGenerateCertificate?: InputMaybe<Scalars['Boolean']>;
  capacity?: InputMaybe<Scalars['Int']>;
  courseType?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  deletedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  directChiefApproval?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  onDuplicated?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<CourseRansack>;
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  state?: InputMaybe<Scalars['Int']>;
  thumbnailData?: InputMaybe<Scalars['JSON']>;
  untilDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryExternalCourseArgs = {
  id: Scalars['ID'];
};


export type QueryExternalCourseUsersArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  externalCourseId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<ExternalCourseUserRansack>;
};


export type QueryExternalCoursesArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  id?: InputMaybe<Scalars['ID']>;
  institution?: InputMaybe<Scalars['String']>;
  modality?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<ExternalCourseRansack>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryLearningPathsArgs = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  deletedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  learningPathType?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  pictureData?: InputMaybe<Scalars['JSON']>;
  q?: InputMaybe<LearningPathRansack>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  userLmsActive?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryMyCoursesArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<UserCourseRansack>;
};


export type QueryPopularCoursesArgs = {
  count_finished_participants_eq?: InputMaybe<Scalars['Int']>;
  count_finished_participants_gt?: InputMaybe<Scalars['Int']>;
  count_finished_participants_gteq?: InputMaybe<Scalars['Int']>;
  count_finished_participants_lt?: InputMaybe<Scalars['Int']>;
  count_finished_participants_lteq?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  participant_count_eq?: InputMaybe<Scalars['Int']>;
  participant_count_gt?: InputMaybe<Scalars['Int']>;
  participant_count_gteq?: InputMaybe<Scalars['Int']>;
  participant_count_lt?: InputMaybe<Scalars['Int']>;
  participant_count_lteq?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<PopularCourseRansack>;
};


export type QueryUsersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  areaId?: InputMaybe<Scalars['ID']>;
  avatar?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  identifier?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  lmsActive?: InputMaybe<Scalars['Boolean']>;
  lmsProfiles?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['String']>;
  q?: InputMaybe<UserRansack>;
  token?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryUsersCountArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  q?: InputMaybe<UserRansack>;
};

export type SynchronousCourse = {
  __typename?: 'SynchronousCourse';
  courseId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  evaluationsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  maximumGrade?: Maybe<Scalars['Float']>;
  minimumGrade?: Maybe<Scalars['Float']>;
  synchronousCourseType: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SynchronousCourseEnrol = {
  __typename?: 'SynchronousCourseEnrol';
  attendance?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  finalState?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SynchronousCourseEnrolAssessment = {
  __typename?: 'SynchronousCourseEnrolAssessment';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  qualification: Scalars['Float'];
  synchronousCourseEnrolId: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type User = {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']>;
  allCoursesCount: Scalars['Int'];
  allCoursesProgress?: Maybe<UserProgress>;
  allCoursesProgressEvaluations?: Maybe<CourseProgressEvaluation>;
  area?: Maybe<Area>;
  avatar?: Maybe<Scalars['String']>;
  courseProgressEvaluations?: Maybe<CourseProgressEvaluation>;
  /** Lists the courses of the user in session */
  courses: CourseUserPage;
  coursesCount: Scalars['Int'];
  coursesProgress?: Maybe<UserProgress>;
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  externalCoursesCount: Scalars['Int'];
  externalCoursesProgress?: Maybe<UserProgress>;
  externalCoursesProgressEvaluations?: Maybe<CourseProgressEvaluation>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  lmsActive?: Maybe<Scalars['Boolean']>;
  lmsProfiles?: Maybe<Array<LmsProfile>>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type UserCoursesArgs = {
  areaId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<UserCourseRansack>;
};

export type UserCourseRansack = {
  advance_blank?: InputMaybe<Scalars['Int']>;
  advance_cont?: InputMaybe<Scalars['Int']>;
  advance_cont_all?: InputMaybe<Scalars['Int']>;
  advance_cont_any?: InputMaybe<Scalars['Int']>;
  advance_does_not_match?: InputMaybe<Scalars['Int']>;
  advance_does_not_match_all?: InputMaybe<Scalars['Int']>;
  advance_does_not_match_any?: InputMaybe<Scalars['Int']>;
  advance_end?: InputMaybe<Scalars['Int']>;
  advance_end_all?: InputMaybe<Scalars['Int']>;
  advance_end_any?: InputMaybe<Scalars['Int']>;
  advance_eq?: InputMaybe<Scalars['Int']>;
  advance_eq_all?: InputMaybe<Scalars['Int']>;
  advance_eq_any?: InputMaybe<Scalars['Int']>;
  advance_false?: InputMaybe<Scalars['Int']>;
  advance_gt?: InputMaybe<Scalars['Int']>;
  advance_gt_all?: InputMaybe<Scalars['Int']>;
  advance_gt_any?: InputMaybe<Scalars['Int']>;
  advance_gteq?: InputMaybe<Scalars['Int']>;
  advance_gteq_all?: InputMaybe<Scalars['Int']>;
  advance_gteq_any?: InputMaybe<Scalars['Int']>;
  advance_i_cont?: InputMaybe<Scalars['Int']>;
  advance_i_cont_all?: InputMaybe<Scalars['Int']>;
  advance_i_cont_any?: InputMaybe<Scalars['Int']>;
  advance_in?: InputMaybe<Array<Scalars['Int']>>;
  advance_in_all?: InputMaybe<Array<Scalars['Int']>>;
  advance_in_any?: InputMaybe<Array<Scalars['Int']>>;
  advance_lt?: InputMaybe<Scalars['Int']>;
  advance_lt_all?: InputMaybe<Scalars['Int']>;
  advance_lt_any?: InputMaybe<Scalars['Int']>;
  advance_lteq?: InputMaybe<Scalars['Int']>;
  advance_lteq_all?: InputMaybe<Scalars['Int']>;
  advance_lteq_any?: InputMaybe<Scalars['Int']>;
  advance_matches?: InputMaybe<Scalars['Int']>;
  advance_matches_all?: InputMaybe<Scalars['Int']>;
  advance_matches_any?: InputMaybe<Scalars['Int']>;
  advance_not_cont?: InputMaybe<Scalars['Int']>;
  advance_not_cont_all?: InputMaybe<Scalars['Int']>;
  advance_not_cont_any?: InputMaybe<Scalars['Int']>;
  advance_not_end?: InputMaybe<Scalars['Int']>;
  advance_not_end_all?: InputMaybe<Scalars['Int']>;
  advance_not_end_any?: InputMaybe<Scalars['Int']>;
  advance_not_eq?: InputMaybe<Scalars['Int']>;
  advance_not_eq_all?: InputMaybe<Scalars['Int']>;
  advance_not_eq_any?: InputMaybe<Scalars['Int']>;
  advance_not_false?: InputMaybe<Scalars['Int']>;
  advance_not_i_cont?: InputMaybe<Scalars['Int']>;
  advance_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  advance_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  advance_not_in?: InputMaybe<Array<Scalars['Int']>>;
  advance_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  advance_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  advance_not_null?: InputMaybe<Scalars['Int']>;
  advance_not_start?: InputMaybe<Scalars['Int']>;
  advance_not_start_all?: InputMaybe<Scalars['Int']>;
  advance_not_start_any?: InputMaybe<Scalars['Int']>;
  advance_not_true?: InputMaybe<Scalars['Int']>;
  advance_null?: InputMaybe<Scalars['Int']>;
  advance_present?: InputMaybe<Scalars['Int']>;
  advance_start?: InputMaybe<Scalars['Int']>;
  advance_start_all?: InputMaybe<Scalars['Int']>;
  advance_start_any?: InputMaybe<Scalars['Int']>;
  advance_true?: InputMaybe<Scalars['Int']>;
  course_id_blank?: InputMaybe<Scalars['Int']>;
  course_id_cont?: InputMaybe<Scalars['Int']>;
  course_id_cont_all?: InputMaybe<Scalars['Int']>;
  course_id_cont_any?: InputMaybe<Scalars['Int']>;
  course_id_does_not_match?: InputMaybe<Scalars['Int']>;
  course_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  course_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  course_id_end?: InputMaybe<Scalars['Int']>;
  course_id_end_all?: InputMaybe<Scalars['Int']>;
  course_id_end_any?: InputMaybe<Scalars['Int']>;
  course_id_eq?: InputMaybe<Scalars['Int']>;
  course_id_eq_all?: InputMaybe<Scalars['Int']>;
  course_id_eq_any?: InputMaybe<Scalars['Int']>;
  course_id_false?: InputMaybe<Scalars['Int']>;
  course_id_gt?: InputMaybe<Scalars['Int']>;
  course_id_gt_all?: InputMaybe<Scalars['Int']>;
  course_id_gt_any?: InputMaybe<Scalars['Int']>;
  course_id_gteq?: InputMaybe<Scalars['Int']>;
  course_id_gteq_all?: InputMaybe<Scalars['Int']>;
  course_id_gteq_any?: InputMaybe<Scalars['Int']>;
  course_id_i_cont?: InputMaybe<Scalars['Int']>;
  course_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  course_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  course_id_in?: InputMaybe<Array<Scalars['Int']>>;
  course_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  course_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  course_id_lt?: InputMaybe<Scalars['Int']>;
  course_id_lt_all?: InputMaybe<Scalars['Int']>;
  course_id_lt_any?: InputMaybe<Scalars['Int']>;
  course_id_lteq?: InputMaybe<Scalars['Int']>;
  course_id_lteq_all?: InputMaybe<Scalars['Int']>;
  course_id_lteq_any?: InputMaybe<Scalars['Int']>;
  course_id_matches?: InputMaybe<Scalars['Int']>;
  course_id_matches_all?: InputMaybe<Scalars['Int']>;
  course_id_matches_any?: InputMaybe<Scalars['Int']>;
  course_id_not_cont?: InputMaybe<Scalars['Int']>;
  course_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  course_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  course_id_not_end?: InputMaybe<Scalars['Int']>;
  course_id_not_end_all?: InputMaybe<Scalars['Int']>;
  course_id_not_end_any?: InputMaybe<Scalars['Int']>;
  course_id_not_eq?: InputMaybe<Scalars['Int']>;
  course_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  course_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  course_id_not_false?: InputMaybe<Scalars['Int']>;
  course_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  course_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  course_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  course_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  course_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  course_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  course_id_not_null?: InputMaybe<Scalars['Int']>;
  course_id_not_start?: InputMaybe<Scalars['Int']>;
  course_id_not_start_all?: InputMaybe<Scalars['Int']>;
  course_id_not_start_any?: InputMaybe<Scalars['Int']>;
  course_id_not_true?: InputMaybe<Scalars['Int']>;
  course_id_null?: InputMaybe<Scalars['Int']>;
  course_id_present?: InputMaybe<Scalars['Int']>;
  course_id_start?: InputMaybe<Scalars['Int']>;
  course_id_start_all?: InputMaybe<Scalars['Int']>;
  course_id_start_any?: InputMaybe<Scalars['Int']>;
  course_id_true?: InputMaybe<Scalars['Int']>;
  enrol_id_blank?: InputMaybe<Scalars['Int']>;
  enrol_id_cont?: InputMaybe<Scalars['Int']>;
  enrol_id_cont_all?: InputMaybe<Scalars['Int']>;
  enrol_id_cont_any?: InputMaybe<Scalars['Int']>;
  enrol_id_does_not_match?: InputMaybe<Scalars['Int']>;
  enrol_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  enrol_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  enrol_id_end?: InputMaybe<Scalars['Int']>;
  enrol_id_end_all?: InputMaybe<Scalars['Int']>;
  enrol_id_end_any?: InputMaybe<Scalars['Int']>;
  enrol_id_eq?: InputMaybe<Scalars['Int']>;
  enrol_id_eq_all?: InputMaybe<Scalars['Int']>;
  enrol_id_eq_any?: InputMaybe<Scalars['Int']>;
  enrol_id_false?: InputMaybe<Scalars['Int']>;
  enrol_id_gt?: InputMaybe<Scalars['Int']>;
  enrol_id_gt_all?: InputMaybe<Scalars['Int']>;
  enrol_id_gt_any?: InputMaybe<Scalars['Int']>;
  enrol_id_gteq?: InputMaybe<Scalars['Int']>;
  enrol_id_gteq_all?: InputMaybe<Scalars['Int']>;
  enrol_id_gteq_any?: InputMaybe<Scalars['Int']>;
  enrol_id_i_cont?: InputMaybe<Scalars['Int']>;
  enrol_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  enrol_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  enrol_id_in?: InputMaybe<Array<Scalars['Int']>>;
  enrol_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  enrol_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  enrol_id_lt?: InputMaybe<Scalars['Int']>;
  enrol_id_lt_all?: InputMaybe<Scalars['Int']>;
  enrol_id_lt_any?: InputMaybe<Scalars['Int']>;
  enrol_id_lteq?: InputMaybe<Scalars['Int']>;
  enrol_id_lteq_all?: InputMaybe<Scalars['Int']>;
  enrol_id_lteq_any?: InputMaybe<Scalars['Int']>;
  enrol_id_matches?: InputMaybe<Scalars['Int']>;
  enrol_id_matches_all?: InputMaybe<Scalars['Int']>;
  enrol_id_matches_any?: InputMaybe<Scalars['Int']>;
  enrol_id_not_cont?: InputMaybe<Scalars['Int']>;
  enrol_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  enrol_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  enrol_id_not_end?: InputMaybe<Scalars['Int']>;
  enrol_id_not_end_all?: InputMaybe<Scalars['Int']>;
  enrol_id_not_end_any?: InputMaybe<Scalars['Int']>;
  enrol_id_not_eq?: InputMaybe<Scalars['Int']>;
  enrol_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  enrol_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  enrol_id_not_false?: InputMaybe<Scalars['Int']>;
  enrol_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  enrol_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  enrol_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  enrol_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  enrol_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  enrol_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  enrol_id_not_null?: InputMaybe<Scalars['Int']>;
  enrol_id_not_start?: InputMaybe<Scalars['Int']>;
  enrol_id_not_start_all?: InputMaybe<Scalars['Int']>;
  enrol_id_not_start_any?: InputMaybe<Scalars['Int']>;
  enrol_id_not_true?: InputMaybe<Scalars['Int']>;
  enrol_id_null?: InputMaybe<Scalars['Int']>;
  enrol_id_present?: InputMaybe<Scalars['Int']>;
  enrol_id_start?: InputMaybe<Scalars['Int']>;
  enrol_id_start_all?: InputMaybe<Scalars['Int']>;
  enrol_id_start_any?: InputMaybe<Scalars['Int']>;
  enrol_id_true?: InputMaybe<Scalars['Int']>;
  g?: InputMaybe<Array<Scalars['JSON']>>;
  lms_profile_id_blank?: InputMaybe<Scalars['Int']>;
  lms_profile_id_cont?: InputMaybe<Scalars['Int']>;
  lms_profile_id_cont_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_cont_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_does_not_match?: InputMaybe<Scalars['Int']>;
  lms_profile_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_end?: InputMaybe<Scalars['Int']>;
  lms_profile_id_end_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_end_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_eq?: InputMaybe<Scalars['Int']>;
  lms_profile_id_eq_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_eq_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_false?: InputMaybe<Scalars['Int']>;
  lms_profile_id_gt?: InputMaybe<Scalars['Int']>;
  lms_profile_id_gt_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_gt_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_gteq?: InputMaybe<Scalars['Int']>;
  lms_profile_id_gteq_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_gteq_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_i_cont?: InputMaybe<Scalars['Int']>;
  lms_profile_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_in?: InputMaybe<Array<Scalars['Int']>>;
  lms_profile_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  lms_profile_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  lms_profile_id_lt?: InputMaybe<Scalars['Int']>;
  lms_profile_id_lt_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_lt_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_lteq?: InputMaybe<Scalars['Int']>;
  lms_profile_id_lteq_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_lteq_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_matches?: InputMaybe<Scalars['Int']>;
  lms_profile_id_matches_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_matches_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_cont?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_end?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_end_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_end_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_eq?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_false?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  lms_profile_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  lms_profile_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  lms_profile_id_not_null?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_start?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_start_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_start_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_not_true?: InputMaybe<Scalars['Int']>;
  lms_profile_id_null?: InputMaybe<Scalars['Int']>;
  lms_profile_id_present?: InputMaybe<Scalars['Int']>;
  lms_profile_id_start?: InputMaybe<Scalars['Int']>;
  lms_profile_id_start_all?: InputMaybe<Scalars['Int']>;
  lms_profile_id_start_any?: InputMaybe<Scalars['Int']>;
  lms_profile_id_true?: InputMaybe<Scalars['Int']>;
  mandatory_blank?: InputMaybe<Scalars['Boolean']>;
  mandatory_cont?: InputMaybe<Scalars['Boolean']>;
  mandatory_cont_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_cont_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_does_not_match?: InputMaybe<Scalars['Boolean']>;
  mandatory_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_end?: InputMaybe<Scalars['Boolean']>;
  mandatory_end_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_end_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_eq?: InputMaybe<Scalars['Boolean']>;
  mandatory_eq_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_eq_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_false?: InputMaybe<Scalars['Boolean']>;
  mandatory_gt?: InputMaybe<Scalars['Boolean']>;
  mandatory_gt_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_gt_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_gteq?: InputMaybe<Scalars['Boolean']>;
  mandatory_gteq_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_gteq_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_i_cont?: InputMaybe<Scalars['Boolean']>;
  mandatory_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_in?: InputMaybe<Array<Scalars['Boolean']>>;
  mandatory_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  mandatory_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  mandatory_lt?: InputMaybe<Scalars['Boolean']>;
  mandatory_lt_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_lt_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_lteq?: InputMaybe<Scalars['Boolean']>;
  mandatory_lteq_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_lteq_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_matches?: InputMaybe<Scalars['Boolean']>;
  mandatory_matches_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_matches_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_cont?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_end?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_end_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_end_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_eq?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_false?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  mandatory_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  mandatory_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  mandatory_not_null?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_start?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_start_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_start_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_not_true?: InputMaybe<Scalars['Boolean']>;
  mandatory_null?: InputMaybe<Scalars['Boolean']>;
  mandatory_present?: InputMaybe<Scalars['Boolean']>;
  mandatory_start?: InputMaybe<Scalars['Boolean']>;
  mandatory_start_all?: InputMaybe<Scalars['Boolean']>;
  mandatory_start_any?: InputMaybe<Scalars['Boolean']>;
  mandatory_true?: InputMaybe<Scalars['Boolean']>;
  sorts?: InputMaybe<Array<Scalars['String']>>;
  state_evaluations_blank?: InputMaybe<Scalars['String']>;
  state_evaluations_cont?: InputMaybe<Scalars['String']>;
  state_evaluations_cont_all?: InputMaybe<Scalars['String']>;
  state_evaluations_cont_any?: InputMaybe<Scalars['String']>;
  state_evaluations_does_not_match?: InputMaybe<Scalars['String']>;
  state_evaluations_does_not_match_all?: InputMaybe<Scalars['String']>;
  state_evaluations_does_not_match_any?: InputMaybe<Scalars['String']>;
  state_evaluations_end?: InputMaybe<Scalars['String']>;
  state_evaluations_end_all?: InputMaybe<Scalars['String']>;
  state_evaluations_end_any?: InputMaybe<Scalars['String']>;
  state_evaluations_eq?: InputMaybe<Scalars['String']>;
  state_evaluations_eq_all?: InputMaybe<Scalars['String']>;
  state_evaluations_eq_any?: InputMaybe<Scalars['String']>;
  state_evaluations_false?: InputMaybe<Scalars['String']>;
  state_evaluations_gt?: InputMaybe<Scalars['String']>;
  state_evaluations_gt_all?: InputMaybe<Scalars['String']>;
  state_evaluations_gt_any?: InputMaybe<Scalars['String']>;
  state_evaluations_gteq?: InputMaybe<Scalars['String']>;
  state_evaluations_gteq_all?: InputMaybe<Scalars['String']>;
  state_evaluations_gteq_any?: InputMaybe<Scalars['String']>;
  state_evaluations_i_cont?: InputMaybe<Scalars['String']>;
  state_evaluations_i_cont_all?: InputMaybe<Scalars['String']>;
  state_evaluations_i_cont_any?: InputMaybe<Scalars['String']>;
  state_evaluations_in?: InputMaybe<Scalars['String']>;
  state_evaluations_in_all?: InputMaybe<Scalars['String']>;
  state_evaluations_in_any?: InputMaybe<Scalars['String']>;
  state_evaluations_lt?: InputMaybe<Scalars['String']>;
  state_evaluations_lt_all?: InputMaybe<Scalars['String']>;
  state_evaluations_lt_any?: InputMaybe<Scalars['String']>;
  state_evaluations_lteq?: InputMaybe<Scalars['String']>;
  state_evaluations_lteq_all?: InputMaybe<Scalars['String']>;
  state_evaluations_lteq_any?: InputMaybe<Scalars['String']>;
  state_evaluations_matches?: InputMaybe<Scalars['String']>;
  state_evaluations_matches_all?: InputMaybe<Scalars['String']>;
  state_evaluations_matches_any?: InputMaybe<Scalars['String']>;
  state_evaluations_not_cont?: InputMaybe<Scalars['String']>;
  state_evaluations_not_cont_all?: InputMaybe<Scalars['String']>;
  state_evaluations_not_cont_any?: InputMaybe<Scalars['String']>;
  state_evaluations_not_end?: InputMaybe<Scalars['String']>;
  state_evaluations_not_end_all?: InputMaybe<Scalars['String']>;
  state_evaluations_not_end_any?: InputMaybe<Scalars['String']>;
  state_evaluations_not_eq?: InputMaybe<Scalars['String']>;
  state_evaluations_not_eq_all?: InputMaybe<Scalars['String']>;
  state_evaluations_not_eq_any?: InputMaybe<Scalars['String']>;
  state_evaluations_not_false?: InputMaybe<Scalars['String']>;
  state_evaluations_not_i_cont?: InputMaybe<Scalars['String']>;
  state_evaluations_not_i_cont_all?: InputMaybe<Scalars['String']>;
  state_evaluations_not_i_cont_any?: InputMaybe<Scalars['String']>;
  state_evaluations_not_in?: InputMaybe<Scalars['String']>;
  state_evaluations_not_in_all?: InputMaybe<Scalars['String']>;
  state_evaluations_not_in_any?: InputMaybe<Scalars['String']>;
  state_evaluations_not_null?: InputMaybe<Scalars['String']>;
  state_evaluations_not_start?: InputMaybe<Scalars['String']>;
  state_evaluations_not_start_all?: InputMaybe<Scalars['String']>;
  state_evaluations_not_start_any?: InputMaybe<Scalars['String']>;
  state_evaluations_not_true?: InputMaybe<Scalars['String']>;
  state_evaluations_null?: InputMaybe<Scalars['String']>;
  state_evaluations_present?: InputMaybe<Scalars['String']>;
  state_evaluations_start?: InputMaybe<Scalars['String']>;
  state_evaluations_start_all?: InputMaybe<Scalars['String']>;
  state_evaluations_start_any?: InputMaybe<Scalars['String']>;
  state_evaluations_true?: InputMaybe<Scalars['String']>;
  user_active_blank?: InputMaybe<Scalars['Boolean']>;
  user_active_cont?: InputMaybe<Scalars['Boolean']>;
  user_active_cont_all?: InputMaybe<Scalars['Boolean']>;
  user_active_cont_any?: InputMaybe<Scalars['Boolean']>;
  user_active_does_not_match?: InputMaybe<Scalars['Boolean']>;
  user_active_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  user_active_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  user_active_end?: InputMaybe<Scalars['Boolean']>;
  user_active_end_all?: InputMaybe<Scalars['Boolean']>;
  user_active_end_any?: InputMaybe<Scalars['Boolean']>;
  user_active_eq?: InputMaybe<Scalars['Boolean']>;
  user_active_eq_all?: InputMaybe<Scalars['Boolean']>;
  user_active_eq_any?: InputMaybe<Scalars['Boolean']>;
  user_active_false?: InputMaybe<Scalars['Boolean']>;
  user_active_filter_blank?: InputMaybe<Scalars['String']>;
  user_active_filter_cont?: InputMaybe<Scalars['String']>;
  user_active_filter_cont_all?: InputMaybe<Scalars['String']>;
  user_active_filter_cont_any?: InputMaybe<Scalars['String']>;
  user_active_filter_does_not_match?: InputMaybe<Scalars['String']>;
  user_active_filter_does_not_match_all?: InputMaybe<Scalars['String']>;
  user_active_filter_does_not_match_any?: InputMaybe<Scalars['String']>;
  user_active_filter_end?: InputMaybe<Scalars['String']>;
  user_active_filter_end_all?: InputMaybe<Scalars['String']>;
  user_active_filter_end_any?: InputMaybe<Scalars['String']>;
  user_active_filter_eq?: InputMaybe<Scalars['String']>;
  user_active_filter_eq_all?: InputMaybe<Scalars['String']>;
  user_active_filter_eq_any?: InputMaybe<Scalars['String']>;
  user_active_filter_false?: InputMaybe<Scalars['String']>;
  user_active_filter_gt?: InputMaybe<Scalars['String']>;
  user_active_filter_gt_all?: InputMaybe<Scalars['String']>;
  user_active_filter_gt_any?: InputMaybe<Scalars['String']>;
  user_active_filter_gteq?: InputMaybe<Scalars['String']>;
  user_active_filter_gteq_all?: InputMaybe<Scalars['String']>;
  user_active_filter_gteq_any?: InputMaybe<Scalars['String']>;
  user_active_filter_i_cont?: InputMaybe<Scalars['String']>;
  user_active_filter_i_cont_all?: InputMaybe<Scalars['String']>;
  user_active_filter_i_cont_any?: InputMaybe<Scalars['String']>;
  user_active_filter_in?: InputMaybe<Scalars['String']>;
  user_active_filter_in_all?: InputMaybe<Scalars['String']>;
  user_active_filter_in_any?: InputMaybe<Scalars['String']>;
  user_active_filter_lt?: InputMaybe<Scalars['String']>;
  user_active_filter_lt_all?: InputMaybe<Scalars['String']>;
  user_active_filter_lt_any?: InputMaybe<Scalars['String']>;
  user_active_filter_lteq?: InputMaybe<Scalars['String']>;
  user_active_filter_lteq_all?: InputMaybe<Scalars['String']>;
  user_active_filter_lteq_any?: InputMaybe<Scalars['String']>;
  user_active_filter_matches?: InputMaybe<Scalars['String']>;
  user_active_filter_matches_all?: InputMaybe<Scalars['String']>;
  user_active_filter_matches_any?: InputMaybe<Scalars['String']>;
  user_active_filter_not_cont?: InputMaybe<Scalars['String']>;
  user_active_filter_not_cont_all?: InputMaybe<Scalars['String']>;
  user_active_filter_not_cont_any?: InputMaybe<Scalars['String']>;
  user_active_filter_not_end?: InputMaybe<Scalars['String']>;
  user_active_filter_not_end_all?: InputMaybe<Scalars['String']>;
  user_active_filter_not_end_any?: InputMaybe<Scalars['String']>;
  user_active_filter_not_eq?: InputMaybe<Scalars['String']>;
  user_active_filter_not_eq_all?: InputMaybe<Scalars['String']>;
  user_active_filter_not_eq_any?: InputMaybe<Scalars['String']>;
  user_active_filter_not_false?: InputMaybe<Scalars['String']>;
  user_active_filter_not_i_cont?: InputMaybe<Scalars['String']>;
  user_active_filter_not_i_cont_all?: InputMaybe<Scalars['String']>;
  user_active_filter_not_i_cont_any?: InputMaybe<Scalars['String']>;
  user_active_filter_not_in?: InputMaybe<Scalars['String']>;
  user_active_filter_not_in_all?: InputMaybe<Scalars['String']>;
  user_active_filter_not_in_any?: InputMaybe<Scalars['String']>;
  user_active_filter_not_null?: InputMaybe<Scalars['String']>;
  user_active_filter_not_start?: InputMaybe<Scalars['String']>;
  user_active_filter_not_start_all?: InputMaybe<Scalars['String']>;
  user_active_filter_not_start_any?: InputMaybe<Scalars['String']>;
  user_active_filter_not_true?: InputMaybe<Scalars['String']>;
  user_active_filter_null?: InputMaybe<Scalars['String']>;
  user_active_filter_present?: InputMaybe<Scalars['String']>;
  user_active_filter_start?: InputMaybe<Scalars['String']>;
  user_active_filter_start_all?: InputMaybe<Scalars['String']>;
  user_active_filter_start_any?: InputMaybe<Scalars['String']>;
  user_active_filter_true?: InputMaybe<Scalars['String']>;
  user_active_gt?: InputMaybe<Scalars['Boolean']>;
  user_active_gt_all?: InputMaybe<Scalars['Boolean']>;
  user_active_gt_any?: InputMaybe<Scalars['Boolean']>;
  user_active_gteq?: InputMaybe<Scalars['Boolean']>;
  user_active_gteq_all?: InputMaybe<Scalars['Boolean']>;
  user_active_gteq_any?: InputMaybe<Scalars['Boolean']>;
  user_active_i_cont?: InputMaybe<Scalars['Boolean']>;
  user_active_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  user_active_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  user_active_in?: InputMaybe<Array<Scalars['Boolean']>>;
  user_active_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  user_active_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  user_active_lt?: InputMaybe<Scalars['Boolean']>;
  user_active_lt_all?: InputMaybe<Scalars['Boolean']>;
  user_active_lt_any?: InputMaybe<Scalars['Boolean']>;
  user_active_lteq?: InputMaybe<Scalars['Boolean']>;
  user_active_lteq_all?: InputMaybe<Scalars['Boolean']>;
  user_active_lteq_any?: InputMaybe<Scalars['Boolean']>;
  user_active_matches?: InputMaybe<Scalars['Boolean']>;
  user_active_matches_all?: InputMaybe<Scalars['Boolean']>;
  user_active_matches_any?: InputMaybe<Scalars['Boolean']>;
  user_active_not_cont?: InputMaybe<Scalars['Boolean']>;
  user_active_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  user_active_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  user_active_not_end?: InputMaybe<Scalars['Boolean']>;
  user_active_not_end_all?: InputMaybe<Scalars['Boolean']>;
  user_active_not_end_any?: InputMaybe<Scalars['Boolean']>;
  user_active_not_eq?: InputMaybe<Scalars['Boolean']>;
  user_active_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  user_active_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  user_active_not_false?: InputMaybe<Scalars['Boolean']>;
  user_active_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  user_active_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  user_active_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  user_active_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  user_active_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  user_active_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  user_active_not_null?: InputMaybe<Scalars['Boolean']>;
  user_active_not_start?: InputMaybe<Scalars['Boolean']>;
  user_active_not_start_all?: InputMaybe<Scalars['Boolean']>;
  user_active_not_start_any?: InputMaybe<Scalars['Boolean']>;
  user_active_not_true?: InputMaybe<Scalars['Boolean']>;
  user_active_null?: InputMaybe<Scalars['Boolean']>;
  user_active_present?: InputMaybe<Scalars['Boolean']>;
  user_active_start?: InputMaybe<Scalars['Boolean']>;
  user_active_start_all?: InputMaybe<Scalars['Boolean']>;
  user_active_start_any?: InputMaybe<Scalars['Boolean']>;
  user_active_true?: InputMaybe<Scalars['Boolean']>;
  user_full_name_or_user_identifier_cont?: InputMaybe<Scalars['String']>;
  user_id_blank?: InputMaybe<Scalars['Int']>;
  user_id_cont?: InputMaybe<Scalars['Int']>;
  user_id_cont_all?: InputMaybe<Scalars['Int']>;
  user_id_cont_any?: InputMaybe<Scalars['Int']>;
  user_id_does_not_match?: InputMaybe<Scalars['Int']>;
  user_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  user_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  user_id_end?: InputMaybe<Scalars['Int']>;
  user_id_end_all?: InputMaybe<Scalars['Int']>;
  user_id_end_any?: InputMaybe<Scalars['Int']>;
  user_id_eq?: InputMaybe<Scalars['Int']>;
  user_id_eq_all?: InputMaybe<Scalars['Int']>;
  user_id_eq_any?: InputMaybe<Scalars['Int']>;
  user_id_false?: InputMaybe<Scalars['Int']>;
  user_id_gt?: InputMaybe<Scalars['Int']>;
  user_id_gt_all?: InputMaybe<Scalars['Int']>;
  user_id_gt_any?: InputMaybe<Scalars['Int']>;
  user_id_gteq?: InputMaybe<Scalars['Int']>;
  user_id_gteq_all?: InputMaybe<Scalars['Int']>;
  user_id_gteq_any?: InputMaybe<Scalars['Int']>;
  user_id_i_cont?: InputMaybe<Scalars['Int']>;
  user_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  user_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  user_id_in?: InputMaybe<Array<Scalars['Int']>>;
  user_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  user_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  user_id_lt?: InputMaybe<Scalars['Int']>;
  user_id_lt_all?: InputMaybe<Scalars['Int']>;
  user_id_lt_any?: InputMaybe<Scalars['Int']>;
  user_id_lteq?: InputMaybe<Scalars['Int']>;
  user_id_lteq_all?: InputMaybe<Scalars['Int']>;
  user_id_lteq_any?: InputMaybe<Scalars['Int']>;
  user_id_matches?: InputMaybe<Scalars['Int']>;
  user_id_matches_all?: InputMaybe<Scalars['Int']>;
  user_id_matches_any?: InputMaybe<Scalars['Int']>;
  user_id_not_cont?: InputMaybe<Scalars['Int']>;
  user_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  user_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  user_id_not_end?: InputMaybe<Scalars['Int']>;
  user_id_not_end_all?: InputMaybe<Scalars['Int']>;
  user_id_not_end_any?: InputMaybe<Scalars['Int']>;
  user_id_not_eq?: InputMaybe<Scalars['Int']>;
  user_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  user_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  user_id_not_false?: InputMaybe<Scalars['Int']>;
  user_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  user_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  user_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  user_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  user_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  user_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  user_id_not_null?: InputMaybe<Scalars['Int']>;
  user_id_not_start?: InputMaybe<Scalars['Int']>;
  user_id_not_start_all?: InputMaybe<Scalars['Int']>;
  user_id_not_start_any?: InputMaybe<Scalars['Int']>;
  user_id_not_true?: InputMaybe<Scalars['Int']>;
  user_id_null?: InputMaybe<Scalars['Int']>;
  user_id_present?: InputMaybe<Scalars['Int']>;
  user_id_start?: InputMaybe<Scalars['Int']>;
  user_id_start_all?: InputMaybe<Scalars['Int']>;
  user_id_start_any?: InputMaybe<Scalars['Int']>;
  user_id_true?: InputMaybe<Scalars['Int']>;
  user_lms_active_blank?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_cont?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_cont_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_cont_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_does_not_match?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_end?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_end_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_end_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_eq?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_eq_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_eq_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_false?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_gt?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_gt_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_gt_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_gteq?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_gteq_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_gteq_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_i_cont?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_in?: InputMaybe<Array<Scalars['Boolean']>>;
  user_lms_active_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  user_lms_active_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  user_lms_active_lt?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_lt_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_lt_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_lteq?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_lteq_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_lteq_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_matches?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_matches_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_matches_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_cont?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_end?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_end_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_end_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_eq?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_false?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  user_lms_active_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  user_lms_active_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  user_lms_active_not_null?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_start?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_start_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_start_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_not_true?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_null?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_present?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_start?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_start_all?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_start_any?: InputMaybe<Scalars['Boolean']>;
  user_lms_active_true?: InputMaybe<Scalars['Boolean']>;
  user_name_or_user_lastname_or_user_identifier_cont?: InputMaybe<Scalars['String']>;
};

export type UserPage = {
  __typename?: 'UserPage';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<User>;
  nodesCount: Scalars['Int'];
  pagesCount: Scalars['Int'];
};

export type UserProgress = {
  __typename?: 'UserProgress';
  finish: Scalars['Int'];
  inProgress: Scalars['Int'];
  pending: Scalars['Int'];
};

export type UserRansack = {
  active_blank?: InputMaybe<Scalars['Boolean']>;
  active_cont?: InputMaybe<Scalars['Boolean']>;
  active_cont_all?: InputMaybe<Scalars['Boolean']>;
  active_cont_any?: InputMaybe<Scalars['Boolean']>;
  active_does_not_match?: InputMaybe<Scalars['Boolean']>;
  active_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  active_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  active_end?: InputMaybe<Scalars['Boolean']>;
  active_end_all?: InputMaybe<Scalars['Boolean']>;
  active_end_any?: InputMaybe<Scalars['Boolean']>;
  active_eq?: InputMaybe<Scalars['Boolean']>;
  active_eq_all?: InputMaybe<Scalars['Boolean']>;
  active_eq_any?: InputMaybe<Scalars['Boolean']>;
  active_false?: InputMaybe<Scalars['Boolean']>;
  active_filter_blank?: InputMaybe<Scalars['String']>;
  active_filter_cont?: InputMaybe<Scalars['String']>;
  active_filter_cont_all?: InputMaybe<Scalars['String']>;
  active_filter_cont_any?: InputMaybe<Scalars['String']>;
  active_filter_does_not_match?: InputMaybe<Scalars['String']>;
  active_filter_does_not_match_all?: InputMaybe<Scalars['String']>;
  active_filter_does_not_match_any?: InputMaybe<Scalars['String']>;
  active_filter_end?: InputMaybe<Scalars['String']>;
  active_filter_end_all?: InputMaybe<Scalars['String']>;
  active_filter_end_any?: InputMaybe<Scalars['String']>;
  active_filter_eq?: InputMaybe<Scalars['String']>;
  active_filter_eq_all?: InputMaybe<Scalars['String']>;
  active_filter_eq_any?: InputMaybe<Scalars['String']>;
  active_filter_false?: InputMaybe<Scalars['String']>;
  active_filter_gt?: InputMaybe<Scalars['String']>;
  active_filter_gt_all?: InputMaybe<Scalars['String']>;
  active_filter_gt_any?: InputMaybe<Scalars['String']>;
  active_filter_gteq?: InputMaybe<Scalars['String']>;
  active_filter_gteq_all?: InputMaybe<Scalars['String']>;
  active_filter_gteq_any?: InputMaybe<Scalars['String']>;
  active_filter_i_cont?: InputMaybe<Scalars['String']>;
  active_filter_i_cont_all?: InputMaybe<Scalars['String']>;
  active_filter_i_cont_any?: InputMaybe<Scalars['String']>;
  active_filter_in?: InputMaybe<Scalars['String']>;
  active_filter_in_all?: InputMaybe<Scalars['String']>;
  active_filter_in_any?: InputMaybe<Scalars['String']>;
  active_filter_lt?: InputMaybe<Scalars['String']>;
  active_filter_lt_all?: InputMaybe<Scalars['String']>;
  active_filter_lt_any?: InputMaybe<Scalars['String']>;
  active_filter_lteq?: InputMaybe<Scalars['String']>;
  active_filter_lteq_all?: InputMaybe<Scalars['String']>;
  active_filter_lteq_any?: InputMaybe<Scalars['String']>;
  active_filter_matches?: InputMaybe<Scalars['String']>;
  active_filter_matches_all?: InputMaybe<Scalars['String']>;
  active_filter_matches_any?: InputMaybe<Scalars['String']>;
  active_filter_not_cont?: InputMaybe<Scalars['String']>;
  active_filter_not_cont_all?: InputMaybe<Scalars['String']>;
  active_filter_not_cont_any?: InputMaybe<Scalars['String']>;
  active_filter_not_end?: InputMaybe<Scalars['String']>;
  active_filter_not_end_all?: InputMaybe<Scalars['String']>;
  active_filter_not_end_any?: InputMaybe<Scalars['String']>;
  active_filter_not_eq?: InputMaybe<Scalars['String']>;
  active_filter_not_eq_all?: InputMaybe<Scalars['String']>;
  active_filter_not_eq_any?: InputMaybe<Scalars['String']>;
  active_filter_not_false?: InputMaybe<Scalars['String']>;
  active_filter_not_i_cont?: InputMaybe<Scalars['String']>;
  active_filter_not_i_cont_all?: InputMaybe<Scalars['String']>;
  active_filter_not_i_cont_any?: InputMaybe<Scalars['String']>;
  active_filter_not_in?: InputMaybe<Scalars['String']>;
  active_filter_not_in_all?: InputMaybe<Scalars['String']>;
  active_filter_not_in_any?: InputMaybe<Scalars['String']>;
  active_filter_not_null?: InputMaybe<Scalars['String']>;
  active_filter_not_start?: InputMaybe<Scalars['String']>;
  active_filter_not_start_all?: InputMaybe<Scalars['String']>;
  active_filter_not_start_any?: InputMaybe<Scalars['String']>;
  active_filter_not_true?: InputMaybe<Scalars['String']>;
  active_filter_null?: InputMaybe<Scalars['String']>;
  active_filter_present?: InputMaybe<Scalars['String']>;
  active_filter_start?: InputMaybe<Scalars['String']>;
  active_filter_start_all?: InputMaybe<Scalars['String']>;
  active_filter_start_any?: InputMaybe<Scalars['String']>;
  active_filter_true?: InputMaybe<Scalars['String']>;
  active_gt?: InputMaybe<Scalars['Boolean']>;
  active_gt_all?: InputMaybe<Scalars['Boolean']>;
  active_gt_any?: InputMaybe<Scalars['Boolean']>;
  active_gteq?: InputMaybe<Scalars['Boolean']>;
  active_gteq_all?: InputMaybe<Scalars['Boolean']>;
  active_gteq_any?: InputMaybe<Scalars['Boolean']>;
  active_i_cont?: InputMaybe<Scalars['Boolean']>;
  active_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  active_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  active_in?: InputMaybe<Array<Scalars['Boolean']>>;
  active_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  active_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  active_lt?: InputMaybe<Scalars['Boolean']>;
  active_lt_all?: InputMaybe<Scalars['Boolean']>;
  active_lt_any?: InputMaybe<Scalars['Boolean']>;
  active_lteq?: InputMaybe<Scalars['Boolean']>;
  active_lteq_all?: InputMaybe<Scalars['Boolean']>;
  active_lteq_any?: InputMaybe<Scalars['Boolean']>;
  active_matches?: InputMaybe<Scalars['Boolean']>;
  active_matches_all?: InputMaybe<Scalars['Boolean']>;
  active_matches_any?: InputMaybe<Scalars['Boolean']>;
  active_not_cont?: InputMaybe<Scalars['Boolean']>;
  active_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  active_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  active_not_end?: InputMaybe<Scalars['Boolean']>;
  active_not_end_all?: InputMaybe<Scalars['Boolean']>;
  active_not_end_any?: InputMaybe<Scalars['Boolean']>;
  active_not_eq?: InputMaybe<Scalars['Boolean']>;
  active_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  active_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  active_not_false?: InputMaybe<Scalars['Boolean']>;
  active_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  active_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  active_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  active_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  active_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  active_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  active_not_null?: InputMaybe<Scalars['Boolean']>;
  active_not_start?: InputMaybe<Scalars['Boolean']>;
  active_not_start_all?: InputMaybe<Scalars['Boolean']>;
  active_not_start_any?: InputMaybe<Scalars['Boolean']>;
  active_not_true?: InputMaybe<Scalars['Boolean']>;
  active_null?: InputMaybe<Scalars['Boolean']>;
  active_present?: InputMaybe<Scalars['Boolean']>;
  active_start?: InputMaybe<Scalars['Boolean']>;
  active_start_all?: InputMaybe<Scalars['Boolean']>;
  active_start_any?: InputMaybe<Scalars['Boolean']>;
  active_true?: InputMaybe<Scalars['Boolean']>;
  all_course_progress_evaluations_approved_blank?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_cont?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_cont_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_cont_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_does_not_match?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_does_not_match_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_does_not_match_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_end?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_end_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_end_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_eq?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_eq_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_eq_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_false?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_gt?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_gt_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_gt_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_gteq?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_gteq_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_gteq_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_i_cont?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_i_cont_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_i_cont_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_in?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_in_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_in_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_lt?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_lt_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_lt_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_lteq?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_lteq_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_lteq_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_matches?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_matches_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_matches_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_cont?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_cont_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_cont_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_end?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_end_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_end_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_eq?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_eq_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_eq_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_false?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_i_cont?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_i_cont_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_i_cont_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_in?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_in_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_in_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_null?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_start?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_start_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_start_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_not_true?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_null?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_present?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_start?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_start_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_start_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_approved_true?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_blank?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_cont?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_cont_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_cont_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_does_not_match?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_does_not_match_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_does_not_match_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_end?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_end_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_end_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_eq?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_eq_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_eq_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_false?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_gt?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_gt_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_gt_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_gteq?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_gteq_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_gteq_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_i_cont?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_i_cont_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_i_cont_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_in?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_in_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_in_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_lt?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_lt_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_lt_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_lteq?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_lteq_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_lteq_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_matches?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_matches_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_matches_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_cont?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_cont_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_cont_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_end?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_end_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_end_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_eq?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_eq_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_eq_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_false?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_i_cont?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_i_cont_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_i_cont_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_in?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_in_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_in_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_null?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_start?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_start_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_start_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_not_true?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_null?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_present?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_start?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_start_all?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_start_any?: InputMaybe<Scalars['String']>;
  all_course_progress_evaluations_reprobate_true?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_blank?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_does_not_match?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_does_not_match_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_does_not_match_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_end?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_end_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_end_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_eq?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_eq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_eq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_false?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_gt?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_gt_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_gt_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_gteq?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_gteq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_gteq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_i_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_i_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_i_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_in?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_in_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_in_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_lt?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_lt_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_lt_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_lteq?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_lteq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_lteq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_matches?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_matches_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_matches_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_end?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_end_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_end_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_eq?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_eq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_eq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_false?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_i_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_i_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_i_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_in?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_in_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_in_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_null?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_start?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_start_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_start_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_not_true?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_null?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_present?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_start?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_start_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_start_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_finish_true?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_blank?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_does_not_match?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_does_not_match_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_does_not_match_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_end?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_end_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_end_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_eq?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_eq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_eq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_false?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_gt?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_gt_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_gt_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_gteq?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_gteq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_gteq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_i_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_i_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_i_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_in?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_in_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_in_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_lt?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_lt_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_lt_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_lteq?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_lteq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_lteq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_matches?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_matches_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_matches_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_end?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_end_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_end_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_eq?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_eq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_eq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_false?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_i_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_i_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_i_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_in?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_in_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_in_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_null?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_start?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_start_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_start_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_not_true?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_null?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_present?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_start?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_start_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_start_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_in_progress_true?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_blank?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_does_not_match?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_does_not_match_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_does_not_match_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_end?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_end_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_end_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_eq?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_eq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_eq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_false?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_gt?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_gt_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_gt_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_gteq?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_gteq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_gteq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_i_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_i_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_i_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_in?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_in_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_in_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_lt?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_lt_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_lt_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_lteq?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_lteq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_lteq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_matches?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_matches_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_matches_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_end?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_end_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_end_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_eq?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_eq_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_eq_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_false?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_i_cont?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_i_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_i_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_in?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_in_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_in_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_null?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_start?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_start_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_start_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_not_true?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_null?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_present?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_start?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_start_all?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_start_any?: InputMaybe<Scalars['String']>;
  all_courses_advance_pending_true?: InputMaybe<Scalars['String']>;
  all_courses_count_blank?: InputMaybe<Scalars['String']>;
  all_courses_count_cont?: InputMaybe<Scalars['String']>;
  all_courses_count_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_count_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_count_does_not_match?: InputMaybe<Scalars['String']>;
  all_courses_count_does_not_match_all?: InputMaybe<Scalars['String']>;
  all_courses_count_does_not_match_any?: InputMaybe<Scalars['String']>;
  all_courses_count_end?: InputMaybe<Scalars['String']>;
  all_courses_count_end_all?: InputMaybe<Scalars['String']>;
  all_courses_count_end_any?: InputMaybe<Scalars['String']>;
  all_courses_count_eq?: InputMaybe<Scalars['String']>;
  all_courses_count_eq_all?: InputMaybe<Scalars['String']>;
  all_courses_count_eq_any?: InputMaybe<Scalars['String']>;
  all_courses_count_false?: InputMaybe<Scalars['String']>;
  all_courses_count_gt?: InputMaybe<Scalars['String']>;
  all_courses_count_gt_all?: InputMaybe<Scalars['String']>;
  all_courses_count_gt_any?: InputMaybe<Scalars['String']>;
  all_courses_count_gteq?: InputMaybe<Scalars['String']>;
  all_courses_count_gteq_all?: InputMaybe<Scalars['String']>;
  all_courses_count_gteq_any?: InputMaybe<Scalars['String']>;
  all_courses_count_i_cont?: InputMaybe<Scalars['String']>;
  all_courses_count_i_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_count_i_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_count_in?: InputMaybe<Scalars['String']>;
  all_courses_count_in_all?: InputMaybe<Scalars['String']>;
  all_courses_count_in_any?: InputMaybe<Scalars['String']>;
  all_courses_count_lt?: InputMaybe<Scalars['String']>;
  all_courses_count_lt_all?: InputMaybe<Scalars['String']>;
  all_courses_count_lt_any?: InputMaybe<Scalars['String']>;
  all_courses_count_lteq?: InputMaybe<Scalars['String']>;
  all_courses_count_lteq_all?: InputMaybe<Scalars['String']>;
  all_courses_count_lteq_any?: InputMaybe<Scalars['String']>;
  all_courses_count_matches?: InputMaybe<Scalars['String']>;
  all_courses_count_matches_all?: InputMaybe<Scalars['String']>;
  all_courses_count_matches_any?: InputMaybe<Scalars['String']>;
  all_courses_count_not_cont?: InputMaybe<Scalars['String']>;
  all_courses_count_not_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_count_not_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_count_not_end?: InputMaybe<Scalars['String']>;
  all_courses_count_not_end_all?: InputMaybe<Scalars['String']>;
  all_courses_count_not_end_any?: InputMaybe<Scalars['String']>;
  all_courses_count_not_eq?: InputMaybe<Scalars['String']>;
  all_courses_count_not_eq_all?: InputMaybe<Scalars['String']>;
  all_courses_count_not_eq_any?: InputMaybe<Scalars['String']>;
  all_courses_count_not_false?: InputMaybe<Scalars['String']>;
  all_courses_count_not_i_cont?: InputMaybe<Scalars['String']>;
  all_courses_count_not_i_cont_all?: InputMaybe<Scalars['String']>;
  all_courses_count_not_i_cont_any?: InputMaybe<Scalars['String']>;
  all_courses_count_not_in?: InputMaybe<Scalars['String']>;
  all_courses_count_not_in_all?: InputMaybe<Scalars['String']>;
  all_courses_count_not_in_any?: InputMaybe<Scalars['String']>;
  all_courses_count_not_null?: InputMaybe<Scalars['String']>;
  all_courses_count_not_start?: InputMaybe<Scalars['String']>;
  all_courses_count_not_start_all?: InputMaybe<Scalars['String']>;
  all_courses_count_not_start_any?: InputMaybe<Scalars['String']>;
  all_courses_count_not_true?: InputMaybe<Scalars['String']>;
  all_courses_count_null?: InputMaybe<Scalars['String']>;
  all_courses_count_present?: InputMaybe<Scalars['String']>;
  all_courses_count_start?: InputMaybe<Scalars['String']>;
  all_courses_count_start_all?: InputMaybe<Scalars['String']>;
  all_courses_count_start_any?: InputMaybe<Scalars['String']>;
  all_courses_count_true?: InputMaybe<Scalars['String']>;
  area_id_blank?: InputMaybe<Scalars['Int']>;
  area_id_cont?: InputMaybe<Scalars['Int']>;
  area_id_cont_all?: InputMaybe<Scalars['Int']>;
  area_id_cont_any?: InputMaybe<Scalars['Int']>;
  area_id_does_not_match?: InputMaybe<Scalars['Int']>;
  area_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  area_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  area_id_end?: InputMaybe<Scalars['Int']>;
  area_id_end_all?: InputMaybe<Scalars['Int']>;
  area_id_end_any?: InputMaybe<Scalars['Int']>;
  area_id_eq?: InputMaybe<Scalars['Int']>;
  area_id_eq_all?: InputMaybe<Scalars['Int']>;
  area_id_eq_any?: InputMaybe<Scalars['Int']>;
  area_id_false?: InputMaybe<Scalars['Int']>;
  area_id_gt?: InputMaybe<Scalars['Int']>;
  area_id_gt_all?: InputMaybe<Scalars['Int']>;
  area_id_gt_any?: InputMaybe<Scalars['Int']>;
  area_id_gteq?: InputMaybe<Scalars['Int']>;
  area_id_gteq_all?: InputMaybe<Scalars['Int']>;
  area_id_gteq_any?: InputMaybe<Scalars['Int']>;
  area_id_i_cont?: InputMaybe<Scalars['Int']>;
  area_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  area_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  area_id_in?: InputMaybe<Array<Scalars['Int']>>;
  area_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  area_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  area_id_lt?: InputMaybe<Scalars['Int']>;
  area_id_lt_all?: InputMaybe<Scalars['Int']>;
  area_id_lt_any?: InputMaybe<Scalars['Int']>;
  area_id_lteq?: InputMaybe<Scalars['Int']>;
  area_id_lteq_all?: InputMaybe<Scalars['Int']>;
  area_id_lteq_any?: InputMaybe<Scalars['Int']>;
  area_id_matches?: InputMaybe<Scalars['Int']>;
  area_id_matches_all?: InputMaybe<Scalars['Int']>;
  area_id_matches_any?: InputMaybe<Scalars['Int']>;
  area_id_not_cont?: InputMaybe<Scalars['Int']>;
  area_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  area_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  area_id_not_end?: InputMaybe<Scalars['Int']>;
  area_id_not_end_all?: InputMaybe<Scalars['Int']>;
  area_id_not_end_any?: InputMaybe<Scalars['Int']>;
  area_id_not_eq?: InputMaybe<Scalars['Int']>;
  area_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  area_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  area_id_not_false?: InputMaybe<Scalars['Int']>;
  area_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  area_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  area_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  area_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  area_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  area_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  area_id_not_null?: InputMaybe<Scalars['Int']>;
  area_id_not_start?: InputMaybe<Scalars['Int']>;
  area_id_not_start_all?: InputMaybe<Scalars['Int']>;
  area_id_not_start_any?: InputMaybe<Scalars['Int']>;
  area_id_not_true?: InputMaybe<Scalars['Int']>;
  area_id_null?: InputMaybe<Scalars['Int']>;
  area_id_present?: InputMaybe<Scalars['Int']>;
  area_id_start?: InputMaybe<Scalars['Int']>;
  area_id_start_all?: InputMaybe<Scalars['Int']>;
  area_id_start_any?: InputMaybe<Scalars['Int']>;
  area_id_true?: InputMaybe<Scalars['Int']>;
  avatar_blank?: InputMaybe<Scalars['String']>;
  avatar_cont?: InputMaybe<Scalars['String']>;
  avatar_cont_all?: InputMaybe<Scalars['String']>;
  avatar_cont_any?: InputMaybe<Scalars['String']>;
  avatar_does_not_match?: InputMaybe<Scalars['String']>;
  avatar_does_not_match_all?: InputMaybe<Scalars['String']>;
  avatar_does_not_match_any?: InputMaybe<Scalars['String']>;
  avatar_end?: InputMaybe<Scalars['String']>;
  avatar_end_all?: InputMaybe<Scalars['String']>;
  avatar_end_any?: InputMaybe<Scalars['String']>;
  avatar_eq?: InputMaybe<Scalars['String']>;
  avatar_eq_all?: InputMaybe<Scalars['String']>;
  avatar_eq_any?: InputMaybe<Scalars['String']>;
  avatar_false?: InputMaybe<Scalars['String']>;
  avatar_gt?: InputMaybe<Scalars['String']>;
  avatar_gt_all?: InputMaybe<Scalars['String']>;
  avatar_gt_any?: InputMaybe<Scalars['String']>;
  avatar_gteq?: InputMaybe<Scalars['String']>;
  avatar_gteq_all?: InputMaybe<Scalars['String']>;
  avatar_gteq_any?: InputMaybe<Scalars['String']>;
  avatar_i_cont?: InputMaybe<Scalars['String']>;
  avatar_i_cont_all?: InputMaybe<Scalars['String']>;
  avatar_i_cont_any?: InputMaybe<Scalars['String']>;
  avatar_in?: InputMaybe<Array<Scalars['String']>>;
  avatar_in_all?: InputMaybe<Array<Scalars['String']>>;
  avatar_in_any?: InputMaybe<Array<Scalars['String']>>;
  avatar_lt?: InputMaybe<Scalars['String']>;
  avatar_lt_all?: InputMaybe<Scalars['String']>;
  avatar_lt_any?: InputMaybe<Scalars['String']>;
  avatar_lteq?: InputMaybe<Scalars['String']>;
  avatar_lteq_all?: InputMaybe<Scalars['String']>;
  avatar_lteq_any?: InputMaybe<Scalars['String']>;
  avatar_matches?: InputMaybe<Scalars['String']>;
  avatar_matches_all?: InputMaybe<Scalars['String']>;
  avatar_matches_any?: InputMaybe<Scalars['String']>;
  avatar_not_cont?: InputMaybe<Scalars['String']>;
  avatar_not_cont_all?: InputMaybe<Scalars['String']>;
  avatar_not_cont_any?: InputMaybe<Scalars['String']>;
  avatar_not_end?: InputMaybe<Scalars['String']>;
  avatar_not_end_all?: InputMaybe<Scalars['String']>;
  avatar_not_end_any?: InputMaybe<Scalars['String']>;
  avatar_not_eq?: InputMaybe<Scalars['String']>;
  avatar_not_eq_all?: InputMaybe<Scalars['String']>;
  avatar_not_eq_any?: InputMaybe<Scalars['String']>;
  avatar_not_false?: InputMaybe<Scalars['String']>;
  avatar_not_i_cont?: InputMaybe<Scalars['String']>;
  avatar_not_i_cont_all?: InputMaybe<Scalars['String']>;
  avatar_not_i_cont_any?: InputMaybe<Scalars['String']>;
  avatar_not_in?: InputMaybe<Array<Scalars['String']>>;
  avatar_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  avatar_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  avatar_not_null?: InputMaybe<Scalars['String']>;
  avatar_not_start?: InputMaybe<Scalars['String']>;
  avatar_not_start_all?: InputMaybe<Scalars['String']>;
  avatar_not_start_any?: InputMaybe<Scalars['String']>;
  avatar_not_true?: InputMaybe<Scalars['String']>;
  avatar_null?: InputMaybe<Scalars['String']>;
  avatar_present?: InputMaybe<Scalars['String']>;
  avatar_start?: InputMaybe<Scalars['String']>;
  avatar_start_all?: InputMaybe<Scalars['String']>;
  avatar_start_any?: InputMaybe<Scalars['String']>;
  avatar_true?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_blank?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_cont?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_cont_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_cont_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_does_not_match?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_does_not_match_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_does_not_match_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_end?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_end_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_end_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_eq?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_eq_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_eq_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_false?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_gt?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_gt_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_gt_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_gteq?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_gteq_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_gteq_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_i_cont?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_i_cont_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_i_cont_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_in?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_in_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_in_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_lt?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_lt_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_lt_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_lteq?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_lteq_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_lteq_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_matches?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_matches_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_matches_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_cont?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_cont_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_cont_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_end?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_end_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_end_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_eq?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_eq_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_eq_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_false?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_i_cont?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_i_cont_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_i_cont_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_in?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_in_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_in_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_null?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_start?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_start_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_start_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_not_true?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_null?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_present?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_start?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_start_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_start_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_approved_true?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_blank?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_cont?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_cont_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_cont_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_does_not_match?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_does_not_match_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_does_not_match_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_end?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_end_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_end_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_eq?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_eq_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_eq_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_false?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_gt?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_gt_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_gt_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_gteq?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_gteq_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_gteq_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_i_cont?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_i_cont_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_i_cont_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_in?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_in_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_in_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_lt?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_lt_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_lt_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_lteq?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_lteq_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_lteq_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_matches?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_matches_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_matches_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_cont?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_cont_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_cont_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_end?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_end_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_end_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_eq?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_eq_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_eq_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_false?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_i_cont?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_i_cont_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_i_cont_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_in?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_in_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_in_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_null?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_start?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_start_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_start_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_not_true?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_null?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_present?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_start?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_start_all?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_start_any?: InputMaybe<Scalars['String']>;
  course_progress_evaluations_reprobate_true?: InputMaybe<Scalars['String']>;
  courses_advance_finish_blank?: InputMaybe<Scalars['String']>;
  courses_advance_finish_cont?: InputMaybe<Scalars['String']>;
  courses_advance_finish_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_does_not_match?: InputMaybe<Scalars['String']>;
  courses_advance_finish_does_not_match_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_does_not_match_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_end?: InputMaybe<Scalars['String']>;
  courses_advance_finish_end_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_end_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_eq?: InputMaybe<Scalars['String']>;
  courses_advance_finish_eq_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_eq_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_false?: InputMaybe<Scalars['String']>;
  courses_advance_finish_gt?: InputMaybe<Scalars['String']>;
  courses_advance_finish_gt_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_gt_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_gteq?: InputMaybe<Scalars['String']>;
  courses_advance_finish_gteq_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_gteq_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_i_cont?: InputMaybe<Scalars['String']>;
  courses_advance_finish_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_in?: InputMaybe<Scalars['String']>;
  courses_advance_finish_in_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_in_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_lt?: InputMaybe<Scalars['String']>;
  courses_advance_finish_lt_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_lt_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_lteq?: InputMaybe<Scalars['String']>;
  courses_advance_finish_lteq_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_lteq_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_matches?: InputMaybe<Scalars['String']>;
  courses_advance_finish_matches_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_matches_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_cont?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_end?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_end_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_end_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_eq?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_eq_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_eq_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_false?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_i_cont?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_in?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_in_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_in_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_null?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_start?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_start_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_start_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_not_true?: InputMaybe<Scalars['String']>;
  courses_advance_finish_null?: InputMaybe<Scalars['String']>;
  courses_advance_finish_present?: InputMaybe<Scalars['String']>;
  courses_advance_finish_start?: InputMaybe<Scalars['String']>;
  courses_advance_finish_start_all?: InputMaybe<Scalars['String']>;
  courses_advance_finish_start_any?: InputMaybe<Scalars['String']>;
  courses_advance_finish_true?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_blank?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_cont?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_does_not_match?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_does_not_match_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_does_not_match_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_end?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_end_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_end_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_eq?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_eq_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_eq_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_false?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_gt?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_gt_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_gt_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_gteq?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_gteq_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_gteq_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_i_cont?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_in?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_in_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_in_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_lt?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_lt_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_lt_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_lteq?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_lteq_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_lteq_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_matches?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_matches_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_matches_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_cont?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_end?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_end_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_end_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_eq?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_eq_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_eq_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_false?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_i_cont?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_in?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_in_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_in_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_null?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_start?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_start_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_start_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_not_true?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_null?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_present?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_start?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_start_all?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_start_any?: InputMaybe<Scalars['String']>;
  courses_advance_in_progress_true?: InputMaybe<Scalars['String']>;
  courses_advance_pending_blank?: InputMaybe<Scalars['String']>;
  courses_advance_pending_cont?: InputMaybe<Scalars['String']>;
  courses_advance_pending_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_does_not_match?: InputMaybe<Scalars['String']>;
  courses_advance_pending_does_not_match_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_does_not_match_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_end?: InputMaybe<Scalars['String']>;
  courses_advance_pending_end_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_end_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_eq?: InputMaybe<Scalars['String']>;
  courses_advance_pending_eq_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_eq_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_false?: InputMaybe<Scalars['String']>;
  courses_advance_pending_gt?: InputMaybe<Scalars['String']>;
  courses_advance_pending_gt_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_gt_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_gteq?: InputMaybe<Scalars['String']>;
  courses_advance_pending_gteq_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_gteq_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_i_cont?: InputMaybe<Scalars['String']>;
  courses_advance_pending_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_in?: InputMaybe<Scalars['String']>;
  courses_advance_pending_in_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_in_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_lt?: InputMaybe<Scalars['String']>;
  courses_advance_pending_lt_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_lt_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_lteq?: InputMaybe<Scalars['String']>;
  courses_advance_pending_lteq_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_lteq_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_matches?: InputMaybe<Scalars['String']>;
  courses_advance_pending_matches_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_matches_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_cont?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_end?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_end_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_end_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_eq?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_eq_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_eq_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_false?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_i_cont?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_in?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_in_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_in_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_null?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_start?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_start_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_start_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_not_true?: InputMaybe<Scalars['String']>;
  courses_advance_pending_null?: InputMaybe<Scalars['String']>;
  courses_advance_pending_present?: InputMaybe<Scalars['String']>;
  courses_advance_pending_start?: InputMaybe<Scalars['String']>;
  courses_advance_pending_start_all?: InputMaybe<Scalars['String']>;
  courses_advance_pending_start_any?: InputMaybe<Scalars['String']>;
  courses_advance_pending_true?: InputMaybe<Scalars['String']>;
  courses_count_blank?: InputMaybe<Scalars['String']>;
  courses_count_cont?: InputMaybe<Scalars['String']>;
  courses_count_cont_all?: InputMaybe<Scalars['String']>;
  courses_count_cont_any?: InputMaybe<Scalars['String']>;
  courses_count_does_not_match?: InputMaybe<Scalars['String']>;
  courses_count_does_not_match_all?: InputMaybe<Scalars['String']>;
  courses_count_does_not_match_any?: InputMaybe<Scalars['String']>;
  courses_count_end?: InputMaybe<Scalars['String']>;
  courses_count_end_all?: InputMaybe<Scalars['String']>;
  courses_count_end_any?: InputMaybe<Scalars['String']>;
  courses_count_eq?: InputMaybe<Scalars['String']>;
  courses_count_eq_all?: InputMaybe<Scalars['String']>;
  courses_count_eq_any?: InputMaybe<Scalars['String']>;
  courses_count_false?: InputMaybe<Scalars['String']>;
  courses_count_gt?: InputMaybe<Scalars['String']>;
  courses_count_gt_all?: InputMaybe<Scalars['String']>;
  courses_count_gt_any?: InputMaybe<Scalars['String']>;
  courses_count_gteq?: InputMaybe<Scalars['String']>;
  courses_count_gteq_all?: InputMaybe<Scalars['String']>;
  courses_count_gteq_any?: InputMaybe<Scalars['String']>;
  courses_count_i_cont?: InputMaybe<Scalars['String']>;
  courses_count_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_count_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_count_in?: InputMaybe<Scalars['String']>;
  courses_count_in_all?: InputMaybe<Scalars['String']>;
  courses_count_in_any?: InputMaybe<Scalars['String']>;
  courses_count_lt?: InputMaybe<Scalars['String']>;
  courses_count_lt_all?: InputMaybe<Scalars['String']>;
  courses_count_lt_any?: InputMaybe<Scalars['String']>;
  courses_count_lteq?: InputMaybe<Scalars['String']>;
  courses_count_lteq_all?: InputMaybe<Scalars['String']>;
  courses_count_lteq_any?: InputMaybe<Scalars['String']>;
  courses_count_matches?: InputMaybe<Scalars['String']>;
  courses_count_matches_all?: InputMaybe<Scalars['String']>;
  courses_count_matches_any?: InputMaybe<Scalars['String']>;
  courses_count_not_cont?: InputMaybe<Scalars['String']>;
  courses_count_not_cont_all?: InputMaybe<Scalars['String']>;
  courses_count_not_cont_any?: InputMaybe<Scalars['String']>;
  courses_count_not_end?: InputMaybe<Scalars['String']>;
  courses_count_not_end_all?: InputMaybe<Scalars['String']>;
  courses_count_not_end_any?: InputMaybe<Scalars['String']>;
  courses_count_not_eq?: InputMaybe<Scalars['String']>;
  courses_count_not_eq_all?: InputMaybe<Scalars['String']>;
  courses_count_not_eq_any?: InputMaybe<Scalars['String']>;
  courses_count_not_false?: InputMaybe<Scalars['String']>;
  courses_count_not_i_cont?: InputMaybe<Scalars['String']>;
  courses_count_not_i_cont_all?: InputMaybe<Scalars['String']>;
  courses_count_not_i_cont_any?: InputMaybe<Scalars['String']>;
  courses_count_not_in?: InputMaybe<Scalars['String']>;
  courses_count_not_in_all?: InputMaybe<Scalars['String']>;
  courses_count_not_in_any?: InputMaybe<Scalars['String']>;
  courses_count_not_null?: InputMaybe<Scalars['String']>;
  courses_count_not_start?: InputMaybe<Scalars['String']>;
  courses_count_not_start_all?: InputMaybe<Scalars['String']>;
  courses_count_not_start_any?: InputMaybe<Scalars['String']>;
  courses_count_not_true?: InputMaybe<Scalars['String']>;
  courses_count_null?: InputMaybe<Scalars['String']>;
  courses_count_present?: InputMaybe<Scalars['String']>;
  courses_count_start?: InputMaybe<Scalars['String']>;
  courses_count_start_all?: InputMaybe<Scalars['String']>;
  courses_count_start_any?: InputMaybe<Scalars['String']>;
  courses_count_true?: InputMaybe<Scalars['String']>;
  created_at_blank?: InputMaybe<Scalars['String']>;
  created_at_cont?: InputMaybe<Scalars['String']>;
  created_at_cont_all?: InputMaybe<Scalars['String']>;
  created_at_cont_any?: InputMaybe<Scalars['String']>;
  created_at_does_not_match?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_all?: InputMaybe<Scalars['String']>;
  created_at_does_not_match_any?: InputMaybe<Scalars['String']>;
  created_at_end?: InputMaybe<Scalars['String']>;
  created_at_end_all?: InputMaybe<Scalars['String']>;
  created_at_end_any?: InputMaybe<Scalars['String']>;
  created_at_eq?: InputMaybe<Scalars['String']>;
  created_at_eq_all?: InputMaybe<Scalars['String']>;
  created_at_eq_any?: InputMaybe<Scalars['String']>;
  created_at_false?: InputMaybe<Scalars['String']>;
  created_at_gt?: InputMaybe<Scalars['String']>;
  created_at_gt_all?: InputMaybe<Scalars['String']>;
  created_at_gt_any?: InputMaybe<Scalars['String']>;
  created_at_gteq?: InputMaybe<Scalars['String']>;
  created_at_gteq_all?: InputMaybe<Scalars['String']>;
  created_at_gteq_any?: InputMaybe<Scalars['String']>;
  created_at_i_cont?: InputMaybe<Scalars['String']>;
  created_at_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_in?: InputMaybe<Scalars['String']>;
  created_at_in_all?: InputMaybe<Scalars['String']>;
  created_at_in_any?: InputMaybe<Scalars['String']>;
  created_at_lt?: InputMaybe<Scalars['String']>;
  created_at_lt_all?: InputMaybe<Scalars['String']>;
  created_at_lt_any?: InputMaybe<Scalars['String']>;
  created_at_lteq?: InputMaybe<Scalars['String']>;
  created_at_lteq_all?: InputMaybe<Scalars['String']>;
  created_at_lteq_any?: InputMaybe<Scalars['String']>;
  created_at_matches?: InputMaybe<Scalars['String']>;
  created_at_matches_all?: InputMaybe<Scalars['String']>;
  created_at_matches_any?: InputMaybe<Scalars['String']>;
  created_at_not_cont?: InputMaybe<Scalars['String']>;
  created_at_not_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_end?: InputMaybe<Scalars['String']>;
  created_at_not_end_all?: InputMaybe<Scalars['String']>;
  created_at_not_end_any?: InputMaybe<Scalars['String']>;
  created_at_not_eq?: InputMaybe<Scalars['String']>;
  created_at_not_eq_all?: InputMaybe<Scalars['String']>;
  created_at_not_eq_any?: InputMaybe<Scalars['String']>;
  created_at_not_false?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_all?: InputMaybe<Scalars['String']>;
  created_at_not_i_cont_any?: InputMaybe<Scalars['String']>;
  created_at_not_in?: InputMaybe<Scalars['String']>;
  created_at_not_in_all?: InputMaybe<Scalars['String']>;
  created_at_not_in_any?: InputMaybe<Scalars['String']>;
  created_at_not_null?: InputMaybe<Scalars['String']>;
  created_at_not_start?: InputMaybe<Scalars['String']>;
  created_at_not_start_all?: InputMaybe<Scalars['String']>;
  created_at_not_start_any?: InputMaybe<Scalars['String']>;
  created_at_not_true?: InputMaybe<Scalars['String']>;
  created_at_null?: InputMaybe<Scalars['String']>;
  created_at_present?: InputMaybe<Scalars['String']>;
  created_at_start?: InputMaybe<Scalars['String']>;
  created_at_start_all?: InputMaybe<Scalars['String']>;
  created_at_start_any?: InputMaybe<Scalars['String']>;
  created_at_true?: InputMaybe<Scalars['String']>;
  email_blank?: InputMaybe<Scalars['String']>;
  email_cont?: InputMaybe<Scalars['String']>;
  email_cont_all?: InputMaybe<Scalars['String']>;
  email_cont_any?: InputMaybe<Scalars['String']>;
  email_does_not_match?: InputMaybe<Scalars['String']>;
  email_does_not_match_all?: InputMaybe<Scalars['String']>;
  email_does_not_match_any?: InputMaybe<Scalars['String']>;
  email_end?: InputMaybe<Scalars['String']>;
  email_end_all?: InputMaybe<Scalars['String']>;
  email_end_any?: InputMaybe<Scalars['String']>;
  email_eq?: InputMaybe<Scalars['String']>;
  email_eq_all?: InputMaybe<Scalars['String']>;
  email_eq_any?: InputMaybe<Scalars['String']>;
  email_false?: InputMaybe<Scalars['String']>;
  email_gt?: InputMaybe<Scalars['String']>;
  email_gt_all?: InputMaybe<Scalars['String']>;
  email_gt_any?: InputMaybe<Scalars['String']>;
  email_gteq?: InputMaybe<Scalars['String']>;
  email_gteq_all?: InputMaybe<Scalars['String']>;
  email_gteq_any?: InputMaybe<Scalars['String']>;
  email_i_cont?: InputMaybe<Scalars['String']>;
  email_i_cont_all?: InputMaybe<Scalars['String']>;
  email_i_cont_any?: InputMaybe<Scalars['String']>;
  email_in?: InputMaybe<Array<Scalars['String']>>;
  email_in_all?: InputMaybe<Array<Scalars['String']>>;
  email_in_any?: InputMaybe<Array<Scalars['String']>>;
  email_lt?: InputMaybe<Scalars['String']>;
  email_lt_all?: InputMaybe<Scalars['String']>;
  email_lt_any?: InputMaybe<Scalars['String']>;
  email_lteq?: InputMaybe<Scalars['String']>;
  email_lteq_all?: InputMaybe<Scalars['String']>;
  email_lteq_any?: InputMaybe<Scalars['String']>;
  email_matches?: InputMaybe<Scalars['String']>;
  email_matches_all?: InputMaybe<Scalars['String']>;
  email_matches_any?: InputMaybe<Scalars['String']>;
  email_not_cont?: InputMaybe<Scalars['String']>;
  email_not_cont_all?: InputMaybe<Scalars['String']>;
  email_not_cont_any?: InputMaybe<Scalars['String']>;
  email_not_end?: InputMaybe<Scalars['String']>;
  email_not_end_all?: InputMaybe<Scalars['String']>;
  email_not_end_any?: InputMaybe<Scalars['String']>;
  email_not_eq?: InputMaybe<Scalars['String']>;
  email_not_eq_all?: InputMaybe<Scalars['String']>;
  email_not_eq_any?: InputMaybe<Scalars['String']>;
  email_not_false?: InputMaybe<Scalars['String']>;
  email_not_i_cont?: InputMaybe<Scalars['String']>;
  email_not_i_cont_all?: InputMaybe<Scalars['String']>;
  email_not_i_cont_any?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<Scalars['String']>>;
  email_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  email_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  email_not_null?: InputMaybe<Scalars['String']>;
  email_not_start?: InputMaybe<Scalars['String']>;
  email_not_start_all?: InputMaybe<Scalars['String']>;
  email_not_start_any?: InputMaybe<Scalars['String']>;
  email_not_true?: InputMaybe<Scalars['String']>;
  email_null?: InputMaybe<Scalars['String']>;
  email_present?: InputMaybe<Scalars['String']>;
  email_start?: InputMaybe<Scalars['String']>;
  email_start_all?: InputMaybe<Scalars['String']>;
  email_start_any?: InputMaybe<Scalars['String']>;
  email_true?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_blank?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_cont?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_cont_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_cont_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_does_not_match?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_does_not_match_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_does_not_match_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_end?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_end_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_end_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_eq?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_eq_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_eq_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_false?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_gt?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_gt_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_gt_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_gteq?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_gteq_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_gteq_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_i_cont?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_i_cont_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_i_cont_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_in?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_in_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_in_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_lt?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_lt_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_lt_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_lteq?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_lteq_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_lteq_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_matches?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_matches_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_matches_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_cont?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_cont_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_cont_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_end?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_end_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_end_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_eq?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_eq_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_eq_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_false?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_i_cont?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_i_cont_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_i_cont_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_in?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_in_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_in_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_null?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_start?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_start_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_start_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_not_true?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_null?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_present?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_start?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_start_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_start_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_approved_true?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_blank?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_cont?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_cont_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_cont_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_does_not_match?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_does_not_match_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_does_not_match_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_end?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_end_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_end_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_eq?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_eq_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_eq_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_false?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_gt?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_gt_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_gt_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_gteq?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_gteq_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_gteq_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_i_cont?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_i_cont_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_i_cont_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_in?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_in_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_in_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_lt?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_lt_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_lt_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_lteq?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_lteq_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_lteq_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_matches?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_matches_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_matches_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_cont?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_cont_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_cont_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_end?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_end_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_end_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_eq?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_eq_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_eq_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_false?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_i_cont?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_i_cont_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_i_cont_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_in?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_in_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_in_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_null?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_start?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_start_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_start_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_not_true?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_null?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_present?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_start?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_start_all?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_start_any?: InputMaybe<Scalars['String']>;
  external_course_progress_evaluations_reprobate_true?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_blank?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_cont?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_does_not_match?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_does_not_match_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_does_not_match_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_end?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_end_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_end_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_eq?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_eq_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_eq_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_false?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_gt?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_gt_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_gt_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_gteq?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_gteq_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_gteq_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_i_cont?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_i_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_i_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_in?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_in_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_in_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_lt?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_lt_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_lt_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_lteq?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_lteq_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_lteq_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_matches?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_matches_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_matches_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_cont?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_end?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_end_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_end_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_eq?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_eq_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_eq_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_false?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_i_cont?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_i_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_i_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_in?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_in_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_in_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_null?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_start?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_start_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_start_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_not_true?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_null?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_present?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_start?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_start_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_start_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_finish_true?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_blank?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_cont?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_does_not_match?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_does_not_match_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_does_not_match_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_end?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_end_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_end_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_eq?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_eq_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_eq_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_false?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_gt?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_gt_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_gt_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_gteq?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_gteq_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_gteq_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_i_cont?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_i_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_i_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_in?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_in_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_in_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_lt?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_lt_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_lt_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_lteq?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_lteq_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_lteq_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_matches?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_matches_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_matches_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_cont?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_end?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_end_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_end_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_eq?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_eq_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_eq_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_false?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_i_cont?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_i_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_i_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_in?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_in_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_in_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_null?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_start?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_start_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_start_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_not_true?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_null?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_present?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_start?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_start_all?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_start_any?: InputMaybe<Scalars['String']>;
  external_courses_advance_pending_true?: InputMaybe<Scalars['String']>;
  external_courses_count_blank?: InputMaybe<Scalars['String']>;
  external_courses_count_cont?: InputMaybe<Scalars['String']>;
  external_courses_count_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_count_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_count_does_not_match?: InputMaybe<Scalars['String']>;
  external_courses_count_does_not_match_all?: InputMaybe<Scalars['String']>;
  external_courses_count_does_not_match_any?: InputMaybe<Scalars['String']>;
  external_courses_count_end?: InputMaybe<Scalars['String']>;
  external_courses_count_end_all?: InputMaybe<Scalars['String']>;
  external_courses_count_end_any?: InputMaybe<Scalars['String']>;
  external_courses_count_eq?: InputMaybe<Scalars['String']>;
  external_courses_count_eq_all?: InputMaybe<Scalars['String']>;
  external_courses_count_eq_any?: InputMaybe<Scalars['String']>;
  external_courses_count_false?: InputMaybe<Scalars['String']>;
  external_courses_count_gt?: InputMaybe<Scalars['String']>;
  external_courses_count_gt_all?: InputMaybe<Scalars['String']>;
  external_courses_count_gt_any?: InputMaybe<Scalars['String']>;
  external_courses_count_gteq?: InputMaybe<Scalars['String']>;
  external_courses_count_gteq_all?: InputMaybe<Scalars['String']>;
  external_courses_count_gteq_any?: InputMaybe<Scalars['String']>;
  external_courses_count_i_cont?: InputMaybe<Scalars['String']>;
  external_courses_count_i_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_count_i_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_count_in?: InputMaybe<Scalars['String']>;
  external_courses_count_in_all?: InputMaybe<Scalars['String']>;
  external_courses_count_in_any?: InputMaybe<Scalars['String']>;
  external_courses_count_lt?: InputMaybe<Scalars['String']>;
  external_courses_count_lt_all?: InputMaybe<Scalars['String']>;
  external_courses_count_lt_any?: InputMaybe<Scalars['String']>;
  external_courses_count_lteq?: InputMaybe<Scalars['String']>;
  external_courses_count_lteq_all?: InputMaybe<Scalars['String']>;
  external_courses_count_lteq_any?: InputMaybe<Scalars['String']>;
  external_courses_count_matches?: InputMaybe<Scalars['String']>;
  external_courses_count_matches_all?: InputMaybe<Scalars['String']>;
  external_courses_count_matches_any?: InputMaybe<Scalars['String']>;
  external_courses_count_not_cont?: InputMaybe<Scalars['String']>;
  external_courses_count_not_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_count_not_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_count_not_end?: InputMaybe<Scalars['String']>;
  external_courses_count_not_end_all?: InputMaybe<Scalars['String']>;
  external_courses_count_not_end_any?: InputMaybe<Scalars['String']>;
  external_courses_count_not_eq?: InputMaybe<Scalars['String']>;
  external_courses_count_not_eq_all?: InputMaybe<Scalars['String']>;
  external_courses_count_not_eq_any?: InputMaybe<Scalars['String']>;
  external_courses_count_not_false?: InputMaybe<Scalars['String']>;
  external_courses_count_not_i_cont?: InputMaybe<Scalars['String']>;
  external_courses_count_not_i_cont_all?: InputMaybe<Scalars['String']>;
  external_courses_count_not_i_cont_any?: InputMaybe<Scalars['String']>;
  external_courses_count_not_in?: InputMaybe<Scalars['String']>;
  external_courses_count_not_in_all?: InputMaybe<Scalars['String']>;
  external_courses_count_not_in_any?: InputMaybe<Scalars['String']>;
  external_courses_count_not_null?: InputMaybe<Scalars['String']>;
  external_courses_count_not_start?: InputMaybe<Scalars['String']>;
  external_courses_count_not_start_all?: InputMaybe<Scalars['String']>;
  external_courses_count_not_start_any?: InputMaybe<Scalars['String']>;
  external_courses_count_not_true?: InputMaybe<Scalars['String']>;
  external_courses_count_null?: InputMaybe<Scalars['String']>;
  external_courses_count_present?: InputMaybe<Scalars['String']>;
  external_courses_count_start?: InputMaybe<Scalars['String']>;
  external_courses_count_start_all?: InputMaybe<Scalars['String']>;
  external_courses_count_start_any?: InputMaybe<Scalars['String']>;
  external_courses_count_true?: InputMaybe<Scalars['String']>;
  full_name_blank?: InputMaybe<Scalars['String']>;
  full_name_cont?: InputMaybe<Scalars['String']>;
  full_name_cont_all?: InputMaybe<Scalars['String']>;
  full_name_cont_any?: InputMaybe<Scalars['String']>;
  full_name_does_not_match?: InputMaybe<Scalars['String']>;
  full_name_does_not_match_all?: InputMaybe<Scalars['String']>;
  full_name_does_not_match_any?: InputMaybe<Scalars['String']>;
  full_name_end?: InputMaybe<Scalars['String']>;
  full_name_end_all?: InputMaybe<Scalars['String']>;
  full_name_end_any?: InputMaybe<Scalars['String']>;
  full_name_eq?: InputMaybe<Scalars['String']>;
  full_name_eq_all?: InputMaybe<Scalars['String']>;
  full_name_eq_any?: InputMaybe<Scalars['String']>;
  full_name_false?: InputMaybe<Scalars['String']>;
  full_name_gt?: InputMaybe<Scalars['String']>;
  full_name_gt_all?: InputMaybe<Scalars['String']>;
  full_name_gt_any?: InputMaybe<Scalars['String']>;
  full_name_gteq?: InputMaybe<Scalars['String']>;
  full_name_gteq_all?: InputMaybe<Scalars['String']>;
  full_name_gteq_any?: InputMaybe<Scalars['String']>;
  full_name_i_cont?: InputMaybe<Scalars['String']>;
  full_name_i_cont_all?: InputMaybe<Scalars['String']>;
  full_name_i_cont_any?: InputMaybe<Scalars['String']>;
  full_name_in?: InputMaybe<Scalars['String']>;
  full_name_in_all?: InputMaybe<Scalars['String']>;
  full_name_in_any?: InputMaybe<Scalars['String']>;
  full_name_lt?: InputMaybe<Scalars['String']>;
  full_name_lt_all?: InputMaybe<Scalars['String']>;
  full_name_lt_any?: InputMaybe<Scalars['String']>;
  full_name_lteq?: InputMaybe<Scalars['String']>;
  full_name_lteq_all?: InputMaybe<Scalars['String']>;
  full_name_lteq_any?: InputMaybe<Scalars['String']>;
  full_name_matches?: InputMaybe<Scalars['String']>;
  full_name_matches_all?: InputMaybe<Scalars['String']>;
  full_name_matches_any?: InputMaybe<Scalars['String']>;
  full_name_not_cont?: InputMaybe<Scalars['String']>;
  full_name_not_cont_all?: InputMaybe<Scalars['String']>;
  full_name_not_cont_any?: InputMaybe<Scalars['String']>;
  full_name_not_end?: InputMaybe<Scalars['String']>;
  full_name_not_end_all?: InputMaybe<Scalars['String']>;
  full_name_not_end_any?: InputMaybe<Scalars['String']>;
  full_name_not_eq?: InputMaybe<Scalars['String']>;
  full_name_not_eq_all?: InputMaybe<Scalars['String']>;
  full_name_not_eq_any?: InputMaybe<Scalars['String']>;
  full_name_not_false?: InputMaybe<Scalars['String']>;
  full_name_not_i_cont?: InputMaybe<Scalars['String']>;
  full_name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  full_name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  full_name_not_in?: InputMaybe<Scalars['String']>;
  full_name_not_in_all?: InputMaybe<Scalars['String']>;
  full_name_not_in_any?: InputMaybe<Scalars['String']>;
  full_name_not_null?: InputMaybe<Scalars['String']>;
  full_name_not_start?: InputMaybe<Scalars['String']>;
  full_name_not_start_all?: InputMaybe<Scalars['String']>;
  full_name_not_start_any?: InputMaybe<Scalars['String']>;
  full_name_not_true?: InputMaybe<Scalars['String']>;
  full_name_null?: InputMaybe<Scalars['String']>;
  full_name_or_identifier_cont?: InputMaybe<Scalars['String']>;
  full_name_or_identifier_or_area_name_or_lms_profiles_name_cont?: InputMaybe<Scalars['String']>;
  full_name_present?: InputMaybe<Scalars['String']>;
  full_name_start?: InputMaybe<Scalars['String']>;
  full_name_start_all?: InputMaybe<Scalars['String']>;
  full_name_start_any?: InputMaybe<Scalars['String']>;
  full_name_true?: InputMaybe<Scalars['String']>;
  g?: InputMaybe<Array<Scalars['JSON']>>;
  id_blank?: InputMaybe<Scalars['Int']>;
  id_cont?: InputMaybe<Scalars['Int']>;
  id_cont_all?: InputMaybe<Scalars['Int']>;
  id_cont_any?: InputMaybe<Scalars['Int']>;
  id_does_not_match?: InputMaybe<Scalars['Int']>;
  id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  id_end?: InputMaybe<Scalars['Int']>;
  id_end_all?: InputMaybe<Scalars['Int']>;
  id_end_any?: InputMaybe<Scalars['Int']>;
  id_eq?: InputMaybe<Scalars['Int']>;
  id_eq_all?: InputMaybe<Scalars['Int']>;
  id_eq_any?: InputMaybe<Scalars['Int']>;
  id_false?: InputMaybe<Scalars['Int']>;
  id_gt?: InputMaybe<Scalars['Int']>;
  id_gt_all?: InputMaybe<Scalars['Int']>;
  id_gt_any?: InputMaybe<Scalars['Int']>;
  id_gteq?: InputMaybe<Scalars['Int']>;
  id_gteq_all?: InputMaybe<Scalars['Int']>;
  id_gteq_any?: InputMaybe<Scalars['Int']>;
  id_i_cont?: InputMaybe<Scalars['Int']>;
  id_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_in?: InputMaybe<Array<Scalars['Int']>>;
  id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_lt?: InputMaybe<Scalars['Int']>;
  id_lt_all?: InputMaybe<Scalars['Int']>;
  id_lt_any?: InputMaybe<Scalars['Int']>;
  id_lteq?: InputMaybe<Scalars['Int']>;
  id_lteq_all?: InputMaybe<Scalars['Int']>;
  id_lteq_any?: InputMaybe<Scalars['Int']>;
  id_matches?: InputMaybe<Scalars['Int']>;
  id_matches_all?: InputMaybe<Scalars['Int']>;
  id_matches_any?: InputMaybe<Scalars['Int']>;
  id_not_cont?: InputMaybe<Scalars['Int']>;
  id_not_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_end?: InputMaybe<Scalars['Int']>;
  id_not_end_all?: InputMaybe<Scalars['Int']>;
  id_not_end_any?: InputMaybe<Scalars['Int']>;
  id_not_eq?: InputMaybe<Scalars['Int']>;
  id_not_eq_all?: InputMaybe<Scalars['Int']>;
  id_not_eq_any?: InputMaybe<Scalars['Int']>;
  id_not_false?: InputMaybe<Scalars['Int']>;
  id_not_i_cont?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  id_not_null?: InputMaybe<Scalars['Int']>;
  id_not_start?: InputMaybe<Scalars['Int']>;
  id_not_start_all?: InputMaybe<Scalars['Int']>;
  id_not_start_any?: InputMaybe<Scalars['Int']>;
  id_not_true?: InputMaybe<Scalars['Int']>;
  id_null?: InputMaybe<Scalars['Int']>;
  id_present?: InputMaybe<Scalars['Int']>;
  id_start?: InputMaybe<Scalars['Int']>;
  id_start_all?: InputMaybe<Scalars['Int']>;
  id_start_any?: InputMaybe<Scalars['Int']>;
  id_true?: InputMaybe<Scalars['Int']>;
  identifier_blank?: InputMaybe<Scalars['String']>;
  identifier_cont?: InputMaybe<Scalars['String']>;
  identifier_cont_all?: InputMaybe<Scalars['String']>;
  identifier_cont_any?: InputMaybe<Scalars['String']>;
  identifier_does_not_match?: InputMaybe<Scalars['String']>;
  identifier_does_not_match_all?: InputMaybe<Scalars['String']>;
  identifier_does_not_match_any?: InputMaybe<Scalars['String']>;
  identifier_end?: InputMaybe<Scalars['String']>;
  identifier_end_all?: InputMaybe<Scalars['String']>;
  identifier_end_any?: InputMaybe<Scalars['String']>;
  identifier_eq?: InputMaybe<Scalars['String']>;
  identifier_eq_all?: InputMaybe<Scalars['String']>;
  identifier_eq_any?: InputMaybe<Scalars['String']>;
  identifier_false?: InputMaybe<Scalars['String']>;
  identifier_gt?: InputMaybe<Scalars['String']>;
  identifier_gt_all?: InputMaybe<Scalars['String']>;
  identifier_gt_any?: InputMaybe<Scalars['String']>;
  identifier_gteq?: InputMaybe<Scalars['String']>;
  identifier_gteq_all?: InputMaybe<Scalars['String']>;
  identifier_gteq_any?: InputMaybe<Scalars['String']>;
  identifier_i_cont?: InputMaybe<Scalars['String']>;
  identifier_i_cont_all?: InputMaybe<Scalars['String']>;
  identifier_i_cont_any?: InputMaybe<Scalars['String']>;
  identifier_in?: InputMaybe<Array<Scalars['String']>>;
  identifier_in_all?: InputMaybe<Array<Scalars['String']>>;
  identifier_in_any?: InputMaybe<Array<Scalars['String']>>;
  identifier_lt?: InputMaybe<Scalars['String']>;
  identifier_lt_all?: InputMaybe<Scalars['String']>;
  identifier_lt_any?: InputMaybe<Scalars['String']>;
  identifier_lteq?: InputMaybe<Scalars['String']>;
  identifier_lteq_all?: InputMaybe<Scalars['String']>;
  identifier_lteq_any?: InputMaybe<Scalars['String']>;
  identifier_matches?: InputMaybe<Scalars['String']>;
  identifier_matches_all?: InputMaybe<Scalars['String']>;
  identifier_matches_any?: InputMaybe<Scalars['String']>;
  identifier_not_cont?: InputMaybe<Scalars['String']>;
  identifier_not_cont_all?: InputMaybe<Scalars['String']>;
  identifier_not_cont_any?: InputMaybe<Scalars['String']>;
  identifier_not_end?: InputMaybe<Scalars['String']>;
  identifier_not_end_all?: InputMaybe<Scalars['String']>;
  identifier_not_end_any?: InputMaybe<Scalars['String']>;
  identifier_not_eq?: InputMaybe<Scalars['String']>;
  identifier_not_eq_all?: InputMaybe<Scalars['String']>;
  identifier_not_eq_any?: InputMaybe<Scalars['String']>;
  identifier_not_false?: InputMaybe<Scalars['String']>;
  identifier_not_i_cont?: InputMaybe<Scalars['String']>;
  identifier_not_i_cont_all?: InputMaybe<Scalars['String']>;
  identifier_not_i_cont_any?: InputMaybe<Scalars['String']>;
  identifier_not_in?: InputMaybe<Array<Scalars['String']>>;
  identifier_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  identifier_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  identifier_not_null?: InputMaybe<Scalars['String']>;
  identifier_not_start?: InputMaybe<Scalars['String']>;
  identifier_not_start_all?: InputMaybe<Scalars['String']>;
  identifier_not_start_any?: InputMaybe<Scalars['String']>;
  identifier_not_true?: InputMaybe<Scalars['String']>;
  identifier_null?: InputMaybe<Scalars['String']>;
  identifier_present?: InputMaybe<Scalars['String']>;
  identifier_start?: InputMaybe<Scalars['String']>;
  identifier_start_all?: InputMaybe<Scalars['String']>;
  identifier_start_any?: InputMaybe<Scalars['String']>;
  identifier_true?: InputMaybe<Scalars['String']>;
  is_internal_blank?: InputMaybe<Scalars['Boolean']>;
  is_internal_cont?: InputMaybe<Scalars['Boolean']>;
  is_internal_cont_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_cont_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_does_not_match?: InputMaybe<Scalars['Boolean']>;
  is_internal_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_end?: InputMaybe<Scalars['Boolean']>;
  is_internal_end_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_end_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_eq?: InputMaybe<Scalars['Boolean']>;
  is_internal_eq_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_eq_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_false?: InputMaybe<Scalars['Boolean']>;
  is_internal_gt?: InputMaybe<Scalars['Boolean']>;
  is_internal_gt_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_gt_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_gteq?: InputMaybe<Scalars['Boolean']>;
  is_internal_gteq_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_gteq_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_i_cont?: InputMaybe<Scalars['Boolean']>;
  is_internal_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_in?: InputMaybe<Array<Scalars['Boolean']>>;
  is_internal_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  is_internal_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  is_internal_lt?: InputMaybe<Scalars['Boolean']>;
  is_internal_lt_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_lt_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_lteq?: InputMaybe<Scalars['Boolean']>;
  is_internal_lteq_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_lteq_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_matches?: InputMaybe<Scalars['Boolean']>;
  is_internal_matches_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_matches_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_cont?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_end?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_end_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_end_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_eq?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_false?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  is_internal_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  is_internal_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  is_internal_not_null?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_start?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_start_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_start_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_not_true?: InputMaybe<Scalars['Boolean']>;
  is_internal_null?: InputMaybe<Scalars['Boolean']>;
  is_internal_present?: InputMaybe<Scalars['Boolean']>;
  is_internal_start?: InputMaybe<Scalars['Boolean']>;
  is_internal_start_all?: InputMaybe<Scalars['Boolean']>;
  is_internal_start_any?: InputMaybe<Scalars['Boolean']>;
  is_internal_true?: InputMaybe<Scalars['Boolean']>;
  joining_date_blank?: InputMaybe<Scalars['String']>;
  joining_date_cont?: InputMaybe<Scalars['String']>;
  joining_date_cont_all?: InputMaybe<Scalars['String']>;
  joining_date_cont_any?: InputMaybe<Scalars['String']>;
  joining_date_does_not_match?: InputMaybe<Scalars['String']>;
  joining_date_does_not_match_all?: InputMaybe<Scalars['String']>;
  joining_date_does_not_match_any?: InputMaybe<Scalars['String']>;
  joining_date_end?: InputMaybe<Scalars['String']>;
  joining_date_end_all?: InputMaybe<Scalars['String']>;
  joining_date_end_any?: InputMaybe<Scalars['String']>;
  joining_date_eq?: InputMaybe<Scalars['String']>;
  joining_date_eq_all?: InputMaybe<Scalars['String']>;
  joining_date_eq_any?: InputMaybe<Scalars['String']>;
  joining_date_false?: InputMaybe<Scalars['String']>;
  joining_date_gt?: InputMaybe<Scalars['String']>;
  joining_date_gt_all?: InputMaybe<Scalars['String']>;
  joining_date_gt_any?: InputMaybe<Scalars['String']>;
  joining_date_gteq?: InputMaybe<Scalars['String']>;
  joining_date_gteq_all?: InputMaybe<Scalars['String']>;
  joining_date_gteq_any?: InputMaybe<Scalars['String']>;
  joining_date_i_cont?: InputMaybe<Scalars['String']>;
  joining_date_i_cont_all?: InputMaybe<Scalars['String']>;
  joining_date_i_cont_any?: InputMaybe<Scalars['String']>;
  joining_date_in?: InputMaybe<Scalars['String']>;
  joining_date_in_all?: InputMaybe<Scalars['String']>;
  joining_date_in_any?: InputMaybe<Scalars['String']>;
  joining_date_lt?: InputMaybe<Scalars['String']>;
  joining_date_lt_all?: InputMaybe<Scalars['String']>;
  joining_date_lt_any?: InputMaybe<Scalars['String']>;
  joining_date_lteq?: InputMaybe<Scalars['String']>;
  joining_date_lteq_all?: InputMaybe<Scalars['String']>;
  joining_date_lteq_any?: InputMaybe<Scalars['String']>;
  joining_date_matches?: InputMaybe<Scalars['String']>;
  joining_date_matches_all?: InputMaybe<Scalars['String']>;
  joining_date_matches_any?: InputMaybe<Scalars['String']>;
  joining_date_not_cont?: InputMaybe<Scalars['String']>;
  joining_date_not_cont_all?: InputMaybe<Scalars['String']>;
  joining_date_not_cont_any?: InputMaybe<Scalars['String']>;
  joining_date_not_end?: InputMaybe<Scalars['String']>;
  joining_date_not_end_all?: InputMaybe<Scalars['String']>;
  joining_date_not_end_any?: InputMaybe<Scalars['String']>;
  joining_date_not_eq?: InputMaybe<Scalars['String']>;
  joining_date_not_eq_all?: InputMaybe<Scalars['String']>;
  joining_date_not_eq_any?: InputMaybe<Scalars['String']>;
  joining_date_not_false?: InputMaybe<Scalars['String']>;
  joining_date_not_i_cont?: InputMaybe<Scalars['String']>;
  joining_date_not_i_cont_all?: InputMaybe<Scalars['String']>;
  joining_date_not_i_cont_any?: InputMaybe<Scalars['String']>;
  joining_date_not_in?: InputMaybe<Scalars['String']>;
  joining_date_not_in_all?: InputMaybe<Scalars['String']>;
  joining_date_not_in_any?: InputMaybe<Scalars['String']>;
  joining_date_not_null?: InputMaybe<Scalars['String']>;
  joining_date_not_start?: InputMaybe<Scalars['String']>;
  joining_date_not_start_all?: InputMaybe<Scalars['String']>;
  joining_date_not_start_any?: InputMaybe<Scalars['String']>;
  joining_date_not_true?: InputMaybe<Scalars['String']>;
  joining_date_null?: InputMaybe<Scalars['String']>;
  joining_date_present?: InputMaybe<Scalars['String']>;
  joining_date_start?: InputMaybe<Scalars['String']>;
  joining_date_start_all?: InputMaybe<Scalars['String']>;
  joining_date_start_any?: InputMaybe<Scalars['String']>;
  joining_date_true?: InputMaybe<Scalars['String']>;
  lastname_blank?: InputMaybe<Scalars['String']>;
  lastname_cont?: InputMaybe<Scalars['String']>;
  lastname_cont_all?: InputMaybe<Scalars['String']>;
  lastname_cont_any?: InputMaybe<Scalars['String']>;
  lastname_does_not_match?: InputMaybe<Scalars['String']>;
  lastname_does_not_match_all?: InputMaybe<Scalars['String']>;
  lastname_does_not_match_any?: InputMaybe<Scalars['String']>;
  lastname_end?: InputMaybe<Scalars['String']>;
  lastname_end_all?: InputMaybe<Scalars['String']>;
  lastname_end_any?: InputMaybe<Scalars['String']>;
  lastname_eq?: InputMaybe<Scalars['String']>;
  lastname_eq_all?: InputMaybe<Scalars['String']>;
  lastname_eq_any?: InputMaybe<Scalars['String']>;
  lastname_false?: InputMaybe<Scalars['String']>;
  lastname_gt?: InputMaybe<Scalars['String']>;
  lastname_gt_all?: InputMaybe<Scalars['String']>;
  lastname_gt_any?: InputMaybe<Scalars['String']>;
  lastname_gteq?: InputMaybe<Scalars['String']>;
  lastname_gteq_all?: InputMaybe<Scalars['String']>;
  lastname_gteq_any?: InputMaybe<Scalars['String']>;
  lastname_i_cont?: InputMaybe<Scalars['String']>;
  lastname_i_cont_all?: InputMaybe<Scalars['String']>;
  lastname_i_cont_any?: InputMaybe<Scalars['String']>;
  lastname_in?: InputMaybe<Array<Scalars['String']>>;
  lastname_in_all?: InputMaybe<Array<Scalars['String']>>;
  lastname_in_any?: InputMaybe<Array<Scalars['String']>>;
  lastname_lt?: InputMaybe<Scalars['String']>;
  lastname_lt_all?: InputMaybe<Scalars['String']>;
  lastname_lt_any?: InputMaybe<Scalars['String']>;
  lastname_lteq?: InputMaybe<Scalars['String']>;
  lastname_lteq_all?: InputMaybe<Scalars['String']>;
  lastname_lteq_any?: InputMaybe<Scalars['String']>;
  lastname_matches?: InputMaybe<Scalars['String']>;
  lastname_matches_all?: InputMaybe<Scalars['String']>;
  lastname_matches_any?: InputMaybe<Scalars['String']>;
  lastname_not_cont?: InputMaybe<Scalars['String']>;
  lastname_not_cont_all?: InputMaybe<Scalars['String']>;
  lastname_not_cont_any?: InputMaybe<Scalars['String']>;
  lastname_not_end?: InputMaybe<Scalars['String']>;
  lastname_not_end_all?: InputMaybe<Scalars['String']>;
  lastname_not_end_any?: InputMaybe<Scalars['String']>;
  lastname_not_eq?: InputMaybe<Scalars['String']>;
  lastname_not_eq_all?: InputMaybe<Scalars['String']>;
  lastname_not_eq_any?: InputMaybe<Scalars['String']>;
  lastname_not_false?: InputMaybe<Scalars['String']>;
  lastname_not_i_cont?: InputMaybe<Scalars['String']>;
  lastname_not_i_cont_all?: InputMaybe<Scalars['String']>;
  lastname_not_i_cont_any?: InputMaybe<Scalars['String']>;
  lastname_not_in?: InputMaybe<Array<Scalars['String']>>;
  lastname_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  lastname_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  lastname_not_null?: InputMaybe<Scalars['String']>;
  lastname_not_start?: InputMaybe<Scalars['String']>;
  lastname_not_start_all?: InputMaybe<Scalars['String']>;
  lastname_not_start_any?: InputMaybe<Scalars['String']>;
  lastname_not_true?: InputMaybe<Scalars['String']>;
  lastname_null?: InputMaybe<Scalars['String']>;
  lastname_present?: InputMaybe<Scalars['String']>;
  lastname_start?: InputMaybe<Scalars['String']>;
  lastname_start_all?: InputMaybe<Scalars['String']>;
  lastname_start_any?: InputMaybe<Scalars['String']>;
  lastname_true?: InputMaybe<Scalars['String']>;
  lms_active_blank?: InputMaybe<Scalars['Boolean']>;
  lms_active_cont?: InputMaybe<Scalars['Boolean']>;
  lms_active_cont_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_cont_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_does_not_match?: InputMaybe<Scalars['Boolean']>;
  lms_active_does_not_match_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_does_not_match_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_end?: InputMaybe<Scalars['Boolean']>;
  lms_active_end_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_end_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_eq?: InputMaybe<Scalars['Boolean']>;
  lms_active_eq_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_eq_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_false?: InputMaybe<Scalars['Boolean']>;
  lms_active_gt?: InputMaybe<Scalars['Boolean']>;
  lms_active_gt_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_gt_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_gteq?: InputMaybe<Scalars['Boolean']>;
  lms_active_gteq_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_gteq_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_i_cont?: InputMaybe<Scalars['Boolean']>;
  lms_active_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_in?: InputMaybe<Array<Scalars['Boolean']>>;
  lms_active_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  lms_active_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  lms_active_lt?: InputMaybe<Scalars['Boolean']>;
  lms_active_lt_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_lt_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_lteq?: InputMaybe<Scalars['Boolean']>;
  lms_active_lteq_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_lteq_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_matches?: InputMaybe<Scalars['Boolean']>;
  lms_active_matches_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_matches_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_cont?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_cont_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_cont_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_end?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_end_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_end_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_eq?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_eq_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_eq_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_false?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_i_cont?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_i_cont_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_i_cont_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  lms_active_not_in_all?: InputMaybe<Array<Scalars['Boolean']>>;
  lms_active_not_in_any?: InputMaybe<Array<Scalars['Boolean']>>;
  lms_active_not_null?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_start?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_start_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_start_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_not_true?: InputMaybe<Scalars['Boolean']>;
  lms_active_null?: InputMaybe<Scalars['Boolean']>;
  lms_active_present?: InputMaybe<Scalars['Boolean']>;
  lms_active_start?: InputMaybe<Scalars['Boolean']>;
  lms_active_start_all?: InputMaybe<Scalars['Boolean']>;
  lms_active_start_any?: InputMaybe<Scalars['Boolean']>;
  lms_active_true?: InputMaybe<Scalars['Boolean']>;
  middle_name_blank?: InputMaybe<Scalars['String']>;
  middle_name_cont?: InputMaybe<Scalars['String']>;
  middle_name_cont_all?: InputMaybe<Scalars['String']>;
  middle_name_cont_any?: InputMaybe<Scalars['String']>;
  middle_name_does_not_match?: InputMaybe<Scalars['String']>;
  middle_name_does_not_match_all?: InputMaybe<Scalars['String']>;
  middle_name_does_not_match_any?: InputMaybe<Scalars['String']>;
  middle_name_end?: InputMaybe<Scalars['String']>;
  middle_name_end_all?: InputMaybe<Scalars['String']>;
  middle_name_end_any?: InputMaybe<Scalars['String']>;
  middle_name_eq?: InputMaybe<Scalars['String']>;
  middle_name_eq_all?: InputMaybe<Scalars['String']>;
  middle_name_eq_any?: InputMaybe<Scalars['String']>;
  middle_name_false?: InputMaybe<Scalars['String']>;
  middle_name_gt?: InputMaybe<Scalars['String']>;
  middle_name_gt_all?: InputMaybe<Scalars['String']>;
  middle_name_gt_any?: InputMaybe<Scalars['String']>;
  middle_name_gteq?: InputMaybe<Scalars['String']>;
  middle_name_gteq_all?: InputMaybe<Scalars['String']>;
  middle_name_gteq_any?: InputMaybe<Scalars['String']>;
  middle_name_i_cont?: InputMaybe<Scalars['String']>;
  middle_name_i_cont_all?: InputMaybe<Scalars['String']>;
  middle_name_i_cont_any?: InputMaybe<Scalars['String']>;
  middle_name_in?: InputMaybe<Array<Scalars['String']>>;
  middle_name_in_all?: InputMaybe<Array<Scalars['String']>>;
  middle_name_in_any?: InputMaybe<Array<Scalars['String']>>;
  middle_name_lt?: InputMaybe<Scalars['String']>;
  middle_name_lt_all?: InputMaybe<Scalars['String']>;
  middle_name_lt_any?: InputMaybe<Scalars['String']>;
  middle_name_lteq?: InputMaybe<Scalars['String']>;
  middle_name_lteq_all?: InputMaybe<Scalars['String']>;
  middle_name_lteq_any?: InputMaybe<Scalars['String']>;
  middle_name_matches?: InputMaybe<Scalars['String']>;
  middle_name_matches_all?: InputMaybe<Scalars['String']>;
  middle_name_matches_any?: InputMaybe<Scalars['String']>;
  middle_name_not_cont?: InputMaybe<Scalars['String']>;
  middle_name_not_cont_all?: InputMaybe<Scalars['String']>;
  middle_name_not_cont_any?: InputMaybe<Scalars['String']>;
  middle_name_not_end?: InputMaybe<Scalars['String']>;
  middle_name_not_end_all?: InputMaybe<Scalars['String']>;
  middle_name_not_end_any?: InputMaybe<Scalars['String']>;
  middle_name_not_eq?: InputMaybe<Scalars['String']>;
  middle_name_not_eq_all?: InputMaybe<Scalars['String']>;
  middle_name_not_eq_any?: InputMaybe<Scalars['String']>;
  middle_name_not_false?: InputMaybe<Scalars['String']>;
  middle_name_not_i_cont?: InputMaybe<Scalars['String']>;
  middle_name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  middle_name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  middle_name_not_in?: InputMaybe<Array<Scalars['String']>>;
  middle_name_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  middle_name_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  middle_name_not_null?: InputMaybe<Scalars['String']>;
  middle_name_not_start?: InputMaybe<Scalars['String']>;
  middle_name_not_start_all?: InputMaybe<Scalars['String']>;
  middle_name_not_start_any?: InputMaybe<Scalars['String']>;
  middle_name_not_true?: InputMaybe<Scalars['String']>;
  middle_name_null?: InputMaybe<Scalars['String']>;
  middle_name_present?: InputMaybe<Scalars['String']>;
  middle_name_start?: InputMaybe<Scalars['String']>;
  middle_name_start_all?: InputMaybe<Scalars['String']>;
  middle_name_start_any?: InputMaybe<Scalars['String']>;
  middle_name_true?: InputMaybe<Scalars['String']>;
  mothers_name_blank?: InputMaybe<Scalars['String']>;
  mothers_name_cont?: InputMaybe<Scalars['String']>;
  mothers_name_cont_all?: InputMaybe<Scalars['String']>;
  mothers_name_cont_any?: InputMaybe<Scalars['String']>;
  mothers_name_does_not_match?: InputMaybe<Scalars['String']>;
  mothers_name_does_not_match_all?: InputMaybe<Scalars['String']>;
  mothers_name_does_not_match_any?: InputMaybe<Scalars['String']>;
  mothers_name_end?: InputMaybe<Scalars['String']>;
  mothers_name_end_all?: InputMaybe<Scalars['String']>;
  mothers_name_end_any?: InputMaybe<Scalars['String']>;
  mothers_name_eq?: InputMaybe<Scalars['String']>;
  mothers_name_eq_all?: InputMaybe<Scalars['String']>;
  mothers_name_eq_any?: InputMaybe<Scalars['String']>;
  mothers_name_false?: InputMaybe<Scalars['String']>;
  mothers_name_gt?: InputMaybe<Scalars['String']>;
  mothers_name_gt_all?: InputMaybe<Scalars['String']>;
  mothers_name_gt_any?: InputMaybe<Scalars['String']>;
  mothers_name_gteq?: InputMaybe<Scalars['String']>;
  mothers_name_gteq_all?: InputMaybe<Scalars['String']>;
  mothers_name_gteq_any?: InputMaybe<Scalars['String']>;
  mothers_name_i_cont?: InputMaybe<Scalars['String']>;
  mothers_name_i_cont_all?: InputMaybe<Scalars['String']>;
  mothers_name_i_cont_any?: InputMaybe<Scalars['String']>;
  mothers_name_in?: InputMaybe<Array<Scalars['String']>>;
  mothers_name_in_all?: InputMaybe<Array<Scalars['String']>>;
  mothers_name_in_any?: InputMaybe<Array<Scalars['String']>>;
  mothers_name_lt?: InputMaybe<Scalars['String']>;
  mothers_name_lt_all?: InputMaybe<Scalars['String']>;
  mothers_name_lt_any?: InputMaybe<Scalars['String']>;
  mothers_name_lteq?: InputMaybe<Scalars['String']>;
  mothers_name_lteq_all?: InputMaybe<Scalars['String']>;
  mothers_name_lteq_any?: InputMaybe<Scalars['String']>;
  mothers_name_matches?: InputMaybe<Scalars['String']>;
  mothers_name_matches_all?: InputMaybe<Scalars['String']>;
  mothers_name_matches_any?: InputMaybe<Scalars['String']>;
  mothers_name_not_cont?: InputMaybe<Scalars['String']>;
  mothers_name_not_cont_all?: InputMaybe<Scalars['String']>;
  mothers_name_not_cont_any?: InputMaybe<Scalars['String']>;
  mothers_name_not_end?: InputMaybe<Scalars['String']>;
  mothers_name_not_end_all?: InputMaybe<Scalars['String']>;
  mothers_name_not_end_any?: InputMaybe<Scalars['String']>;
  mothers_name_not_eq?: InputMaybe<Scalars['String']>;
  mothers_name_not_eq_all?: InputMaybe<Scalars['String']>;
  mothers_name_not_eq_any?: InputMaybe<Scalars['String']>;
  mothers_name_not_false?: InputMaybe<Scalars['String']>;
  mothers_name_not_i_cont?: InputMaybe<Scalars['String']>;
  mothers_name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  mothers_name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  mothers_name_not_in?: InputMaybe<Array<Scalars['String']>>;
  mothers_name_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  mothers_name_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  mothers_name_not_null?: InputMaybe<Scalars['String']>;
  mothers_name_not_start?: InputMaybe<Scalars['String']>;
  mothers_name_not_start_all?: InputMaybe<Scalars['String']>;
  mothers_name_not_start_any?: InputMaybe<Scalars['String']>;
  mothers_name_not_true?: InputMaybe<Scalars['String']>;
  mothers_name_null?: InputMaybe<Scalars['String']>;
  mothers_name_present?: InputMaybe<Scalars['String']>;
  mothers_name_start?: InputMaybe<Scalars['String']>;
  mothers_name_start_all?: InputMaybe<Scalars['String']>;
  mothers_name_start_any?: InputMaybe<Scalars['String']>;
  mothers_name_true?: InputMaybe<Scalars['String']>;
  name_blank?: InputMaybe<Scalars['String']>;
  name_cont?: InputMaybe<Scalars['String']>;
  name_cont_all?: InputMaybe<Scalars['String']>;
  name_cont_any?: InputMaybe<Scalars['String']>;
  name_does_not_match?: InputMaybe<Scalars['String']>;
  name_does_not_match_all?: InputMaybe<Scalars['String']>;
  name_does_not_match_any?: InputMaybe<Scalars['String']>;
  name_end?: InputMaybe<Scalars['String']>;
  name_end_all?: InputMaybe<Scalars['String']>;
  name_end_any?: InputMaybe<Scalars['String']>;
  name_eq?: InputMaybe<Scalars['String']>;
  name_eq_all?: InputMaybe<Scalars['String']>;
  name_eq_any?: InputMaybe<Scalars['String']>;
  name_false?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gt_all?: InputMaybe<Scalars['String']>;
  name_gt_any?: InputMaybe<Scalars['String']>;
  name_gteq?: InputMaybe<Scalars['String']>;
  name_gteq_all?: InputMaybe<Scalars['String']>;
  name_gteq_any?: InputMaybe<Scalars['String']>;
  name_i_cont?: InputMaybe<Scalars['String']>;
  name_i_cont_all?: InputMaybe<Scalars['String']>;
  name_i_cont_any?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lt_all?: InputMaybe<Scalars['String']>;
  name_lt_any?: InputMaybe<Scalars['String']>;
  name_lteq?: InputMaybe<Scalars['String']>;
  name_lteq_all?: InputMaybe<Scalars['String']>;
  name_lteq_any?: InputMaybe<Scalars['String']>;
  name_matches?: InputMaybe<Scalars['String']>;
  name_matches_all?: InputMaybe<Scalars['String']>;
  name_matches_any?: InputMaybe<Scalars['String']>;
  name_not_cont?: InputMaybe<Scalars['String']>;
  name_not_cont_all?: InputMaybe<Scalars['String']>;
  name_not_cont_any?: InputMaybe<Scalars['String']>;
  name_not_end?: InputMaybe<Scalars['String']>;
  name_not_end_all?: InputMaybe<Scalars['String']>;
  name_not_end_any?: InputMaybe<Scalars['String']>;
  name_not_eq?: InputMaybe<Scalars['String']>;
  name_not_eq_all?: InputMaybe<Scalars['String']>;
  name_not_eq_any?: InputMaybe<Scalars['String']>;
  name_not_false?: InputMaybe<Scalars['String']>;
  name_not_i_cont?: InputMaybe<Scalars['String']>;
  name_not_i_cont_all?: InputMaybe<Scalars['String']>;
  name_not_i_cont_any?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  name_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  name_not_null?: InputMaybe<Scalars['String']>;
  name_not_start?: InputMaybe<Scalars['String']>;
  name_not_start_all?: InputMaybe<Scalars['String']>;
  name_not_start_any?: InputMaybe<Scalars['String']>;
  name_not_true?: InputMaybe<Scalars['String']>;
  name_null?: InputMaybe<Scalars['String']>;
  name_present?: InputMaybe<Scalars['String']>;
  name_start?: InputMaybe<Scalars['String']>;
  name_start_all?: InputMaybe<Scalars['String']>;
  name_start_any?: InputMaybe<Scalars['String']>;
  name_true?: InputMaybe<Scalars['String']>;
  position_blank?: InputMaybe<Scalars['String']>;
  position_cont?: InputMaybe<Scalars['String']>;
  position_cont_all?: InputMaybe<Scalars['String']>;
  position_cont_any?: InputMaybe<Scalars['String']>;
  position_does_not_match?: InputMaybe<Scalars['String']>;
  position_does_not_match_all?: InputMaybe<Scalars['String']>;
  position_does_not_match_any?: InputMaybe<Scalars['String']>;
  position_end?: InputMaybe<Scalars['String']>;
  position_end_all?: InputMaybe<Scalars['String']>;
  position_end_any?: InputMaybe<Scalars['String']>;
  position_eq?: InputMaybe<Scalars['String']>;
  position_eq_all?: InputMaybe<Scalars['String']>;
  position_eq_any?: InputMaybe<Scalars['String']>;
  position_false?: InputMaybe<Scalars['String']>;
  position_gt?: InputMaybe<Scalars['String']>;
  position_gt_all?: InputMaybe<Scalars['String']>;
  position_gt_any?: InputMaybe<Scalars['String']>;
  position_gteq?: InputMaybe<Scalars['String']>;
  position_gteq_all?: InputMaybe<Scalars['String']>;
  position_gteq_any?: InputMaybe<Scalars['String']>;
  position_i_cont?: InputMaybe<Scalars['String']>;
  position_i_cont_all?: InputMaybe<Scalars['String']>;
  position_i_cont_any?: InputMaybe<Scalars['String']>;
  position_in?: InputMaybe<Array<Scalars['String']>>;
  position_in_all?: InputMaybe<Array<Scalars['String']>>;
  position_in_any?: InputMaybe<Array<Scalars['String']>>;
  position_lt?: InputMaybe<Scalars['String']>;
  position_lt_all?: InputMaybe<Scalars['String']>;
  position_lt_any?: InputMaybe<Scalars['String']>;
  position_lteq?: InputMaybe<Scalars['String']>;
  position_lteq_all?: InputMaybe<Scalars['String']>;
  position_lteq_any?: InputMaybe<Scalars['String']>;
  position_matches?: InputMaybe<Scalars['String']>;
  position_matches_all?: InputMaybe<Scalars['String']>;
  position_matches_any?: InputMaybe<Scalars['String']>;
  position_model_id_blank?: InputMaybe<Scalars['Int']>;
  position_model_id_cont?: InputMaybe<Scalars['Int']>;
  position_model_id_cont_all?: InputMaybe<Scalars['Int']>;
  position_model_id_cont_any?: InputMaybe<Scalars['Int']>;
  position_model_id_does_not_match?: InputMaybe<Scalars['Int']>;
  position_model_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  position_model_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  position_model_id_end?: InputMaybe<Scalars['Int']>;
  position_model_id_end_all?: InputMaybe<Scalars['Int']>;
  position_model_id_end_any?: InputMaybe<Scalars['Int']>;
  position_model_id_eq?: InputMaybe<Scalars['Int']>;
  position_model_id_eq_all?: InputMaybe<Scalars['Int']>;
  position_model_id_eq_any?: InputMaybe<Scalars['Int']>;
  position_model_id_false?: InputMaybe<Scalars['Int']>;
  position_model_id_gt?: InputMaybe<Scalars['Int']>;
  position_model_id_gt_all?: InputMaybe<Scalars['Int']>;
  position_model_id_gt_any?: InputMaybe<Scalars['Int']>;
  position_model_id_gteq?: InputMaybe<Scalars['Int']>;
  position_model_id_gteq_all?: InputMaybe<Scalars['Int']>;
  position_model_id_gteq_any?: InputMaybe<Scalars['Int']>;
  position_model_id_i_cont?: InputMaybe<Scalars['Int']>;
  position_model_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  position_model_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  position_model_id_in?: InputMaybe<Array<Scalars['Int']>>;
  position_model_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  position_model_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  position_model_id_lt?: InputMaybe<Scalars['Int']>;
  position_model_id_lt_all?: InputMaybe<Scalars['Int']>;
  position_model_id_lt_any?: InputMaybe<Scalars['Int']>;
  position_model_id_lteq?: InputMaybe<Scalars['Int']>;
  position_model_id_lteq_all?: InputMaybe<Scalars['Int']>;
  position_model_id_lteq_any?: InputMaybe<Scalars['Int']>;
  position_model_id_matches?: InputMaybe<Scalars['Int']>;
  position_model_id_matches_all?: InputMaybe<Scalars['Int']>;
  position_model_id_matches_any?: InputMaybe<Scalars['Int']>;
  position_model_id_not_cont?: InputMaybe<Scalars['Int']>;
  position_model_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  position_model_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  position_model_id_not_end?: InputMaybe<Scalars['Int']>;
  position_model_id_not_end_all?: InputMaybe<Scalars['Int']>;
  position_model_id_not_end_any?: InputMaybe<Scalars['Int']>;
  position_model_id_not_eq?: InputMaybe<Scalars['Int']>;
  position_model_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  position_model_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  position_model_id_not_false?: InputMaybe<Scalars['Int']>;
  position_model_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  position_model_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  position_model_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  position_model_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  position_model_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  position_model_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  position_model_id_not_null?: InputMaybe<Scalars['Int']>;
  position_model_id_not_start?: InputMaybe<Scalars['Int']>;
  position_model_id_not_start_all?: InputMaybe<Scalars['Int']>;
  position_model_id_not_start_any?: InputMaybe<Scalars['Int']>;
  position_model_id_not_true?: InputMaybe<Scalars['Int']>;
  position_model_id_null?: InputMaybe<Scalars['Int']>;
  position_model_id_present?: InputMaybe<Scalars['Int']>;
  position_model_id_start?: InputMaybe<Scalars['Int']>;
  position_model_id_start_all?: InputMaybe<Scalars['Int']>;
  position_model_id_start_any?: InputMaybe<Scalars['Int']>;
  position_model_id_true?: InputMaybe<Scalars['Int']>;
  position_not_cont?: InputMaybe<Scalars['String']>;
  position_not_cont_all?: InputMaybe<Scalars['String']>;
  position_not_cont_any?: InputMaybe<Scalars['String']>;
  position_not_end?: InputMaybe<Scalars['String']>;
  position_not_end_all?: InputMaybe<Scalars['String']>;
  position_not_end_any?: InputMaybe<Scalars['String']>;
  position_not_eq?: InputMaybe<Scalars['String']>;
  position_not_eq_all?: InputMaybe<Scalars['String']>;
  position_not_eq_any?: InputMaybe<Scalars['String']>;
  position_not_false?: InputMaybe<Scalars['String']>;
  position_not_i_cont?: InputMaybe<Scalars['String']>;
  position_not_i_cont_all?: InputMaybe<Scalars['String']>;
  position_not_i_cont_any?: InputMaybe<Scalars['String']>;
  position_not_in?: InputMaybe<Array<Scalars['String']>>;
  position_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  position_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  position_not_null?: InputMaybe<Scalars['String']>;
  position_not_start?: InputMaybe<Scalars['String']>;
  position_not_start_all?: InputMaybe<Scalars['String']>;
  position_not_start_any?: InputMaybe<Scalars['String']>;
  position_not_true?: InputMaybe<Scalars['String']>;
  position_null?: InputMaybe<Scalars['String']>;
  position_present?: InputMaybe<Scalars['String']>;
  position_start?: InputMaybe<Scalars['String']>;
  position_start_all?: InputMaybe<Scalars['String']>;
  position_start_any?: InputMaybe<Scalars['String']>;
  position_true?: InputMaybe<Scalars['String']>;
  role_id_blank?: InputMaybe<Scalars['Int']>;
  role_id_cont?: InputMaybe<Scalars['Int']>;
  role_id_cont_all?: InputMaybe<Scalars['Int']>;
  role_id_cont_any?: InputMaybe<Scalars['Int']>;
  role_id_does_not_match?: InputMaybe<Scalars['Int']>;
  role_id_does_not_match_all?: InputMaybe<Scalars['Int']>;
  role_id_does_not_match_any?: InputMaybe<Scalars['Int']>;
  role_id_end?: InputMaybe<Scalars['Int']>;
  role_id_end_all?: InputMaybe<Scalars['Int']>;
  role_id_end_any?: InputMaybe<Scalars['Int']>;
  role_id_eq?: InputMaybe<Scalars['Int']>;
  role_id_eq_all?: InputMaybe<Scalars['Int']>;
  role_id_eq_any?: InputMaybe<Scalars['Int']>;
  role_id_false?: InputMaybe<Scalars['Int']>;
  role_id_gt?: InputMaybe<Scalars['Int']>;
  role_id_gt_all?: InputMaybe<Scalars['Int']>;
  role_id_gt_any?: InputMaybe<Scalars['Int']>;
  role_id_gteq?: InputMaybe<Scalars['Int']>;
  role_id_gteq_all?: InputMaybe<Scalars['Int']>;
  role_id_gteq_any?: InputMaybe<Scalars['Int']>;
  role_id_i_cont?: InputMaybe<Scalars['Int']>;
  role_id_i_cont_all?: InputMaybe<Scalars['Int']>;
  role_id_i_cont_any?: InputMaybe<Scalars['Int']>;
  role_id_in?: InputMaybe<Array<Scalars['Int']>>;
  role_id_in_all?: InputMaybe<Array<Scalars['Int']>>;
  role_id_in_any?: InputMaybe<Array<Scalars['Int']>>;
  role_id_lt?: InputMaybe<Scalars['Int']>;
  role_id_lt_all?: InputMaybe<Scalars['Int']>;
  role_id_lt_any?: InputMaybe<Scalars['Int']>;
  role_id_lteq?: InputMaybe<Scalars['Int']>;
  role_id_lteq_all?: InputMaybe<Scalars['Int']>;
  role_id_lteq_any?: InputMaybe<Scalars['Int']>;
  role_id_matches?: InputMaybe<Scalars['Int']>;
  role_id_matches_all?: InputMaybe<Scalars['Int']>;
  role_id_matches_any?: InputMaybe<Scalars['Int']>;
  role_id_not_cont?: InputMaybe<Scalars['Int']>;
  role_id_not_cont_all?: InputMaybe<Scalars['Int']>;
  role_id_not_cont_any?: InputMaybe<Scalars['Int']>;
  role_id_not_end?: InputMaybe<Scalars['Int']>;
  role_id_not_end_all?: InputMaybe<Scalars['Int']>;
  role_id_not_end_any?: InputMaybe<Scalars['Int']>;
  role_id_not_eq?: InputMaybe<Scalars['Int']>;
  role_id_not_eq_all?: InputMaybe<Scalars['Int']>;
  role_id_not_eq_any?: InputMaybe<Scalars['Int']>;
  role_id_not_false?: InputMaybe<Scalars['Int']>;
  role_id_not_i_cont?: InputMaybe<Scalars['Int']>;
  role_id_not_i_cont_all?: InputMaybe<Scalars['Int']>;
  role_id_not_i_cont_any?: InputMaybe<Scalars['Int']>;
  role_id_not_in?: InputMaybe<Array<Scalars['Int']>>;
  role_id_not_in_all?: InputMaybe<Array<Scalars['Int']>>;
  role_id_not_in_any?: InputMaybe<Array<Scalars['Int']>>;
  role_id_not_null?: InputMaybe<Scalars['Int']>;
  role_id_not_start?: InputMaybe<Scalars['Int']>;
  role_id_not_start_all?: InputMaybe<Scalars['Int']>;
  role_id_not_start_any?: InputMaybe<Scalars['Int']>;
  role_id_not_true?: InputMaybe<Scalars['Int']>;
  role_id_null?: InputMaybe<Scalars['Int']>;
  role_id_present?: InputMaybe<Scalars['Int']>;
  role_id_start?: InputMaybe<Scalars['Int']>;
  role_id_start_all?: InputMaybe<Scalars['Int']>;
  role_id_start_any?: InputMaybe<Scalars['Int']>;
  role_id_true?: InputMaybe<Scalars['Int']>;
  rut_blank?: InputMaybe<Scalars['String']>;
  rut_cont?: InputMaybe<Scalars['String']>;
  rut_cont_all?: InputMaybe<Scalars['String']>;
  rut_cont_any?: InputMaybe<Scalars['String']>;
  rut_does_not_match?: InputMaybe<Scalars['String']>;
  rut_does_not_match_all?: InputMaybe<Scalars['String']>;
  rut_does_not_match_any?: InputMaybe<Scalars['String']>;
  rut_end?: InputMaybe<Scalars['String']>;
  rut_end_all?: InputMaybe<Scalars['String']>;
  rut_end_any?: InputMaybe<Scalars['String']>;
  rut_eq?: InputMaybe<Scalars['String']>;
  rut_eq_all?: InputMaybe<Scalars['String']>;
  rut_eq_any?: InputMaybe<Scalars['String']>;
  rut_false?: InputMaybe<Scalars['String']>;
  rut_gt?: InputMaybe<Scalars['String']>;
  rut_gt_all?: InputMaybe<Scalars['String']>;
  rut_gt_any?: InputMaybe<Scalars['String']>;
  rut_gteq?: InputMaybe<Scalars['String']>;
  rut_gteq_all?: InputMaybe<Scalars['String']>;
  rut_gteq_any?: InputMaybe<Scalars['String']>;
  rut_i_cont?: InputMaybe<Scalars['String']>;
  rut_i_cont_all?: InputMaybe<Scalars['String']>;
  rut_i_cont_any?: InputMaybe<Scalars['String']>;
  rut_in?: InputMaybe<Array<Scalars['String']>>;
  rut_in_all?: InputMaybe<Array<Scalars['String']>>;
  rut_in_any?: InputMaybe<Array<Scalars['String']>>;
  rut_lt?: InputMaybe<Scalars['String']>;
  rut_lt_all?: InputMaybe<Scalars['String']>;
  rut_lt_any?: InputMaybe<Scalars['String']>;
  rut_lteq?: InputMaybe<Scalars['String']>;
  rut_lteq_all?: InputMaybe<Scalars['String']>;
  rut_lteq_any?: InputMaybe<Scalars['String']>;
  rut_matches?: InputMaybe<Scalars['String']>;
  rut_matches_all?: InputMaybe<Scalars['String']>;
  rut_matches_any?: InputMaybe<Scalars['String']>;
  rut_not_cont?: InputMaybe<Scalars['String']>;
  rut_not_cont_all?: InputMaybe<Scalars['String']>;
  rut_not_cont_any?: InputMaybe<Scalars['String']>;
  rut_not_end?: InputMaybe<Scalars['String']>;
  rut_not_end_all?: InputMaybe<Scalars['String']>;
  rut_not_end_any?: InputMaybe<Scalars['String']>;
  rut_not_eq?: InputMaybe<Scalars['String']>;
  rut_not_eq_all?: InputMaybe<Scalars['String']>;
  rut_not_eq_any?: InputMaybe<Scalars['String']>;
  rut_not_false?: InputMaybe<Scalars['String']>;
  rut_not_i_cont?: InputMaybe<Scalars['String']>;
  rut_not_i_cont_all?: InputMaybe<Scalars['String']>;
  rut_not_i_cont_any?: InputMaybe<Scalars['String']>;
  rut_not_in?: InputMaybe<Array<Scalars['String']>>;
  rut_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  rut_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  rut_not_null?: InputMaybe<Scalars['String']>;
  rut_not_start?: InputMaybe<Scalars['String']>;
  rut_not_start_all?: InputMaybe<Scalars['String']>;
  rut_not_start_any?: InputMaybe<Scalars['String']>;
  rut_not_true?: InputMaybe<Scalars['String']>;
  rut_null?: InputMaybe<Scalars['String']>;
  rut_present?: InputMaybe<Scalars['String']>;
  rut_start?: InputMaybe<Scalars['String']>;
  rut_start_all?: InputMaybe<Scalars['String']>;
  rut_start_any?: InputMaybe<Scalars['String']>;
  rut_true?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sorts?: InputMaybe<Array<Scalars['String']>>;
  token_blank?: InputMaybe<Scalars['String']>;
  token_cont?: InputMaybe<Scalars['String']>;
  token_cont_all?: InputMaybe<Scalars['String']>;
  token_cont_any?: InputMaybe<Scalars['String']>;
  token_does_not_match?: InputMaybe<Scalars['String']>;
  token_does_not_match_all?: InputMaybe<Scalars['String']>;
  token_does_not_match_any?: InputMaybe<Scalars['String']>;
  token_end?: InputMaybe<Scalars['String']>;
  token_end_all?: InputMaybe<Scalars['String']>;
  token_end_any?: InputMaybe<Scalars['String']>;
  token_eq?: InputMaybe<Scalars['String']>;
  token_eq_all?: InputMaybe<Scalars['String']>;
  token_eq_any?: InputMaybe<Scalars['String']>;
  token_false?: InputMaybe<Scalars['String']>;
  token_gt?: InputMaybe<Scalars['String']>;
  token_gt_all?: InputMaybe<Scalars['String']>;
  token_gt_any?: InputMaybe<Scalars['String']>;
  token_gteq?: InputMaybe<Scalars['String']>;
  token_gteq_all?: InputMaybe<Scalars['String']>;
  token_gteq_any?: InputMaybe<Scalars['String']>;
  token_i_cont?: InputMaybe<Scalars['String']>;
  token_i_cont_all?: InputMaybe<Scalars['String']>;
  token_i_cont_any?: InputMaybe<Scalars['String']>;
  token_in?: InputMaybe<Array<Scalars['String']>>;
  token_in_all?: InputMaybe<Array<Scalars['String']>>;
  token_in_any?: InputMaybe<Array<Scalars['String']>>;
  token_lt?: InputMaybe<Scalars['String']>;
  token_lt_all?: InputMaybe<Scalars['String']>;
  token_lt_any?: InputMaybe<Scalars['String']>;
  token_lteq?: InputMaybe<Scalars['String']>;
  token_lteq_all?: InputMaybe<Scalars['String']>;
  token_lteq_any?: InputMaybe<Scalars['String']>;
  token_matches?: InputMaybe<Scalars['String']>;
  token_matches_all?: InputMaybe<Scalars['String']>;
  token_matches_any?: InputMaybe<Scalars['String']>;
  token_not_cont?: InputMaybe<Scalars['String']>;
  token_not_cont_all?: InputMaybe<Scalars['String']>;
  token_not_cont_any?: InputMaybe<Scalars['String']>;
  token_not_end?: InputMaybe<Scalars['String']>;
  token_not_end_all?: InputMaybe<Scalars['String']>;
  token_not_end_any?: InputMaybe<Scalars['String']>;
  token_not_eq?: InputMaybe<Scalars['String']>;
  token_not_eq_all?: InputMaybe<Scalars['String']>;
  token_not_eq_any?: InputMaybe<Scalars['String']>;
  token_not_false?: InputMaybe<Scalars['String']>;
  token_not_i_cont?: InputMaybe<Scalars['String']>;
  token_not_i_cont_all?: InputMaybe<Scalars['String']>;
  token_not_i_cont_any?: InputMaybe<Scalars['String']>;
  token_not_in?: InputMaybe<Array<Scalars['String']>>;
  token_not_in_all?: InputMaybe<Array<Scalars['String']>>;
  token_not_in_any?: InputMaybe<Array<Scalars['String']>>;
  token_not_null?: InputMaybe<Scalars['String']>;
  token_not_start?: InputMaybe<Scalars['String']>;
  token_not_start_all?: InputMaybe<Scalars['String']>;
  token_not_start_any?: InputMaybe<Scalars['String']>;
  token_not_true?: InputMaybe<Scalars['String']>;
  token_null?: InputMaybe<Scalars['String']>;
  token_present?: InputMaybe<Scalars['String']>;
  token_start?: InputMaybe<Scalars['String']>;
  token_start_all?: InputMaybe<Scalars['String']>;
  token_start_any?: InputMaybe<Scalars['String']>;
  token_true?: InputMaybe<Scalars['String']>;
  user_name_or_user_lastname_or_user_identifier_cont?: InputMaybe<Scalars['String']>;
};
